<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C1" :fill="fill">
      <path
        class="st4"
        d="M207.1,105.4l-0.1-0.1C207,105.4,207,105.5,207.1,105.4L207.1,105.4z"
      />
      <path
        class="st4"
        d="M221.1,104.5c0.1,0.1,0.2,0.3,0.2,0.4c0.7-0.4,0.8-0.9,0.8-1.4c0,0,0,0.1-0.1,0.1
		C221.9,103.9,221.5,104.3,221.1,104.5z"
      />
      <path
        class="st4"
        d="M199.9,110.1c-0.3,0.4-0.6,0.7-1,1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.2-0.1,0.3-0.2,0.5
		c-0.2,0.4-0.5,0.8-0.7,1.2C199.4,112.5,200,111.8,199.9,110.1z"
      />
      <path
        class="st4"
        d="M301,96.4l-0.1-0.1c-0.3,0.6-0.4,0.9-0.1,1.3c0.3-0.3,0.6-0.6,1-0.9C301.4,96.5,301.2,96.5,301,96.4z"
      />
      <path
        class="st4"
        d="M299.4,267c-0.2-0.3,0-0.8,0-1.2c-0.5-0.3-1.3,0.6-1.5-0.2c-0.1-0.3,0.1-0.4,1.1-0.7c0-0.2-0.2-0.5-0.1-0.7
		c0.8-1.2,0.2-2-0.6-3c-1.1-1.4-1.3-3.3,0.5-4.6c0.2-0.1,0.4-0.3,0.5-0.4c-0.3-0.6-0.7-0.6-1.3-0.5c0,0,0,0.1-0.1,0.1
		c0,0-0.1,0-0.2,0h-0.1c-0.3-0.5-0.6-0.9-1.1-1.6c0,0.7,0,1.1,0,1.6c-0.6-0.4-0.9-0.9-1-1.5h-0.1c-0.9,0.2-1.8-0.3-2.1-1
		c-0.3,0.1-0.5,0.1-0.8,0.1c-0.7,0-1.4,0.6-2.4,1.1c0.6,0.2,0.9,0.4,1.2,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0.1,0.2,0.2,0.2,0.3
		c-0.1,0-0.1,0.1-0.2,0.1c0-0.1-0.1-0.2-0.1-0.3c-0.5,0.8-1,1.6,0.1,2.3c-0.4,0.6-0.9,1.2-1.3,1.7c-0.3,0.4-0.6,0.8-1,1.1
		c-0.9,0.7-1.3,1.5-0.8,2.4c0.3,0,0.5-0.2,0.8-0.4c-0.2-0.7,0.2-1.3,1.2-1.8c0.5,0.4,1,0.7,1.5,1c0.1-0.2,0.2-0.4,0.2-0.6
		c0.4,0,1,0.1,1.9,0.1c0,0.2,0.1,0.7,0.2,1.1c-0.7,0.1-1.3,0.1-1.5,0.3c-0.2,0.3-0.2,0.8,0,1.1c0.1,0.2,0.3,0.4,0.6,0.6h0.1v0.1
		c0.1,0.1,0.3,0.3,0.4,0.4c0.2,0.4-0.4,0.7-0.4,1.2c0.1,1.1,0.4,1.6,1.7,1.6h0.1c0.2-0.5,0.7-0.9,1.4-1c1-0.2,1.9,0.2,2.1,0.9
		c0.1,0.5-0.2,1.1-0.8,1.5c0.1,0,0.2,0,0.2,0c0,0.3-0.1,0.5-0.2,0.8l0,0c0.9,0.1,1.7,0.1,2.7,0.2C299.8,269.5,300.4,268.1,299.4,267
		z M291.4,255.6L291.4,255.6L291.4,255.6L291.4,255.6z M295,255c0.1,0,0.2,0.1,0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1
		c-0.1,0-0.2-0.1-0.3-0.1C294.8,255.1,294.9,255,295,255z M291.9,257.3c-0.1-0.1-0.2-0.2-0.2-0.3c0.1,0,0.2-0.1,0.3-0.1
		c0.1,0,0.2,0.1,0.2,0.2C292.1,257.2,292,257.3,291.9,257.3z M292.4,256.5c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0.1-0.1,0.2-0.2
		c0,0.1,0.1,0.1,0.1,0.2C292.5,256.4,292.5,256.5,292.4,256.5z M293.2,255.4c0,0-0.2-0.1-0.2-0.2c0.2-0.2,0.4-0.5,0.6-0.7
		c0.2,0.1,0.3,0.2,0.5,0.3C293.8,255,293.5,255.2,293.2,255.4z M296.1,265c-0.4,0.1-0.8,0.2-1.4,0.3c-0.3-0.4-0.6-0.7-0.7-1
		c-0.3-0.7,0.3-1.5,1.2-1.8c0.9-0.3,1.9,0.1,2.2,0.8C297.6,263.9,297.1,264.7,296.1,265z M296.8,258.9c-0.6,0.3-1.3,0.5-1.9,0.1
		c-0.3-0.2-0.5-0.6-0.8-0.9c0.4-0.9,1.1-1.2,2-1.2c0.7,0,1.2,0.3,1.4,0.9C297.6,258.3,297.3,258.7,296.8,258.9z"
      />
      <path
        class="st4"
        d="M10.6,303.4c0.5-0.3,1-0.7,1-1.4c0-0.1,0.1-0.3,0.2-0.4l0,0c-0.4,0.4-1,0.7-1.6,1
		C10.3,302.9,10.4,303.2,10.6,303.4z"
      />
      <path
        class="st4"
        d="M186.4,127.8L186.4,127.8c0.5-0.1,0.9-0.1,1.4-0.2c-0.3-0.4-0.6-0.8-0.9-1.2c-0.4,0-0.8,0.1-1.3,0.1
		c-0.1,0.1-0.3,0.4-0.5,0.6c-0.7,0.6-1.3,0.7-1.8,0c0-0.1-0.1-0.1-0.1-0.2c0,0.3,0.1,0.5,0,0.8c-0.1,0.7-1,0.3-1.5,0.7
		c1.7,0.4,2.7,0,3.4-1.1c0.3-0.6,0.8-0.8,1.3-0.5C186.9,127.1,186.8,127.5,186.4,127.8z"
      />
      <path
        class="st4"
        d="M180,125.4c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.3-0.2-0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.4c0,0,0,0,0-0.1
		c-0.1-0.4-0.2-0.9-0.3-1.3c-1.3,0.5-1.3,0.6-1.1,1.8c-1.3,0.3-2.4,0.1-3.3-0.4c-0.4,0.5-0.7,0.8-0.8,1.2c-0.2,0.8-0.8,1.2-1.4,1.5
		c0.1,0.5,0,1.1-0.4,1.7l0,0c1-0.2,1.6-0.6,1.8-1.6c0.5,0.3,0.9,0.5,1.3,0.7h0.1c0,0,0,0,0,0.1c0.4,0,1-0.2,1.1,0.3
		c0,0.1-0.2,0.3-0.3,0.4c-0.6,0.1-0.8-0.3-0.8-0.7c0,0,0,0-0.1,0l0,0c-0.3,0.2-0.7,0.3-1,0.5c-0.1,0.1-0.1,0.3-0.2,0.5
		c0.4,0,0.7,0,1.2,0c-0.1,0.9-0.2,1.6-0.3,2.4c0.1,0,0.2,0.1,0.3,0.1c0.4-0.2,0.7-0.5,1.2-0.8c-0.1-0.2-0.3-0.4-0.4-0.9
		c1.2-0.5,1.7-0.5,1.8,0c0.1,0.4,0,0.8-0.6,1c-0.3,0.1-0.5,0.1-0.6,0.1c0.3,0.3,0.5,0.5,0.6,0.8c0.7-0.5,1.4-1,1.4-1.9
		c1.3-0.5,1-1.2,0.6-1.9c-0.3-0.6-0.1-1.2,0.2-2c0.5,0.4,0.9,0.6,1.1,0.8c0.3-0.3,0.5-0.6,0.8-0.9c-0.2,0-0.3,0-0.5,0
		C180.6,126,180.2,125.8,180,125.4z M175.3,126.4L175.3,126.4L175.3,126.4L175.3,126.4z M178.3,125.9c0,0,0.1,0,0.1,0.1l-0.1,0.1
		c0,0-0.1,0-0.1-0.1C178.2,126,178.3,126,178.3,125.9z M177.9,128.1c-0.1,0-0.3-0.1-0.4-0.1c0.1-0.2,0.3-0.5,0.4-0.7
		c0.1,0.1,0.3,0.1,0.5,0.2C178.3,127.7,178.1,127.9,177.9,128.1z"
      />
      <path
        class="st4"
        d="M170,120.4c0-0.1,0-0.2-0.1-0.2s-0.2,0-0.3,0.1s-0.2,0.3-0.2,0.4c0,0,0.2,0.1,0.3,0.1
		C169.8,120.7,169.9,120.6,170,120.4z"
      />
      <path
        class="st4"
        d="M209.1,90.5c0.5,0.4,1,0.8,1.7,1.3c-0.2-1-0.4-1.7-0.5-2.5c-1.1,0.7-2.4,0.9-3,1.9c-0.6,0.7-1.2,1.4-2.1,2.4
		c1.3-0.3,2.1-0.6,3-0.8C208.5,92.1,207.9,91.1,209.1,90.5z"
      />
      <path
        class="st4"
        d="M289.9,129.6c0,0.1,0,0.2,0.1,0.3h0.1c0.2,0,0.4,0.1,0.6,0.2c0.1-0.1,0.3-0.2,0.4-0.3
		c-0.1-0.3,0.1-0.7,0.8-0.9c0.2,0.1,0.5,0.3,0.7,0.5c0.5,0,1,0,1.5,0.2c0.1-0.2,0.1-0.2,0.1-0.3c0-0.5,0-1-0.1-1.5
		c-0.2,0-0.4,0-0.6,0c-1.8,0.1-2.7-0.3-3-1.3s0.2-1.8,1.7-2.7c1.3-0.8,1.6-2,0.6-3c-0.7-0.8-1.4-1.6-1.9-2.5c-0.8-1.3,0-2.8,1.7-3.5
		c1.5-0.6,3.2-0.1,3.9,1c0.7,1.3,0,2.9-1.6,3.6c-0.5,0.2-1,0.3-1.6,0.5c1.1,0.7,1.4,1.5,1.4,2.6c0,1.2,0.4,2.4,1.2,3.4
		c0.4,0.5,0.7,1.2,1.1,1.7l0,0c0.2,0.3,0.6,0.7,1,0.7c1.1,0.1,1.3,0.9,1.8,1.4c0.2,0.2,0.5,0.4,0.9,0.5c0.1,0,0.2,0.2,0.2,0.4
		c0,0.1-0.1,0.2-0.1,0.4c-0.4-0.1-0.8-0.2-1.2-0.3c-0.2,0.3-0.4,0.6-0.7,1c0.8,0.2,1.4,0.3,2.2,0.5c0.1,0.3,0.1,0.7,0.2,1.1
		c0.5-0.2,0.9-0.4,1.3-0.5c0-1.5,0.3-3,1.4-4.3c0.3-0.4,0.7-0.8,1-1.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.5,0.2-0.9,0.5-1.4,0.6
		c-0.1,0.6-0.7,1.2-1.5,1.4c-1,0.2-2-0.3-2.2-1.1c0-0.1,0-0.2,0-0.3c-0.4-0.1-0.7-0.3-0.8-0.7c-0.1-0.3-0.1-0.6,0-0.9
		c0-0.1,0-0.3,0.1-0.4c0.5-0.8,1.4-0.8,2.3-1.1c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.2,0.9-0.2,1.4-0.2c0.2,0,0.4,0,0.5,0.1
		c0.5,0.4,1,0.4,1.6,0.4v-0.2V124c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.3,0.3-0.4c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.1,0.6-0.2
		s0.4-0.1,0.7-0.2c0.4-0.1,0.8-0.3,1.2-0.4c0.1-0.2,0.2-0.5,0.3-0.8c0-0.1,0-0.1,0.1-0.2c0,0.1,0,0.1,0.1,0.1
		c0.2,0.6,0.6,0.8,1.1,0.9c0.1-1,0.9-1.9,2-2.3c0.6-0.2,1.2-0.3,1.8-0.3c-0.2-0.4-0.2-0.8-0.4-1.2c-0.1-0.2,0.3-0.7,0.6-0.8
		c0.3-0.1,0.8,0.1,1.1,0.3c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.6,0,1.1c0,0.2-0.1,0.4-0.1,0.6c0.4,0.2,0.7,0.5,0.9,0.8
		c0.2,0.3,0.3,0.6,0.5,0.9c0.2-0.2,0.3-0.3,0.4-0.4c0,0.2,0.2,0.5,0.1,0.6c-0.2,0.1-0.3,0.2-0.4,0.3c0.3,0.1,0.5,0.2,0.7,0.3
		c0-0.4,0.3-0.6,0.9-0.7c0,0,0,0,0-0.1l0,0c-0.8-0.5-1.7-2.3-1.8-3.5c0-0.2-0.2-0.4-0.3-0.7c0.2-0.3,0.6-0.8,0.9-1.2
		c0.3-0.4,0.6-0.8,1-1.1c0-0.3,0-0.7-0.1-0.9c-0.8,0.6-1.6,1.3-2.6,1.8c-0.5,0.3-1.3,0.4-1.9,0.5c-1.1,0.2-1.8-0.1-2.3-0.9
		c-0.3,0.9-1.1,1.6-2.2,1.9c-0.3,0.1-0.5,0.1-0.8,0.1c0.5,0.3,0.8,0.7,0.8,1.3c0.2,0.1,0.2,0.2,0.2,0.6c-0.1,0-0.2-0.1-0.3-0.1
		c0,0.3-0.1,0.7-0.3,1.2c-0.5-0.1-1.2-0.1-1-0.7c0.2-0.7,0-1.3-0.1-1.9c0-0.1,0-0.2,0.1-0.4c-0.2,0-0.4-0.1-0.6-0.2
		c-0.6-0.3-1.1-0.8-1.3-1.4c-0.2-0.9,0.4-1.9,1.3-2.5c0.3-0.2,0.6-0.3,0.9-0.4c0.4-0.1,1-0.1,1.5,0c-0.5-0.6-0.4-1.3,0-2
		c1.2-2.2,4.2-3.1,6.6-1.9c0.3-0.2,0.6-0.3,1-0.4c1.5-0.3,2.9,0.4,3.2,1.7c0.2,1.1-0.5,2-1.7,2.5c0.1,0.6,0.1,1.2,0.2,1.8
		c1.7-1.3,4-1.7,6.1-0.9c1,0.4,1.8,1,2.2,1.8c0.3-0.2,0.6-0.4,0.9-0.6c-0.6-0.9-0.1-1.8,0.2-2.6c0.2,0.3,0.2,0.7,0.3,1
		c0.1,0.3,0.3,0.5,0.5,0.6c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.9,0.7-1.9,1.9-2.1c0.6-0.1,1.2,0,1.6,0.3l0.1-0.1c0.1,0,0.2,0.1,0.3,0.1
		c0,0.1,0,0.3-0.1,0.4c0.2,0.2,0.3,0.4,0.3,0.7c0.1,0.7-0.3,1.3-0.9,1.7c0,0.2,0.1,0.3,0.2,0.5s0.2,0.3,0.2,0.4
		c0.1,0.1,0.1,0.3,0.2,0.4c0.4-1.3,2-2.1,3.7-1.6c-0.1-0.3-0.3-0.7-0.4-1s-0.2-0.7-0.3-1.1c-0.5,0.5-1.1,0.8-1.8,0.4
		c-0.3-0.2-0.5-0.5-0.5-0.9l0,0l0,0c0-0.2,0-0.4,0.1-0.6c0.3-0.7,1.1-1,1.7-0.5c0.4,0.3,0.6,0.7,0.9,1.1c0.2-0.3,0.4-0.6,0.7-0.9
		c-0.3,0-0.5,0-0.6,0s-0.2,0-0.3,0c-0.1-0.1-0.3-0.1-0.4-0.2c0-0.1,0-0.1-0.1-0.2s-0.2-0.2-0.3-0.4c0.1,0,0.1-0.1,0.2-0.1
		c0,0.2,0.1,0.3,0.1,0.5l0.1,0.1c0.2,0.1,0.3,0.1,0.5,0.2c0.1,0,0.1,0,0.2,0c0.7-0.1,0.4-0.5,0.4-0.9c0,0,0-0.1-0.1-0.1l0,0l0,0
		c-0.1-0.1-0.3-0.1-0.4-0.2c0,0,0-0.1-0.1-0.1H337h0.1l0,0h0.1c0.1,0.1,0.3,0.1,0.4,0.2c0,0.1,0,0.1,0,0.2c0.1,0.2,0.3,0.4,0.5,0.7
		c0.9-0.7,2-1.1,3.5-1.1c-0.9-1-1.3-2-0.7-3c0.5-0.9,1.3-1.7,2-2.6c-0.6-0.2-1.2-0.5-1.4-1.2c0.7-0.1,1.2-0.2,1.8-0.3
		c0.4,1.4,0.4,1.4,1.3,1.3l0.1-0.1c0-0.1,0-0.2-0.1-0.3c-0.2-0.8-0.2-1.6,0.1-2.3c-0.3-0.1-0.5-0.3-0.6-0.6c-0.1-0.5,0.4-1.1,1-1.3
		c0.3-0.1,0.7,0,0.9,0.1c0.2-0.2,0.4-0.3,0.7-0.5c0.9-0.6,1.5-1.3,1.7-2.3c0.1-0.4,0.2-0.8,0.4-1.2c0.1-0.5,0.2-1,0.4-1.6l0,0
		c-0.1,0.7-0.6,1.3-1.4,1.6c-0.5,0.2-1,0.3-1.5,0.1c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.3,0,0.8,0.1,1.4c-0.7-0.1-1.2-0.2-1.7-0.2
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.2-0.2,0.4-0.3,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.5,0.1,0.9-0.8,1.6c0.1,0.5,0,0.9-0.4,1.3
		s-0.9,0.8-1.4,1c-1,0.4-1.8,0.2-2.6-0.5c-0.1,0.1-0.1,0.2-0.2,0.3c-0.4-0.4-0.5-0.6-0.4-0.9c-0.1-0.1-0.2-0.1-0.4-0.2
		c-0.4,0.4-0.8,0.9-1.4,1.4c-0.6-0.6-1.5-0.9-1.7-1.7c-0.1-0.4-0.3-0.3-1.1,0c1.4,2.4,1.4,3.6-0.5,4.7c0.1,0,0.1,0.1,0.1,0.1
		c-0.2,0.3-0.4,0.5-0.6,0.7c-0.2-0.1-0.3-0.2-0.5-0.3c0.1-0.1,0.2-0.1,0.3-0.2c-0.4,0.2-0.8,0.3-1.2,0.5c0.1,0.2,0.2,0.5,0.3,0.7
		c0.3,0,0.6,0,0.9,0.2s0.5,0.6,0.8,0.9c-0.3,0.6-0.7,0.9-1.2,1.1c0,0.2-0.1,0.3-0.3,0.5c0,0-0.1,0.1-0.2,0.1
		c-0.5,0.8-1.2,1.4-2.2,1.7c0,0.1,0,0.2,0.1,0.2c-0.1,0-0.1,0-0.2,0c0-0.1-0.1-0.2-0.1-0.2c-0.2,0-0.4,0.1-0.6,0.1
		c-1.5,0.2-3-0.5-3.6-1.6c-0.7-1.3-0.2-2.7,1.1-3.8c0.3-0.2,0.6-0.4,0.8-0.6c-0.1-0.8-0.1-1.5-0.2-2.3c-0.8,0.2-1.6,0.2-2.2,0.1
		c-0.2,0-0.5-0.1-0.6-0.2c-0.6-0.2-1.1-0.5-1.7-0.9c0-1.5,0.2-2.9,2-3.8c1.5-0.8,2.7-0.3,3.9,0.5c0.2-0.3,0.5-0.7,0.8-1.1
		c-1.2-0.1-2.2-0.4-2.6-1.3c-0.1-0.1-0.1-0.3-0.1-0.4c-0.3,0.3-0.6,0.5-0.9,0.7c-1.2,0.7-2.3,0.6-2.9-0.4c-0.6-0.9-0.4-1.9,0.5-2.7
		c0.4-0.4,0.9-0.7,0.6-1.3c-0.1-0.4,0.4-0.8,1-0.8s1,0.4,0.8,0.8c-0.3,0.6,0.1,0.8,0.4,1.1c0.3,0.3,0.5,0.7,0.6,1.1
		c0.4-0.9,1.4-1.3,3.7-1.6l0,0h-0.1c-1,0.2-1.9-0.2-2.1-1c-0.2-0.7,0.5-1.6,1.4-1.8c0.1,0,0.1,0,0.2,0c-0.7-0.4-1.3-0.7-1.9-1
		c-0.3,0.1-0.7,0.3-1.1,0.4c-1,0.2-1.9-0.1-2.4-0.8c-0.3-0.5-0.7-0.9-1-1.3c0.6-0.5,1.2-1,1.8-1.4c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.4,0.1-1.1,0.1-1.3,0.3c-0.8,0.8-1.9,0.8-2.8,1c-1.4,0.3-2,0.1-2.7-1c-0.1-0.2-0.2-0.4-0.3-0.6c-0.9,0.7-1.7,1.3-2.5,1.9
		c-0.1-0.1-0.2-0.1-0.3-0.2c0.3-0.5,0.5-0.9,0.7-1.4c0-0.1-0.2-0.2-0.3-0.3c-0.1,0.2-0.1,0.5-0.3,0.6c-0.7,0.6-1.5,1.2-2.2,1.8
		c1.2,0.7,2.4,1.4,3.6,2.1c0.1-0.2,0.3-0.4,0.5-0.5s0.4-0.2,0.5-0.3c0.2,0.1,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.3,0.2,0.4
		c-0.4,1.1,0.4,2.2-0.4,3.5c-0.4-0.4-0.5-0.7-0.8-0.9c-0.7,0.4-1.1,1-1,1.7c-0.2,0-0.5,0.1-0.5,0.2c-0.3,1-1.4,1.3-2.2,1.9
		c-0.5,0.4-1.2,0.3-1.3,0.5c-0.5,0.8-0.9,0-1.3,0.1c-0.8,0.2-1.5-0.2-2.2-0.3c-0.1,0-0.2,0-0.3,0c0,0.6-0.1,1.2-0.1,1.8
		c-0.1,0-0.2,0-0.3,0c-0.2-0.6-0.4-1.2-0.7-1.8c-0.2-0.4-0.2-1.2-0.9-1.2v-4.5c-0.6,0.3-1.2,0.7-1.9,1c0-0.7,0-1.3,0-1.9
		c1.1-0.5,1.5-0.7,1.9-0.3v-1.5c0,0,0,0,0,0.1c-0.2-0.1-0.3-0.2-0.5-0.2c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0.1,0.1,0.2,0.1v-5
		c-0.8,0.1-1.6-0.1-2.1-0.6c-0.4,0.7-1,0.9-1.8,0.7c-0.3-0.1-0.8,0.2-1.2,0.4c-0.5,0.2-1,0.4-1.6,0.7c0,0.2,0,0.6,0,1.1
		c-0.7-0.3-1.2-0.6-1.9-0.9c-0.2,0.4-0.3,0.7-0.5,1c-0.6-0.1-0.8-0.8-1.3-1c-0.3,0.4-0.8,0.7-1.3,0.7c-0.9,0.1-1.9-0.3-2-1
		c-0.2-0.7,0.6-1.7,1.5-1.9c-0.1-0.6-0.2-1.2-0.4-1.7c0-0.1-0.1-0.3,0-0.3c1-0.8,0.1-1.5,0-2.2c0-0.2-0.1-0.4-0.1-0.5
		c-1-0.2-1.3,0.5-1.8,0.9c-0.1-0.3-0.2-0.7-0.3-1c-1.4,0.4-1.4,0.4-2.4-0.5c-0.1,0.3-0.2,0.5-0.3,0.7c-0.1,0.5-0.5,0.8-1,0.8
		c-0.3,0-0.7-0.3-0.8-0.5c-0.2-0.4,0.1-0.8,0.6-1c0.3-0.2,0.6-0.4,0.8-0.8c-0.3,0-0.5,0-0.8,0c-0.2,0-0.5,0.1-0.7,0.2
		c-0.3,0.5-0.7,1-1,1.5c0.3,0.2,0.5,0.4,0.7,0.5c-0.4,0.6-1.5-0.3-1.7,0.8c0.3,0.1,0.7,0.3,1.2,0.5c-0.8,0.5-1.4,0.9-2.1,1.3
		c1,0.1,1.8,1.6,3.2,0.4l0,0c0,0,0,0,0.1,0V81c0.9-0.1,1.8-0.2,2.9-0.3c0.2,0.7,0.4,1.5,0.6,2.4c-0.1,0.1-0.3,0.2-0.6,0.3
		c-0.2-0.5-0.4-1-0.6-1.5c-0.4-0.2-0.9-0.3-1.4-0.5c-0.2,0.7-0.5,1.5-0.7,2.2c0.3,0.2,0.9-0.5,1.2,0.2c0.2,0.5,0.9,0.7,1.7,0.6
		c0.7-0.1,1.1,0.2,1.3,0.8c0.4,0.7,0.9,1.4,1.3,2c-0.3,0.5-0.6,0.8-0.8,1.2c-0.3,0.9-0.4,1.1-0.9,1.3c-0.1,0.2-0.3,0.4-0.5,0.6
		c0.1,0.2,0.2,0.4,0.4,0.7c0.6,0,1.4,0,2.1,0c0.1-0.4,0.2-0.8,0.3-1.4c0.6-0.1,1.3-0.2,2.2-0.3c0.1-0.2,0.3-0.5,0.6-0.9
		c0.2,0.3,0.4,0.5,0.7,0.8c-0.2,0.1-0.4,0.2-0.5,0.3l0,0c-0.1,0-0.1,0.1-0.2,0.1l0,0c-0.5,0.3-0.7,0.7-0.7,1.3
		c0.4-0.1,1-0.1,1.6,0.1c-0.5,0.4-0.9,0.9-1.4,1.3c0,0.5-0.3,1-1.3,1.2c0,0,0,0-0.1,0.1c1.4,0.1,2.5,0.2,2.6,1.5V95c0,0,0,0,0,0.1
		c0,0,0,0-0.1,0c-0.2,0.7-0.4,1.5-0.6,2.2c1.6-0.3,2.8-2,4.7-1.1v0.1h0.1c0.1,0,0.2,0.1,0.3,0.1c0.5,0.1,0.9,0.2,1.4,0.3
		c-0.2,1.1,0.6,2.5-1.5,3.1c-0.1,0.5-0.2,0.9-0.2,1.4c0.1,0,0.2,0.1,0.3,0.1c0.4-0.5,0.9-0.9,1.4-1.5c0.6,0.4,1.1,0.8,2.1,0.8
		c0.3,0,0.7,0,1,0.1v4.3c-0.4-0.1-0.8-0.2-1.2-0.3c-0.4-0.3-0.7-0.7-1.1-1c-0.4,0.3-0.7,0.5-1.1,0.8c-1.3-0.5,0.6-2-0.9-2.4
		c-0.1,0.3-0.1,0.7-0.2,1.1c-0.9,0.3-1.3-0.3-2-0.6c0.3-0.5,0.7-1,1-1.6c-1,0-1.4,0.6-1.9,1.2c0.4,0.6,0.8,1.2,1.1,1.8
		c-0.5,0.2-0.9,0.4-1.3,0.6c0,0.1,0,0.2,0,0.3c1.1,0,1.8,1,3.1,0.6h-0.1h0.1c0,0-0.1,0-0.1,0.1c0.4,0.2,0.9,0.4,1.3,0.7
		c0,0-0.1,0.2-0.4,0.5c0.6,0.1,1,0.1,1.5,0.1c0.3,0.5,0.7,1.1,1.1,1.8c0.3-0.3,0.7-0.4,1-0.4v2c0,0,0-0.1,0.1-0.1s0.2,0,0.3,0
		l-0.1,0.1c-0.1,0-0.2,0-0.3-0.1v4.4c-0.4-0.1-0.7-0.3-1.1-0.4c-0.1,0.4-0.2,0.7-0.3,1.1c-0.7-0.3-1.4-0.5-1.9-1l-0.1-0.1
		c-0.4,1.4-2.5,2.5-4,2.2c-1.8-0.3-2.9-1.7-2.4-3.3c0.2-0.7,0.7-1.2,1.3-1.6c0-0.2,0-0.4,0-0.6c-0.2,0-0.4-0.1-0.6-0.1
		c-1.1,1-2.7,1.4-4,0.8c-1.1-0.5-1.6-1.7-1.2-2.7c-0.1,0.1-0.2,0.1-0.3,0.2c0.1-0.7,0.1-1.2,0.2-1.8c-0.6-0.1-1.3-0.3-2.1-0.4
		c-0.2-0.4-0.4-0.9-0.6-1.4c0.4-0.6,0.8-1.1,1.2-1.7c-1.2-0.7-1.6,0.3-2.3,0.7c-0.9-0.5-1.8-0.9-2.8-1.5c0.2-0.3,0.4-0.5,0.7-0.9
		c-0.3,0-0.6,0-0.9,0c0.1-0.3,0.2-0.6,0.3-0.7c-0.5-0.5-0.9-1-1.4-1.4c-0.3-0.2-0.7-0.4-1.1-0.5c-0.5-0.1-1-0.2-1.6-0.3
		c-0.1,0.2-0.3,0.4-0.5,0.6c0.5,0.1,0.9,0.5,1.1,1c0.2,0.9-0.4,1.7-1.5,2s-2.1-0.2-2.3-1c-0.1-0.6,0.2-1.2,0.8-1.6
		c-0.2-0.1-0.3-0.3-0.2-0.7c0.2-0.7,0.3-1.3,0.5-2c0.2-0.8,0.3-1.5-0.1-2.4c-1.3,0.5-2.6,1-3.7,1.5c0.1,0.1,0.1,0.2,0.2,0.4
		c-0.5,0.4-1,0.7-1.4,0.2c-0.1-0.1,0-0.6,0.2-0.7c0.3-0.2,0.6-0.2,0.8-0.1c0.2-1.1,1.1-1.9,2.7-2.4c-0.4-0.1-0.6-0.2-0.8-0.2
		c0.1-0.2,0.3-0.4,0.5-0.5c-0.2,0-0.3-0.1-0.5-0.1c0,0,0,0,0-0.1c-0.5,0.1-1.2,0.6-1.7,1.3c-0.2-0.1-0.5-0.2-0.8-0.3
		c0.3-0.3,0.5-0.5,0.9-0.8c-0.5-0.1-0.8-0.2-1.1-0.3c0-0.6,0-1.2,0-1.7c-0.8-0.2,0.3-0.9-0.4-1.2c-1.4,0.8-2.4,1.8-3,3.1
		c0.2-0.3,0.5-0.5,0.9-0.7c0.8-0.4,1.3-0.2,2.4,0.8c-0.4,0.4-0.6,0.9-1,1.2c-0.5,0.4-1.2,0.6-1.8,0.3c-0.2-0.1-0.5-0.3-0.6-0.6
		c0,0.1,0,0.1,0.1,0.2c0.1,0.5,0.2,1,0.4,1.8c-0.6-0.2-0.9-0.4-1.2-0.5c-0.5,0.4-0.9,1.6-1.8,0.5c-0.6-0.7-0.4-1.3,0.7-1.9
		c-1.6-0.1-1.9,0.1-2.5,1.1c-0.2,0.4-0.4,0.7-0.9,0.5s-0.4-0.6-0.1-0.9c0.1-0.1,0.2-0.2,0.2-0.2c-0.3-0.5-0.6-1-0.9-1.5
		c-0.7-1.2-1.4-1.2-2.6-0.2c-0.1,0.1-0.2,0.3-0.3,0.4c0.2,1.1,1,2.2-0.1,3.4c0-0.2-0.1-0.5-0.2-0.9c-0.5,0.6-0.8,1.1-1.2,1.5
		c0-0.3,0.1-0.7,0.1-1c0.1-0.7,0.1-1.3,0.1-2c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0.3-0.5,0.6-0.7,1s-0.2,0.8-0.4,1.2c-0.4,1-1,1.3-2.1,1
		c-0.3-0.1-0.6-0.3-1-0.3c-0.5-0.1-1,0-1.2,0c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.3,0.9,0.8,1.3,1.2c0.4,0.4,0.3,0.5-0.6,1.4
		c1.1,1.2,1.1,1.3,0.5,2.5c-1.1-0.5-1.4-1.2-1.2-2.2c-1-0.1-1.7-0.4-2.2-0.7c-0.1,0.5-0.2,1-0.3,1.5c1.1,0.4,0.7-0.8,1.3-1
		c0.8,0.2,0.7,0.9,0.8,1.6c-1,0.2-2,1.2-2.8-0.2h-0.1c0.1,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0,0.5-0.1,0.5c-0.2,0.1-0.7,0.3-0.8,0.2
		c-0.4-0.3-0.9-0.5-1.4-0.6c-0.1,0-0.2,0-0.3,0c-0.8,0.3-0.7,1.4-1.8,1.5c-0.1,0-0.2,0.2-0.3,0.4c-0.6,1.7-1.3,2.3-2.8,2.4
		c-0.1,0-0.2,0-0.3,0c0.1,0,0.2,0.1,0.3,0.1c-0.2,0.1-0.3,0.3-0.4,0.3c0,0-0.2-0.1-0.2-0.2s0.1-0.2,0.1-0.3
		c-1.1-0.1-1.8-0.8-2.2-2.2c0-0.1-0.1-0.2-0.3-0.4c-0.6,0.3-1.3,0.6-2,0.9c-0.7-0.7,0.2-1,0.7-1.6c-0.7-0.5-1.5-1-2.4-1.6
		c-0.2,0.4-0.4,0.7-0.4,0.9c0.6,3-0.6,4.2-4.2,4.4c-0.2,0-0.3,0.1-0.6,0.2c0,0.2,0,0.4,0,0.6s0.1,0.4,0.2,0.6
		c0.3-0.1,0.6-0.3,0.9-0.4c-0.6,0.8-1.2,1.5-1.9,2.3c-0.9,1.1-2.2,1.6-3.6,1.6c-0.8,0.3-1.7,0.4-2.5,0.1c-1.1-0.4-1.7-1.6-1.4-2.6
		c0.1-0.3,0.2-0.5,0.4-0.8c0-0.1,0-0.2-0.1-0.3c-1.1,0.5-2.1,1.2-3.2,0.9c-0.2,0.3-0.5,0.5-0.7,0.8c0-0.1,0-0.1,0-0.2
		c-0.2,0.4-0.5,0.7-0.7,1s-0.3,0.6-0.5,0.8c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c1.7-0.4,3.4,0.5,3.7,1.9s-0.8,2.9-2.5,3.3
		c-1.8,0.4-3.5-0.5-3.8-1.9c-0.2-1,0.3-2,1.3-2.7c-0.1-0.1-0.3-0.1-0.5-0.3c0.1-0.2,0.3-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.3
		c0.3-0.3,0.7-0.7,1-1.1c-0.4,0-0.7,0-1.2,0l-0.1,0.1c-0.5,0.4-1.1,0.6-1.7,0.2c-0.5-0.4-1-0.9-0.6-1.6c0.3-0.5,0.5-1.1,0.7-1.7
		s0.5-0.9,1.1-0.9c0.4,0,0.9,0.4,1,0.7c0.1,0.3,0.3,0.7,0.4,1c0.1-0.2,0.2-0.3,0.3-0.3c0.3,0,0.6,0.2,1,0.4c0.7-0.1,0.6-0.2,0.6-1
		c0-0.4,0.3-0.8,0.4-1c-0.2-0.2-0.5-0.4-0.6-0.7c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.3-0.1-0.5c-0.7,0.1-1.2,1-2,0.4
		c-0.4-0.4-0.7-0.9-1-1.3c-1.5,1.3-2.8,1.5-3.8,0.9c-0.5,0.1-1.1,0.1-1.7,0.2c0,0.7-0.4,1.3-1.3,1.6l0,0c0.8,0.7,0.6,1.5,0.2,2.4
		c-0.3,0.5-0.8,0.8-1.4,1l0,0c0.6,0.4,0.5,0.8-0.3,1.9c-0.3,0-0.5,0-0.7-0.1v0.1c-0.3,0.1-0.6,0.1-0.8,0.2c0-0.1,0-0.1,0-0.2
		c0.2,0,0.4-0.1,0.6-0.1c-0.7-0.2-1-0.4-1-1c0-0.5,0.3-0.8,0.8-1h0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.3-0.7-0.8-1.2-1.2
		c-0.1,0-0.2,0-0.4,0c-0.2,0.1-0.4,0.2-0.7,0.3c-0.5,0.1-1-0.1-1.3-0.4c-0.2,0-0.3,0-0.5-0.1c-1.1-0.8-1.2-2-1.6-3c0,0,0,0-0.1,0
		v-0.1c-0.1,0-0.2-0.1-0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0
		c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0,0,0.1l0,0c0,0.1,0,0.2,0,0.2s0,0,0.1,0l0,0c1.6-0.9,3.3-1.2,5.3-1.2c-0.1,0.3-0.3,0.6-0.3,0.9
		c0,0.2,0.3,0.5,0.5,0.9c0.4-0.6,0.6-1,0.9-1.4c0.3,0.1,0.6,0.1,0.9,0.2l0.1-0.1c0.2-0.2,0.6-0.2,0.9-0.4c0.1-0.5,0.2-1,0.4-1.4
		c0-0.1,0.1-0.2,0.2-0.3c-0.2-0.1-0.4-0.2-0.5-0.4c0-0.2,0.3-0.5,0.5-0.5s0.4,0.1,0.7,0.3c0.5-0.3,1-0.4,1.5-0.4
		c0.5-0.9,0.8-1.2,2.1-1.6l0,0c0,0,0,0,0.1,0l0,0l0,0c0.3,0.5-0.1,0.9-0.6,1.2c-0.3,0.2-0.6,0.3-0.9,0.5c0.2,0.1,0.5,0.2,0.7,0.4
		c1.2-0.1,2.1,0.6,2.6,1.8c0.3-0.1,0.6-0.3,0.9-0.4c0.8-0.4,1.6-0.6,2.4-0.3c0.4,0.2,0.9,0.1,1.4,0.1c0.6,0,1,0.2,1.1,0.4
		c0.2-0.7,1-1.2,1.9-1s1.3,0.9,0.9,1.7c-0.1,0.3-0.4,0.5-0.7,0.9c0.2,0.1,0.4,0.3,0.6,0.5c0.1,0.1,0.3,0.3,0.4,0.5
		c1-0.5,2.1-0.9,3.2-1.4c0.2-0.6,0.5-1.4,0.8-2.3c-0.7-0.2-1.5-0.4-2.1-0.7c-0.6-0.3-1-0.9-1.5-1.3c-0.4-0.3-0.4-0.7-0.2-1.1
		c0.7-1.3,1.6-2.5,3.5-2.7c1.7-0.2,2.8,0.5,3.5,1.9c0.5-0.3,0.9-0.6,1.4-0.9c-1.8-0.9-2.6-2.1-1.5-3.8c0.9-1.3,2.1-1.4,4.8-0.7
		c0.2-0.5,0.3-1,0.5-1.6c-0.9,0.2-1.7,0.6-2.5,0.6s-1.6-0.3-2.5-0.5c-0.5,0.3-1,0.9-1.6,1.1c-0.7,0.3-1.4,0.3-2.3,0.4
		c0,0.4-0.5,1,0.3,1.6c0.4,0.2-0.5,1.4-1.4,1.7c-0.7,0.2-1.4,0.3-2.2,0.5c-0.6,1.2-1.5,2.3-3,2.9c-0.3-0.3-0.7-0.7-1.1-1.1
		c0.1-0.4,0.3-1.1,0.5-1.7c-0.7,0.2-0.4-0.3-0.4-0.6c-0.2,0-0.3,0-0.5-0.1c0.1-0.4,0.4-0.8,0.3-1.2c0-0.4-0.3-1-0.5-1
		c-1.2,0.1-1.7-0.9-2.6-1.3c-0.6,1.5-1.7,2.2-3.5,2.2c-0.7,0-1.4,0.6-2.2,0.3c0.1-0.2,0.2-0.4,0.3-0.6c0.3,0.1,0.6,0.2,1,0.3
		c-0.7-1.1-1.5-1.9-2.9-2.2c0.4,0.6,0.7,1.2,1,1.7c-1.3,0.9-1.3,0.9-2.5,0.2c-0.5,0.5-1.1,0.9-2,0.6c-0.7-0.2-1,0.1-0.8,1.1
		c-0.7,0.5-1.5,1-2.3,1.5c-0.2,0.1-0.4,0.3-0.4,0.5c-0.2,0.8-1,0.8-1.9,1.1c0.2-1,0.6-2-0.4-2.6c-1.9,1.2-2,1.3-3.1,3.1
		c-0.4,0-0.8-0.1-1.3-0.1c0.1,1,0.1,1.9,0.2,3c-0.7-0.1-1.1-0.2-1.6-0.3c-0.5,1.2-3,1.8-1.8,3.6c-0.4,0.3-0.7,0.5-1.1,0.8
		c-0.3-0.5-0.6-0.9-1-1.4c-0.1,0-0.3,0.1-0.4,0.1c0,0.4,0,0.8,0,1.1c0,0.6,0,1.2-0.7,1.5c-0.4-0.7-0.8-1.3-1.1-1.9
		c-0.5,0.1-1,0.2-1.4,0.2c-1.1,0.1-1.2,0.2-1.6,1.1c-0.1,0.3-0.5,0.5-0.8,0.7c0,0-0.2-0.1-0.3-0.1c0.2-0.1,0.3-0.3,0.6-0.5
		c-1.2-0.2-1.8,0.5-2.5,0.9c0.4,0.1,0.7,0.3,1.2,0.5c-0.3,0.1-0.5,0.2-0.6,0.2c0.4,0.2,0.9,0.4,1.5,0.7c0.2-0.6,0.3-1,0.5-1.5
		c0.6,0.2,1.2,0.4,1.7,0.7c0.4-0.3,0.8-0.5,0.9-0.6c0.8,0,1.2,0,1.7,0c0.5,0.6,0.9-0.2,1.3-0.3c0.3,0.3,0.7,0.5,1,0.8
		c0.1-0.9,0.8-1.9,1.7-2.3c1.1-0.4,2.2-0.5,3.2-0.1c0.8,0.3,1.5,0.8,2.2,1.3c0.5,0.4,0.6,1.3,0.3,2.1c0.5-0.2,1-0.4,1.7-0.7
		c-0.3,0.5-0.6,0.7-0.9,0.9c0.6,0.2,1,0.6,1.5,0.9c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1,0,0.2,0.1c0.3-0.2,0.6-0.4,0.9-0.6
		c0.4-0.3,0.9-0.5,1.4-0.8c0.5,0.1,0.7,0.4,0.4,1c-0.1,0.2-0.3,0.5-0.5,0.7c-0.9,0.9-1.6,1.8-1.6,3c0,0.2-0.4,0.4-0.5,0.5
		c0.4,0.5,0.9,0.9,1,1.4c0.1,0.6-0.4,1.2-0.7,1.9c-0.1,0-0.1,0-0.1-0.1l0,0c-0.6,0-1,0-1.2-0.1c-0.2,0.3-0.1,0.6,0.1,0.9
		c0.1,0,0.2,0,0.4,0c1.4,0.5,1.4,0.5,2.7,0.4c0.7,0.9,1,1.2,0.8,1.6c0.2,0.1,0.3,0.1,0.5,0.2c0.5-0.5,1-1,1.4-1.5
		c-0.1-0.1-0.2-0.2-0.2-0.4c-0.2-0.7,0.4-1.4,1.3-1.6c0.2,0,0.4-0.1,0.6,0c1.1-0.9,2.3-1.5,4-1.1c1.6,0.5,2.1,1.5,2.1,2.9
		c0.1,0,0.2,0.1,0.2,0.1c0.4,0,0.6,0,0.9,0c0.6-0.2,1.1-0.7,1.6-1c0.2,0.2,0.4,0.5,0.3,0.6c-0.3,0.5-0.6,0.9-1,1.4
		c0,0.1,0,0.1,0,0.2c0.1,0.1,0.3,0.2,0.4,0.3c0.3-0.2,0.6-0.3,1.1-0.6c-0.4,0.5-0.6,0.7-0.8,0.8c0.5,0.3,0.9,0.7,1.4,1
		c0.3,0.2,0.9-0.1,0.9-0.5c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.9-0.1-1.7,0.3-2.4c0,0,0,0-0.1,0l0.1-0.1c0.4-0.7,1-1.2,1.8-1.6
		c0.1-0.3,0.2-0.6,0.5-0.9c0.4-0.4,0.8-0.7,1.3-1.1h0.1c-0.1-0.1-0.1-0.1-0.2-0.3c0,0,0,0-0.1,0c0,0-0.1,0-0.1-0.1
		c-0.2,0-0.5-0.1-0.7-0.1c0-0.1,0.1-0.2,0.1-0.3c0.2,0.1,0.4,0.3,0.6,0.4h0.1v0.1c0.2,0.1,0.5,0.2,0.7,0.4h0.1l0,0
		c1-0.2,1.6-0.7,2.1-1.4c0.2-0.3,0.4-0.7,0.7-0.9c1.3-1.4,3.6-2,5.5-1.5c0.2,0.1,0.3,0.1,0.5,0.2c0-0.2,0.2-0.4,0.5-0.5
		c0.1-0.1,0-0.4,0-0.6s0-0.4,0.1-0.8c0.7,0,1.3,0.1,1.9,0.1c0.3-0.7,1-1.3,1.8-1.5c1.3-0.3,2.6,0.4,2.8,1.5c0,0.1,0,0.2,0,0.3
		c0,0,0,0.1,0.1,0.1c0.1,0.2,0.2,0.4,0.3,0.6c0.6,0.2,1.1,0.7,1.2,1.4c0-0.1,0-0.2,0.1-0.3c0.2-0.6,0.7-0.8,1.5-0.7
		c1.1,0,2,0.2,2.5,1c-0.6,0.4-1.1,0.4-1.6,0c-0.5,0.3-1,0.6-1.5,0.9c-0.4-0.1-0.8-0.3-0.9-0.5c0.1,0.8-0.3,1.5-1,2
		c-0.1,0.4-0.5,0.9-1.2,1.2c-0.6,0.3-1.5,0.3-2-0.2c-0.3-0.3-0.5-0.6-0.7-0.9c-0.6,0-1.1,0-1.7,0c0,0.1,0,0.3,0,0.4
		c0,0.2-0.1,0.3-0.1,0.5l0,0c0.2,0.1,0.5,0.3,0.6,0.5c0.6,0.7,0.3,1.8-0.4,2.6c0.3,0.1,0.5,0.4,0.8,0.6c0.7,0.1,1.3,0.6,1.4,1.1
		c0.1,0.8-0.6,1.7-1.6,1.9c-0.5,0.1-1,0-1.4-0.2c-1.5,0.3-2.1-0.1-2.8-1.5c-0.6,0.1-1.3,0.3-1.9,0.3l0,0c0.1,0.2,0.2,0.4,0.2,0.6
		c0,0.3,0,0.7-0.2,0.9c0.5,0.2,1,0.4,1.4,0.7c0.9,0.7,1.4,1.7,2.1,2.6c0.2-0.3,0.4-0.7,0.5-1l0,0c0,0,0,0,0-0.1
		c-0.1,0-0.2,0-0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0-0.1s0.1-0.1,0.1-0.2c0,0.1-0.1,0.2-0.1,0.2l0,0c0,0.1,0,0.1,0,0.2
		c0,0,0,0,0.1,0l0,0c1.2-0.2,2.3-0.8,3.5-0.3c0.6,0.3,1,0.6,0.8,1.2c-0.1,0.5-0.3,0.9-0.4,1.4c-0.4-0.2-1-0.2-1.7-0.2
		c-1,0-1.9-0.1-2.9-0.1l0,0c-0.2-0.1-0.4-0.2-0.6-0.3c-1,1.4-2.3,2.5-4.3,2.6c-0.2,0-0.4,0-0.6,0c-0.4,0.4-1,0.7-1.7,0.9
		c-0.4,0.1-0.9,0.1-1.3,0c0.2,0.6,0,1.2-0.4,1.8c0.2,0.3,0.2,0.7,0.2,1.1c0,0.4,0,0.8,0.1,1.1c1.2-0.7,2.6-0.8,3.8-0.2
		c0,0,0,0,0.1,0h0.1c0.5,0.2,0.9,0.5,1.2,0.9c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0,0.1,0,0.2c0.1,0.3,0.1,0.6,0.1,0.9
		c0.6-0.1,0.8,0.1,1.3,0.8c0.3,0,0.7,0,1.1,0.2c0.4,0.1,0.9,0,1.4,0.1c0.9,0.1,1.5,0.5,1.8,1.2v0.1c0.2,0.1,0.4,0.2,0.7,0.3
		c0.3-0.3,0.5-0.6,0.8-0.8c-0.4-0.4-1-0.6-1.4-0.9c-0.6-0.5-1.3-0.6-2-0.5c-1-1,0.4-2.7-1.2-3.4c-0.7,0-1.3,0-1.8-0.1
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.1-0.3-0.3-0.5-0.4c-0.5-0.2-0.8-0.6-1-1.1c-0.2-0.8,0.3-1.9,1.2-2.4c1.2-0.7,2.5-0.6,4.1,0.4
		c2.5-1.4,5-2,7.5-1.2c0.4,0.3,0.8,0.6,1.1,1c0.1,0.1,0.2,0.1,0.2,0.2c0.3-0.3,0.5-0.6,0.8-0.9c0.6,0.2,1.2,0.3,1.6,0.4
		c0.4-0.3,0.7-0.4,0.9-0.7c0.3-0.3,0.6-0.8,0.5-1.1c-0.3-0.7-0.1-1.5-0.6-2c0.4-0.6,0.7-1.1,1-1.6c-0.2-0.1-0.4-0.1-0.5-0.1
		s-0.2,0.1-0.3,0.1c-0.9,0.2-1.8-0.4-1.9-1.2c-0.1-0.4,0.1-0.8,0.4-1.2c0-0.2,0-0.4,0-0.6c-0.3,0.3-0.6,0.4-0.9,0.7
		c-0.3-1.1-1.4-0.3-2.1-0.5c-0.5,0.4-0.6,1.1-1.5,1.3c-0.2-1.1,0.9-1.7,1.3-2.5c-0.2-0.1-0.4-0.2-0.7-0.4c-0.3,0.3-0.5,0.5-0.8,0.7
		s-0.8,0.3-1,0.2c-0.2-0.1-0.3-0.5-0.3-0.8c0.2-0.5,0.5-1,0.8-1.6c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.2-0.4
		c0.6,0.2,1,0.3,0.8,0.8c0.2,0.1,0.4,0.1,0.6,0.1c1.1-0.3,1.4,0.2,1.7,0.8c-0.2,0.4-0.3,0.7-0.6,1.3c0.7-0.4,1.1-0.6,1.5-0.7
		s0.9-0.2,1.4-0.3c-0.1-0.3-0.2-0.5-0.2-0.7c-0.1-0.1-0.2-0.1-0.4-0.2c0.1-0.1,0.1-0.2,0.2-0.3l0,0l0,0c0.1-0.2,0.3-0.4,0.4-0.5
		c0.2-0.1,0.5,0.1,0.9,0.2c0-0.2,0-0.3,0-0.5l0,0v-0.1c-0.5-0.2-1.2,0-1.2-0.8c0.7,0,1.1,0.3,1.2,0.8h0.1l0,0c1-0.2,1.3-0.3,1.6,0.1
		c0.2-0.9,0.4-1.8,0.6-2.8c1.4-0.1,2.6,0.5,2.9,1.3c0.1,0.2,0.1,0.5,0.1,0.8c0.5,0.6,1.6,0.2,1.9,1c-1.8,0.2-2.3,0-1.9-1
		c0,0,0,0.1-0.1,0.1c-0.2,0.3-0.5,0.6-0.8,0.8c0.4,0.4,0.6,0.8,0.7,1.3c0,0,0,0,0.1,0l-0.1,0.1c0.5-0.3,0.9-0.5,1.4-0.8
		c0.6,0.5,1.1,0.9,1.5,1.3c0.3-0.4,0.7-0.7,1-1.1c0.2,0.1,0.5,0.2,0.5,0.3c0.4,0.8,1.5,1.2,1.7,2.1c0,0.1,0.2,0.3,0.3,0.3
		c1.3-0.4,1.2,0.6,1.7,0.9c-0.2,0.1-0.4,0.2-0.5,0.3l0,0l0,0c-0.4,0.3-0.3,0.4-0.2,1c0.4-0.2,0.9-0.1,1.3-0.6c0.6-0.7,1-0.7,1.6-0.2
		c0.2-0.1,0.3-0.1,0.5-0.2c-0.2-0.4-0.2-0.6-0.4-0.9c0,0-0.3,0-0.5,0.1l0,0l-0.1,0.1c0,0.1,0,0.3-0.1,0.4c-0.1,0-0.2,0-0.2-0.1
		c0.1-0.1,0.2-0.2,0.3-0.3v-0.1c0,0,0,0,0.1,0c0.1-0.5,0.2-1.1,0.3-1.6c-0.1-0.1-0.1-0.2-0.2-0.4c-0.3-1,0.4-1.9,1.6-2.2
		c0.4-0.1,0.9-0.1,1.2,0c0.2-0.1,0.4-0.1,0.6-0.1c1.5-0.2,3.1,0.4,3.7,1.5c0,0,0,0.1,0.1,0.1c0.1-0.2,0.3-0.3,0.5-0.4
		c-0.3-0.2-0.5-0.3-0.8-0.6c-1.5-1.4-1.8-3.7-0.6-5.5c0.2-0.4,0.5-0.7,0.9-1.3c-2.5,0.3-4.3-0.4-5.6-2.1c0,0.3-0.1,0.6,0,0.8
		c0.3,0.8,0.4,1.6,0.2,2.3c0,0,0,0.1,0.1,0.1h-0.1c-0.2,0.6-0.5,1.2-1.1,1.8c-0.4,0.4-0.5,0.8-0.4,1.3c0,0.5-0.1,1-0.3,1.3
		c0.1,0.1,0.2,0.2,0.3,0.3c-0.2,0-0.3-0.1-0.4-0.1c-0.3,0.5-0.8,0.8-1.4,1c0.3,0.2,0.5,0.6,0.2,0.9c-0.5,0.6-0.3,1,0,1.5
		c-0.1,0.1-0.3,0.1-0.4,0.2c-0.4-0.9-0.8-1.7-1.2-2.5c-0.3,0-0.6-0.1-0.8-0.2c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.2,0.1-0.3,0.1
		c-0.1-0.1-0.1-0.2-0.2-0.4c-0.9-0.4-1.5-1-1.2-2.2c0-0.2-0.1-0.4-0.2-0.7l0,0c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1,0.4-0.1,0.8-0.3,1.5
		c-0.5-0.5-0.9-0.8-0.9-1c0.1-0.6-0.1-1-0.4-1.4c-0.3-0.5,0.1-0.9,0.8-0.9c0.2,0,0.3,0,0.4,0c-0.2-1,0.1-1.9,0.8-2.8
		c1.1-1.4,2.8-2,4.8-1.8l0,0l0.1-0.1l0.1,0.1l0,0c0.1,0,0.2,0,0.3,0c0.8,0.1,1.6,0,2.5,0c0.1-0.6,0.2-1,0.2-1.5
		c0-0.3-0.2-0.7-0.4-0.9c-0.7-0.6-1-1-1.2-1.8c0,0,0,0-0.1,0c0-0.1,0-0.2,0-0.2c0-0.2-0.1-0.4-0.1-0.6c0.1,0,0.2,0.1,0.3,0.1h0.1
		l0,0c0.2,0.1,0.3,0.1,0.5,0.2c-0.2-0.5-0.4-1,0.2-1.5c1.6,0.4,2.1,1,1.8,2.1c-0.1,0.4-0.4,0.8,0.1,0.9c0.4,0.1,0.9-0.1,1.3-0.4
		c0.3-0.2,0.3-0.6,0.5-0.8c0.6-0.2,0.9,0.5,1.5,0c0.9-0.7,1.9-0.4,2.8,0.1c2,1.2,2.5,3.2,1.4,5.2c-0.2,0.4-0.5,0.7-0.8,1.2
		c1.6-0.3,3-0.2,4.3,0.4c0.2,0.1,0.4,0,0.7-0.1l0,0h0.1c0.2-0.4,0.5-0.8,0.8-1.3c0.1,0.4,0.2,0.7,0.2,1.1c0,0,0,0,0.1,0l0,0
		c0,0,0,0,0,0.1c0.5-0.1,0.8-0.2,1-0.7c0.9-1.9,2-2.4,4.2-2.2c0.5,0,0.9-0.1,1.5-0.2c0.2,0.7,0.5,1.6,0.7,2.5c0.2,1.3-0.6,2.5-2,3
		c-1.5,0.6-3.1,0.3-3.9-0.7c-0.3-0.4-0.6-0.9-0.8-1.4c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1-0.2-0.2-0.4-0.3-0.7c0,0,0,0-0.1,0
		c0,0,0,0,0-0.1c-0.3,0.1-0.7,0.1-1,0.2c0,0,0,0,0,0.1l0,0c1,1,1.6,2.2,1.8,3.5c0.1,0.7,0,1.3-0.2,1.8h0.1c0.2,0.2,0.4,0.4,0.6,0.6
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.2-0.3-0.4-0.4-0.6c-0.6,1.3-1.8,2.3-2.8,2.8c-0.6,0.3-1.3,0.4-1.9,0.5c-0.2,0.1-0.3,0.3-0.5,0.4
		c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.3c-0.4,0-0.8,0-1.2-0.1c0.3,0.5,0.7,0.9,1,1.5c-1,0.6-2,1.3-3.1,2
		c-0.3-0.3-0.6-0.6-0.9-0.9c-0.1,0.2-0.3,0.3-0.4,0.4c-0.4,0.3-0.8,0.5-1.1,0.8c0,0.2,0,0.4,0,0.6c1.2-0.1,2.3,0.2,3.2,0.9
		c0.5,0.4,1.1,0.7,1.6,1.1c0.7,0.5,0.7,1.3-0.2,1.6c0,0-0.1,0-0.1,0.1c-0.2,0.9-0.7,1.7-1.9,2.2c-0.5,0.2-1.1,0.4-1.6,0.4
		c-0.2,0.5-0.4,1-0.6,1.4c0.1,0.2,0.2,0.4,0.2,0.6c0.2,0.2,0.3,0.3,0.4,0.4c-0.2,0.3-0.4,0.5-0.6,0.8c-0.1,0.3-0.3,0.5-0.6,0.7
		c-0.4,0.5-0.7,0.9-1.1,1.3c-0.8,0.7-1.3,1.5-0.8,2.4c0.5-0.1,0.7-1,1.4-0.4c0.2-0.2,0.3-0.3,0.5-0.5c0,0,0,0,0-0.1h-0.1h0.1l0,0
		h0.1v0.1c0.7,0.1,1.3,0,1.7-0.6c-0.2-0.2-0.4-0.3-0.6-0.5c0.9,0.1,1.7,0.2,2.6,0.2c0,0.5-0.1,1-0.1,1.4c-0.4-0.1-0.7-0.2-1-0.3
		c-0.2,0.3-0.5,0.6-0.5,1c0,0.1,0.1,0.2,0.2,0.3c0.6,0.4,1,1,1.5,1.5c-0.3,0.2-0.5,0.4-0.7,0.5c0.1,0.3-0.2,0.7-0.1,1
		c0.3-0.1,0.5-0.2,0.8-0.4c0.4-0.2,0.8-0.5,1.3-0.6c2.7-0.5,2.7-0.5,4.4,1.2c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.6-0.2-1.2-0.3-1.8
		c-0.4,0.2-0.6,0.4-0.9,0.5c-0.7-0.6-0.6-0.6,0.1-1c0.2-0.1,0.5-0.2,0.5-0.3c0.1-0.2,0.1-0.5,0.1-0.7c-0.1-0.1-0.2-0.3-0.2-0.4
		c0-0.5,0.1-0.9,0.1-1.4c-0.2-0.2-0.4-0.5-0.6-0.7c-1.3-1.6-1.2-3,0.5-4.6c0.2-0.2,0.4-0.3,0.5-0.4c-0.4-0.9-1.1-0.3-1.7-0.3
		c-0.3-0.4-0.6-0.8-1.1-1.4c0,0.6,0,1,0.1,1.3c-0.1,0-0.2,0.1-0.4,0.1c-0.3-0.6-0.7-1.2-0.9-1.9c-0.2-0.5,0.2-0.8,0.6-1
		c1,0.5,1.8,1.2,2.7,1.3c1.2,0.2,1.3,0.8,1.4,1.5c0.8,0.4,1.6,0.7,2.4,1c-0.6,1.1-0.7,1.2-1.5,1.1c-0.9,0-1.5,0.3-2.1,0.9
		c0,0.6,0.1,1.2,0.4,1.6c0.1-0.1,0.2-0.2,0.2-0.3c0.3,0.3,0.5,0.5,0.7,0.7c0.9-0.5,1-1.1,0.8-1.6c0.4-0.2,0.8-0.3,1.1-0.5
		c0.2-0.2,0.3-0.7,0.5-0.7c0.7-0.2,1.1-0.5,1.6-1c0.4-0.3,1.2-0.1,1.5-0.6c0.4,0.3,0.9,0.3,1.4,0.1c0-0.4,0.2-0.8,0.6-1.2
		c0.2-0.3,0.5-0.5,0.8-0.8l0,0c-0.8,0.3-1.6,0.4-2.4,0.1c-0.4-0.1-0.9,0-1.4,0.1l0,0c0,0,0,0-0.1,0c0,0.1,0,0.2,0.1,0.2
		c0.2,0.4,0.6,0.9,0,1.2c-0.9,0.4-0.8-0.5-1.2-0.7c0.1-0.6,0.7-0.7,1.2-0.8c0,0,0,0,0-0.1l0,0c-0.7-0.6-1.5-1.3-2.3-2
		c0.2-0.3,0.5-0.7,0.8-1.1c1,0.3,2.4-0.3,2.7,1c0.9-0.3,1.7-0.7,2.5-0.1s0.3,1.4,0.1,2.1l0,0l-0.1,0.1c0.4,0,0.7-0.1,1.1-0.1
		C288.9,128,289.7,128.5,289.9,129.6z M336.7,113.1L336.7,113.1L336.7,113.1L336.7,113.1z M338.6,108.2l0.1-0.1v0.1H338.6z
M338.7,103.5c0.3,0.2,0.6,0.4,0.7,0.5c0,0.1-0.3,0.4-0.5,0.5c-0.1,0-0.5-0.2-0.5-0.3C338.4,104.1,338.6,103.9,338.7,103.5z
M335.1,110c0-0.1-0.1-0.1-0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.2,0.1,0.2C335.3,109.8,335.2,109.9,335.1,110z M335.9,109
		c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2C335.8,108.9,335.9,108.9,335.9,109z M335,105.2L335,105.2
		L335,105.2L335,105.2z M335.1,108c0.1,0,0.4,0,0.4,0.1c0.2,0.4-0.1,0.7-0.6,0.8C334.6,108.6,334.7,108.3,335.1,108z M324.5,109.4
		c0,0,0,0.1,0.1,0.1c-0.1,0-0.1,0-0.2,0.1C324.4,109.6,324.4,109.5,324.5,109.4C324.5,109.5,324.5,109.4,324.5,109.4z M321.9,106
		c0.6-0.1,1.2,0.2,1.4,0.7c0.1,0.5-0.4,1.2-1,1.3c-0.7,0.1-1.4-0.3-1.5-0.8C320.7,106.7,321.2,106.1,321.9,106z M320.7,94
		c0,0.1,0.1,0.1,0.1,0.2l-0.1,0.1c-0.1-0.1-0.1-0.1-0.1-0.2L320.7,94z M320.3,101c-0.1,0.2-0.1,0.3-0.2,0.4s-0.3,0-0.5,0
		c0.1-0.2,0.2-0.3,0.3-0.4C320,101,320.1,101,320.3,101z M319.4,98.4c-0.6-0.3-0.7-0.8-0.7-1.4C320.2,97.1,320.3,97.4,319.4,98.4z
M318.8,88c0.1,0.4,0.2,0.8,0.3,1.4C318.3,89,318.2,88.6,318.8,88z M318.1,98.4L318.1,98.4c0.1,0,0.2,0.1,0.3,0.1l-0.1,0.1
		C318.2,98.5,318.1,98.5,318.1,98.4L318.1,98.4C318,98.4,318,98.4,318.1,98.4C318,98.4,318.1,98.4,318.1,98.4z M316,100.6h0.1
		c0,0,0,0.1,0.1,0.1C316.1,100.7,316.1,100.7,316,100.6C316,100.6,316,100.6,316,100.6z M315.9,103c0,0.1,0,0.1,0,0.2
		C315.9,103.1,315.8,103.1,315.9,103C315.8,103,315.9,103,315.9,103z M314.7,104.4L314.7,104.4L314.7,104.4L314.7,104.4z
M313.2,100.8c0.2,0,0.3,0,0.5-0.1c0.1,0.4,0.1,0.8,0.2,1.5C312.9,101.7,312.8,101.3,313.2,100.8z M312.1,104.4
		c0.2,0,0.4,0,0.7,0.1c-0.1,0.2-0.2,0.5-0.3,0.5c-0.2,0-0.4-0.1-0.6-0.2C311.9,104.7,312,104.4,312.1,104.4z M295.3,86.2
		c-0.9,0.3-0.8,1.1-1.4,1.4c-0.6,0-0.9-0.2-1-0.7l0,0l0,0l0,0l0,0c1.2-0.3,0.6-1.4,1.3-2.1c0.3,0,0.7,0,0.9,0.1
		C295.8,85.3,295.9,86,295.3,86.2z M307,121.9h0.1c0,0.1-0.1,0.2-0.1,0.3c-0.1,0-0.2-0.1-0.2-0.1C306.9,122.1,307,122,307,121.9z
M306.9,100.5c0.1,0,0.1,0,0.2,0c0.2,0,0.4,0.2,0.7,0.3c-0.2,0.2-0.4,0.5-0.5,0.5l0,0c-0.2,0-0.5-0.2-0.7-0.3
		C306.6,100.9,306.7,100.6,306.9,100.5z M304.2,82.4c0.1,0.2,0.2,0.4,0.4,0.6c0,0-0.1,0-0.1,0.1c-0.1-0.2-0.3-0.4-0.4-0.6
		C304.1,82.5,304.1,82.4,304.2,82.4z M296.9,93.7c-0.4-0.6-0.4-1.1-0.1-1.5h-0.1c0.1-0.4,0.1-0.6,0.2-0.8c0.2-0.3,0.5-0.7,1-0.5
		c0.2,0.1,0.4,0.3,0.4,0.4l0,0C298.7,92.7,298.5,93,296.9,93.7z M300.8,94.6c-0.1,0-0.2-0.1-0.3-0.1l0.1-0.1c0.1,0,0.2,0,0.3,0
		C300.8,94.5,300.8,94.6,300.8,94.6z M301.4,91.6c-0.2,0.1-0.8,0-0.9-0.2c-0.2-0.3-0.3-0.7-0.4-1.1c0,0,0,0-0.1,0l0,0
		c-0.4,0.2-0.7,0.5-1,0.4c-0.6-0.1-1.1-0.4-1.5-0.7c-0.1-0.1-0.1-0.5,0-0.7c0.1-0.1,0.6-0.2,0.8-0.1c0.6,0.3,1.2,0.7,1.7,1.1h0.1
		c0,0,0,0,0,0.1c0.5-0.1,0.9-0.2,1.4-0.1c0.3,0,0.7,0.4,0.6,0.6C302.1,91.1,301.7,91.4,301.4,91.6z M302.4,88.3
		c-0.7,0.1-1.5-0.2-1.9-0.7c-0.4,0.1-0.7,0.4-1,0c-0.2-0.4-0.5-0.8-0.6-1.2c-0.1-0.8,0.6-1.6,1.6-1.9c1.3-0.4,2.6,0.2,2.9,1.2
		c0.3,0.2,0.4,0.5,0.5,0.8C304,87.3,303.3,88.1,302.4,88.3z M303.8,88.3C303.8,88.3,303.7,88.4,303.8,88.3c-0.1,0-0.2,0-0.2-0.1
		l0.1-0.1C303.7,88.2,303.7,88.2,303.8,88.3z M304.4,98.2c-0.1,0-0.2-0.2-0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.1,0.5,0.2
		C304.7,98.1,304.5,98.2,304.4,98.2z M303.7,97.3c-0.9-1.6-0.4-2.3,1.8-2.7C306,96,305.6,96.7,303.7,97.3z M305.9,97.1
		c0.1,0.1,0.2,0.1,0.2,0.2V99C305,97.9,305.1,97.7,305.9,97.1z M306.2,106.5v-1.2c0,0,0,0,0-0.1c0.1,0,0.2-0.1,0.2-0.1
		c0.5-0.1,1,0,1.1,0.5c0,0.1,0,0.3-0.1,0.4c-0.1,0.2-0.3,0.5-0.4,0.9C306.6,106.8,306.4,106.6,306.2,106.5z M306.5,107.3l-0.1-0.1
		v-0.1V107c0.1,0,0.2,0.1,0.2,0.1l0,0C306.6,107.2,306.5,107.3,306.5,107.3z M296.2,124.4c0-0.1-0.1-0.1-0.1-0.2l0.1-0.1l0.1,0.1
		C296.3,124.3,296.2,124.3,296.2,124.4z M306.2,123.3c-0.2,0-0.4,0-0.6-0.1c-0.5-0.2-0.7-0.6-0.5-1.1s0.6-0.8,1.1-0.8V123.3z
M303.2,115c1-0.4,2-0.6,3-0.9v4h0.1c0,0.1-0.1,0.1-0.1,0.2v2.9c-0.1-0.1-0.1-0.1-0.2-0.2c-1-0.6-2.1-1.2-3.2-1.8
		c-0.9-0.5-1.4-1.2-1.3-2.1C301.5,116.1,302.1,115.4,303.2,115z M298.3,119.3c1.5-0.3,2.8,0.4,3,1.7c0.2,1.2-0.8,2.3-2.2,2.6
		c-1.5,0.3-2.9-0.4-3.1-1.6c0-0.1,0-0.1,0-0.2c-0.1,0-0.2,0-0.3,0c0.1-0.3,0.1-0.7,0.2-1c0.1,0,0.2,0,0.3,0
		C296.6,120,297.4,119.4,298.3,119.3z M292.2,111.3c0.3,0.5,0,0.8-0.6,1.2C291.3,111.9,291.4,111.5,292.2,111.3z M291.4,113.2
		c0.2,0.1,0.3,0.2,0.3,0.3c0,0.1-0.1,0.3-0.2,0.3s-0.3-0.1-0.4-0.1C291.1,113.6,291.3,113.5,291.4,113.2z M291.6,122.5h0.1v0.1
		L291.6,122.5C291.6,122.6,291.6,122.6,291.6,122.5z M290.9,122.5c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.2-0.1,0.3c-0.1,0-0.2,0-0.3,0
		C290.8,122.6,290.8,122.6,290.9,122.5z M218.8,105.4c0,0,0.1,0,0.1,0.1l-0.1,0.1c-0.1,0-0.1-0.1-0.1-0.1
		C218.7,105.4,218.7,105.4,218.8,105.4z M216.4,105.2c0,0.1,0,0.1,0.1,0.2c-0.3,0.1-0.6,0.2-0.9,0.3c0-0.1,0-0.2-0.1-0.2
		C215.8,105.4,216.1,105.3,216.4,105.2z M218.8,99.8c0.4,0.2,0.7,0.3,1.2,0.6c-0.7,0.2-1.2,0.4-1.7,0.6c-0.1-0.1-0.2-0.1-0.2-0.2
		C218.3,100.4,218.5,100.1,218.8,99.8z M209.3,95.7C209.3,95.7,209.3,95.6,209.3,95.7L209.3,95.7c0.1,0,0.1,0,0.2,0.1
		C209.4,95.7,209.3,95.7,209.3,95.7L209.3,95.7z M202.3,102c0.5,0.1,0.8,0.4,1.5,0.7c-0.6,0.5-0.9,0.9-1.3,1
		c-0.5,0.2-1.1-0.2-1.1-0.6C201.2,102.6,201.7,102,202.3,102z M196.6,104.9c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1,0.1-0.1
		c0,0.1,0.1,0.1,0.1,0.2C196.6,104.8,196.6,104.8,196.6,104.9z M204.2,112.3c0-0.1,0-0.1,0-0.2c0.3-0.1,0.6-0.1,0.9-0.2
		c0,0.1,0,0.1,0,0.2C204.8,112.1,204.5,112.2,204.2,112.3z M207.3,111.8c0.2-0.1,0.4-0.2,0.6-0.2c0,0.1,0.1,0.1,0.1,0.2
		c-0.2,0-0.4,0.1-0.5,0.1C207.4,111.9,207.3,111.9,207.3,111.8z M207.9,113.1c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0.1-0.1
		c0,0,0.1,0,0.1,0.1C208,113,208,113.1,207.9,113.1z M208.4,113.7c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0.1,0.1,0.1S208.4,113.6,208.4,113.7
		z M211.6,105.3c0,0,0.1,0,0.1,0.1l-0.1,0.1c0,0-0.1,0-0.1-0.1L211.6,105.3z M211.7,112.5L211.7,112.5c0.1-0.1,0.1,0,0.2,0
		C211.8,112.5,211.7,112.5,211.7,112.5z M211.2,112.1c-0.1-0.1-0.1-0.1-0.2-0.2c0.2-0.3,0.4-0.7,0.7-1.1c0.2,0.2,0.5,0.5,0.4,0.5
		C211.9,111.6,211.5,111.8,211.2,112.1z M209.9,108.9c0.2-0.9,0.7-1.4,1.5-1.5c0.8-0.2,1.4,0.1,1.8,0.8
		C212.2,108.6,211.2,108.7,209.9,108.9z M215,115.1c-0.1,0-0.2,0-0.3,0c0.1-0.1,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.1
		C215.1,114.9,215.1,115.1,215,115.1z M215.9,113.7C215.8,113.8,215.8,113.8,215.9,113.7C215.8,113.8,215.8,113.7,215.9,113.7
		C215.8,113.7,215.9,113.7,215.9,113.7L215.9,113.7z M217,116.9c0-0.1,0.1-0.3,0.1-0.4c0.1,0.1,0.3,0.1,0.3,0.1
		c0,0.1-0.1,0.2-0.1,0.3C217.3,116.9,217.1,116.9,217,116.9z M218.2,117.5l-0.2-0.1c0.1-0.1,0.2-0.3,0.3-0.4
		c-0.2,0.3-0.5,0.5-0.7,0.8c-0.1-0.1-0.2-0.1-0.4-0.2c0.3-0.3,0.7-0.6,1-1c0.1,0,0.2,0.1,0.2,0.1l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.2
		C218.5,117.3,218.3,117.4,218.2,117.5z M239.2,106.3c-0.1,0.1-0.4-0.2-0.8-0.4c0.3-0.3,0.5-0.5,0.7-0.6c0.2,0,0.4,0.2,0.7,0.3
		C239.6,105.9,239.4,106.2,239.2,106.3z M243.2,109.3c-0.3-0.3-0.5-0.5-0.7-0.7c-0.2,0.2-0.4,0.4-0.6,0.7c-0.1,0-0.1-0.1-0.2-0.1
		c0.2-0.2,0.4-0.5,0.6-0.7l0.1,0.1l0,0c0-0.2,0.4-0.4,0.7-0.6c0.3,0.2,0.7,0.4,0.8,0.6C243.9,108.7,243.5,109,243.2,109.3z
M238,116.9c-0.1-0.2-0.1-0.4-0.2-0.6c0.1,0,0.2,0,0.3-0.1c0.1,0.2,0.1,0.4,0.2,0.6C238.2,116.9,238.1,116.9,238,116.9z
M239.1,117.7c0,0-0.1,0-0.1-0.1v-0.1h0.1C239.1,117.6,239.1,117.6,239.1,117.7z M233.5,121.1c-0.1-0.1-0.2-0.1-0.2-0.2
		s0.1-0.3,0.2-0.5c0.2,0.3,0.4,0.4,0.3,0.4C233.7,120.9,233.6,121,233.5,121.1z M227.5,131.3c-0.2-0.1-0.3-0.1-0.6-0.2
		c0.2-0.2,0.3-0.4,0.5-0.5c0.1,0,0.4,0.1,0.4,0.2C227.8,131,227.6,131.2,227.5,131.3z M228.6,132.3c-0.2-0.2-0.3-0.2-0.3-0.3
		c0,0,0.1-0.2,0.2-0.2c0.1,0,0.3,0.1,0.4,0.1C228.9,132,228.8,132.1,228.6,132.3z M234.4,134.5c0.1,0,0.2,0,0.3,0c0,0,0,0.2-0.1,0.2
		s-0.2,0-0.3-0.1C234.4,134.6,234.4,134.5,234.4,134.5z M233.2,133.2v0.1c-0.3,0.1-0.7,0.1-1,0.2v-0.1
		C232.6,133.3,232.9,133.3,233.2,133.2z M236.2,127.6L236.2,127.6L236.2,127.6L236.2,127.6z M243.2,126.4c0-0.1,0-0.1-0.1-0.2h0.1
		V126.4C243.3,126.3,243.2,126.4,243.2,126.4z M242.7,123.9c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0,0c0.1,0,0.2,0,0.4,0l0,0
		c0,0,0,0,0.1,0c-0.1-0.2-0.1-0.4-0.2-0.5c-0.2-0.3-0.5-0.7,0-0.9c0.3-0.2,0.8-0.3,1.2-0.2c1.3,0.4,2.6,0.8,3.3,1.9
		c-0.9,1.1-1.4,1.2-2.1,0.3c-0.6-0.7-1.3-0.7-2.1-0.6l0,0c0,0,0,0-0.1,0c0.2,0.3,0.4,0.7,0.6,1c-0.8-0.1-1.5-0.2-1-1l0,0l0,0
		c-0.1,0-0.1,0-0.2,0C242.7,124,242.7,124,242.7,123.9z M242.6,121.8L242.6,121.8L242.6,121.8L242.6,121.8z M243.1,114.9
		c-0.1,0-0.5-0.1-0.5-0.2c0-0.2,0.2-0.4,0.4-0.5c0.1-0.1,0.4,0.1,0.7,0.2C243.4,114.6,243.3,114.9,243.1,114.9z M244.1,114
		c-0.1,0-0.2,0-0.2-0.1s0-0.2,0.1-0.3c0.1,0,0.2,0.1,0.2,0.1C244.1,113.8,244.1,113.9,244.1,114z M244.4,114.7
		c0-0.1-0.1-0.2-0.1-0.3l0.1-0.1c0.1,0.1,0.1,0.1,0.2,0.2C244.5,114.6,244.5,114.7,244.4,114.7z M245.7,115.1
		c-0.1,0-0.2-0.1-0.3-0.1l0.1-0.1c0.1,0,0.2,0,0.3,0C245.7,114.9,245.7,115,245.7,115.1z M246.1,115.4l0.1-0.1v0.1H246.1z
M246.7,104.4c0.3,0.2,0.7,0.3,0.7,0.4s-0.2,0.5-0.4,0.5s-0.6-0.1-0.7-0.3C246.3,105,246.5,104.8,246.7,104.4z M247,105.8
		c0.2,0.2,0.2,0.7,0.1,0.9c0,0.1-0.7,0.2-1,0.2c-0.4-0.1-0.6-0.4-1-0.7C246.1,105.4,246.6,105.3,247,105.8z M246.1,108.9
		c0,0.2,0.1,0.4,0,0.7c-0.4-0.2-0.6-0.4-0.8-0.5c-0.3,0-0.7-0.1-1.1-0.3c0.3-0.2,0.7-0.4,1-0.6c0-0.1,0.1-0.1,0.1-0.2
		c0,0,0.1,0,0.1,0.1c0.5-0.3,0.9-0.5,1.5-0.8C246.7,108.1,246.5,108.6,246.1,108.9z M247.2,109.4c-0.1-0.1-0.2-0.3-0.2-0.3
		c0.2-0.2,0.5-0.3,0.7-0.4c0.1,0.1,0.1,0.1,0.2,0.2C247.7,109,247.4,109.2,247.2,109.4z M247.8,112.3c-0.1-0.2,0.1-0.5,0.2-1.1
		c0.6,0.7,0.9,1,1.2,1.4C248.3,113.1,248,112.6,247.8,112.3z M249.7,113.5c0,0-0.1,0-0.2,0c0.1-0.1,0.2-0.3,0.3-0.4
		c0,0.1,0.1,0.2,0.1,0.2C249.9,113.4,249.8,113.4,249.7,113.5z M250,107.5c-0.9,0.2-1.8-0.2-2.1-1c-0.2-0.8,0.5-1.7,1.5-1.9
		c1-0.2,2,0.3,2.2,1.1C251.8,106.4,251.2,107.1,250,107.5z M267.3,113.3c0.1,0,0.2,0,0.4,0c-0.1,0.3-0.1,0.7-0.2,1
		c-0.1,0-0.2,0-0.4,0C267.2,113.9,267.2,113.6,267.3,113.3z M254.2,106.5L254.2,106.5L254.2,106.5L254.2,106.5z M253.2,102.9
		c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2-0.3-0.4-0.6-0.7-1.1C253.1,102.1,253.2,102.5,253.2,102.9z M252.7,111.1c-0.2-0.2-0.5-0.4-0.5-0.4
		c0.1-0.2,0.3-0.4,0.6-0.5c0.1,0,0.3,0.2,0.5,0.3C253.2,110.6,253,110.8,252.7,111.1z M254.1,113.1c-0.1-0.1-0.1-0.1-0.1-0.2
		l0.1-0.1c0.1,0.1,0.1,0.2,0.2,0.2C254.1,113,254.1,113.1,254.1,113.1z M254.8,111.2c-0.2-0.2-0.4-0.4-0.7-0.7
		C255.1,110.5,255.1,110.5,254.8,111.2z M260.4,98.9c-0.3,0-0.8-0.3-0.8-0.6c0-0.2,0.4-0.7,0.7-0.7c0.3-0.1,0.7,0.3,1.2,0.5
		C261,98.5,260.7,98.9,260.4,98.9z M262.2,103.6c-0.1-0.1-0.3-0.2-0.3-0.2c0-0.1,0.2-0.2,0.3-0.4c0.1,0.2,0.3,0.3,0.3,0.4
		C262.4,103.4,262.3,103.5,262.2,103.6z M262,102.6c-0.3-0.6,0-1.1,0.3-1.6c0,0,0,0,0-0.1c0,0,0,0,0.1-0.1v0.1l0,0
		C262.5,101.6,262.7,102.1,262,102.6z M263.7,100.5C263.7,100.5,263.7,100.6,263.7,100.5L263.7,100.5L263.7,100.5L263.7,100.5
		L263.7,100.5L263.7,100.5C263.7,100.4,263.7,100.5,263.7,100.5z M265.9,99.2L265.9,99.2L265.9,99.2L265.9,99.2z M267.4,101.3
		c0,0,0,0.1-0.1,0.1C267.3,101.4,267.3,101.3,267.4,101.3L267.4,101.3c0-0.1,0.1-0.1,0.1-0.1C267.5,101.2,267.4,101.2,267.4,101.3z
M275.5,97c0.1,0.1,0.3,0.1,0.4,0.2c0,0.1-0.1,0.2-0.1,0.4c-0.2-0.1-0.4-0.1-0.4-0.2C275.3,97.3,275.5,97.1,275.5,97z M272.9,100.7
		c-0.1-0.1-0.2-0.2-0.2-0.3l0.2-0.2c0.1,0,0.2,0.1,0.4,0.2C273.2,100.5,273,100.6,272.9,100.7z M273.8,98.2c0.3-0.6,0.5-1.1,0.7-1.6
		C274.9,97.4,274.9,97.4,273.8,98.2z M274.4,97.9c0.1,0.1,0.2,0.2,0.2,0.2c0,0.1-0.1,0.2-0.3,0.5c-0.1-0.2-0.3-0.3-0.3-0.4
		C274.1,98.1,274.3,98,274.4,97.9z M274.6,103.3L274.6,103.3l0.1-0.2c0-0.2,0.1-0.5,0.1-0.7c0.1,0,0.2,0.1,0.4,0.1
		c-0.2,0.2-0.3,0.4-0.5,0.6C274.7,103.1,274.7,103.2,274.6,103.3L274.6,103.3c0,0.2,0,0.3,0,0.5c-0.1,0-0.2,0-0.3,0
		C274.4,103.6,274.5,103.5,274.6,103.3z M275.5,106.8c0,0,0-0.1-0.1-0.1c-0.3,0-0.6-0.1-1-0.2c0.3-0.3,0.5-0.6,0.6-0.6
		c0.2,0,0.4,0.1,0.6,0.2c0.3-0.2,0.6,0.1,0.8,0.3C276.3,106.7,276,107.1,275.5,106.8z M277.5,99.7l-0.1-0.1v-0.1
		c0.1,0,0.1,0,0.2,0.1C277.6,99.6,277.5,99.6,277.5,99.7z M281,105.3c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.2,0.3-0.5,0.4-0.7
		c0.1,0,0.2,0.1,0.2,0.1C281.3,104.9,281.2,105.1,281,105.3z M282.7,105.9L282.7,105.9L282.7,105.9L282.7,105.9z M269.9,130.1
		c-0.1,0-0.1,0-0.2,0V130C269.8,130,269.8,130,269.9,130.1C269.9,130,269.9,130.1,269.9,130.1z M270.1,131.3
		C270.1,131.4,270.1,131.4,270.1,131.3c0,0.1-0.1,0.2-0.1,0.3C270,131.5,270,131.5,270.1,131.3C270,131.4,270.1,131.4,270.1,131.3
		c0-0.2,0-0.5-0.1-0.9C270.3,130.8,270.6,131.1,270.1,131.3z M270.5,129.3L270.5,129.3L270.5,129.3L270.5,129.3z M276.4,136.8
		L276.4,136.8c0.1,0.1,0,0.1,0,0.2c0,0-0.1,0-0.1-0.1C276.3,136.8,276.3,136.8,276.4,136.8z M273.4,129.1c0,0,0-0.1,0.1-0.1
		C273.4,129,273.4,129.1,273.4,129.1c0,0.1,0,0.1,0,0.1C273.3,129.2,273.4,129.1,273.4,129.1z M271.9,128.2c0.2,0.2,0.4,0.4,0.6,0.6
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2-0.2-0.3-0.5-0.5-0.7C271.8,128.3,271.8,128.2,271.9,128.2z M270.9,133.7c0.7-0.7,1.1-0.4,1.6-0.1
		C271.9,134.4,271.5,133.9,270.9,133.7z M272.4,139.7c-0.5-0.4-0.5-0.8,0-1.3C272.9,138.8,273,139.2,272.4,139.7z M274.8,134.1
		c-0.3,0.6-0.9,0.6-1.5,0.8c-0.1-0.1-0.2-0.2-0.3-0.3c0.3-0.2,0.6-0.4,0.9-0.7C274.1,133.9,274.4,134,274.8,134.1z M273.5,130.7
		L273.5,130.7v0.1V130.7z M273.6,133.1c-0.3-0.6-0.6-1.1-0.9-1.7C274,131.8,274,131.8,273.6,133.1z M277.8,132.8
		c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.1,0.2,0.2C277.9,132.7,277.8,132.7,277.8,132.8z M276.1,126.4
		c-0.2-0.1-0.4-0.5-0.3-0.7c0.2-0.5,0.6-0.6,1.7-0.3C277.2,126,277.1,126.7,276.1,126.4z M279.3,123.6c-1.2,0.3-2.4-0.2-3-1
		c0,0.3,0.1,0.5,0.2,0.8c0.4,0.7-0.5,1.3-1,1.9v0.1c0,0-0.1,0-0.1-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c-1.1-0.8-1.7-1.7-0.8-2.9
		c0.1-0.2,0-0.6,0-0.8c-0.1-0.4-0.1-0.4,0.5-1.2c0.6,0.1,1,0.4,1.2,0.7c0-1.1,0.9-2.1,2.2-2.4c0.3-0.1,0.7-0.1,1-0.1
		c0.2-0.2,0.5-0.5,0.6-0.8c0.3,0.4,0.5,0.7,0.7,1c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.3,0.9,0.7,1.1,1.3
		C281.7,121.8,280.7,123.2,279.3,123.6z M281.7,122.2c-0.1,0-0.2,0-0.2-0.1V122c0.1,0,0.2,0,0.2,0S281.7,122.1,281.7,122.2z
M282.2,124.4c-0.1-0.1-0.1-0.2-0.2-0.2c0.3-0.2,0.7-0.4,1-0.6c0.1,0.1,0.2,0.2,0.3,0.3C282.9,124.1,282.6,124.2,282.2,124.4z
M283,116.7c-0.1,0-0.2-0.1-0.3-0.2c0.1-0.1,0.3-0.3,0.4-0.4s0.3,0,0.8,0.1C283.3,116.5,283.2,116.6,283,116.7z M290.3,109.3
		c0,0,0.1,0,0.1,0.1v0.1c-0.1,0-0.1,0-0.2-0.1C290.2,109.4,290.2,109.3,290.3,109.3z M289.4,107.8c0.1,0,0.3,0,0.4,0.1
		c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0-0.2,0-0.3,0C289.3,108.3,289.3,108,289.4,107.8z M289.2,111.9c0.6-0.1,1.1,0.3,1.1,0.7
		c0,0.4-0.4,1-0.9,1.1s-1.1-0.2-1.2-0.6C288.1,112.5,288.6,112,289.2,111.9z M288.5,105.5c0,0.1,0.1,0.1,0.1,0.2s-0.1,0.1-0.2,0.2
		c-0.1-0.1-0.2-0.2-0.2-0.2C288.3,105.7,288.4,105.6,288.5,105.5z M287.1,112.3c0.1,0.2,0.2,0.4,0.4,0.6c-0.1,0.1-0.2,0.1-0.2,0.2
		c-0.2-0.2-0.3-0.3-0.5-0.5C286.8,112.5,286.9,112.4,287.1,112.3z M287.1,114.4c1.5-0.3,3,0.5,3.2,1.8s-0.8,2.6-2.4,2.9
		c-1.4,0.3-3-0.5-3.2-1.6C284.5,116,285.5,114.8,287.1,114.4z M285.2,118.3c0.3,0.5,0.5,0.8,0.8,1.1
		C285,119.4,284.6,119.2,285.2,118.3z M286,125l-0.1-0.1c0-0.1,0-0.2,0.1-0.3l0.1,0.1C286.1,124.8,286.1,124.9,286,125z
M286.5,122.4c-0.1-0.2-0.1-0.5-0.3-0.7c-0.1-0.2-0.3-0.2-0.5-0.4c0.4-0.4,0.8-0.7,1.2-1.1c1-0.8,2.3-0.9,3.1-0.2
		c0.8,0.7,0.8,1.9-0.1,2.7C289.1,123.5,287.1,123.4,286.5,122.4z M289.7,126.1c-0.3-0.2-0.6-0.3-1-0.4
		C289.4,125.6,289.4,125.6,289.7,126.1z"
      />
      <path
        class="st4"
        d="M173.5,106.7c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C173.4,106.9,173.4,106.8,173.5,106.7z"
      />
      <path
        class="st4"
        d="M203.9,121c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.1-0.4-0.2-0.6-0.2C203.7,120.8,203.8,120.9,203.9,121z"
      />
      <path
        class="st4"
        d="M202.1,121.4c-0.1,0.1-0.1,0.2-0.2,0.4c0,0.1,0,0.1,0,0.2c0.3,0.5-0.1,0.4-0.4,0.5c-0.1,0.1-0.1,0.2-0.2,0.3
		l0,0c0,0,0,0,0,0.1c0,0,0.2,0.2,0.3,0.4c0.1,0.2,0.3,0.4,0.5,0.8c-0.2,0.1-0.4,0.3-0.7,0.5c0,0,0,0,0,0.1c0.2-0.1,0.4-0.1,0.6-0.2
		c0.3-0.9,0.6-1.8,0.8-2.7c-0.2,0-0.4-0.1-0.6-0.2C202.1,121.4,202.1,121.4,202.1,121.4z"
      />
      <path
        class="st4"
        d="M280.8,263.8c-0.5-0.1-1.1-0.2-1.3,0.4c-0.5-0.3-1-0.6-1.5-0.9c-0.1,0.2-0.2,0.5-0.3,0.8
		c-0.1,0.7-0.4,1.3-0.9,1.8c0.1,0,0.3,0.1,0.4,0.1c0.2-0.3,0.6-0.6,1-0.8c0.5-0.2,1-0.2,1.5-0.1c0-0.2,0.1-0.5,0.1-0.7
		c0.8,0.8,1.6,0.9,2.5,0.6c-0.1-0.4,0-0.7,0.6-0.8c0.3-0.1,0.6-0.3,0.9-0.5c-0.5-0.1-0.9-0.2-1.5-0.3
		C282.1,263.9,281.5,264,280.8,263.8z"
      />
      <path
        class="st4"
        d="M187.1,129.6c-0.2-0.2-0.4-0.5-0.7-0.8c0.2,0.4,0.4,0.8,0.6,1.1c0.5,1,1,1.3,1.8,1.1c0-0.1,0-0.2,0.1-0.4
		c-0.8-1-0.8-1,0.2-1.7v-0.1C188.5,129.1,188,129.3,187.1,129.6z"
      />
      <path
        class="st4"
        d="M303.1,76.5c0.6,0.7,1.2,1.6,1.5,2.4c0.3-0.2,0.6-0.3,0.9-0.3c0.2,0,0.4-0.1,0.6,0v-1c-0.4,0.2-0.9,0-1.4-0.1
		c0.4-1.1,0.6-1.4,1.3-1.3c0.1,0,0.1,0,0.2,0.1v-4.6c-1.4-0.7-2.7-1.5-4.5-1.8c0,0-0.3,0.1-0.3,0.2c-0.1,0.5-0.1,1.1-0.1,1.6
		s0.1,1,0,1.5C301.1,74.8,302.2,75.5,303.1,76.5z M304.1,76.9c0.1,0,0.1,0,0.2,0l-0.1,0.1c-0.1,0-0.1,0-0.2,0
		C304,76.9,304,76.9,304.1,76.9z"
      />
      <path
        class="st4"
        d="M41.6,308.6c-0.3,0.4-0.8,0.7-1.1,1.2C41,309.5,41.4,309.1,41.6,308.6z"
      />
      <path
        class="st4"
        d="M18,317.3c0.6,1,0.9,2,0.2,3.3c0.8-0.3,1.6-0.3,2.3-0.2c0.1-0.7,0.3-1.3,0.4-2c0-0.1,0.2-0.3,0.4-0.4
		c0.1-0.1,0.2-0.2,0.3-0.3c-0.7,0.2-1.5,0.3-2.2,0.1C19,317.7,18.5,317.5,18,317.3C18.1,317.3,18.1,317.3,18,317.3
		C18.1,317.3,18.1,317.3,18,317.3z"
      />
      <path
        class="st4"
        d="M47.4,303.4c-0.7-0.5-0.7-1.2,0.2-1.6c0.7-0.2,1.1-0.9,2.1-0.7c0.7,0.1,1.6-0.4,2.2-1.2
		c-0.4-0.1-0.7-0.2-0.9-0.2c0.3-0.7,0.6-1.5,0.9-2.1c-0.4-0.3-0.6-0.6-0.8-0.7c0.4-0.5,0.7-0.8,1-1.2c-0.3,0-0.5,0-0.7-0.1
		c-0.8-0.3-1.3-1.2-1.8-1.8c0.1-0.1,0.1-0.1,0.2-0.2c-0.4,0-0.7-0.1-1.1-0.1c0-0.2,0-0.3,0.1-0.5c-0.1,0.1-0.3,0.1-0.4,0.1
		c-2.7,0.5-2.7,0.5-4.5-1.3c-0.3,0.2-0.6,0.5-0.9,0.8v0.1c0.3,0.4,0.6,0.7,0.9,1.1c1,1.2,1.1,2.3,0.3,3.4c0,0.3,0,0.6,0.1,0.9
		c0.1,0.2-0.3,0.6-0.6,0.9c-0.3-0.3-0.5-0.5-0.6-0.7c-0.1,0.1-0.2,0.2-0.3,0.3c0.4,0.9,1.1,0.3,1.7,0.3c0.3,0.4,0.6,0.8,1.1,1.3
		c0-0.6,0-0.9,0-1.3c0.1,0,0.2-0.1,0.4-0.1c0.3,0.6,0.7,1.2,0.9,1.8c0.2,0.5-0.2,0.8-0.6,0.9c-1-0.5-1.7-1.1-2.6-1.3
		c-1-0.1-1.2-0.6-1.3-1.1c-0.1,0.3-0.1,0.5,0,0.8c-0.4,0.2-0.8,0.3-1,0.5s-0.3,0.7-0.5,0.8c-0.4,0.1-0.8,0.3-1.1,0.5
		c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.3-0.5,0.7-0.8,1.1c-0.8-0.2-1.9,0.1-2.4-0.4c-0.2,0-0.4,0.1-0.7,0.1c-0.3,0.1-0.6-0.1-1-0.3
		c-0.2,0-0.3,0-0.5,0c0,0.3-0.1,0.6-0.1,0.8l0,0c0,0.1,0,0.2-0.1,0.3c0,0.2,0,0.3-0.1,0.5c-0.4-0.2-0.5-0.4-0.6-0.6
		c-0.2-0.6-0.6-1.2-0.7-1.9c-0.1-0.6-1-0.5-0.9-0.7c0.2-0.3,0.2-0.5,0.1-0.6c-0.2,0-0.4-0.1-0.5-0.1s-0.1,0-0.2,0s-0.2-0.1-0.2-0.2
		c-0.4-0.2-0.7-0.6-0.8-1.2c-0.1-0.2-0.1-0.5-0.2-0.7c0,0,0,0-0.1,0c-0.5,0.4-0.9,0.6-1.4,0.8c-0.7,0.8-1.5,1.5-2.7,1.5
		c0,0.1,0,0.1,0,0.2c0.2,0,0.4,0,0.6,0c1.8-0.1,2.7,0.3,3,1.3c0.1,0.2,0.1,0.5,0.1,0.7c0.2,0.1,0.4,0.2,0.5,0.3
		c0.2,0.4-0.1,0.8-0.8,1.1c-0.1-0.1-0.3-0.2-0.4-0.2c-0.3,0.2-0.6,0.5-1.1,0.8c-1.3,0.7-1.6,1.9-0.7,2.9c0.7,0.7,1.4,1.5,1.9,2.4
		c0.8,1.2-0.1,2.7-1.8,3.4c-1.5,0.6-3.2,0.1-3.9-1c-0.7-1.3,0-2.8,1.7-3.4c0-0.1,0-0.1,0-0.2c0,0,0,0.1,0.1,0.1
		c0.2-0.1,0.5-0.2,0.7-0.2c-0.4-0.2-0.5-0.5-0.2-1c0,0,0,0,0.1,0c-0.4-0.5-0.5-1-0.5-1.7c0-1.2-0.4-2.3-1.2-3.3
		c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2,0-0.3,0-0.5,0c-0.8-0.2-1.1-0.6-1.1-1.2c-1.3-0.2-1.2-1.6-2.4-1.8c-0.1,0-0.2-0.2-0.2-0.4
		c0,0,0,0,0-0.1c-0.6,0.1-1.2,0.3-1.8,0.4c-0.1,0-0.1,0-0.2,0c-0.2,0.6-0.5,1.3-1.1,1.9c-0.4,0.4-0.8,0.9-1.1,1.4
		c0.3-0.2,0.7-0.3,1-0.5c-0.1,0-0.3-0.1-0.4-0.2c0.3-0.3,0.5-0.6,0.9-1c0.2,0.3,0.5,0.5,0.4,0.7c-0.1,0.1-0.1,0.2-0.2,0.3
		c0.2,0,0.4,0,0.7,0c0.7,0.2,1.4,0.2,2.1,0c0.7-0.1,1.3,0.1,1.4,0.6c0.1,0.4,0.1,0.9-0.1,1.3c-0.6,1.1-2.3,0.8-3.2,1.5
		c-0.3,0.2-0.9,0.2-1.4,0.2c-0.2,0-0.4,0-0.5-0.1c-0.6-0.5-1.4-0.4-2.1-0.3c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.2,0,0.5-0.1,0.9
		c-0.2-0.2-0.3-0.3-0.4-0.4l0,0l0,0c-0.2-0.2-0.3-0.3-0.5-0.4c-0.2,0.1-0.3,0.3-0.5,0.4c-0.6-0.1-0.8-0.2-1-0.3
		c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0,0.2,0c1.2,0,2.1,0.4,2.4,1.4c0.1,0.3,0.3,0.8,0.6,1c1,0.6,2.1,1.2,3.2,1.7
		c0.9,0.5,1.4,1.1,1.3,2s-0.7,1.7-1.8,2.1c-0.4,0.1-0.8,0.2-1.2,0.4c1.1,0.4,1.3,0.7,1.4,1.9c-0.6,0.2-1.2-0.1-1.8,0.1
		c0.1,0.2,0.1,0.5,0.1,0.7c0,0.1,0.1,0.3,0.1,0.4c0.5,0,0.9,0.2,1.4,0.4c0.3,0.1,0.6,0.2,0.8,0.3l0,0c0,0,0,0,0.1,0
		c-0.2-0.7-0.8-1.3-0.7-2.2c0.2-1.5,2.5-2.8,4.1-2.5c1.4,0.2,2.4,1.1,2.5,2.2c0,0,0,0,0.1,0c0,0,0,0.1-0.1,0.1c0,0.3,0,0.6-0.1,0.9
		c-0.1,0.2-0.2,0.4-0.3,0.6c0.8-0.2,1.6-0.4,2-1.4c0.6,1,1.8,1,2.9,1c0.2,0,0.6-0.4,0.8-0.6c0.1-0.2,0.1-0.6,0.2-1.2
		c0.3,0.3,0.5,0.5,0.7,0.8c0.2-0.3,0.5-0.6,0.8-0.6c0.5-0.1,1.1,0.2,1.2,0.6c0.1,0.5-0.3,1-1,1.1c-0.3,0-0.6,0-0.8-0.2
		c0,0.2-0.2,0.4-0.3,0.6c0.6,0.4,1-0.2,1.5-0.4c2.3-0.5,2.6-0.5,3.9,1c0.5,0.5,0.6,1.2,1.1,1.7c0.9,1,1.2,2.1,1.3,3.3
		c0.8,0,0-1.6,1.5-0.6c-0.1-0.9-0.1-1.6-0.1-2.3c0.1,0,0.2-0.1,0.3-0.1c0.1,0.2,0.3,0.4,0.5,0.6c0.2-0.3,0.3-0.6,0.4-0.8
		c-0.1-0.2-0.1-0.3-0.2-0.3c-2.3-1.3-3.4-3.7-2.5-5.9c0.4-0.9,1.3-1.6,2.1-2.3c0.2-0.2,0.5-0.4,0.7-0.6c-0.3-0.4-0.5-0.7-0.7-0.9
		c0.4-0.3,0.8-0.5,1-0.8c0.3-0.3,0.4-0.7,0.7-1c0.2,0,0.3,0.1,0.5,0.1c0.2,0.5,0.1,0.8-0.2,1.2c0.9,0,1.4,0.2,1.3,1.2
		c0.8-0.4,1.3-0.7,1.8-0.9c-0.3-0.6-0.3-1.2-0.2-1.7c-0.7-0.5-0.5-1.5-0.8-2.1c-0.4-0.9,0.9-1.5,1.4-2.2c1.1,0.8,1.7,1.6,0.8,2.8
		c-0.2,0.2,0,0.5,0,0.8c0.1,0.3,0.1,0.4-0.4,1.1c0.2,0.4,0.6,0.6,1.4,0.6c0.5-0.3,1-0.6,1.5-0.9c0.2-0.2,0.3-0.5,0.5-0.7
		c0.2-0.5,0.4-1,0.9-1.3c-0.3-0.1-0.6-0.3-0.8-0.5C48.5,304,47.9,303.7,47.4,303.4z M50.5,298.4c0.1,0,0.1,0,0.2,0v0.1
		C50.6,298.4,50.5,298.4,50.5,298.4L50.5,298.4z M50.3,297.1L50.3,297.1c0-0.1,0.1-0.2,0.1-0.3C50.4,296.9,50.4,297,50.3,297.1
		L50.3,297.1c0,0.2,0,0.5,0.1,0.9C50.1,297.6,49.8,297.4,50.3,297.1z M49.9,299.1L49.9,299.1L49.9,299.1L49.9,299.1z M45,296.1
		C44.9,296,44.9,296,45,296.1c-0.1-0.1,0-0.1,0-0.2c0,0,0.1,0,0.1,0.1C45.1,296,45,296,45,296.1z M19,307.4c0-0.1,0-0.2,0-0.3
		c-0.8,0-1.4-0.4-1.5-1.1c-0.2-0.8,0.5-1.7,1.5-1.9c0.9-0.2,1.8,0.2,2.1,0.9h0.1c1.5-0.3,2.9,0.4,3.1,1.5s-0.7,2.2-2.2,2.6l0,0l0,0
		c0,0,0,0-0.1,0C20.5,309.3,19.2,308.6,19,307.4z M22.2,310.1c-0.1,0-0.2-0.1-0.2-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1,0.1,0.2,0.2
		C22.4,310.1,22.2,310.2,22.2,310.1z M30.7,302.3C30.7,302.4,30.7,302.4,30.7,302.3c0.1,0,0.2-0.1,0.2-0.2c0.3,0.1,0.6,0.2,1,0.4
		c-0.3,0.3-0.5,0.6-0.6,0.6c-0.2,0-0.6-0.2-0.7-0.3C30.6,302.7,30.6,302.6,30.7,302.3C30.7,302.4,30.7,302.4,30.7,302.3z
M30.6,310.8c-0.1,0-0.2,0-0.3,0c0-0.1,0.1-0.2,0.1-0.3c0.1,0,0.2,0,0.3,0C30.6,310.6,30.6,310.7,30.6,310.8z M30.3,308.2
		c-0.8-0.6-0.8-1.8,0.1-2.6c0.9-0.8,2.8-0.7,3.5,0.3c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.1,0.3,0.2,0.5,0.4c-0.4,0.4-0.8,0.7-1.2,1
		C32.5,308.7,31.2,308.8,30.3,308.2z M35.1,309.8c-0.3-0.5-0.5-0.8-0.8-1.1C35.3,308.7,35.7,308.9,35.1,309.8z M36.5,306.4
		c-0.2,0-0.4-0.1-0.5-0.2c0.1-0.1,0.2-0.3,0.3-0.3c0.2,0,0.4,0.1,0.7,0.2C36.7,306.2,36.6,306.4,36.5,306.4z M37.3,304.7
		c-0.1-0.1-0.2-0.2-0.3-0.3c0.4-0.2,0.7-0.3,1.1-0.5c0.1,0.1,0.1,0.2,0.2,0.2C38,304.3,37.7,304.5,37.3,304.7z M44.5,302.7
		c-0.2,0.5-0.6,0.6-1.7,0.3c0.3-0.6,0.5-1.2,1.4-0.9C44.4,302.1,44.6,302.4,44.5,302.7z M47,299.3c0,0,0,0.1-0.1,0.1
		C46.9,299.4,46.9,299.3,47,299.3c0-0.1,0-0.1,0.1-0.1C47,299.2,47,299.3,47,299.3z M49.5,294.9c-0.7,0.6-1.1,0.4-1.5,0.1
		C48.5,294.2,48.9,294.7,49.5,294.9z M48.2,299.4c0.2,0.2,0.3,0.5,0.5,0.7c-0.1,0-0.1,0.1-0.2,0.1c-0.2-0.2-0.4-0.4-0.6-0.6
		C48,299.5,48.1,299.4,48.2,299.4z M45.6,294.5c0.3-0.6,0.9-0.6,1.5-0.7c0.1,0.1,0.2,0.2,0.3,0.3c-0.3,0.2-0.6,0.4-0.9,0.7
		C46.3,294.7,46,294.6,45.6,294.5z M46.8,295.5c0.3,0.6,0.6,1,0.9,1.6C46.3,296.7,46.3,296.7,46.8,295.5z M46.8,297.8L46.8,297.8
		v-0.1V297.8z"
      />
      <path
        class="st4"
        d="M20.6,298C20.6,298,20.7,298,20.6,298c0.1-0.2,0-0.2,0-0.3c-0.2,0-0.4,0.1-0.6,0.1
		C20.2,297.9,20.4,298,20.6,298z"
      />
      <path
        class="st4"
        d="M28.6,326.7c-1.3,0.9,0,1.6,0.1,2.8c-0.4-0.5-0.6-0.7-0.7-0.9c-0.1-0.4-0.3-0.8-0.3-1.2c0-0.9-0.5-1.2-1.4-1.3
		c-0.3,0-0.6-0.1-0.9-0.2c-0.1,0.3-0.2,0.5-0.3,0.6c0.5,0.1,0.8,0.5,0.8,0.9c0,0.6-0.5,1.2-1.3,1.4c-0.8,0.2-1.6-0.2-1.7-0.9
		c-0.1-0.7,0.5-1.3,1.4-1.4c0.2,0,0.4,0,0.5,0c-0.7-0.4-1.4-0.7-2.1-1.1c-0.8,0.8-1.9,1.3-3.2,1.4c0,0.7,0.2,1.4,0.4,2.1
		c1,0.2,1.9,0.6,2.4,1.3c0.9,1.4,0.3,2.8-0.8,3.8c0.2,0.3,0.5,0.5,1,0.6s0.6,0.9,1.3,0.5c0.5,1.2,1.9,0.8,2.9,0.8
		c0.7,0,1.4-0.5,1.2-1.4c-0.9-0.2-2-0.1-2.2-1.2c0-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.6-0.1-0.9-0.2c-0.8-0.3-1.3-1-0.9-1.5
		c0.4-0.4,1-0.6,1.6-0.6c0.8-0.1,1,0.3,1,1.1c0,0.2,0,0.5-0.1,0.7c0.6,0,1.3,0,1.9,0c0.5,0,1.1,0,1.7,0c0-1.2,0.1-2.3,0.1-3.5
		c0.7-0.4,1.3-0.7,2-1.1C31.2,326.3,29.8,326.8,28.6,326.7z M25.8,330.6c-0.1-0.3-0.2-0.6-0.4-0.9c0.1,0,0.1-0.1,0.2-0.1
		c0.2,0.3,0.3,0.5,0.5,0.8C26,330.5,25.9,330.6,25.8,330.6z"
      />
      <path
        class="st4"
        d="M52.9,309.3c-0.1-0.1-0.1-0.1-0.2-0.2c-0.6,0.1-1.1,0.1-1.5,0s-0.8-0.2-1.1-0.3c0,0.2,0,0.3,0.1,0.5
		s0,0.4-0.3,0.7c0.1,0.1,0.1,0.3,0.2,0.4c0.4-0.2,0.7-0.5,1-0.6c0.8-0.3,1.5-0.4,2.1-0.2l0,0C53.1,309.5,53,309.4,52.9,309.3z"
      />
      <path
        class="st4"
        d="M9.4,303.3c0-0.1-0.1-0.1-0.1-0.2c-0.5,0.3-0.9,0.6-1.2,1.1c1,0.5,1.4,0.7,1.9,0.8
		C9.9,304.4,9.6,303.9,9.4,303.3z"
      />
      <path
        class="st4"
        d="M273.2,267.7c-0.7,0.1-1.3,0.1-2-0.1c-0.5,0.2-1,0.4-1.7,0.7c1.7,0.4,3.3,0,4.3,1.1c-0.3,0.8-0.3,1.2,0.1,1.3
		c0.2-0.1,0.4-0.2,0.7-0.3c-0.1-0.1-0.2-0.3-0.3-0.4c0.1-0.1,0.1-0.3,0.2-0.3c0.5-0.3,1.1-0.6,1.6-0.8c0.1,0,0.1-0.1,0.2-0.1
		c0-0.1,0.1-0.1,0.1-0.2v0.1c0.3-0.1,0.5-0.2,0.7-0.4c-1.4,0-2.8,0.1-4.2,0.1C273,268.2,273.1,268,273.2,267.7z"
      />
      <path
        class="st4"
        d="M10.2,318c-0.1,0.8-0.3,1.7-0.4,2.5c0.4-0.2,0.9-0.3,1.4-0.2c0.2,0,0.3,0,0.5,0v-0.1c-0.2-1.2,0.2-2.2,1.5-2.9
		c0.2-0.1,0.4-0.2,0.6-0.3c-0.2-0.3-0.4-0.6-0.5-0.9C12.9,317,12,317.4,10.2,318z"
      />
      <path
        class="st4"
        d="M246.9,253.2c0.4-0.7,0.6-0.8,1.3-0.9c-0.1-0.2-0.3-0.4-0.4-0.7c-0.5,0.4-1,0.7-1.7,1.1
		C246.4,252.9,246.7,253,246.9,253.2z"
      />
      <path
        class="st4"
        d="M266.6,256.4c-1.6-0.3-3.5-0.3-4.6-1.5l0,0c0,0.1,0,0.3,0,0.5c-0.1,0.2-0.1,0.5-0.3,0.7c0,0,0.1,0,0.1,0.1
		c0.4,0.3,0.6,0.8,0.8,1.2c0.1,0.6-0.2,1.1-1,1.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3,0.5-0.8,1-1.4,1.1s-1.1-0.3-1.2-0.8v-0.1
		c0-0.1,0-0.2,0-0.4c-0.1-0.2-0.2-0.4-0.2-0.6c0.4-0.3,0.7-0.4,1.1-0.4c0.1-0.1,0.3-0.1,0.4-0.1s0.2,0,0.4,0c0.3,0,0.5,0.1,0.7,0.2
		c0.2-0.3,0-0.6-0.2-0.8h-0.1c-0.9,0.2-1.8-0.2-2.2-0.9c-0.2,0.2-0.3,0.3-0.5,0.6c0.1,0.2,0.3,0.5,0.5,0.8c-1.6,0.6-2.5,0-3.6-0.6
		c-0.4-0.1-0.6-0.4-0.4-0.9c0.4,0.1,0.6,0.2,0.7,0.5c0.5-0.4,0.9-0.9,1.8-0.8c0.1,0,0.4-0.4,0.6-0.7l0,0c0.3-0.1,0.6-0.2,0.9-0.3
		c0.2-0.4,0.6-0.7,1.2-0.9c0.2-0.5,0.3-1.1,0.4-1.7c-1,0-1.9,0-2.9,0h-0.1c-0.1,0.1-0.3,0.2-0.4,0.3c0.1,0.1,0.3,0.2,0.4,0.4
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0.2-0.4,0.4-0.6,0.5l0,0
		c0.1,0.5,0.1,0.9,0.3,1.3c0.2,0.4-0.5,0.9-1.1,0.8c-0.4-0.1-0.9-0.3-1.2-0.5c-0.2-0.1-0.4-0.3-0.4-0.6c-0.1,0-0.2,0-0.2,0l0,0
		c-0.1,0.1-0.2,0.1-0.2,0.2c0-0.1-0.1-0.1-0.1-0.2c-0.6,0-1.2-0.1-1.7-0.4c-0.2,0.2-0.4,0.3-0.6,0.5c-0.1,0-0.2,0.1-0.2,0.1
		c0.2,0,0.5-0.1,0.9-0.1c-0.5,0.4-1.1,0.7-1.7,0.8v0.1c0,0.7-0.2,1.4-0.6,2c-0.1,0.1-0.2,0.2-0.3,0.3c0.5-0.1,1,0,1.6,0.3
		c0.7,0.3,1.5,0.4,2.5,0.6c-1,0.9-1.8,1.6-2.6,2.3c-2-0.2-2.7-0.7-3.1-1.9c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.1,0-0.2,0
		c-0.7-0.1-1.5-0.3-2.3-0.5c-0.3,0.2-0.7,0.2-1.2,0.2c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.7-0.4,1.4-0.6,2.1l0,0l0,0c0.1,0,0.2,0,0.3,0
		c0,0,0,0.1-0.1,0.1c0.3,0.1,0.6,0.3,0.9,0.4c0.1,0.5,0.2,0.9,0.3,1.5c0.9-0.3,1.7-0.3,2.4,0.1c0.1-0.7,0.7-0.9,1.9-1.2
		c0.2,0,0.4-0.1,0.5-0.1c1.3,0,2.6,0.1,3.9,0.1c0,0.1,0,0.2,0,0.3c-0.3,0-0.5,0-0.8,0.1l-0.1,0.1c0.4,0.1,0.9,0.2,1.3,0.2
		c0,0.1,0,0.1,0,0.2c-0.3,0-0.5,0.1-0.9,0.1c-0.2,0.3-0.4,0.6-0.6,0.9c-0.3,0.5-0.6,0.7-1.3,0.8c-0.7,0.1-1.4,0.3-2.1,0.5
		c-0.1-0.3-0.1-0.4-0.1-0.7c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.2,0.1,0.2c0.4,1.4-0.6,2.5-2.9,3.3c0.7,0.7,1.6,0.8,2.5,0.5
		c0.9-0.4,1.6-0.2,2.4,0c0.8,0.3,1.7,0.4,2.5,0.6c0.7,0.9,1,1.8,0.4,3.1c1.6-0.5,3-0.8,4.5-1.3c-0.1,1.4-0.1,1.4,1,1.6
		c0.3-0.5,0.7-1,0.9-1.5c0.1-0.3,0.2-0.8,0.1-0.9c-0.9-0.5-0.7-1.4-1-2.1c-0.2-0.3-0.4-0.6-0.6-0.9c-0.6,0.1-0.8,0.4-0.9,0.8
		c0.2,0.2,0.2,0.4,0.1,0.8c-0.3,0-0.5,0-0.6-0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.8-1-1.5-2-2.3-3.1c1.2-1.1,2.6-1.3,4-1.7
		c0-0.4,0.1-0.8,0.1-1.2c0.9-0.8,1.6,0,2.4,0.1c0.2,0-0.3,0.7,0.3,0.3c0.1-0.1,0.2-0.4,0.1-0.5c0-0.2-0.2-0.3,0-0.6
		c0.4,0.2,0.8,0.4,1.3,0.6c0.4-0.4,0.8-0.8,1.3-1.3c0.5,0.1,1.1,0.1,1.7,0.2c0.5-0.2,0.9-0.5,1.4-0.7c-0.1-0.2-0.1-0.5-0.1-0.8
		c0-1.5,1.5-2.2,2.4-3.3c0.2-0.3,0.6-0.5,0.9-0.7c0.1-0.1,0.1-0.2,0.2-0.2C267.4,256.8,267.3,256.5,266.6,256.4z M244.8,260.6
		c0,0.3-0.3,0.5-0.7,0.6c0.1-0.2,0.1-0.4,0.2-0.6l-0.1-0.1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.3,0.2-0.5
		C244.7,260.2,244.8,260.4,244.8,260.6c0-0.1,0.1-0.1,0.1-0.1C244.9,260.5,244.8,260.6,244.8,260.6z M245.2,262.3
		c-0.1-0.1-0.2-0.2-0.2-0.2s0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.1,0.1,0.2C245.3,262.2,245.3,262.2,245.2,262.3z M245.9,260.6
		L245.9,260.6l0.1-0.1L245.9,260.6z M249.3,265.9C249.3,266,249.3,266,249.3,265.9C249.2,266,249.2,266,249.3,265.9
		c-0.1,0.2-0.2,0.2-0.3,0.3c-0.1,0-0.1-0.1-0.2-0.1C248.9,266.1,249.1,266.1,249.3,265.9C249.2,266,249.2,266,249.3,265.9
		C249.2,266,249.3,265.9,249.3,265.9c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0.1C249.4,265.8,249.3,265.9,249.3,265.9z M254.5,259.6
		c0,0,0,0.1,0.1,0.1l-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2C254.4,259.6,254.5,259.5,254.5,259.6z M254.2,257.9l-0.1,0.1v-0.1H254.2z
M253.3,256.4c0.1,0.1,0.2,0.1,0.2,0.2c-0.3,0.2-0.5,0.3-0.8,0.5c-0.1-0.1-0.1-0.1-0.2-0.2C252.8,256.7,253,256.5,253.3,256.4z
M251.1,259.9c0.9,0,1,0.5,1.2,1.2C251.4,260.9,251,260.6,251.1,259.9z M254.9,264.8c-1.9,0.2-2.4-0.1-2.9-1.6
		c0.9-0.5,1.7-0.4,2.5,0C255,263.6,255.5,264.1,254.9,264.8z"
      />
      <path
        class="st4"
        d="M242.4,247.2c-0.2-0.2-0.4-0.4-0.7-0.6c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.3-0.2
		c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.2-0.4-0.3-0.5-0.5c-0.3-0.5-1.1-0.7-1.3-0.5c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.5,0.4,0.7,0.6l0,0
		c0,0,0,0,0,0.1c0.5,0.4,1,0.8,1.5,1.2C242,247.4,242.2,247.3,242.4,247.2z"
      />
      <path
        class="st4"
        d="M269.9,266.8c-0.1,0.1-0.1,0.2-0.2,0.3c0.3,0.1,0.5,0.1,0.8,0.2l0,0C270.4,267.1,270.1,267,269.9,266.8z"
      />
      <path
        class="st4"
        d="M180.2,274.5c0.1-0.1,0.1-0.1,0.2-0.2l0,0C180.3,274.4,180.2,274.5,180.2,274.5z"
      />
      <path
        class="st4"
        d="M85.6,305.1c0,0-0.1,0-0.1-0.1c0.2,0.3,0.3,0.7,0.4,1.1c-0.5-0.2-0.6-0.3-0.8-0.4c-0.3,0.3-0.6,0.6-0.8,0.9
		c0.2,0.1,0.3,0.3,0.4,0.5c0.2-0.2,0.4-0.3,0.6-0.5c1.1,0.7,2.2,1.4,3.7,1.2c0,0.1,0.1,0.1,0.1,0.2c0.2-0.5,0.5-1,0.7-1.4
		c-0.6-0.2-1.4-0.4-1.9-0.7C87.2,305.9,86.5,305.6,85.6,305.1z M85.2,306.1L85.2,306.1L85.2,306.1L85.2,306.1z M86.8,307.4
		c-0.2-0.2-0.4-0.3-0.3-0.4s0.2-0.2,0.3-0.3c0.1,0.1,0.2,0.1,0.2,0.2C86.9,307,86.8,307.1,86.8,307.4z M88.2,307.3
		c0.1,0,0.2,0.1,0.2,0.1c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-0.2,0-0.2-0.1C88.1,307.5,88.1,307.4,88.2,307.3z"
      />
      <path
        class="st4"
        d="M102.6,309.5c0,0.1,0,0.2,0,0.3c0,0,0,0,0-0.1c0.1,0.1,0.2,0.1,0.4,0.2c-0.2,0.1-0.3,0.3-0.5,0.4
		c0,0,0,0,0.1,0c0.6-0.1,1.2-0.2,1.7-0.3c-0.1-0.2-0.1-0.5-0.1-0.8C103.7,309.2,103.2,309.3,102.6,309.5z"
      />
      <path
        class="st4"
        d="M81.5,309.2c0.4,0.3,0.7,0.5,1,0.7c0.1-0.2,0.3-0.4,0.4-0.6c-0.4,0-0.8,0-1.1-0.2
		C81.7,309.1,81.6,309.2,81.5,309.2z"
      />
      <path
        class="st4"
        d="M175,124.9c-0.5-0.3-0.9-0.6-1.2-1l-0.1-0.1c0.1,0.6-0.4,0.8-1.2,0.9c-0.2-0.4-0.5-0.9-0.7-1.4l0,0
		c0,0,0,0,0-0.1l0,0l0,0c0.3-0.2,0.5-0.4,0.6-0.6c-0.4-0.4-0.8-0.8-0.9-1.5c0.8-0.5,1.7-1,2.6-1.4c0.2-0.1,0.7,0.3,1,0.2
		c0.9-0.3,1.8-0.7,2.6-1c0-0.3,0-0.5-0.1-0.7c-0.2,0.2-0.4,0.4-0.6,0.7c-0.4-0.3-0.6-0.4-1-0.7c0.4-0.5,0.8-0.9,1.2-0.9
		c0.5-0.7,0.9-1.3,0.7-2.1c-0.2-0.2-0.5-0.5-1-0.9c0.1-0.1,0.3-0.3,0.4-0.3c0.2,0,0.4-0.1,0.5-0.2c-0.3-0.1-0.6-0.3-1-0.6
		c0.6-0.4,1-0.7,1.4-0.9c0.2-0.1,0.6-0.1,0.8,0c0.4-0.6,0.9-1,1.5-1.5c0.1-0.1,0.3-0.2,0.4-0.3c0-0.2-0.1-0.4-0.2-0.6
		c-0.3-0.5-0.1-1,0.4-1.6c-0.4,0.1-0.7,0.3-1.1,0.4l-0.1-0.1c0.1,0.3-0.2,0.6-0.4,1c-0.6-0.1-1.2,0-1.3-0.5c-0.5,0.1-1,0.2-1.5,0.3
		c0.3,0.3,0.5,0.5,0.8,0.8c-0.5-0.1-1-0.1-1.5-0.2c0,0-0.1,0-0.1,0.1c0,0,0,0,0-0.1c-0.4-0.1-0.8-0.1-1.3-0.2c0-0.3-0.1-0.7-0.2-1.2
		c0.3-0.1,0.6-0.2,0.8-0.1c0.3,0.1,0.5,0.1,0.8,0.1c0.1-0.1,0.2-0.2,0.4-0.3c0,0,0,0,0-0.1c0.1-0.1,0.1-0.1,0.1-0.2
		c0,0-0.1,0.1-0.1,0.2l0,0l0,0l0.1-0.1c0.4-0.5,0.3-1,0-1.5c-0.4-0.5-0.9-1-1.5-1.6c1.4-0.3,0.9-1.3,1-1.9s-0.6-1.5-1.5-1.5
		c-0.8,0-1.4-0.1-2.2-0.2c-0.3-0.8,0.2-1.8-1-2.2l0,0h-0.1c-0.1,0.4-0.2,0.8-0.9,0.6c-0.2-0.4-0.1-0.8,0.4-1.1l0,0
		c-0.4,0-0.8-0.1-1.2-0.1c-0.8,0.1-1.5,0-2.1-0.4c0,1-0.1,2-0.1,3c0,0.2-0.1,0.5,0,0.6c1,1,0.2,2.4,0.7,3.5c0.3,0.6,0.2,1.3-0.3,2
		c-0.5,0.6-0.3,1.3,0.2,1.9c0.7,0.9,1.2,1.9,1.3,3.1c0.1,0.9-0.2,1.5-0.6,2.1c0.1,0,0.3,0.1,0.4,0.1c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.1,0-0.2,0-0.3-0.1c-0.1,0.1-0.2,0.2-0.4,0.3c-0.3,0.3-0.7,0.5-1,0.7c0.4,0.9,1.2,0.8,2,0.5l0.1,0.1c0-0.1,0.1-0.1,0.1-0.2
		c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.3-0.1,0.4c0.4,0.6,0.5,1.2,0.4,1.8c-0.4,0-0.8,0.1-1.2,0c-0.3-0.1-0.5-0.4-0.8-0.5
		c-1.4-0.5-1.4-0.5-1.3-1.9c-0.1,0-0.1-0.1-0.2-0.1l0,0c0.3,0.4,0,0.8,0.1,1.3c-0.3-0.1-0.5-0.2-0.6-0.3c-0.1,0.2-0.2,0.3-0.4,0.5
		c-0.1,0-0.2-0.1-0.2-0.1c0.1-0.2,0.3-0.4,0.4-0.5c-0.2-0.2-0.1-0.4,0.2-0.8c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.7-0.3-1-0.4
		c-1.8-0.2-2.3-0.7-2-2.2c0-0.1,0-0.3,0-0.4l0,0l-0.1-0.1H162h0.1l0,0c0,0,0.1,0,0.1,0.1l0,0c0.3-0.2,0.6-0.4,0.9-0.5
		c1.3-0.5,2.4-0.1,2.7,0.8c0.9,0,1.6-0.5,2.2-1c0-1.2-0.3-2.2-1.3-3c-0.6-0.5-0.7-1-0.7-1.7c0.1-2.2-0.5-4.4-1.7-6.3
		c-0.4,0-1,0-1.4-0.1c-1.3-0.4-2.3,0.3-3.2,1c-0.5,0.4-0.3,0.8,0.2,1.2c0.6-0.2,1.3-0.9,1.9-0.2c0.2,0.2,0.3,0.7,0.2,1
		c-0.3,0.7-1,0.7-1.9,0.3c0.2,1.6-1.2,2.4-1.9,3.7c-0.9-0.6-1.9-1.2-2.7-1.9c-0.8-0.6-1.5-1.2-2.4-2c-0.1,0-0.2-0.1-0.4-0.1
		c0.1,0,0.1-0.1,0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.3,1.5-0.6,2.7-0.8,4c-0.1,0.4,0,0.8,0.1,1.1c0.1,0.1,0.1,0.3,0.1,0.4
		c0.2-0.1,0.4-0.1,0.6-0.2c0.5,0.3,1,0.6,1.4,0.9l0,0c0.1,0.1,0.2,0.2,0.3,0.3c0-0.1,0-0.3,0-0.4l0,0c0.5-0.1,0.7-0.9,1.5-0.4
		c-0.2,0.4-0.4,0.9-0.6,1.5c0.5,0.2,1,0.6,1.4,0.6c1.2-0.2,1.4,0.3,1.5,1.1c0,0.3,0.2,0.7,0.3,0.9c-0.6,0.7-1.1,1.4-1.6,2
		c1.1,0.8,1.6,0.2,2.2-0.4c-0.6-0.5-0.7-0.8-0.5-1.3c0.2-0.4,0.5-0.6,1-0.6l-0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1,0.1,0.3,0.1
		c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0,0.5,0,0.8,0c-0.3,0.6-0.5,1.1-0.8,1.7c0.7,0.2,1.4,0.3,1.5,1.1c0,0.1,0.4,0.1,0.6,0.2
		c0.3,0.1,0.6,0.2,0.9,0.4c0,0,0,0,0-0.1c0.4,0.1,0.7,0.2,1.1,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.3-0.1-0.7-0.2-1-0.2
		c-0.4,0.3-0.8,0.6-1.3,1c0.6-0.1,1.1-0.1,1.6-0.1c-0.3,0.5-0.5,0.8-0.7,1.2c0.6,0.5,1.4,0.6,1.5,1.4c0,0.3,0.7,0.8,1,0.7
		c1-0.2,1.5,0.5,2.4,0.6c-0.1-1.2,1-1.6,1.9-2.2c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0,0.2,0,0.4,0l0,0l0,0c-0.4-0.6-0.1-1.1,0.6-1.6
		c0.2,0.7-0.2,1.1-0.6,1.6c0,0,0,0,0,0.1l0,0c1.1,1-0.2,2.2,0,3.3c-0.5,0.4-0.6,0.8-0.7,1.3c0.2,0,0.3,0,0.6,0
		c0.2,0.1,0.4,0.1,0.9,0.3c-0.2,0.4-0.3,0.8-0.5,1c-0.3,0.3-0.7,0.4-1.1,0.4c0.1,0.1,0.3,0.2,0.4,0.2c0.4-0.1,0.8-0.2,1.2-0.3
		c0.1-0.1,0.3-0.2,0.5-0.3l0.1,0.1c0.3-0.1,0.6-0.1,0.8-0.2C173.3,125.6,174,125.3,175,124.9z M177.2,112.3L177.2,112.3
		c0.1,0.1,0,0.1,0,0.2C177.2,112.4,177.2,112.3,177.2,112.3z M175.3,107.3c0.1,0.1,0.2,0.1,0.2,0.2s-0.1,0.2-0.2,0.4
		c-0.1-0.1-0.3-0.2-0.3-0.2C175.1,107.5,175.2,107.4,175.3,107.3z M167.6,112.4c0,0-0.1,0-0.1,0.1c0,0,0-0.1-0.1-0.1
		C167.4,112.3,167.5,112.3,167.6,112.4C167.6,112.3,167.6,112.4,167.6,112.4z M167.2,111.5c0.1,0,0.3,0.2,0.4,0.3
		c-0.2,0.1-0.3,0.3-0.5,0.4c-0.1,0-0.2-0.2-0.4-0.3C166.8,111.7,167,111.5,167.2,111.5z M163.5,107.7c-0.1,0-0.2,0-0.3,0
		c0-0.1,0.1-0.1,0.1-0.2c0.1,0,0.2,0,0.3,0C163.6,107.6,163.6,107.7,163.5,107.7z M164.7,109.6c0.3,0.3,0.3,0.3-0.5,0.9
		c-0.1-0.3-0.2-0.6-0.4-1.1C164.2,109.4,164.5,109.4,164.7,109.6z M163.3,103.6c0.1,0,0.3,0,0.5,0.1c-0.1,0.2-0.2,0.3-0.3,0.4
		c-0.1,0-0.3-0.1-0.4-0.1C163.1,103.8,163.2,103.6,163.3,103.6z M159.1,108.9c-0.1-0.1-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.5
		s0.4,0.1,0.8,0.2C159.5,108.6,159.3,108.7,159.1,108.9z M165.6,119.8c0,0-0.1,0-0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2l0.1,0.1
		C165.8,119.7,165.7,119.7,165.6,119.8z M173.1,115.4c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.2,0.2-0.4,0.3-0.7c0.1,0,0.2,0.1,0.3,0.1
		C173.3,115,173.2,115.2,173.1,115.4z M173,108.7c0-0.1,0-0.2,0-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0,0.1,0.1,0.1,0.1,0.2
		C173.2,108.6,173.1,108.6,173,108.7z M173.5,113.1c0.1,0,0.2,0,0.3,0c0,0.4,0,0.8-0.1,1.2c-0.1,0-0.2,0-0.4,0
		C173.4,113.9,173.4,113.5,173.5,113.1z M174.1,119.5L174.1,119.5C174,119.5,174,119.5,174.1,119.5c-0.1,0.1-0.1,0.2-0.1,0.2v-0.1
		C174,119.5,174,119.5,174.1,119.5C174.1,119.4,174.1,119.4,174.1,119.5C174.1,119.4,174.1,119.5,174.1,119.5z M173.8,117.9
		c-0.1-0.3,0.1-0.6,0.1-0.9c0.1,0,0.2,0,0.3,0c0.3,0.6,0.6,1.2,0.9,1.8C174,119,173.9,118.4,173.8,117.9z M177.4,116
		c-0.7,1-1.3,0.4-1.9,0C176.4,115.1,176.8,115.9,177.4,116z M174.1,114.4c0-0.1,0-0.1,0.1-0.2l0,0c0.2-0.1,0.4-0.2,0.8-0.2l0,0l0,0
		c-0.2-0.3-0.3-0.5-0.5-0.9c0.4-0.2,0.7-0.5,1.2-0.8c0.1,0.2,0.3,0.4,0.2,0.5c-0.3,0.4-0.6,0.8-0.8,1.2c0,0,0,0,0,0.1H175
		c-0.2,0.5-0.5,0.9-0.7,1.4v-0.1c-0.2,0.2-0.4,0.3-0.4,0.5c-0.1-0.1-0.2-0.1-0.4-0.2C173.7,115.3,173.9,114.9,174.1,114.4
		L174.1,114.4z M173.5,106.1c0,0.2,0,0.4,0.1,0.6c0.1,0.1,0.2,0.1,0.3,0.2c-0.4,0.4-0.6,1-1.1,1.2c-0.6,0.2-1.3-0.1-1.5-0.8
		C172,106.8,172.7,106.5,173.5,106.1z M171.5,105.9c0.1,0.1,0.1,0.3,0.2,0.4c-0.3,0.1-0.7,0.2-1,0.3c0-0.1-0.1-0.1-0.1-0.2
		C170.9,106.3,171.2,106.1,171.5,105.9z M167.9,100.6c1.3-0.3,1.9,0.2,2.1,1.1C168.7,102.2,168.5,102.1,167.9,100.6z M169.4,106.2
		c-0.1,0-0.4-0.2-0.4-0.2c0.1-0.3,0.3-0.5,0.5-0.7c0.1-0.1,0.4,0.1,0.8,0.2C169.9,105.8,169.7,106,169.4,106.2z M170.4,105.5
		c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.2-0.1,0.3h-0.2C170.3,105.7,170.4,105.6,170.4,105.5z M170.4,109.6c0.4-0.5,0.7-0.9,1-1.3
		c0.2,0.5,1,0.9,0.2,1.4C171.4,109.9,170.9,109.7,170.4,109.6z M171.5,123.2h-0.1c0,0,0,0,0-0.1c0,0,0.1,0,0.1-0.1
		C171.4,123.1,171.4,123.2,171.5,123.2z M171,111.6h-0.1H171L171,111.6z M170.8,112.4c-0.1,0-0.1,0-0.2-0.1c0.1-0.2,0.2-0.4,0.3-0.6
		c0.1,0,0.2,0.1,0.3,0.1C171.1,111.9,171,112.1,170.8,112.4z M171.5,125.4c-0.1,0-0.2,0-0.3,0l0.1-0.1c0.1,0,0.2,0,0.3,0
		C171.6,125.3,171.6,125.4,171.5,125.4z"
      />
      <path
        class="st4"
        d="M29.2,316.3c0.2,0,0.4,0.1,0.6,0.1c-0.1-0.1-0.3-0.2-0.4-0.3C29.3,316.2,29.3,316.3,29.2,316.3z"
      />
      <path
        class="st4"
        d="M8.7,335.6c-4-0.5-5-1.9-4-5.1c-1.8,0.2-3.2-0.1-3.9-1.4c-0.5-1-0.2-2.1,0.8-2.9c1.3-1.1,2.8-1.2,4.4-0.7
		c-0.2-0.7-0.3-1.4-0.4-2c-0.7,0.2-1.3,0.4-1.9,0.5c-0.7,0.1-1.3,0.1-2,0.1c-0.3,0.3-0.6,0.6-0.8,0.8c0.3,0.1,0.5,0.4,0.6,0.7
		c0.1,0.6-0.4,1.3-1.1,1.5c-0.1,0-0.2,0-0.3,0v7.8c0.1,0,0.3,0.1,0.4,0.1c0.4,0.2,1.1-0.2,1.5,0.4c0.1,0.2,1,0,1.6,0
		c0,0.3,0,0.6,0,0.9c0.3,0.4,1.4,0,0.9,0.9c0.6,0.5,1.2,1.1,1.8,1.6c0.6,0.3,0.9,0.4,1.1,0.6h2.9c-0.3-0.2-0.5-0.5-0.6-0.9
		C8.7,337.8,8.6,336.7,8.7,335.6z M4.6,324c0.1,0.1,0.3,0.2,0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1-0.1-0.3-0.2-0.4-0.3
		C4.4,324.1,4.6,324,4.6,324z"
      />
      <path
        class="st4"
        d="M24.4,336.6l0.1,0.1l0.1-0.1c0,0-0.1,0-0.1-0.1C24.5,336.6,24.5,336.6,24.4,336.6z"
      />
      <path
        class="st4"
        d="M3.4,189.2c0.1-0.2,0.2-0.5,0.4-1c0.2,0.7,0.7,0.9,1.2,1.1c0.1-1,0.9-1.9,2-2.3c0.6-0.2,1.2-0.3,1.8-0.3
		c-0.2-0.4-0.2-0.8-0.4-1.2c-0.1-0.2,0.3-0.7,0.6-0.8s0.8,0.1,1.1,0.3c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.3,0,1-0.1,1.7
		c0.4,0.2,0.7,0.5,0.9,0.8s0.3,0.6,0.5,0.9c0.2-0.2,0.3-0.3,0.4-0.4c0,0.2,0.2,0.5,0.1,0.6c-0.2,0.1-0.3,0.2-0.4,0.3
		c0.3,0.1,0.5,0.2,0.7,0.3c0-0.4,0.3-0.6,0.9-0.7c0,0,0,0,0-0.1l0,0c-0.8-0.5-1.7-2.3-1.8-3.5c0-0.2-0.2-0.4-0.3-0.7
		c0.2-0.3,0.6-0.8,0.9-1.2c0.3-0.4,0.6-0.8,1-1.1c0-0.3,0-0.7-0.1-0.9c-0.8,0.6-1.6,1.3-2.6,1.8c-0.5,0.3-1.3,0.4-1.9,0.5
		c-1.1,0.2-1.8-0.1-2.3-0.9c-0.3,0.9-1.1,1.6-2.2,1.9c-0.3,0.1-0.5,0.1-0.8,0.1c0.5,0.3,0.8,0.7,0.8,1.3c0.2,0.1,0.2,0.2,0.2,0.6
		c-0.1,0-0.2-0.1-0.3-0.1c0,0.3-0.1,0.7-0.3,1.2c-0.5-0.1-1.2-0.1-1-0.7c0.2-0.7,0-1.3-0.1-1.9c0-0.1,0-0.2,0.1-0.4
		c-0.9-0.2-1.7-0.8-1.9-1.6c-0.3-1.1,0.8-2.5,2.2-2.9c0.4-0.1,1-0.1,1.5,0c-0.5-0.6-0.4-1.3,0-2c1.2-2.2,4.2-3.1,6.6-2
		c0.3-0.2,0.6-0.3,1-0.4c1.5-0.3,2.9,0.4,3.2,1.7c0.2,1.1-0.5,2-1.7,2.5c0.1,0.6,0.1,1.2,0.2,1.8c1.7-1.3,4-1.7,6.1-0.9
		c1,0.4,1.8,1,2.2,1.8c0.3-0.2,0.6-0.4,0.9-0.6c-0.6-0.9-0.1-1.8,0.2-2.6c0.2,0.3,0.2,0.7,0.3,1c0.1,0.3,0.3,0.5,0.5,0.6
		c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.9,0.7-1.9,1.9-2.1c0.6-0.1,1.2,0,1.6,0.3l0.1-0.1c0.1,0,0.2,0.1,0.3,0.1c0,0.1,0,0.3-0.1,0.4
		c0.2,0.2,0.3,0.4,0.3,0.7c0.1,0.7-0.3,1.3-0.9,1.7c0,0.2,0.1,0.3,0.2,0.5c0.1,0.3,0.3,0.6,0.5,0.8c0.4-1.3,2-2.1,3.7-1.6
		c-0.1-0.3-0.3-0.7-0.4-1s-0.2-0.7-0.3-1.1c-0.5,0.5-1.1,0.8-1.8,0.4c-0.3-0.2-0.5-0.5-0.5-0.9l0,0l0,0c0-0.2,0-0.4,0.1-0.6
		c0.3-0.7,1.1-1,1.7-0.5c0.4,0.3,0.6,0.7,0.9,1.1c0.2-0.3,0.4-0.6,0.7-0.9c-0.3,0-0.5,0-0.6,0s-0.2,0-0.3,0
		c-0.1-0.1-0.3-0.1-0.4-0.2c0-0.1,0-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.3-0.4c0.1,0,0.1-0.1,0.2-0.1c0,0.2,0.1,0.3,0.1,0.5l0.1,0.1
		c0.2,0.1,0.3,0.1,0.5,0.2c0.1,0,0.1,0,0.2,0c0.7-0.1,0.4-0.5,0.4-0.9c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.3-0.1-0.4-0.2
		c0,0,0-0.1-0.1-0.1H31h0.1l0,0h0.1c0.1,0.1,0.3,0.1,0.4,0.2c0,0.1,0,0.1,0,0.2c0.1,0.2,0.3,0.4,0.5,0.7c0.9-0.7,2-1.1,3.5-1.1
		c-0.9-1-1.3-2-0.7-3c0.5-0.9,1.3-1.7,2-2.6c-0.6-0.2-1.2-0.5-1.4-1.2c0.7-0.1,1.2-0.2,1.8-0.3c0.4,1.4,0.4,1.4,1.3,1.3l0.1-0.1
		c0-0.1,0-0.2-0.1-0.3c-0.2-0.8-0.2-1.6,0.1-2.3c-0.3-0.1-0.5-0.3-0.6-0.6c-0.1-0.5,0.4-1.1,1-1.3c0.3-0.1,0.7,0,0.9,0.1
		c0.2-0.2,0.4-0.3,0.7-0.5c0.9-0.6,1.5-1.3,1.7-2.3c0.1-0.4,0.2-0.8,0.4-1.2c0.1-0.5,0.2-1,0.4-1.6l0,0c-0.1,0.7-0.6,1.3-1.4,1.6
		c-0.5,0.2-1,0.3-1.5,0.1c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.3,0,0.8,0.1,1.4c-0.7-0.1-1.2-0.2-1.7-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		c-0.1,0.2-0.2,0.4-0.3,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.5,0.1,0.9-0.8,1.6c0.1,0.5,0,0.9-0.4,1.3c-0.4,0.4-0.9,0.8-1.4,1
		c-1,0.4-1.8,0.2-2.6-0.5c-0.1,0.1-0.1,0.2-0.2,0.3c-0.4-0.4-0.5-0.6-0.4-0.9c-0.1-0.1-0.2-0.1-0.4-0.2c-0.4,0.4-0.8,0.9-1.4,1.4
		c-0.6-0.6-1.5-0.9-1.7-1.7c-0.1-0.4-0.3-0.3-1.1,0c1.4,2.4,1.5,3.6-0.5,4.7c0.1,0,0.1,0.1,0.1,0.1c-0.2,0.3-0.4,0.5-0.6,0.7
		c-0.2-0.1-0.3-0.2-0.5-0.3c0.1-0.1,0.2-0.1,0.3-0.2c-0.4,0.2-0.8,0.3-1.2,0.5c0.1,0.2,0.2,0.5,0.3,0.7c0.3,0,0.6,0,0.9,0.2
		s0.5,0.6,0.8,0.9c-0.3,0.6-0.7,0.9-1.2,1.1c0,0.2-0.1,0.3-0.3,0.5c0,0-0.1,0.1-0.2,0.1c-0.5,0.8-1.2,1.4-2.2,1.7
		c0,0.1,0,0.2,0.1,0.2c-0.1,0-0.1,0-0.2,0c0-0.1-0.1-0.2-0.1-0.2c-0.2,0-0.4,0.1-0.6,0.1c-1.5,0.2-3-0.5-3.6-1.6
		c-0.7-1.3-0.2-2.7,1.1-3.8c0.3-0.2,0.6-0.4,0.8-0.6c-0.1-0.8-0.1-1.5-0.2-2.3c-0.8,0.2-1.6,0.2-2.2,0.1c-0.2,0-0.5-0.1-0.7-0.2
		c-0.6-0.2-1.1-0.5-1.7-0.9c0-1.5,0.2-2.9,2-3.8c1.5-0.8,2.7-0.3,3.9,0.5c0.2-0.3,0.5-0.7,0.8-1.1c-1.2-0.1-2.2-0.4-2.6-1.3
		c-0.1-0.1-0.1-0.3-0.1-0.4c-0.3,0.3-0.6,0.5-0.9,0.7c-1.2,0.7-2.3,0.6-2.9-0.4c-0.6-0.9-0.4-1.9,0.5-2.7c0.4-0.4,0.9-0.7,0.6-1.3
		c-0.1-0.4,0.4-0.8,1-0.8s1,0.4,0.8,0.8c-0.3,0.6,0.1,0.8,0.4,1.1s0.5,0.7,0.6,1.1c0.4-0.9,1.4-1.3,3.7-1.6l0,0h-0.1
		c-1,0.2-1.9-0.2-2.1-1c-0.2-0.7,0.5-1.6,1.4-1.8c0.1,0,0.1,0,0.2,0c-0.7-0.4-1.3-0.7-1.9-1c-0.3,0.1-0.7,0.3-1.1,0.4
		c-1,0.2-1.9-0.1-2.4-0.8c-0.3-0.5-0.7-0.9-1-1.3c0.6-0.5,1.2-1,1.8-1.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4,0.1-1.1,0.1-1.3,0.3
		c-0.8,0.8-1.9,0.8-2.8,1c-1.4,0.3-2,0.1-2.7-1c-0.1-0.2-0.2-0.4-0.3-0.6c-0.9,0.7-1.7,1.3-2.5,1.9c-0.1-0.1-0.2-0.1-0.3-0.2
		c0.3-0.5,0.5-0.9,0.7-1.4c0-0.1-0.2-0.2-0.3-0.3c-0.1,0.2-0.1,0.5-0.3,0.6c-0.7,0.6-1.5,1.2-2.2,1.8c1.2,0.7,2.4,1.4,3.6,2.1
		c0.1-0.2,0.3-0.4,0.5-0.5s0.4-0.2,0.5-0.3c0.2,0.1,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.3,0.2,0.4c-0.4,1.1,0.4,2.2-0.4,3.5
		c-0.4-0.4-0.5-0.7-0.8-0.9c-0.7,0.4-1.1,1-1,1.7c-0.2,0-0.5,0.1-0.5,0.2c-0.3,1-1.4,1.3-2.2,1.9c-0.5,0.4-1.2,0.3-1.3,0.5
		c-0.5,0.8-0.9,0-1.3,0.1c-1,0.2-1.7-0.3-2.5-0.3c0,0.6-0.1,1.2-0.1,1.8c-0.1,0-0.2,0-0.3,0c-0.2-0.6-0.4-1.2-0.7-1.8
		c-0.2-0.4-0.2-1.2-0.9-1.2v10.2c0.1,0,0.2-0.1,0.2-0.1c0.5-0.1,1,0,1.1,0.5c0,0.3-0.3,0.7-0.5,1.3c-0.3-0.2-0.5-0.3-0.7-0.5v2.7
		c0,0,0-0.1,0.1-0.1s0.2,0,0.3,0L0,176.5c-0.1,0-0.2,0-0.3-0.1v8.8h0.1c0,0.1-0.1,0.1-0.1,0.2v5.6c0.3-0.3,0.3-0.7,0.6-1
		C1.5,189.9,2.4,189.6,3.4,189.2z M30.6,180.4L30.6,180.4L30.6,180.4L30.6,180.4z M32.4,175.5l0.1-0.1L32.4,175.5L32.4,175.5z
M32.6,170.8c0.3,0.2,0.6,0.4,0.7,0.5c0,0.1-0.3,0.4-0.5,0.5c-0.1,0-0.5-0.2-0.5-0.3C32.2,171.4,32.4,171.2,32.6,170.8z
M28.9,177.3c0-0.1-0.1-0.1-0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.2,0.1,0.2S29,177.2,28.9,177.3z M29.8,176.3
		c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2C29.6,176.1,29.7,176.2,29.8,176.3z M28.9,172.5
		L28.9,172.5L28.9,172.5L28.9,172.5z M29,175.3c0.1,0,0.4,0,0.4,0.1c0.2,0.4-0.1,0.7-0.6,0.8C28.4,175.9,28.5,175.6,29,175.3z
M18.4,176.7c0,0,0,0.1,0.1,0.1c-0.1,0-0.1,0-0.2,0.1C18.3,176.9,18.3,176.8,18.4,176.7C18.3,176.8,18.3,176.7,18.4,176.7z
M15.7,173.3c0.6-0.1,1.2,0.2,1.4,0.7c0.1,0.5-0.4,1.2-1,1.3c-0.7,0.1-1.4-0.3-1.5-0.8S15,173.4,15.7,173.3z M14.6,161.3
		c0,0.1,0.1,0.1,0.1,0.2l-0.1,0.1c-0.1-0.1-0.1-0.1-0.1-0.2C14.5,161.4,14.5,161.3,14.6,161.3z M14.1,168.3
		c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.3,0-0.5,0c0.1-0.2,0.2-0.3,0.3-0.4C13.8,168.3,14,168.3,14.1,168.3z M13.2,165.7
		c-0.6-0.3-0.7-0.8-0.7-1.4C14,164.4,14.2,164.7,13.2,165.7z M12.6,155.2c0.1,0.4,0.2,0.8,0.3,1.4C12.1,156.3,12,155.8,12.6,155.2z
M11.9,165.7L11.9,165.7c0.1,0,0.2,0.1,0.3,0.1l-0.1,0.1C12,165.8,12,165.8,11.9,165.7L11.9,165.7L11.9,165.7L11.9,165.7z
M9.9,167.8H10c0,0,0,0.1,0.1,0.1c-0.1,0-0.1,0-0.2,0C9.8,167.9,9.8,167.9,9.9,167.8z M9.7,170.3c0,0.1,0,0.1,0,0.2
		C9.7,170.4,9.7,170.4,9.7,170.3L9.7,170.3z M8.5,171.7L8.5,171.7L8.5,171.7L8.5,171.7z M7,168.1c0.2,0,0.3,0,0.5-0.1
		c0.1,0.4,0.1,0.8,0.2,1.5C6.7,169,6.6,168.6,7,168.1z M5.9,171.6c0.2,0,0.4,0,0.7,0.1c-0.1,0.2-0.2,0.5-0.3,0.5
		c-0.2,0-0.4-0.1-0.6-0.2C5.7,172,5.8,171.7,5.9,171.6z M1,168.7c-0.3,0-0.5-0.2-0.7-0.3c0.1-0.2,0.2-0.6,0.4-0.6s0.5,0.2,0.8,0.3
		C1.3,168.4,1.2,168.7,1,168.7z M0.9,189.2H1c0,0.1-0.1,0.2-0.1,0.3c-0.1,0-0.2-0.1-0.2-0.1S0.8,189.3,0.9,189.2z M0.3,174.6
		l-0.1-0.1c0-0.1,0-0.2,0.1-0.2s0.2,0.1,0.2,0.1C0.5,174.5,0.4,174.6,0.3,174.6z"
      />
      <path
        class="st4"
        d="M1.7,310.6c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.2-0.2,0.3-0.3,0.5c0.3,0.1,0.6,0.2,0.9,0.4c0-0.1,0-0.2,0-0.3
		c0,0,0,0-0.1,0L1.9,311l0.1-0.1c0,0,0,0,0,0.1c0-0.1,0-0.1,0-0.2l0,0C2,310.8,1.8,310.7,1.7,310.6z"
      />
      <path
        class="st4"
        d="M0.5,305.2c0.2,0,0.3,0,0.4,0c-0.1-0.3,0-0.7,0.1-1C0.9,304.5,0.7,304.8,0.5,305.2z"
      />
      <path
        class="st4"
        d="M284.2,262.8c0,0.3-0.1,0.6-0.1,0.9c0.3,0.1,0.6,0.3,0.8,0.4c-0.2,0.1-0.4,0.1-0.6,0.2c0,0.1,0.1,0.1,0.1,0.2
		c0.2-0.1,0.4-0.3,0.6-0.4c0.5,0,1-0.3,0.8-0.6C285.5,263.1,285.2,262.4,284.2,262.8z"
      />
      <path
        class="st4"
        d="M2.4,313.7c0-0.1-0.1-0.1-0.1-0.2c0-0.2,0-0.5,0-0.7c-1,0.1-1.5-0.5-2-1.1c-0.1,0.1-0.3,0.1-0.4,0.2v0.7
		c0.2,0.1,0.3,0.2,0.5,0.4C1.2,313,1.9,313.2,2.4,313.7z"
      />
      <path
        class="st4"
        d="M5.3,304.1c0.3,1-0.5,2-1.7,2.3c-0.1,0-0.1,0-0.2,0v0.1c0.2,0.7-0.1,1.4-0.9,1.9c-0.4,0.3-0.8,0.4-1.2,0.5
		c0.1,0.1,0.1,0.3,0.1,0.4c0.1,0.4,0,0.8-0.1,1.1c0.1,0,0.2,0.1,0.2,0.1c0.2,0.1,0.3,0.1,0.5,0.2c0,0,0,0,0,0.1
		c0.3,0.1,0.6,0.2,1,0.4c0.1-0.4,0.2-0.8,0.5-1.1c0.6-0.5,1.5-0.9,2.3-1.4c-0.5-1.2,0-2.6,0.7-3.8C6.2,304.7,5.7,304.4,5.3,304.1z"
      />
      <path
        class="st4"
        d="M5.8,339.2c0.1-0.1,0.2-0.2,0.3-0.3C6,339,5.8,339.1,5.8,339.2C5.7,339.1,5.8,339.2,5.8,339.2z"
      />
      <path
        class="st4"
        d="M225.1,95.7c0.1,0,0.4-0.1,0.4-0.1c0-0.2,0-0.3,0-0.5c-0.1,0.1-0.3,0.2-0.3,0.3
		C225.1,95.5,225.2,95.6,225.1,95.7z"
      />
      <path
        class="st4"
        d="M227.3,93.6c-0.5-0.5-0.9-1-1.7-0.3c0,0.6-0.1,1.2-0.1,1.7c0.5-0.4,0.9-0.8,1.4-1.1l0,0l0.1-0.1l0,0
		C227.1,93.7,227.2,93.6,227.3,93.6z M226.4,93.1L226.4,93.1h0.1H226.4z"
      />
      <path
        class="st4"
        d="M226.9,91.1c0.1-0.3,0.2-0.4,0.2-0.5c-0.1-1.4,0.4-2.6,2.2-3.2c0.5-0.2,0.5-0.7,0.2-1.2
		c-0.5,0.1-1.3,0.2-1.4,0.4c-0.2,0.8-1.2,1-1.5,1.7c-0.4,1-1.4,1.8-2.4,2.2c-1.3,0.5-1.7,1.3-2,2.3c0.4,0.2,0.8,0.4,1.3,0.6
		C224.1,92.2,225.1,91.2,226.9,91.1z"
      />
      <path
        class="st4"
        d="M221.6,95.3c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C221.7,95.4,221.6,95.4,221.6,95.3z"
      />
      <path
        class="st4"
        d="M201.2,117.5c-0.4-0.4-0.6-1-1.5-0.7c0.1,0.4,0.3,0.8,0.2,1.2c-0.1,0.4-0.5,0.7-0.8,1.1
		c1.3,0.7,2.2-0.3,3.2-0.7C201.7,118.3,201.5,117.8,201.2,117.5z"
      />
      <path
        class="st4"
        d="M274.3,90.2c0,0.1,0,0.1-0.1,0.2h0.1C274.3,90.2,274.3,90.2,274.3,90.2z"
      />
      <path
        class="st4"
        d="M179.4,122.7c-0.4,0.3-0.3,0.5,0.1,0.7v0.1c0.1,0,0.2-0.1,0.3-0.1c0.5-0.2,0.4-0.5,0.2-0.8
		C179.9,122.5,179.5,122.6,179.4,122.7z"
      />
      <path
        class="st4"
        d="M184.2,108.8C184.2,108.7,184.1,108.8,184.2,108.8C184.1,108.8,184.2,108.8,184.2,108.8L184.2,108.8z"
      />
      <path
        class="st4"
        d="M294.1,93C294,93.1,294,93.1,294.1,93c0,0.1,0,0.2,0.1,0.2v-0.1C294.1,93.1,294.1,93.1,294.1,93z"
      />
      <path
        class="st4"
        d="M150.4,136.7L150.4,136.7c0.1-0.1,0.2-0.3,0.4-0.4c0.5-0.4,1-0.8,1.6-1c-0.1-0.2-0.1-0.4-0.2-0.5
		c0.5-0.8,0.9-1.3,1.1-1.8c0.1-0.4,0.4-0.7,0.6-1c-0.4-0.1-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.7-0.4-1.1c-0.1,0-0.2,0-0.3,0
		c-0.1,0.5-0.2,1-0.3,1.4c-0.9,0.8-1.9,0.3-2.8,0.3l-0.1,0.1c-0.2,0.4-0.5,0.7-0.8,1.2c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.4,0.2-0.8,0.4-1.3,0.6c-0.5,0.1-1,0.2-1.4,0.1c0.1,0.1,0.3,0.1,0.4,0.2c0.5,0.4,0.5,0.9,0.4,1.5l0,0l0,0
		c0.4-0.2,0.8-0.4,1.1-0.6c0.6,0.3,1.2,0.6,1.7,0.9c0.5,0.3,0.5,1,0.1,1.2c-0.5,0.3-1,0.2-1.2-0.2s-0.6-0.5-1.1-0.6
		c-0.3-0.1-0.5-0.4-0.7-0.6c0,0,0,0-0.1,0c0,0,0,0,0-0.1c-0.6,0-1.2,0.1-1.7,0.1c-0.6,0-0.7-0.4-0.7-0.9s0.5-0.9,1-1
		c-1-0.2-1.8-0.8-2.2-1.7c-1.4,0-2.5-0.8-2.8-2c-0.4-1.5,0.8-3.1,2.6-3.5c0.3-0.1,0.6-0.1,1-0.1c0-0.1,0.1-0.3,0.3-0.4
		c0.5-0.4,1.1-0.8,1.8-1.3l0.1,0.1c0-0.2,0-0.4,0-0.7c0-0.1,0-0.2,0-0.3c-0.2,0.1-0.3,0.1-0.5,0.2c-0.7,0.2-1.3,0.1-1.7-0.4
		c0.5-0.7,1-1.4,1.5-2.2c-1.8-0.5-1.7-1.5-1.3-2.6c0.1-0.2,0.1-0.3,0.2-0.5c0-0.1-0.1-0.2-0.1-0.2c-1.2-0.1-1.1,1.4-2.3,1.4
		c-0.2-0.2-0.5-0.5-0.7-0.8c-0.2,0.9-1.1,1.7-2.2,1.6c-0.7-0.1-1,0.2-1.4,0.5c-0.9,0.6-2,0.7-2.8,0.2c-0.9-0.7-1.8-0.7-3-0.7
		c0,0.1,0,0.3,0,0.5c0.3,0.1,0.6,0.3,0.9,0.7c-0.1,0.6-0.5,1-1,1.3c0.1,0.2,0.1,0.4,0.1,0.6c0.1,0.9,0.7,1.3,1.4,1.8
		c0.6,0.4,1,0.8,1.6,1.2c0.4,0.3,0.7,0.5,1.1,0.7c1.4,0.7,2,1.9,1.6,3.2c-0.2,0.6-0.5,1.1-0.9,1.4l0,0c-0.1,0.1-0.3,0.3-0.5,0.4
		h-0.1c-0.5,0.3-1.2,0.5-1.9,0.6c-0.4,0-0.7,0.1-1.1,0.2c-0.7,0.2-1.4,0.4-2.2,0.7c0.4,0.1,0.8,0.2,1.2,0.3c0.8,0.1,1.5,0.2,2.3-0.3
		c1-0.6,2.4-0.1,2.4,0.8c-0.1,1.2,0.6,1.9,1.1,2.8c0,0.1,0,0.2,0,0.6c-2-0.6-3.8-1.1-5.6-1.7c-0.1,0.3-0.2,0.5-0.2,0.7
		c1.1-0.2,2.3,0.1,3.1,0.7c1.7,1.4,2,1.9,0.8,5c0.7-0.2,1.3-0.3,1.8-0.3c0-0.2,0.1-0.4,0.2-0.7c-0.1-0.3-0.2-0.5-0.3-0.8
		c-0.3-2.1,0.9-3.6,3.2-4.1c1.6-0.4,3.1,0.1,3.9,1.2c-0.1-0.3-0.1-0.7-0.3-1.2c0.6,0.3,0.9,0.4,1.3,0.6c0.4,0.2,0.7,0.5,1.2,0.7
		c0.2-0.5,0.4-0.8,0.7-1.3c0.5,0.5,0.9,1,1.3,1.4c0.5,0.6,1.1-0.3,1.5-0.2C149.9,137.4,150.1,137.1,150.4,136.7
		C150.4,136.8,150.4,136.7,150.4,136.7z M135.7,124.6c-0.4,0.3-0.8,0.5-1.2,0.1c-0.1-0.1,0-0.3,0.1-0.4c0.2-0.3,0.3-0.3,1.3,0
		C135.8,124.5,135.8,124.6,135.7,124.6z M136.7,133c-0.3,0.1-0.5,0.2-0.8,0.3c0-0.1-0.1-0.2-0.1-0.3c0.3-0.1,0.6-0.1,0.9-0.2
		C136.7,132.8,136.8,133,136.7,133z M141.8,122.5c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C141.7,122.6,141.8,122.5,141.8,122.5z M141.8,125.7c0,0,0.2,0.1,0.5,0.3c-0.3,0.2-0.4,0.3-0.6,0.3c-0.1,0-0.3-0.1-0.4-0.1
		C141.4,126,141.6,125.8,141.8,125.7z M140.8,123.6L140.8,123.6v0.2V123.6C140.7,123.6,140.8,123.6,140.8,123.6z M139.6,124.2
		c0.8,0.5,1,1.2,1.2,1.9c0.1,0.5-0.3,0.7-1,0.8c-0.5-0.5-1-1-1.5-1.5C138.3,124.7,138.9,124.5,139.6,124.2z M138.3,132.3
		C138.3,132.4,138.3,132.4,138.3,132.3c-0.1,0-0.2,0-0.2,0S138.2,132.3,138.3,132.3z M141.1,135.8c-0.6,0.1-1.4,0.5-2,0.4
		c-0.5-0.1-0.8-0.7-1.2-1.2c0.6-0.3,1.2-0.5,1.7-0.7s1.1-0.5,1.7-0.8C141.2,134.3,141.2,135,141.1,135.8z M149.6,134.7
		c-0.5,0.3-0.9,0.2-1.2-0.2c-0.3-0.3-0.1-0.7,0.3-0.9c0.4-0.2,0.9-0.2,1.5-0.3C150.4,134,150.1,134.3,149.6,134.7z"
      />
      <path
        class="st4"
        d="M133.2,117.4c1.2-0.8,2.4-1.2,3.8-0.6c0-0.3-0.1-0.5-0.1-0.9c-0.6-0.2-1.2-0.5-1.8-0.8
		c-0.2,0.2-0.3,0.5-0.5,0.7l0,0c0.1,0,0,0.3-0.1,0.4c-0.1,0-0.2,0.1-0.4,0.1c-0.3,0.3-0.8,0.6-1.2,0.9c-0.2,0.1-0.4,0.1-0.6,0.2
		c0.1,0.1,0.2,0.3,0.3,0.4C132.9,117.7,133,117.6,133.2,117.4z"
      />
      <path
        class="st4"
        d="M128.7,120c-0.1-0.6,0.2-0.8,1.6-0.9c0.3-1.4,0.3-1.4-0.9-2.2c-0.5,0.2-0.9,0.4-1.4,0.7c0,0,0.1,0,0.1,0.1
		c0.1,0.1-0.1,0.5-0.2,0.5c-0.3,0.1-0.7,0.3-1,0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.3,0.2-0.7,0.3-1,0.5c-0.4,0.2-0.6,0.7-0.9,1
		c0.6,0.9,2.2,1.6,3.5,1.6c0.4,0,0.7,0,1,0.1c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.1,0.3-0.2,0.4-0.3c-0.2-0.3-0.3-0.6-0.5-0.8
		C129.3,119.9,129,120,128.7,120z"
      />
      <path
        class="st4"
        d="M117.8,124.7c-0.8,0.6-1.6,0.8-2.4,0.6c0.1,0.4,0.2,0.8,0.3,1.1c1.5-0.2,2.6,0,3.2,0.5c0.5-0.5,1.1-0.8,1.9-1
		c0.3-0.1,0.7-0.1,1.2-0.1c-0.9-2,0-3.7,1.2-5.4c-0.7-0.3-1.4-0.5-1.9-0.9c-0.4-0.4-0.6-1-1-1.6c-2.1-0.9-3.9-0.1-4.7,2.4
		c1.6,0,2.9,0.4,3.3,1.8C119,123.2,118.7,124.1,117.8,124.7z M118,118.9C118,118.9,117.9,118.9,118,118.9v-0.2
		C118,118.7,118,118.8,118,118.9C118,118.8,118,118.9,118,118.9z"
      />
      <polygon class="st4" points="61.1,173.3 61.1,173.4 61.2,173.3 	" />
      <polygon class="st4" points="151.6,129.3 151.5,129.3 151.6,129.4 	" />
      <path
        class="st4"
        d="M136.8,113c-0.2-0.2-0.1-0.6-0.1-0.9c-0.1,0.7-0.4,1.3-0.7,1.8c0.1,0,0.2,0.1,0.3,0.1
		C136.5,113.6,136.9,113.1,136.8,113z"
      />
      <path
        class="st4"
        d="M151.7,126.8c0,0.1,0,0.2,0,0.3c0.1-0.1,0.1-0.2,0.2-0.2C151.8,126.9,151.7,126.9,151.7,126.8z"
      />
      <path
        class="st4"
        d="M143.2,117.3c-0.1-0.3-0.3-0.5-0.5-0.8c0.1,0.3,0.3,0.6,0.4,0.9C143.2,117.4,143.2,117.4,143.2,117.3z"
      />
      <path
        class="st4"
        d="M137.6,111.1c0.8,0,1,0.5,1,0.9s-0.3,0.8-0.5,1.2c0.4,0.1,0.8,0.3,1.2,0.4c-0.1-0.1-0.3-0.2-0.5-0.3
		c-0.1,0-0.1-0.5,0-0.7c0.3-0.3,0.6-0.2,0.9,0.1c0.1,0.1,0.2,0.2,0.4,0.4c0.4-0.4,0.7-0.8,1.1-1.1c-0.4-1-1.2-1.1-2.4-0.8
		c0-0.6,0-1.1-0.1-1.6c-0.5,0.1-1,0.2-1.7,0.4c0,0.2-0.1,0.3-0.1,0.5C137.2,110.9,137.4,111.1,137.6,111.1z M139.8,112.1
		L139.8,112.1L139.8,112.1L139.8,112.1z"
      />
      <path
        class="st4"
        d="M121.8,131.5L121.8,131.5c-0.4,0.1-0.8,0.1-1.2,0c-1.1-0.1-2-0.7-2.4-1.6c-0.7,0.4-1.5,0.4-2.4,0.3
		c0,0.2,0,0.4,0.1,0.6c0.5,0.2,1,0.5,1.3,1c0.2,0.2,0.3,0.6,0.6,0.7c0.7,0.4,1.4,0.8,2.2,0.8c0.2-0.4,0.5-0.7,1-1.1
		C121.4,132.1,121.7,132,121.8,131.5z"
      />
      <path
        class="st4"
        d="M47.2,157.3c1.3-1,2.2-0.9,2.9,0.3c0.1,0.2,0.2,0.5,0.4,0.6c0.1-0.1,0.3-0.2,0.5-0.3c0.5-0.1,1.2,0.2,1.3,0.6
		c0.1,0.2,0,0.4-0.2,0.6c0.4,0.3,0.9,0.5,1.6,0.2c0.1,0.3,0.4,0.6,0.5,0.9c0.1-0.2,0.3-0.5,0.4-0.7c2.7-0.7,3.4-0.3,3.8,2.2
		c0.5,0.2,1.1,0.4,1.9,0.6c-0.3,0.2-0.5,0.4-0.7,0.6c0.2,0,0.4,0,0.6,0c0.4-0.4,0.9-0.7,1.5-0.8c0.4-0.1,0.8-0.1,1.2,0
		c0-0.2,0-0.3,0-0.5c0.7-0.3,1.5-0.7,2.5-1.1c-0.1-0.8,0-1.5,0.4-2.1c-0.1-0.2-0.1-0.4,0-0.6c0.2,0,0.4,0,0.5,0.1
		c0.2-0.2,0.5-0.4,0.8-0.6c0.8-0.5,1.3-1.4,2-2.2c0.5,0,1,0,1.5,0c0,0,0,0,0-0.1h-0.1c-0.8-0.2-1.2-1.1-0.9-1.8
		c-0.4-0.1-0.8-0.2-1.1-0.3c-0.6-0.1-1.3,0-2.2-0.1c1.1,1.5,0.2,3-0.2,4.4c-0.2,0.6-0.8,1.1-1.8,1.3c0-0.6-0.1-1.1-0.1-1.9
		c-0.8,0.2-1.4,0.4-2.1,0.7c-0.2-0.3-0.3-0.7-0.3-1c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.2v-0.1
		c-0.1,0-0.2-0.1-0.3-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0.1,0c0.1,0.1,0.3,0.1,0.4,0.2c0,0,0.1,0,0.1,0.1
		c0.1,0,0.3,0,0.4,0c-0.2-1.2,0.2-2.4,1.1-3.2c0.9-0.8,0.3-1.5,0.1-2.2c-1.4,0.2-2.5,0.6-3.1,1.8c-0.2,0.3-0.7,0.6-1.1,0.8
		c-1-0.1-1.8-0.4-2.4-1c-0.2,0-0.3,0-0.5,0c0-0.1,0-0.2,0-0.3c0.1,0,0.2,0,0.3,0c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.7-0.6-1-0.9
		c0.3-0.9,1.3-0.6,2-1c-0.1-0.6-0.3-1.2-0.4-1.9c-0.6,0.7-0.9,1.4-1.9,1.2c-0.1,0-0.4,0.2-0.4,0.3c-0.6,1.3-2.4,2-2.7,3.5
		c0,0.1,0,0.1-0.1,0.1c-1.5,0.4-1.9,2.2-3.7,2.2c0,0.4,0,0.7,0,1c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0.2-0.2,0.4-0.4,0.6
		c0,0.3,0.1,0.6,0.1,1C46.9,157.4,47.1,157.4,47.2,157.3z M59.6,160.6L59.6,160.6L59.6,160.6C59.7,160.6,59.7,160.6,59.6,160.6
		C59.7,160.6,59.6,160.6,59.6,160.6z M61.7,157.7c0.2,0.1,0.4,0.1,0.4,0.2c0,0.1,0,0.3-0.1,0.3c-0.2,0-0.3,0-0.4,0
		C61.6,158.1,61.7,158,61.7,157.7z M59.3,158c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1-0.1-0.2-0.1-0.2-0.2
		C59.1,158.2,59.2,158.1,59.3,158z M59.2,158.8c2.2-0.1,2.7,0.1,3.1,1.8c-0.8,0.6-1.6,0.5-2.3,0.1C59.2,160.2,58.9,159.6,59.2,158.8
		z M54.3,154.3c0.9,0,1.4,0.4,1.9,1C54.6,155.9,54.2,155.8,54.3,154.3z"
      />
      <path
        class="st4"
        d="M62.8,132.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.2-0.3-0.6-0.5-0.9
		c-1.2,0.3-0.6,1.2-1.1,1.7c0.1,0.1,0.3,0.1,0.4,0.2C62.1,133.3,62.4,133.1,62.8,132.9z"
      />
      <path
        class="st4"
        d="M112.8,147.7c0.6-0.1,1.2,0.1,1.6,0.5c0.2-0.2,0.3-0.3,0.5-0.5c0.3-0.2,0.5-0.3,0.8-0.5c0-0.4-0.1-0.9-0.4-1.2
		s-0.5-0.5-0.6-0.6c-0.7,0.9-1.8,1.6-3.3,1.4c-0.6-0.1-1.2-0.4-1.6-0.8c-0.1,0.2-0.3,0.5-0.5,0.8c-0.3-0.2-0.6-0.4-0.6-0.5
		c0.1-0.3,0.4-0.5,0.6-0.7c0.1,0.1,0.2,0.1,0.4,0.2l0,0l0,0c-0.2-0.3-0.3-0.5-0.3-0.8v-0.1c-0.5,0.4-1.3,0.7-2,0.5
		c-1.1-0.2-2.1-1.1-1.6-1.9c0.6-1.1,0.1-2-0.4-3c1.6,0,1.6,0,2.3,1.2c0.2,0,0.3,0.1,0.5,0.1c0.2-0.1,0.4-0.2,0.6-0.2
		c0.9-0.2,1.7,0.3,2,1c0.2-0.2,0.5-0.3,0.8-0.5c-0.4-0.8-0.6-1.6-0.5-2.6c-0.2,0.2-0.4,0.3-0.8,0.4c-0.8,0.2-1.5-0.1-1.6-0.8
		c-0.1-0.6,0.3-1.1,1-1.3s1.3,0,1.6,0.6c0.1-0.5,0.3-1.1,0.5-1.8c-0.2-0.2-0.4-0.4-0.6-0.7c-0.1-0.2-0.2-0.3-0.3-0.5
		c-0.3,0.1-0.6,0.2-0.9,0.2c-0.5,0-1.1-0.1-1.8-0.1c-0.3,0.6-0.8,1.3-1.9,1.2c-0.6-0.1-0.9-0.5-0.9-1c-0.1-1.1,1.1-1.1,2-1.5
		c-0.3-0.3-0.5-0.4-0.8-0.6h-0.1c-0.2,0-0.3,0-0.5,0c0.2,0,0.3,0,0.5,0c0,0,0,0,0.1,0.1c0.6,0,0.6-0.5,0.8-0.9
		c0.5-0.9,1.4-1.5,2.6-1.6c0.8,0,1.4,0.2,1.9,0.6c0.1-0.1,0.2-0.2,0.4-0.3c0.9-0.6,2-0.7,3-0.5c0-0.2,0-0.4,0-0.6
		c-1.4,0-2.7-0.1-3.4-1.2c-0.6,1.2-2.1,2-3.6,1.8c-0.2,0-0.4,0-0.5-0.1c-1.2-0.7-2.1-0.6-3.1,0.6c-0.3,0.3-0.9,0.3-1.6,0.4
		c0.1,0.3,0.2,0.6,0.1,1c-0.1,0.1-0.2,0.1-0.4,0.2v0.1c0,0.4-0.4,0.8-0.7,1.2c0.4,0.4,0.9,0.8,1.3,1.3c0.1,0.1,0,0.3-0.1,0.5
		c1,0.1,1.9,0.7,2.1,1.6c0.1,0.4,0,0.8-0.1,1.2c0.4,0.1,0.6,0.3,0.6,0.7c0,0.5-0.3,0.7-0.9,0.8c-0.4,0.1-0.7-0.1-0.9-0.3
		c-0.3,0.1-0.5,0.3-0.8,0.3c-1.4,0.4-2.9-0.3-3.2-1.5c-0.2-0.5,0-1.1,0.3-1.6c-0.5,0.1-1,0.2-1.5,0.4c0.5,0.4,0.9,0.9,1.1,1.6
		c-0.4,0.3-0.7,0.7-1.1,1c0.6,0.9,1.6,1.7,0.3,2.9c-0.3-0.2-0.5-0.3-0.7-0.5c0,0.3,0,0.6-0.1,1c-0.4,1-1.4,1.6-2.7,1.7
		c0.3,0.9,0.2,1.7-0.6,2.7c-0.1-0.5-0.2-0.8-0.2-1.2c-0.1-0.5-0.1-1-0.2-1.6c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2,0.1-0.3,0.1
		c-0.2-0.7-0.5-1.2-0.6-1.8c0-0.1,0-0.2,0-0.3c-0.2-0.1-0.4-0.2-0.5-0.4c-0.3-0.5-0.9-0.5-1.5-0.6c-0.7-0.1-1.3-0.4-1.7-0.7
		c-0.8,0.4-1.7,0.4-2.9-0.1c-0.7,0.6-1.5,1.3-2.6,0.8s-1-1.3-0.7-2.3c-1.4-0.5-1-1.5-0.6-2.5c-0.6,0-1.1,0-1.6-0.1
		c-0.5-0.2-0.9-0.1-1.4,0c-0.9,0.3-1.7-0.1-2-0.6c-0.3-0.6-0.1-1.2,0.6-1.9c0.4-0.3,1.2-0.5,0.7-1.3c-1.7-0.5-1.5,1.4-2.9,1.5
		c0.3,0.4,0.5,0.7,0.8,1.2c-0.8-0.1-1.4-0.2-2.1-0.3c-0.1,0.3-0.1,0.6-0.2,1c-0.6-0.2-1.1-0.4-1.7-0.6c-0.2,0.2-0.4,0.4-0.6,0.7
		c-0.5-0.2-0.8-0.6-1.5-0.4c-0.6,0.1-0.9,0.1-1.4-0.3c-0.1,0.4-0.2,0.8-0.4,1.1c-0.1,0.2-0.3,0.4-0.4,0.6c0.1-0.1,0.2-0.1,0.4-0.2
		c0.6,0.4,1.2,0.8,1.8,1.1c0.6-0.1,1.3,0.1,1.7,0.6c0.5,0.5,0.4,1.3-0.2,1.8c-0.2,0.2-0.3,0.3-0.5,0.4v0.1c0.6-0.2,1.2-0.2,1.5-0.5
		c0.6-0.5,2-0.3,1.9-1.6c0.6,0.1,1.1,0.3,0.6,0.8c-0.6,0.6-0.6,1.1,0,1.7c0.3,0.3,0.4,0.8,0.5,1.3c-0.2,0.4-0.4,0.8-0.7,1.2
		c0.7-0.4,1.5-0.6,2.4-0.2c0.3,0.7,0.7,1.4,1,2.2c1.3-0.4,1.6-2.3,3.7-1.9c-0.1,0.3-0.3,0.6-0.4,0.9c-0.1,0.4-0.1,0.9,0.5,1
		c1.4,0.1,1.3,1,1.4,1.9c-1.2,0-1.6,0.7-1.8,1.6c0.5,0.3,1,0.7,1.6,1.2c-0.2,0.3-0.5,0.5-1.1,1.1c1.4-0.1,2.6,0.7,3.5-0.5
		c0,0.5,0.5,0.6,1,0.7c0.4,0.8,1-0.1,1.6,0.1c0.4,0.3,0.9,0.7,1.4,1.1c0.3-0.2,0.7-0.4,1-0.6c0.1-0.8,0.9-1.5,1.9-1.7
		c1.3-0.3,2.4,0.4,2.6,1.5c0,0.2,0,0.4,0,0.6c0.2,0.2,0.4,0.4,0.7,0.6c-0.4,0.6-0.9,0.6-1.3,0.5c-0.2,0.2-0.5,0.4-0.9,0.5
		c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0,0.5,0.1,0.8,0.1l0,0l0,0c0.2,0,0.5,0.1,0.8,0.1c-0.3,0.1-0.5,0.2-0.7,0.3l0,0c0,0,0,0-0.1,0
		c-0.4,0.2-0.8,0.3-1.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.3c0.2,0.4,0.4,0.8,0.6,1.3c-0.8,0-1.4,0-2,0c0,0.3,0,0.6,0.1,0.9
		c-0.9-0.1-1.8-0.3-2.8-0.4H90c0,0,0,0.1-0.1,0.1v-0.1c-0.4-0.1-0.9-0.4-1-0.3c-0.4,0.2-0.8,0.3-1.3,0.3c0.2,0.1,0.3,0.2,0.5,0.3
		c-0.7,0.3-1.1,0.1-1.4-0.2c-0.3,0.1-0.6,0.2-0.8,0.5c-0.6-0.6-1.1-1-0.7-2c-2,0.7-2.3-0.4-2.9-1.5c-0.5,0.3-0.8,0.6-1.3,0.9
		c-0.4,0-1-0.1-1.5-0.2c-0.2,0.3-0.4,0.6-0.7,1c-0.1-0.4-0.2-0.5-0.3-0.7c-0.2-0.8-0.5-1-1.3-0.8c-0.5,0.2-0.9,0.3-1.3-0.1
		c-0.4-0.4-1-0.8-0.6-1.5c0.1-0.1,0-0.3,0-0.7c-0.7,0.3-1.2,0.7-1.8,0.8c-0.5,0.1-1-0.1-1.8-0.2c-0.1,0-0.1,0-0.2,0l0.1,0.1l0.1-0.1
		c0.1,0,0.1,0.1,0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1c0.2,0.2,0.3,0.3,0.4,0.4c1,0.7,1.3,1.6,0.9,2.7c-0.4,1.1-1.3,1.8-2.7,2
		c-0.6,0.1-1.3,0.4-2,0.6c0.2,0.4,0.4,0.7,0.6,1c0.5,1,0.3,2-0.5,2.9c0,0.1,0,0.1,0.1,0.2c-0.2,0.1-0.3,0.2-0.5,0.2
		c-0.8,0.6-1.8,0.8-2.9,0.6c-0.3-0.1-0.5-0.2-0.7-0.3c-0.4,0.6-1,1-1.7,1.2c-1.5,0.3-2.9-0.5-3.1-1.7l0,0c-0.4-0.1-0.8-0.3-1-0.6
		c-0.1-0.2-0.2-0.3-0.4-0.6c0.3-0.2,0.5-0.3,0.7-0.4c-0.5,0-1,0-1.5,0c0.6,0.2,1.1,0.7,1.3,1.5c0.3,0.9-0.3,1.9-1.3,2.5
		c-0.4,0.2-0.8,0.4-1.1,0.4c-0.5,0.9-1.5,1.5-2.1,2.4c-0.2,0.3-0.6,0.5-0.9,0.8c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0.4,0.2,0.7,0.9,0.8
		c0.4,0.1,0.9,0.2,1.3,0.2v-0.1h0.1h-0.1c1.2,0.2,2.5,0.5,3.3,1.4c0.3,0.4,0.9,0.3,1.4-0.2c0.4-0.3,0.9-0.7,1.4-0.7
		c0.1,0,0.1,0,0.1,0c0.1-0.6,0.5-1.1,1.1-1.5c-0.1-0.1-0.1-0.2-0.2-0.3c0.6-0.2,1.1-0.3,1.6-0.2c1.3-0.1,2.5,0.6,2.8,1.7
		c0.1,0.2,0,0.5,0,0.7c0.4,0.1,0.8,0.3,1.1,0.5c0.3,0.2,0.8,0.6,0.1,1v0.2c0,0.1,0.1,0.1,0.1,0.1c0.9-1,1.9-1.3,3.1-0.9l0,0
		c0.2-0.2,0.6-0.2,1-0.4c0.5,0.3,1.1,0.7,1.7,1c-0.5,1.1-0.7,1.4-1.3,1.5c0,0.4-0.2,0.7-0.4,1c-0.7,0.9-1.7,1.2-3,0.9
		c0,0.1,0,0.2,0,0.3c-0.1,0.9-0.6,1.5-1.6,1.9c-0.8-0.4-1.3-0.8-1.5-1.2c-0.2,0.2-0.4,0.4-0.6,0.7c-0.4-0.6-0.7-0.9-0.9-1.2
		c-0.2,0.1-0.4,0.2-0.6,0.2c0,0.2-0.2,0.4-0.4,0.6c-0.1-0.2-0.1-0.3-0.2-0.4h-0.1c-0.7,0.5-1.1,1.1-1.1,2c0.5-0.4,0.9-0.8,1.3-1.2
		c0.4,0.4,0.9,0.7,1.3,0.9c0.7-0.6,1.8-0.7,2.7-0.2c0.6,0.4,0.8,1,0.6,1.6c0.4,0.5,0.7,1.1,1.1,1.6c0.3-0.4,0.7-0.7,0.8-1.2
		c0-0.1,0.7-0.2,0.9-0.2c0.1,0,0.2,0.1,0.3,0.3c0.1-0.1,0.3-0.3,0.4-0.4c-0.8,0.1-1.3,0.2-1.8,0.2c-0.1-0.4-0.2-0.8-0.3-1.3
		c1,0.3,1.3-0.3,1.8-0.8c0.7-0.7,1.7-0.9,2.4-0.6c0-0.1,0-0.2,0-0.3c-0.3-0.2-0.5-0.4-0.8-1c-0.4,0-0.8,0.1-1.4,0.2
		c1.1-0.9,2.3-0.9,3.4-1.2c0.2,0,0.4,0,0.6,0.1c0,0,0,0,0.1,0h0.1c-0.1-0.1-0.2-0.1-0.3-0.1c0.3,0,0.5-0.1,0.8-0.1
		c0.2,0,0.4,0.1,0.6,0.2l0,0c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0.1,0,0.2c0,0,0,0-0.1,0c0,0,0,0.1-0.1,0.1c0.8,0.1,1.5,0.7,1.6,1.5
		c0.2,1-0.4,1.8-1.4,2.2c0.2,0.1,0.7-0.2,0.9,0.1c0.5,0.6,1.4,1.1,1.8,1.8c0.3,0.5,1,0.7,1.2,0.6c-0.1-0.1-0.2-0.3-0.3-0.5
		c0-0.1,0-0.2,0-0.3c-0.1,0-0.2,0.1-0.2,0.1c-0.2-0.8-0.2-1.5,0.5-1.9c0.4-0.3,0.7-0.4,0.8-0.9c0-0.3,0.3-0.5,0.5-0.7
		c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.4-0.5-0.5-0.6c-0.1-0.6,0-1.1,0.7-1.4c0.6-0.3,1.1-0.1,1.4,0.2c0.1,0.1,0.3,0.3,0.4,0.4
		c0.5,0.6,0.4,1-0.1,1.4c0.2,0,0.4,0.1,0.6,0.2c0.3-0.6,0.5-0.9,0.9-1.1c-0.1-0.6,0.5-1.4,1.3-1.7c0,0,0,0,0,0.1
		c0.3-0.1,0.5-0.1,0.7,0.1c0.2-0.3,0.3-0.6,0.4-0.8c0.1,0.1,0.2,0.2,0.3,0.3c0.4-0.4,0.9-0.7,1.2-1.2c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.6,0.3-1.5,0.7-1.9,0.5c-0.3-0.2-0.7-0.2-1-0.2c0,0,0,0,0.1,0c0.2,0.2,0.4,0.6,0.2,0.9c-0.2,0.4-0.6,0.8-0.9,1.1
		c-0.8,0-1.5-0.2-1.3-0.8c0.1-0.4,0.5-0.8,0.9-1.2c-0.2,0-0.4,0-0.6,0c0-0.1-0.1-0.1-0.1-0.2c-0.5,0.8-1.5,1.5-2.7,1.7
		c-2.1,0.4-3.9-0.7-4.2-2.5c-0.1-0.5,0-0.9,0-1.5c-0.4,0.2-0.7,0.3-1,0.4c-1.6,0.5-3,0.3-4-0.7c-0.5-0.5-0.9-0.7-1.6-0.8
		c-1-0.2-1.1-0.8-0.3-1.5c0.2-0.2,0.4-0.3,0.5-0.5c-0.4-0.1-0.7-0.1-1.2-0.2c1-0.9,1.8-1.6,2.6-2.4c0.2,0,0.4,0.1,0.6,0.1
		c0,0,0,0-0.1,0c0.1,0,0.1-0.1,0.2-0.1l0,0h0.1c0.1-0.1,0.1-0.2,0.2-0.2s0.1,0.1,0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1l0,0l0,0
		c0,0.1,0,0.1,0,0.2c0.2,0,0.4,0.1,0.6,0.2c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c-0.3-0.8-0.6-1.6,0-2.5
		c0.5-0.7,0.6-0.7,1.4,0c0.4-0.6,0.8-1.2,1.2-1.9c0.4-0.1,1-0.3,1.5-0.4c1.7-0.3,2.9,0.2,3.6,1.4c0.4,0.8,0.2,1.8-0.4,2.6
		c0.1,0.1,0.2,0.3,0.3,0.4c-0.1-0.5,0.6-0.9,1.3-0.8c0.3,0,0.6,0.1,0.9,0.3l0.1-0.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0.1,0
		c0,0,0,0,0.1,0.1H84h-0.1l0,0h-0.1c0,0,0,0,0-0.1c-0.1,0-0.1,0-0.2,0c0.5,0.2,0.9,0.5,1.3,0.6c0.7,0.2,1.2,0.6,1.5,1.1
		c0.2,0.2,0.4,0.4,0.8,0.7c0.4-0.5,0.7-0.9,1-1.3l0,0l0,0c0.1-0.2,0.2-0.3,0.4-0.5c-0.5-0.1-0.8-0.1-1.1-0.1
		c-1.5-0.2-1.8-0.5-1.7-1.7c0-0.4,0.3-0.9,0.3-1.3c0-0.2-0.2-0.5-0.4-0.8c-0.2,0.4-0.3,0.6-0.4,0.7c-1,0.4-0.8-0.5-1.4-0.7
		c-0.3,0.1-0.6,0.3-1,0.4c-0.2-0.4-0.5-0.7-0.4-1c0.1-0.6-0.3-1-0.9-1.1c-1.2-0.2-1.5-0.9-1.8-1.8c0.4,0,0.9,0,1.2,0.1
		c0.6,0.4,1.2,0.8,2.2,0.5c0.5-0.1,1.3,0.8,1.1,1.3c-0.3,0.2-0.6,0.4-0.9,0.6c0.2,0.2,0.4,0.4,0.7,0.8c0.5-0.6,1.1-1,2-0.7
		c0.2,0.1,0.7-0.3,0.9-0.5c-0.1-0.4-0.2-0.8-0.2-1.1l0.1-0.1c1,0.2,1.4,0.3,1.5,0.9c0.3,1,1,1.4,2.2,1.1c0.1,0.2,0.2,0.4,0.3,0.5
		c0.2-0.2,0.5-0.4,0.9-0.5c0.4,0,0.7,0.1,0.9,0.3c0.4-0.2,0.8-0.3,1-0.5c0.2-0.1,0.2-0.4,0.3-0.6l0,0l0,0c-0.3,0.1-0.6,0.2-1.1,0.4
		c0.2-0.3,0.3-0.5,0.5-0.8c-0.4,0-0.8,0-1.3,0c0.1-0.4,0.2-0.8,0.2-1.1s-0.1-0.6,0-0.9c0.9,0.6,1.5,1.4,1.7,2.3c0,0,0,0,0.1,0l0,0
		c0,0,0,0,0,0.1c0.5-0.2,1-0.4,1.6-0.7c0.5,0.5,1,1,1.4,1.5c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.7,0.4-1.5,0.6-2.5c-0.7-0.8-0.9-1.3-0.4-2
		c-0.4-0.3-0.7-0.7-0.4-1.3c0.1-0.3-0.3-0.7-0.4-1c-0.2-0.6,0.3-1,1.1-1c1.6,0.2,1.6,0.2,2.3,1.4c-0.2,0.3-0.3,0.6-0.5,1
		c0.3,0,0.7,0.1,1,0.2c1-1.6,2.3-0.5,3.5-0.5c-0.1-0.3-0.3-0.5-0.2-0.7c0.2-0.3,0.3-0.6,0.4-0.9c-0.7-0.4-0.8-1-0.7-1.7
		c0.4,0.1,0.7,0.2,0.9,0.3c0-0.1,0-0.1,0-0.2c0-0.6,0.5-1,1.3-1.2c0.7-0.2,1.4-0.1,1.8,0.4c0.3,0.3,0.6,0.7,0.8,1.1
		c1.8,0.1,3.7-0.3,5.4,0.2c0.2,0.1,0.6-0.1,0.9-0.1c0.5-0.1,0.9-0.3,1.2-0.6c-1-0.4-1.8-1-2.1-2.2c-0.1-0.2-0.1-0.5-0.1-0.7h-0.1
		c-1,0.1-1.8-0.3-1.9-1.2C111.2,148.7,111.9,147.9,112.8,147.7z M104.5,131.6c0.9,0,0.9,0.4,0.7,1.2
		C104.9,132.3,104.8,132,104.5,131.6z M75.9,141.3c-0.1-0.1-0.1-0.1-0.2-0.2l0.1-0.1c0,0,0.1,0,0.1,0.1
		C75.9,141.1,75.9,141.2,75.9,141.3z M78.5,142.8c0,0-0.1,0-0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0.1,0.2,0.1
		C78.7,142.7,78.6,142.7,78.5,142.8z M83.1,141.8c0.1,0.1,0.2,0.2,0.3,0.3l-0.2,0.2c-0.1-0.1-0.3-0.1-0.4-0.2
		C82.9,142,83,141.9,83.1,141.8z M82.8,143.8c-0.1-0.1-0.1-0.1-0.2-0.2c0.1,0,0.2-0.1,0.3-0.1l0.1,0.1
		C82.9,143.7,82.9,143.7,82.8,143.8z M83.3,144.4c-0.1,0-0.2,0-0.3,0l0.1-0.1c0.1,0,0.2,0,0.3,0C83.4,144.3,83.4,144.4,83.3,144.4z
M86.1,143.7c0.5-0.1,1.1,0.2,1.2,0.6c0.1,0.4-0.4,1.1-0.9,1c-0.4,0-0.9-0.3-1.1-0.6S85.6,143.8,86.1,143.7z M87.1,145.9
		c-0.4,0.7-0.8,0.9-1.4,0.6C85.9,145.9,86.3,145.7,87.1,145.9z M85.7,152c-0.8,0.1-1.5-0.3-1.6-0.8c-0.1-0.6,0.5-1.2,1.2-1.4
		c0.8-0.1,1.5,0.2,1.6,0.8C87,151.3,86.4,151.8,85.7,152z M88.8,149.9L88.8,149.9C88.7,149.9,88.7,149.9,88.8,149.9
		c-0.3-0.1-0.5-0.2-0.6-0.3c-0.4-0.2-0.7-0.5-0.9-0.9c-0.2,0-0.3,0-0.4-0.1c-0.4-0.2-0.7-0.6-1.1-0.8c0.2-0.7,0.7-0.9,1.3-0.8
		c0-0.1,0.1-0.1,0.1-0.2c0.3-0.4,0.9-0.7,1.5-1.1c1.5,1.1,0.9,2.7,1.6,3.9C89.8,150,89.3,150,88.8,149.9z M60,170.2
		c-1.2,1.1,0.6,1.3,0.5,2.2c-0.7,0.4-1.4,0.3-2-0.2c-0.4-0.3-0.7-0.8-0.8-1.3c-0.1-0.6,0.2-1.1,1-1.4c0.4-0.1,0.8-0.2,1-0.6
		c0-0.1,0.6-0.2,0.8-0.2c1,0.1,1.6,0.6,1.7,1.5C61.3,171.1,60.6,170.5,60,170.2z M62.6,167.6c-0.1,0-0.2-0.1-0.3-0.1
		c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0,0.2,0.1,0.3,0.2C62.8,167.6,62.7,167.6,62.6,167.6z M66.1,170.4l0.1-0.1L66.1,170.4L66.1,170.4z
M69.6,178.5c0.1,0.1,0.2,0.2,0.2,0.3c0,0-0.2,0.1-0.3,0.2c-0.1-0.1-0.1-0.2-0.2-0.2C69.4,178.6,69.5,178.6,69.6,178.5z
M69.1,180.5c0.4-0.2,0.6-0.2,0.7-0.3c0,0.1,0,0.1,0,0.2C69.7,180.5,69.6,180.5,69.1,180.5z M70.4,179.3
		C70.3,179.3,70.3,179.3,70.4,179.3c-0.1-0.1,0-0.1,0-0.2C70.4,179.2,70.4,179.2,70.4,179.3C70.4,179.2,70.4,179.3,70.4,179.3z
M79.4,179.2l0.1,0.2c-0.2,0.6-0.7,0.2-1.1,0.1C78.8,179.4,79.1,179.3,79.4,179.2z M78.2,180.4c0,0,0-0.1-0.1-0.1
		c0,0,0-0.1,0.1-0.1l0.1,0.1C78.3,180.3,78.3,180.3,78.2,180.4z M77.9,176.9c0,0,0.1,0,0.1,0.1l-0.1,0.1c0,0-0.1,0-0.1-0.1
		S77.8,176.9,77.9,176.9z M78.2,177.7L78.2,177.7c-0.2,0.1-0.3,0.2-0.5,0.2c0-0.1,0-0.1,0-0.2C77.8,177.7,78,177.7,78.2,177.7z
M76,173.9c0.1,0,0.2,0.1,0.2,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.1-0.2-0.1-0.2-0.2C75.7,174,75.9,173.9,76,173.9z M70.3,173.2
		c-0.9,0-1-0.5-1.2-1.2C70,172.2,70.4,172.5,70.3,173.2z M75.6,157.8l-0.1-0.1l0.1-0.1l0.1,0.1C75.7,157.7,75.7,157.7,75.6,157.8z
M83,165.4c0.1,0,0.2,0.1,0.2,0.1c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1-0.1-0.3-0.1-0.4-0.2C82.6,165.9,82.8,165.7,83,165.4z M81.1,162.2
		l0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c-0.2,0-0.3-0.1-0.4-0.1C80.9,162.4,81,162.3,81.1,162.2z M88.7,161.4c-0.6-0.6-1.1-1,0-1.8
		c0.3,0,0.7,0,1.2,0c0.2,0.3,0.4,0.5,0.6,0.8C90.2,161.3,89.3,161.2,88.7,161.4z M90.8,162c0.1-0.1,0.1-0.2,0.2-0.2s0.3,0.1,0.4,0.1
		c-0.1,0.1-0.2,0.2-0.2,0.2C91,162.1,90.9,162.1,90.8,162z M91.4,162.8l-0.2-0.1c0-0.1,0.1-0.2,0.2-0.4c0.2,0.1,0.4,0.2,0.4,0.3
		C91.7,162.6,91.5,162.7,91.4,162.8z M95.7,157.6L95.7,157.6c-0.1,0-0.1,0-0.2,0C95.6,157.6,95.7,157.6,95.7,157.6z M93.7,159.7
		c-0.1-0.1-0.1-0.1-0.2-0.2l0.1-0.1c0.1,0.1,0.1,0.1,0.2,0.2C93.7,159.6,93.7,159.7,93.7,159.7z M96.1,161.1c-0.7-0.2-1.4-0.4-2-0.7
		c-0.5-0.2-0.2-0.6,0.2-0.8c0.7,0.2,1.3,0.4,1.8,0.6c0.2,0.1,0.4,0.3,0.5,0.5C96.6,160.8,96.2,161.1,96.1,161.1z M98.5,150.4
		c0.1,0,0.1-0.1,0.2-0.1s0.1,0,0.2,0C98.7,150.4,98.6,150.4,98.5,150.4z M99,151.1L99,151.1c-0.1-0.1-0.1-0.1-0.1-0.2H99
		C99.1,151,99.1,151.1,99,151.1z M101.8,155.1c0.1,0.3,0.2,0.6,0.3,0.9C101.3,155.8,101.3,155.8,101.8,155.1z M101.7,154.6
		c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2C101.9,154.3,101.8,154.4,101.7,154.6C101.8,154.5,101.8,154.5,101.7,154.6z M100.9,152
		c-0.1-0.2,0-0.5,0.1-0.5c0.2-0.1,0.6-0.1,0.8,0c0.2,0.2,0.3,0.5,0.5,0.7C101.6,152.7,101.2,152.6,100.9,152z M102.9,148.8
		c-0.3,0.8-0.9,1.3-1.8,1.5s-1.8,0-2.2-0.7c-0.5-0.7-0.9-1.5-1.3-2.2c0.1,0,0.2-0.1,0.3-0.1c0.3,0.1,0.6,0.3,0.9,0.4
		c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.3-0.5-0.6-0.7-0.9c0.9-1.2,1.4-1.4,2.3-1.3c0.8,0.1,0.5,0.7,0.4,1.1c0.4,0.2,0.9,0.3,1.3,0.6
		C102.9,147.4,103.2,148,102.9,148.8z M103.4,141.4L103.4,141.4L103.4,141.4L103.4,141.4z M105.4,150.2c-0.1,0-0.1-0.1-0.2-0.1V150
		c0.1,0,0.1,0,0.2,0C105.4,150,105.4,150.1,105.4,150.2z M108.1,150.6c-0.9-0.1-0.8-0.7-0.8-1.2c0.7-0.4,1.4-0.5,1.7,0.2
		C109.2,149.9,108.6,150.6,108.1,150.6z M110.7,147.8c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.1,0.2-0.3,0.3-0.4c0.2-0.1,0.4-0.1,0.6-0.2
		c0.1,0.1,0.1,0.2,0.2,0.3C111.3,147.5,111,147.6,110.7,147.8z"
      />
      <path
        class="st4"
        d="M68.6,133.8c0.3-0.3,0.8-0.6,1.1-0.9c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.5-0.4-0.6-0.7
		c-0.1-0.1-0.2-0.2-0.4-0.4c-0.7,0.5-1.5,0.6-2.1,1.2c0.7,0.1,1.4,0.3,1.9,0.7C68.2,133.3,68.4,133.5,68.6,133.8z"
      />
      <path
        class="st4"
        d="M105.6,118.9c-0.1-0.1-0.1-0.2-0.1-0.3c-0.2-0.8,0.4-1.6,1.4-1.7c0.5-0.1,1,0,1.4,0.3l0,0v-0.1
		c-0.1-0.5,0.2-1.1,0.7-1.4c0.2-0.3,0.2-0.6-0.2-0.9c-0.1-0.1,0.2-0.5,0.4-0.7c0.4-0.3,0.9-0.4,1.4-0.6c0.1-1.5-1.7-1.5-2.6-2.4
		c-0.1,0.4-0.2,0.6-0.3,0.8l0,0c0.6,0.3,0.6,0.6-0.1,0.8c-0.9,0.3-1.4,0.4-1.9,0.4c0,0.1,0.1,0.2,0.1,0.3c0.1,0.7-0.4,1.4-1.3,1.6
		c0.1,0.1,0.3,0.1,0.4,0.2c-0.7,0.6-1.4,1.2-2.1,1.8C103.2,118.3,104.7,118.4,105.6,118.9z"
      />
      <path
        class="st4"
        d="M97.3,141c0.2,0.1,0.3,0.2,0.4,0.4c0-0.3,0-0.7,0.2-1.1c-0.5-0.1-1-0.1-1.5-0.2c-0.8-0.2-1.4-0.7-1.7-1.3
		c-0.3,0.3-0.3,0.6-0.4,1.3c0,0.3,0,0.5,0,0.8C95.3,140.4,96.5,140.4,97.3,141z"
      />
      <path
        class="st4"
        d="M109.5,119c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2,0.5-0.7,1-1.4,1.1c-0.6,0.1-1.1-0.1-1.4-0.4
		c0.1,0.6,0.2,1.1,0.4,1.6l0,0c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.2c0.6-0.1,1.1-0.1,1.5-0.1c-0.1,0.1-0.1,0.3-0.2,0.3
		c-0.6,0.6-1.6,0.9-1.7,1.9c0.7,0.2,1.7,0.1,1.9,0.5c0.6,0.9,1.5,0.9,2.4,1.2c1.1,0.3,1.7,1.2,1.8,2.2c0.4-0.9,0.8-1,2.6-1.2
		c0-0.4-0.1-0.8-0.1-1.2c-0.3-0.1-0.7-0.3-1-0.5c-0.4,0.3-0.7,0.6-1.1,0.7c-0.7,0.3-1.4,0-1.2-0.6c0.1-0.5,0-0.8-0.2-1.1
		c-0.2-0.1-0.4-0.3-0.5-0.6c0-0.2,0-0.4,0-0.5c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.2-0.1-0.5-0.2-0.8c0.7,0.4,1,0.5,1.3,1
		c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.5,0,0.7,0.1c0.1-0.2,0.1-0.4,0.2-0.6c0.2-0.5,0.4-1,0.6-1.5c-1.4,0.1-2.8,0.2-4.3,0
		C109,119.4,109.3,119.2,109.5,119z M111.8,120.6c0.1,0,0.2,0.1,0.2,0.1s0,0.1-0.1,0.1s-0.2,0-0.3,0
		C111.7,120.7,111.7,120.6,111.8,120.6z"
      />
      <path
        class="st4"
        d="M100.5,136.7c0.2-0.3,0.5-0.5,0.8-0.6c-0.3-0.1-0.5-0.3-0.8-0.6c-0.5,0.3-1,0.6-1.5,0.9c0,0.1,0,0.2,0.1,0.3
		C99.6,136.7,100,136.7,100.5,136.7z"
      />
      <path
        class="st4"
        d="M140.8,148.5c-0.6,0.7-1.3,1.2-2.2,1.5c0.2,0,0.4,0.1,0.6,0.2c-0.7,1.3-1.2,1.6-1.9,1.4
		c-0.6-0.2-0.8-0.7-0.5-1.2l0,0c-0.2,0-0.4,0-0.5,0c-0.4,0-0.7-0.1-1.1-0.1c-0.1,0.4-0.2,0.9-0.3,1.3c1.1,0.7,2.2,1.3,3.5,1.8
		c-0.2-0.7,0.2-0.9,0.8-1.1c-0.2,0.3-0.4,0.6-0.7,1.2c0.5,0.2,1,0.4,1.5,0.5c0.1-0.2,0.3-0.5,0.4-0.8c0.1-0.4,0-0.9,0.1-1.3
		c0.2-0.7,0.5-1.3,0.1-2c-0.1-0.1-0.1-0.3,0-0.4C141.1,149.1,141,148.8,140.8,148.5z M139.8,150.8c0-0.1-0.1-0.1-0.1-0.2
		c0.1,0,0.2-0.1,0.3-0.1l0.1,0.1C140,150.7,139.9,150.8,139.8,150.8z"
      />
      <path
        class="st4"
        d="M118.5,144.9c-0.3,0-0.5,0-0.8,0.1c0,0.4,0,0.7-0.1,1.1c0,0.2,0,0.5,0.1,0.7c0.9,0,1.8,0.3,2.8,0.8
		c-0.1-0.6-0.3-1.2-0.4-1.7C119.4,145.9,118.7,145.5,118.5,144.9z"
      />
      <path
        class="st4"
        d="M125.5,140c0-0.1,0-0.2,0-0.2c-0.1,0.5-0.2,1-0.3,1.6c0.8,0.3,1.7,0.5,2.6,0.8c-0.1-0.3-0.2-0.7-0.2-1
		C126.6,141.2,125.7,140.7,125.5,140z"
      />
      <path
        class="st4"
        d="M86.8,172.9c0.1,0,0.1-0.1,0.1-0.1c0.2-0.1,0.2-0.5,0.3-0.8c0.2-0.1,0.4-0.2,0.7-0.2c-0.3-0.5-0.5-0.8-0.8-1.2
		c0.3-0.1,0.6-0.2,0.8-0.3c-0.1-0.4-1.2-0.2-0.3-1.2c-0.8,0.3-1.2,0.5-1.6,0.7c-0.6,0.3-1.1,0.3-1.5,0.2l0,0
		c-0.1,0.1-0.4-0.1-0.6-0.2c0.1-0.1,0.1-0.2,0.2-0.3c-0.4-0.6-1-0.9-1.9-1c-0.7-0.1-0.9-0.5-1-1c-0.1,0-0.2,0.1-0.3,0.1
		c-0.1-0.2-0.2-0.4-0.2-0.6c-0.2,0.2-0.4,0.3-0.6,0.5c-0.9,0.6-1.9,0.7-2.8,0.5c0.1,0.5,0.1,0.9,0,1.2c0.4,0.6,0.5,1.4,0.3,2.3
		c0.7-0.2,1.2-0.5,1.8-0.6c2-0.5,3.8,0.4,4.3,2c1.6,0.5,2,0.6,2.6,0.4c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3
		C86.5,172.8,86.7,172.9,86.8,172.9z M79.6,169.2l-0.1-0.1c0.1,0,0.2-0.1,0.2-0.1s0.1,0,0.1,0.1C79.8,169,79.7,169.1,79.6,169.2z
M82.5,170.4c-0.2-0.2-0.3-0.3-0.5-0.5c-0.3,0.1-0.4,0.1-0.6,0.1s-0.3-0.1-0.4-0.2c0.5-0.5-0.7-0.8-0.1-1.3l0,0c-0.1,0-0.2,0-0.3,0
		c0-0.1,0.1-0.1,0.1-0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0.1,0l0,0c1,0,1,0.7,1.4,1.2c0.2,0.1,0.3,0.3,0.5,0.4
		C82.7,170.2,82.6,170.3,82.5,170.4z"
      />
      <path
        class="st4"
        d="M225.5,114.4C225.4,114.4,225.4,114.4,225.5,114.4c0,0.1,0.2,0.1,0.3,0.2c0,0-0.1-0.1-0.1-0.2
		C225.6,114.4,225.6,114.4,225.5,114.4L225.5,114.4z"
      />
      <path
        class="st4"
        d="M125.9,137.9c-0.1,0.4-0.2,0.8-0.3,1.2c0.3-0.5,1.1-1,2.2-1.2c0-0.1-0.1-0.3-0.1-0.4
		C127.2,137.7,126.6,137.8,125.9,137.9z"
      />
      <path
        class="st4"
        d="M74.5,167.4c0.3-0.1,0.6-0.2,0.9-0.3c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.3,0.3-0.4c-0.2-0.2-0.5-0.5-0.8-0.8
		C74.9,166.8,74.7,167.1,74.5,167.4z"
      />
      <path
        class="st4"
        d="M60.7,176.3c0.1,0,0.2-0.1,0.3-0.1c0.5-0.1,1.1,0,1.5,0.2c0.7-0.2,1.4,0.1,2.2,0.7c0.5-0.2,0.9-0.4,1.4-0.6
		c-0.4-0.5-0.4-1.1-0.6-1.8c-0.3,0.3-0.8,0.5-1.2,0.6c-0.6,0.1-1.2,0.1-1.7-0.1c-0.2,0.3-0.6,0.5-0.9,0.5c-0.3,0-0.7,0-0.9-0.1
		C60.8,175.8,60.7,176,60.7,176.3z M64,175.6c0.3,0.3,0.6,0.6,0.9,1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3-0.3-0.7-0.6-1-1
		C63.8,175.7,63.9,175.6,64,175.6z"
      />
      <path
        class="st4"
        d="M76,167.7c0.2,0,0.4,0,0.5,0c-0.2-0.1-0.3-0.2-0.4-0.3C76.1,167.5,76,167.6,76,167.7z"
      />
      <path
        class="st4"
        d="M149.4,129.1c0.1-0.8,0.4-1.5,1.7-2c-2.3-0.2-2.7-0.5-2.9-1.9v0.1c0,0,0,0-0.1-0.1c-0.2,0-0.5,0-0.7,0
		c0.1-0.1,0.2-0.2,0.3-0.4c0.1,0.1,0.3,0.3,0.4,0.4c0,0,0,0,0.1,0c-0.1-0.9,0.9-1.7,0.7-2.5c-0.5,0.2-1,0.4-1.6,0.6
		c-0.7,1.3-0.3,2.3,0.7,3.4C148.6,127.4,149,128.2,149.4,129.1z"
      />
      <path
        class="st4"
        d="M145.4,127.4c0.4-0.1,0.8-0.1,1.3-0.2c-0.2-0.3-0.3-0.4-0.4-0.6l0,0C145.9,126.8,145.5,126.9,145.4,127.4
		C145.3,127.3,145.4,127.3,145.4,127.4z"
      />
      <path
        class="st4"
        d="M224.5,126.7c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0.1-0.3,0.1-0.4C224.7,126.5,224.6,126.6,224.5,126.7z"
      />
      <path
        class="st4"
        d="M13.5,188.9c-0.2,0.3-0.4,0.7-0.6,1c0.2,0.2,0.4,0.3,0.5,0.5c0.4,0.5,0.7,1.1,1.1,1.7c0.1,0.2,0.2,0.6,0.4,0.6
		c0.6,0.2,0.6,0.7,0.7,1.1c0,0.2,0.1,0.4,0.1,0.5c0.1-0.2,0.3-0.4,0.4-0.4c0.2,0,0.6,0.2,0.6,0.3s-0.1,0.2-0.2,0.4
		c0.2-0.1,0.5-0.3,0.7-0.4c0.1-0.2,0-0.5-0.1-0.8c-0.4-0.6-0.4-1.3-0.1-2.1c-0.7-0.5-1.1-1.1-1.3-1.9c0-0.1,0-0.2-0.1-0.3
		C15,189,14.3,188.9,13.5,188.9C13.5,188.8,13.6,188.8,13.5,188.9L13.5,188.9z M14.8,191.8c0.2-0.2,0.6-0.1,0.9-0.2
		c-0.1,0.3-0.1,0.6-0.2,1C14.8,192.4,14.3,192.3,14.8,191.8z"
      />
      <path
        class="st4"
        d="M227.4,115.8c-0.2-0.5-0.3-0.9-0.4-1.3c-0.5,0.3-0.7,0.5-0.9,0.5c0.3,0.3,0.5,0.6,0.7,0.8
		C227,115.7,227.2,115.8,227.4,115.8z"
      />
      <path
        class="st4"
        d="M89.9,166.7c-0.3,0.4-0.1,0.5,0.1,0.6c0-0.1,0-0.2,0-0.3l0,0C90,166.8,89.9,166.7,89.9,166.7L89.9,166.7z"
      />
      <path
        class="st4"
        d="M123.7,149.9c0.2-0.2,0.5-0.4,0.7-0.6c-1.1-0.3-2.1-0.5-3-0.7c0,0.9,0,1.9,0,3c1,0,2.1,0,3.2,0
		c0.1-0.2,0.1-0.4,0.2-0.6C124.5,150.7,124.1,150.4,123.7,149.9z"
      />
      <path
        class="st4"
        d="M150.7,142.1c0.3,0.8-0.1,1.3-0.8,1.8c0.2,0.5,0.3,1,0.4,1.5c0.4-0.2,0.8-0.3,1.2-0.4c0.9-0.2,1.8-0.1,2.7-0.2
		c0.1-0.8,0.3-1.5,0.4-2.3c-1.9-0.1-3.2-0.5-4.1-1.2C150.5,141.6,150.6,141.9,150.7,142.1z M153.3,144.5L153.3,144.5l-0.1,0.1
		L153.3,144.5z"
      />
      <path
        class="st4"
        d="M97.8,157.1c0,0.1,0.1,0.3,0.1,0.4c0.2-0.1,0.3-0.1,0.5-0.2C98.2,157.2,98,157.1,97.8,157.1z"
      />
      <path
        class="st4"
        d="M92.7,163.7c-0.1,0.4-0.5,0.9-1,0.9c-0.3,0-0.6-0.1-0.9-0.2c0,0.1-0.1,0.3-0.2,0.5l0,0l0,0l0,0
		c-0.6,0.2-0.9,0.6-0.7,1c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.2,0.1,0.4,0.1,0.5,0.2c0-0.3,0-0.6,0.1-0.8
		s0.5-0.3,0.8-0.3c0.7,0,0.6,0.4,0.6,0.8c0.2-0.1,0.4-0.1,0.7-0.2l0,0c0.1-0.1,0.1-0.2,0.2-0.2c0,0.1-0.1,0.2-0.1,0.3l0,0
		c0.1,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.5-0.3,0.5-0.3c-0.2-0.4-0.4-0.9-0.6-1.3C93.1,164.1,92.9,163.9,92.7,163.7z"
      />
      <path
        class="st4"
        d="M60.2,182.4c-0.1,0.1-0.3,0.1-0.4,0.2c0.2,0.1,0.3,0.2,0.5,0.4c0.2,0,0.3,0,0.5,0c0.3-0.4,0.5-0.8,0.8-1.4
		c-0.5,0.3-0.9,0.5-1.2,0.7C60.3,182.3,60.2,182.4,60.2,182.4z"
      />
      <path
        class="st4"
        d="M181.3,108.3c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.1-0.3,0.2-0.5C181.6,108.2,181.5,108.3,181.3,108.3z"
      />
      <path
        class="st4"
        d="M297,270.3L297,270.3c0.1-0.2,0.2-0.4,0.3-0.6c-0.2,0.1-0.3,0.2-0.5,0.2C296.8,270.1,296.9,270.2,297,270.3z"
      />
      <path
        class="st4"
        d="M113.9,117.5c0.3-0.7,0-1-0.7-1.3c0,0.5,0,0.9-0.1,1.2c-0.1,0.3-0.2,0.5-0.4,0.7c0.3,0,0.6,0.1,0.8,0.2
		C113.7,118.1,113.8,117.8,113.9,117.5z"
      />
      <path
        class="st4"
        d="M34.6,184.3c-0.3-0.2-0.5-0.5-0.7-0.7c0,0.8,0.6,1.3,0.9,2c0,0,0,0,0,0.1c0-0.2-0.1-0.3-0.1-0.5
		C34.6,184.9,34.2,184.7,34.6,184.3z"
      />
      <path
        class="st4"
        d="M41.4,158.8c-0.1,0.1-0.1,0.2-0.2,0.3c0.2,0,0.3,0,0.5,0.1C41.6,159,41.5,158.9,41.4,158.8z"
      />
      <path
        class="st4"
        d="M54.7,163.1c0.3,0,0.6-0.1,0.9-0.1c-0.4-0.1-0.8-0.3-1.1-0.5C54.5,162.7,54.6,162.9,54.7,163.1z"
      />
      <path
        class="st4"
        d="M60.9,134.6l-0.1,0.1C60.8,134.7,60.8,134.7,60.9,134.6C60.9,134.7,60.9,134.7,60.9,134.6z"
      />
      <path
        class="st4"
        d="M98.5,137C98.6,137,98.5,136.9,98.5,137c-0.1-0.1-0.3-0.1-0.4-0.1c0.1,0,0.1,0.1,0.2,0.1
		C98.4,137.1,98.5,137.1,98.5,137z"
      />
      <path
        class="st4"
        d="M124.7,128.2c-0.1,0.4-0.2,0.8-0.4,1.2c-0.1,0.4-0.4,0.7-0.6,1c0.6,0.1,1.3,0.2,1.9,0.3
		C125.5,128.6,125.4,128.6,124.7,128.2z"
      />
      <path
        class="st4"
        d="M7.3,328.6c0.9-0.1,1.7-0.1,2.6-0.2c0.1-0.3,0.1-0.6,0.2-0.8c-0.6-0.3-1.1-0.6-1.6-1c-0.4,0-0.8-0.1-1.2-0.1
		C7.2,327.1,7.3,327.9,7.3,328.6z"
      />
      <path
        class="st4"
        d="M15.9,195.1c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.1-0.3-0.2-0.4-0.3C15.8,194.8,15.9,195,15.9,195.1z"
      />
      <path
        class="st4"
        d="M17.9,335.2c0.1,0.4,0.2,0.7,0.2,1c0.3-0.2,0.5-0.3,0.7-0.4c0,0,0,0,0.1,0c0.1-0.1,0.1-0.1,0.2-0.2
		c0.2-0.2,0.4-0.4,0.6-0.7c-0.3,0.1-0.5,0.1-0.8,0.1C18.6,335,18.3,335.1,17.9,335.2z"
      />
      <path
        class="st4"
        d="M17.8,336.9c0,0,0.1,0,0.1-0.1l0,0C17.9,336.8,17.8,336.8,17.8,336.9z"
      />
      <path
        class="st4"
        d="M282.5,265c0,0.1,0.1,0.1,0.1,0.2c0.2,0,0.3,0.1,0.5,0.2c0.3-0.2,0.5-0.4,0.8-0.6
		C283.2,264.4,282.8,264.7,282.5,265z"
      />
      <path
        class="st4"
        d="M288.5,251.6c0.3-0.2,0.4-0.3,0.3-0.5c-0.2-0.1-0.3-0.2-0.5-0.3C288.2,251.1,288.1,251.4,288.5,251.6z"
      />
      <path
        class="st4"
        d="M241.7,258L241.7,258c-0.1,0-0.2,0.1-0.2,0.2C241.6,258.1,241.7,258.1,241.7,258z"
      />
      <path
        class="st4"
        d="M78.9,294.7c0.1,0.5,0.1,0.9,0.2,1.4l0,0l0.1,0.1l0,0c0.3-0.3,0.5-0.5,0.8-0.6c-0.1-0.1-0.2-0.3-0.4-0.6
		C79.4,294.9,79.2,294.8,78.9,294.7z"
      />
      <path
        class="st4"
        d="M93.1,290.3c0.9,0.1,1.6,0.5,2,1.1c0.6-0.6,0.4-1.3-0.1-1.9c-0.8,0.2-1.7,0.2-2.3,0.8
		C92.8,290.3,93,290.3,93.1,290.3z"
      />
      <path
        class="st4"
        d="M99.2,306.7c0,0.2,0.1,0.4,0.2,0.6c0,0.2,0.1,0.4,0.1,0.5c0.3-0.1,0.5-0.1,0.8-0.1c0.4,0,0.8,0,1.2,0.2l0,0
		c0.2,0.1,0.4,0.2,0.5,0.3c0.1-0.2,0.2-0.3,0.4-0.5c-0.7-0.5-1.4-1.1-2.2-1.5C99.8,306,99.2,306.4,99.2,306.7z"
      />
      <path
        class="st4"
        d="M90,297c-0.5,0.3-1,0.5-1.6,0.5c-0.4,0-0.7,0-1.1-0.2c-0.2-0.1-0.5-0.1-0.8-0.1l0,0c0.3,0.2,0.7,0.4,1.2,0.7
		c-0.4,0.4-0.8,0.8-1.2,1c0,0.2,0,0.5,0,0.7c0.2,0.2,0.3,0.4,0.3,0.7c-0.1,0-0.2,0-0.2-0.1c0,0.3,0.2,0.7,0.5,0.9
		c0.8-0.7,1.8-1.2,3.1-1.3c-0.4-0.4-0.6-1.1-0.5-1.7C89.7,297.8,89.9,297.4,90,297C90,297.1,90,297.1,90,297
		C89.9,297.1,89.9,297,90,297z"
      />
      <path
        class="st4"
        d="M256.5,249.5c0.1-0.1,0.2-0.3,0.4-0.4c0.1,0.2,0.2,0.3,0.2,0.4c0.2-0.1,0.4-0.3,0.5-0.4
		c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0.1-0.2,0.2-0.3,0.3c-1-0.9-2.1-1.3-3.4-1.2c0.8,0.3,1.4,0.8,1.9,1.3
		C255.9,249,256.2,249.2,256.5,249.5z"
      />
      <path
        class="st4"
        d="M285.7,243.4c0.1,0.3,0.6,0.5,0.1,0.8c0.2,0.1,0.3,0.3,0.5,0.4c0.2-0.5,0.5-0.9,0.9-1.4l0.1-0.1
		c-0.2-0.4-0.5-0.8-0.8-1.2C285.4,242.4,285.5,242.9,285.7,243.4z"
      />
      <path
        class="st4"
        d="M253.1,247.4c0.1,0,0.3,0.1,0.4,0.1c-0.1-0.1-0.3-0.2-0.4-0.3C253.1,247.3,253.1,247.3,253.1,247.4z"
      />
      <path
        class="st4"
        d="M304.5,242.2c-0.1,0.2-0.1,0.3-0.3,0.5c-0.2,0.3-0.4,0.6-0.7,0.8c0.9,0.1,1.8,0.3,2.6,0.4v-0.8v-1.5v-0.4
		c-0.2,0-0.3,0-0.5,0.1c0.1-0.3,0.1-0.7,0.2-1.1c0.1,0,0.2,0.1,0.3,0.1V237c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.2-0.2-0.5-0.4-0.6
		c-0.6-0.2-0.6-0.6-0.7-1.1c0-0.1-0.1-0.3-0.1-0.4c0,0,0,0-0.1,0c-0.3-0.1-0.5-0.2-0.7-0.4c-0.3,0.1-0.5,0.3-0.8,0.5
		c-0.1,0.1,0,0.3,0,0.5c0-0.1,0.1-0.1,0.1-0.2c0.1,0.2,0.3,0.3,0.3,0.4c0,0.1-0.1,0.2-0.2,0.2h-0.1c0.1,0.3,0.1,0.7-0.3,1
		c-0.2-0.2-0.3-0.4-0.6-0.6c-0.1,0.3-0.2,0.6-0.4,1c1.1,0.4,1.9,1,2.4,1.9c0.1,0,0.2,0,0.3,0.1c0,0.1-0.1,0.2-0.1,0.2h-0.1
		c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0.1,0.3,0.2,0.5c0.3,0.1,0.5,0.2,0.8,0.3C305.5,241.4,305.2,242.1,304.5,242.2z M304.5,234.4
		L304.5,234.4l-0.1,0.1L304.5,234.4z M304,236.2c-0.6-0.4-0.5-0.9,0-1.4h-0.1h0.2l0,0c0.6,0.1,1,0.4,1,0.9c0,0.2-0.1,0.4-0.3,0.5
		C304.5,236.3,304.1,236.3,304,236.2z M305,237.9L305,237.9c0,0.1,0,0.1-0.1,0.1c0,0.2-0.1,0.4-0.1,0.5c-0.1,0-0.2-0.1-0.3-0.1
		c0.1-0.1,0.3-0.3,0.4-0.4C304.9,238,304.9,237.9,305,237.9L305,237.9c0-0.3,0-0.6,0-0.9C305.5,237.3,305.4,237.6,305,237.9z"
      />
      <path
        class="st4"
        d="M95.1,300.7c-0.4-0.3-0.7-0.6-0.9-0.9c-0.2,0.2-0.4,0.3-0.6,0.4s-0.5,0.2-0.7,0.3c0.6,0.4,1,1,1.4,1.7
		c0.3-0.2,0.6-0.4,0.9-0.6v-0.1C95.1,301.3,95.1,301,95.1,300.7z"
      />
      <path
        class="st4"
        d="M41.6,291.1c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.2,0C41.6,291.2,41.6,291.1,41.6,291.1z"
      />
      <path
        class="st4"
        d="M42.8,296.2c0.2-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.2,0.4-0.3c-0.1-0.6-0.3-1.2-0.9-1.6
		c-0.2-0.2-0.4-0.3-0.5-0.5c-0.2,0.1-0.4,0.1-0.6,0.2c0.1-0.4,0.1-0.8,0.2-1.2c-0.8,0.1-1.1,0.6-1.6,1.1c0.1,0.3,0,0.6,0,0.9
		c1.1,0.3,1.7,1,2.5,1.5c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.1,0.1,0.2C42.9,296,42.9,296.1,42.8,296.2
		C42.7,296.1,42.8,296.2,42.8,296.2z"
      />
      <path
        class="st4"
        d="M101.4,293.6C101.5,293.6,101.5,293.6,101.4,293.6c0.2-0.4,0.3-0.9,0.5-1.3c-0.6-0.1-1.1-0.1-1.6-0.2
		c0.2-0.2,0.3-0.4,0.3-0.5c-0.5,0-1.2,0-2.1,0c0.6,0.8,0.6,1.6,0.2,2.5c-0.2,0.5-0.4,1-0.5,1.5c0.3,0.1,0.6,0.1,0.9,0.2
		C99.9,295.2,100.4,294.2,101.4,293.6z"
      />
      <path
        class="st4"
        d="M84,290.9C84,291,84,291,84,290.9C84.1,290.9,84,290.9,84,290.9L84,290.9z"
      />
      <path
        class="st4"
        d="M93.9,295.9c0-0.1,0-0.3,0-0.4s0-0.2,0-0.2c-1.2,0.7-2.6,0.7-3.7,0.2c-0.5-0.3-1-0.6-1.5-1
		c0-1,0.2-1.9,0.7-2.8c-0.3-0.2-0.6-0.4-0.9-0.7c-0.1-0.1-0.3-0.1-0.4-0.2c0.1,0,0.2,0,0.2,0c-0.4-0.4-0.7-0.8-1.2-1.2
		c-0.1,0-0.2,0-0.3,0c0,0.4,0,0.8-0.1,1.2c-0.9,0.3-0.9,0.3-1.9,0.2c-0.2,0-0.5,0.1-0.7,0.1l0,0c-0.1,0-0.1,0.1-0.2,0.1
		c-0.1,0.2-0.2,0.3-0.2,0.5c-0.1,0.2-0.5,0.4-0.8,0.6c-0.2,0.1-0.6,0.1-0.6,0.2c-0.3,1-1.4,1.3-2.3,1.6c0,0.1,0,0.1,0,0.2
		c0.2-0.1,0.5-0.2,0.6-0.1c0.8,0.2,1.1,0.7,1.5,1.3c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.3l0.1,0.1c0,0,0,0.1,0.1,0.1
		c0.1,0.3,0.3,0.5,0.6,0.7l0,0c0.6-0.5,0.7-0.4,1,0.2c0,0,0,0,0.1,0v0.1c0.2-0.1,0.4-0.1,0.7-0.2c-0.2-0.2-0.3-0.4-0.4-0.6
		c0-0.1-0.1-0.3-0.1-0.4c-0.2,0.1-0.4,0.3-0.7,0.4c0.3-0.4,0.4-0.6,0.7-0.7c0.1-0.5,0.3-0.9,0.6-1.2l0.1-0.1l0.1-0.1
		c1.1-0.8,3.1-0.4,3.5,0.7c0.2,0.4,0.2,0.9,0.3,1.3c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0.1,0.4,0.1,0.7,0.2c-0.1,0.3-0.2,0.5-0.3,0.7l0,0
		l0,0c0.5-0.2,0.9-0.5,1.4-0.7c0.1,0,0.1,0,0.2,0c0.8-0.2,1.6-0.2,2.3,0.1c0.3,0.1,0.5,0.3,0.6,0.5c0.4-0.5,1-0.9,1.7-1.1
		c0.1,0,0.1,0,0.2-0.1c0-0.2,0-0.4,0-0.6C95.5,295.5,94.8,295.6,93.9,295.9L93.9,295.9z M82.3,293.1c-0.1,0-0.1-0.1-0.2-0.1
		c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.2,0.1,0.3,0.2C82.5,293,82.4,293.1,82.3,293.1z"
      />
      <path
        class="st4"
        d="M53,304.1c0.2,0.1,0.5,0.1,0.7,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C53.2,304,53.1,304.1,53,304.1z"
      />
      <path
        class="st4"
        d="M53.2,303.3c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.1-0.3-0.2-0.4-0.2
		C53.3,303.2,53.3,303.2,53.2,303.3z"
      />
      <path
        class="st4"
        d="M305.9,126.5c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.1,0.2-0.1,0.4c0.1,0,0.3-0.1,0.4-0.2
		C305.8,126.7,305.9,126.5,305.9,126.5z"
      />
      <path
        class="st4"
        d="M220.1,131.8c0,0-0.1,0-0.1-0.1c-0.7,0.9-1,1.9-1.2,2.9c0.7-0.1,1.5-0.3,2.1-0.8c-0.1-0.2-0.2-0.3-0.4-0.5
		C220.1,132.9,220,132.3,220.1,131.8z"
      />
      <path
        class="st4"
        d="M225.1,136.6c0,0.5,0,0.9,0,1.4c0.4-0.1,0.8-0.2,1.1-0.3C225.7,137.4,225.4,137.1,225.1,136.6z"
      />
      <path
        class="st4"
        d="M223,138.1c0.2-0.5,0.3-0.9,0.5-1.4c-0.7,0.2-1.1,0.6-1.5,1C222.4,137.8,222.7,137.9,223,138.1z"
      />
      <path
        class="st4"
        d="M233.3,139c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.4-0.2-0.8-0.3-1.3c-0.5-0.1-1-0.3-1.6-0.4l0,0
		c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c0,0,0,0,0,0.1c0.4,0.2,0.8,0.3,1.5,0.6c-1.1,0.2-1.4,0-1.5-0.6
		c0,0,0,0-0.1,0l0,0c-0.9,1-2.1,1.2-3.3,1c0,0.7,0,1.4,0,2c-0.1,0.4-0.3,1-0.7,1.2c-1,0.6-1,1.2-0.6,1.9c0.3,0.1,0.6,0.1,0.8,0.2
		c0.7-0.1,1.4-0.3,1.9-0.9c0.4-0.5,0.8-0.9,1.2-1.2c-0.2-0.3-0.4-0.6-0.6-0.9C230.7,139.6,231.9,139.1,233.3,139z M231.5,138.2
		C231.5,138.3,231.5,138.3,231.5,138.2c-0.1,0-0.2,0-0.3,0C231.3,138.2,231.4,138.2,231.5,138.2z M229.5,140.6
		c0,0.2-0.2,0.3-0.3,0.4c-0.1-0.1-0.4-0.1-0.4-0.2c0-0.1,0.1-0.3,0.3-0.4C229.3,140.5,229.6,140.6,229.5,140.6z"
      />
      <path
        class="st4"
        d="M232.1,144.4c0.1,0.5,0.3,0.9,0.4,1.3c0.1,0,0.2,0,0.2,0c0.5-0.3,0.9-0.6,1.2-0.7c0.5-0.1,0.7-0.2,1-0.4
		c-0.4-0.3-0.5-0.7-0.6-1C233.5,143.8,232.8,144.1,232.1,144.4z M232.8,145c0,0-0.1-0.2-0.2-0.3c0.3-0.1,0.6-0.2,0.9-0.4
		c0,0.1,0.1,0.2,0.1,0.3C233.3,144.8,233,144.9,232.8,145z"
      />
      <path
        class="st4"
        d="M233.4,118c-0.1,0-0.2,0.1-0.3,0.1c0.2,0.1,0.4,0.2,0.6,0.4C233.7,118.4,233.6,118.2,233.4,118z"
      />
      <path
        class="st4"
        d="M225.5,133.7c-0.5,0.2-1,0.4-1.3,0.6c-0.2,0.9-0.4,1.7-0.6,2.4c0.5-0.1,0.9-0.2,1.5-0.3c0-0.1-0.1-0.1-0.1-0.1
		C224.6,135.4,224.8,134.4,225.5,133.7z"
      />
      <path
        class="st4"
        d="M235.1,124.9c-0.1,0-0.1,0.1-0.2,0.1c0.1,0,0.1,0.1,0.2,0.1C235,125,235,125,235.1,124.9z"
      />
      <path
        class="st4"
        d="M234.3,143.4c-0.1-0.6-0.2-1.1-0.7-1.6c-0.3,0-0.5,0.1-0.7,0.2C233.4,142.5,233.8,143,234.3,143.4z"
      />
      <path
        class="st4"
        d="M248.7,130.1c0.2,0.1,0.3,0.1,0.5,0.2c0-0.1,0.1-0.3,0.1-0.4c0.2,0,0.3,0.1,0.5,0.1c0.2-0.3,0.4-0.6,0.6-0.9
		c-1.2,0-2,1.4-3.2,0.6c-0.5,0.2-0.9,0.2-1.4,0.1c0.4,0.7,0.6,1.4,0.5,2.2c0.2,0,0.3,0,0.5,0.1c-0.1-0.6,0.4-1.4,0.9-1.3
		C248.6,131,248.3,130.3,248.7,130.1z"
      />
      <polygon class="st4" points="259.8,121.9 259.9,121.9 259.8,121.8 	" />
      <path
        class="st4"
        d="M264.1,103.4c0.1,0,0.2-0.1,0.3-0.1c-0.2-0.2-0.3-0.4-0.5-0.6C264,103,264,103.2,264.1,103.4z"
      />
      <path
        class="st4"
        d="M279.9,140.2c1-0.3,1.2-1.3,2.5-1.8c-1.8-0.1-2.6-1-3.6-1.6c0,0.9,0.3,1.7,0.6,2.4c0.2-0.1,0.3-0.1,0.5-0.1
		c0,0.3-0.1,0.6-0.1,0.9C279.8,140,279.8,140.1,279.9,140.2z"
      />
      <path
        class="st4"
        d="M248.1,117.5c0.1,0,0.1,0,0.2,0c0-0.1,0-0.1,0-0.2C248.2,117.4,248.1,117.4,248.1,117.5z"
      />
      <path
        class="st4"
        d="M289.7,132.5c-0.1-0.4-0.1-0.8-0.2-1.2c-0.2,0.2-0.5,0.3-0.7,0.4c0.2,0.1,0.5,0.1,0.4,0.2
		C288.9,132.5,289.1,132.6,289.7,132.5z"
      />
      <path
        class="st4"
        d="M252.4,118c-0.4-0.1-0.9-0.2-0.9-0.7c-0.5,0.4-1.1,0.8-2,0.2c0,0,0-0.1,0-0.2c-0.4,0.2-0.8,0.5-1.3,0.8
		c0.5,0.3,0.9,0.8,1.1,0.7c1.2-0.3,1.3,0.4,1.4,0.7c-0.3,1.2-0.6,2.1-0.8,3.1c0.7-0.1,1.1-0.4,1.5-0.3c0.3,0,0.5,0.4,0.8,0.8
		c0.4-0.9,0.8-1.7,1.2-2.5c-0.5-0.5-1-1-1.5-1.5c0.4-0.4,0.7-0.7,1-1c0,0,0,0,0-0.1C252.8,118.1,252.6,118.1,252.4,118L252.4,118z
M251.1,118.8c-0.2-0.3-0.4-0.6-0.6-0.8c0.1,0,0.2-0.1,0.3-0.1c0.2,0.3,0.3,0.6,0.5,0.9C251.2,118.7,251.1,118.7,251.1,118.8z
M251.5,119.1L251.5,119.1h0.1H251.5z"
      />
      <path
        class="st4"
        d="M247.4,134.7c-0.2,0-0.3,0-0.5,0c0.3,0.3,0.5,0.6,0.8,0.8c0.1-0.1,0.2-0.3,0.3-0.4
		C247.6,135.1,247.5,134.9,247.4,134.7z"
      />
      <path
        class="st4"
        d="M8.6,310.4c-0.1,1-0.4,1.8-1.1,2.3c0,0.6-0.2,1.1-0.6,1.5c0.1,0.1,0.3,0.3,0.6,0.4c0.7-0.7,1.5-1.3,2.2-2
		C9,312.2,9.9,311.1,8.6,310.4z"
      />
      <path
        class="st4"
        d="M9.5,152.6c0.4-0.3,0.7-0.6,1-0.9c0.4-0.4,0.2-0.7-0.5-0.7c0,0,0,0-0.1,0.1c0,0.2,0,0.3,0,0.5
		c-0.1,0-0.3,0-0.4,0l0,0c-0.2,0.2-0.3,0.4-0.5,0.6C9,152.1,9.3,152.4,9.5,152.6L9.5,152.6z"
      />
      <path
        class="st4"
        d="M132.3,117.5c-0.3-0.1-0.7-0.2-1.3-0.3C131.6,117.8,132,117.6,132.3,117.5z"
      />
      <path
        class="st4"
        d="M347.8,223.8c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.2,0C347.8,223.9,347.8,223.8,347.8,223.8z"
      />
      <path
        class="st4"
        d="M353.6,236.1c-0.7-0.5-0.7-1.2,0.2-1.6c0.7-0.2,1.1-0.9,2.1-0.7c0.7,0.1,1.6-0.4,2.2-1.2
		c-0.4-0.1-0.7-0.2-0.9-0.2c0.3-0.7,0.6-1.5,0.9-2.1c-0.4-0.3-0.6-0.6-0.8-0.7c0.4-0.5,0.7-0.8,1-1.2c-0.3,0-0.5,0-0.7-0.1
		c-0.8-0.3-1.3-1.2-1.8-1.8c0.1-0.1,0.1-0.1,0.2-0.2c-0.4,0-0.7-0.1-1.1-0.1c0-0.2,0-0.3,0.1-0.5c-0.1,0.1-0.3,0.1-0.4,0.1
		c-2.7,0.5-2.7,0.5-4.5-1.3c-0.3,0.2-0.6,0.5-0.9,0.8v0.1c0.3,0.4,0.6,0.7,0.9,1.1c1,1.2,1.1,2.3,0.3,3.4c0,0.3,0,0.6,0.1,0.9
		c0.1,0.2-0.3,0.6-0.6,0.9c-0.3-0.3-0.5-0.5-0.6-0.7c-0.1,0.1-0.2,0.2-0.3,0.3c0.4,0.9,1.1,0.3,1.7,0.3c0.3,0.4,0.6,0.8,1.1,1.3
		c0-0.6,0-0.9,0-1.3c0.1,0,0.2-0.1,0.4-0.1c0.3,0.6,0.7,1.2,0.9,1.8c0.2,0.5-0.2,0.8-0.6,0.9c-1-0.5-1.7-1.1-2.6-1.3
		c-1-0.1-1.2-0.6-1.3-1.1c-0.1,0.3-0.1,0.5,0,0.8c-0.4,0.2-0.8,0.3-1,0.5s-0.3,0.7-0.5,0.8c-0.4,0.1-0.8,0.3-1.1,0.5
		c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.3-0.5,0.7-0.8,1.1c-0.8-0.2-1.9,0.1-2.4-0.4c-0.2,0-0.4,0.1-0.7,0.1c-0.2,0.1-0.6-0.1-0.9-0.2
		c0,0-0.1,0-0.1-0.1c-0.2,0-0.3,0-0.5,0c0,0.3-0.1,0.6-0.1,0.8l0,0c0,0.1,0,0.2-0.1,0.3c0,0.2,0,0.3-0.1,0.5
		c-0.4-0.2-0.5-0.4-0.6-0.6c-0.2-0.5-0.5-1.1-0.6-1.6c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.6-1-0.5-0.9-0.7c0.2-0.3,0.2-0.5,0.1-0.6
		c-0.2,0-0.4-0.1-0.5-0.1s-0.1,0-0.2,0s-0.2-0.1-0.2-0.2c-0.4-0.2-0.7-0.6-0.8-1.2c-0.1-0.2-0.1-0.5-0.2-0.7c0,0,0,0-0.1,0
		c-0.5,0.4-0.9,0.6-1.4,0.8c-0.6,0.7-1.3,1.3-2.2,1.5c-0.2,0-0.3,0.1-0.5,0.1c0,0.1,0,0.1,0,0.2c0.2,0,0.4,0,0.6,0
		c1.8-0.1,2.7,0.3,3,1.3c0.1,0.2,0.1,0.5,0.1,0.7c0.2,0.1,0.4,0.2,0.5,0.3c0.2,0.4-0.1,0.8-0.8,1.1c-0.1-0.1-0.3-0.2-0.4-0.2
		c-0.3,0.2-0.6,0.5-1.1,0.8c-1.3,0.7-1.6,1.9-0.7,2.9c0.7,0.7,1.4,1.5,1.9,2.4c0.8,1.2-0.1,2.7-1.8,3.4c-1.5,0.6-3.2,0.1-3.9-1
		c-0.7-1.3,0-2.8,1.7-3.4c0-0.1,0-0.1,0-0.2c0,0,0,0.1,0.1,0.1c0.2-0.1,0.5-0.2,0.7-0.2c-0.4-0.2-0.5-0.5-0.2-1c0,0,0,0,0.1,0
		c-0.4-0.5-0.5-1-0.5-1.7c0-1.2-0.4-2.3-1.2-3.3c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2,0-0.3,0-0.5,0c-0.8-0.2-1.1-0.6-1.1-1.2
		c-1.3-0.2-1.2-1.6-2.4-1.8c-0.1,0-0.2-0.2-0.2-0.4c0,0,0,0,0-0.1c-0.6,0.1-1.2,0.3-1.8,0.4c-0.1,0-0.1,0-0.2,0
		c-0.2,0.6-0.5,1.3-1.1,1.9c-0.4,0.4-0.8,0.9-1.1,1.4c0.3-0.2,0.7-0.3,1-0.5c-0.1,0-0.3-0.1-0.4-0.2c0.3-0.3,0.5-0.6,0.9-1
		c0.2,0.3,0.5,0.5,0.4,0.7c-0.1,0.1-0.1,0.2-0.2,0.3c0.2,0,0.4,0,0.7,0c0.7,0.2,1.4,0.2,2.1,0c0.7-0.1,1.3,0.1,1.4,0.6
		c0.1,0.4,0.1,0.9-0.1,1.3c-0.6,1.1-2.3,0.8-3.2,1.5c-0.3,0.2-0.9,0.2-1.4,0.2c-0.2,0-0.4,0-0.5-0.1c-0.6-0.5-1.4-0.4-2.1-0.3
		c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.2,0,0.5-0.1,0.9c-0.2-0.2-0.3-0.3-0.4-0.4l0,0l0,0c-0.2-0.2-0.3-0.3-0.5-0.4
		c-0.2,0.1-0.3,0.3-0.5,0.4c-0.6-0.1-0.8-0.2-1-0.3c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0,0.2,0c1.2,0,2.1,0.4,2.4,1.4
		c0.1,0.3,0.3,0.8,0.6,1c1,0.6,2.1,1.2,3.2,1.7c0.9,0.5,1.4,1.1,1.3,2s-0.7,1.7-1.8,2.1c-0.4,0.1-0.8,0.2-1.2,0.4
		c1.2,0.4,1.3,0.7,1.4,1.9c-0.6,0.2-1.2-0.1-1.8,0.1c0.1,0.2,0.1,0.5,0.1,0.7c0,0.1,0.1,0.3,0.1,0.4c0.5,0,0.9,0.2,1.4,0.4
		c0.3,0.1,0.6,0.2,0.8,0.3l0,0c0,0,0,0,0.1,0c-0.2-0.7-0.8-1.3-0.7-2.2c0.2-1.5,2.5-2.8,4.1-2.5c1.4,0.2,2.4,1.1,2.5,2.2
		c0,0,0,0,0.1,0c0,0,0,0.1-0.1,0.1c0,0.3,0,0.6-0.1,0.9c-0.1,0.2-0.2,0.4-0.3,0.6c0.8-0.2,1.6-0.4,2-1.4c0.6,1,1.8,1,2.9,1
		c0.2,0,0.6-0.4,0.8-0.6c0.1-0.2,0.1-0.6,0.2-1.2c0.3,0.3,0.5,0.5,0.7,0.8c0.2-0.3,0.5-0.6,0.8-0.6c0.5-0.1,1.1,0.2,1.2,0.6
		c0.1,0.5-0.3,1-1,1.1c-0.3,0-0.6,0-0.8-0.2c0,0.2-0.2,0.4-0.3,0.6c0.6,0.4,1-0.2,1.5-0.4c2.3-0.5,2.6-0.5,3.9,1
		c0.5,0.5,0.6,1.2,1.1,1.7c0.9,1,1.2,2.1,1.3,3.3c0.8,0,0-1.6,1.5-0.6c-0.1-0.9-0.1-1.6-0.1-2.3c0.1,0,0.2-0.1,0.3-0.1
		c0.1,0.2,0.3,0.4,0.5,0.6c0.2-0.3,0.3-0.6,0.4-0.8c-0.1-0.2-0.1-0.3-0.2-0.3c-2.3-1.3-3.4-3.7-2.5-5.9c0.4-0.9,1.3-1.6,2.1-2.3
		c0.2-0.2,0.5-0.4,0.7-0.6c-0.3-0.4-0.5-0.7-0.7-0.9c0.4-0.3,0.8-0.5,1-0.8c0.3-0.3,0.4-0.7,0.7-1c0.2,0,0.3,0.1,0.5,0.1
		c0.2,0.5,0.1,0.8-0.2,1.2c0.9,0,1.4,0.2,1.3,1.2c0.8-0.4,1.3-0.7,1.8-0.9c-0.3-0.6-0.3-1.2-0.2-1.7c-0.7-0.5-0.5-1.5-0.8-2.1
		c-0.4-0.9,0.9-1.5,1.4-2.2c1.1,0.8,1.7,1.6,0.8,2.8c-0.2,0.2,0,0.5,0,0.8c0.1,0.3,0.1,0.4-0.4,1.1c0.2,0.4,0.6,0.6,1.4,0.6
		c0.5-0.3,1-0.6,1.5-0.9c0.2-0.2,0.3-0.5,0.5-0.7c0.2-0.5,0.4-1,0.9-1.3c-0.3-0.1-0.6-0.3-0.8-0.5
		C354.7,236.8,354.1,236.4,353.6,236.1z M356.7,231.1c0.1,0,0.1,0,0.2,0v0.1C356.8,231.1,356.7,231.1,356.7,231.1
		C356.6,231.1,356.7,231.1,356.7,231.1z M356.5,229.8L356.5,229.8c0-0.1,0.1-0.2,0.1-0.3C356.6,229.6,356.5,229.7,356.5,229.8
		L356.5,229.8c0,0.2,0,0.5,0.1,0.9C356.3,230.3,355.9,230.1,356.5,229.8z M356,231.8L356,231.8L356,231.8L356,231.8z M351.1,228.8
		C351.1,228.8,351.1,228.7,351.1,228.8c-0.1-0.1,0-0.1,0-0.2c0,0,0.1,0,0.1,0.1C351.2,228.7,351.2,228.7,351.1,228.8z M325.1,240.1
		c0-0.1,0-0.2,0-0.3c-0.8,0-1.4-0.4-1.5-1.1c-0.2-0.8,0.5-1.7,1.5-1.9c0.9-0.2,1.8,0.2,2.1,0.9h0.1c1.5-0.3,2.9,0.4,3.1,1.5
		s-0.7,2.2-2.2,2.6l0,0l0,0c0,0,0,0-0.1,0C326.7,242,325.3,241.3,325.1,240.1z M328.4,242.8c-0.1,0-0.2-0.1-0.2-0.2
		c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1,0.1,0.2,0.2C328.5,242.8,328.4,242.9,328.4,242.8z M336.9,235C336.9,235.1,336.9,235.1,336.9,235
		c0.1,0,0.2-0.1,0.2-0.2c0.3,0.1,0.6,0.2,1,0.4c-0.3,0.3-0.5,0.6-0.6,0.6c-0.2,0-0.6-0.2-0.7-0.3C336.7,235.4,336.8,235.3,336.9,235
		C336.9,235.1,336.9,235.1,336.9,235z M336.7,243.5c-0.1,0-0.2,0-0.3,0c0-0.1,0.1-0.2,0.1-0.3c0.1,0,0.2,0,0.3,0
		C336.8,243.3,336.7,243.4,336.7,243.5z M336.5,240.9c-0.8-0.6-0.8-1.8,0.1-2.6s2.8-0.7,3.5,0.3c0.1,0.2,0.1,0.5,0.3,0.7
		c0.1,0.1,0.3,0.2,0.5,0.4c-0.4,0.4-0.8,0.7-1.2,1C338.6,241.5,337.3,241.5,336.5,240.9z M341.3,242.5c-0.3-0.5-0.5-0.8-0.8-1.1
		C341.5,241.4,341.9,241.6,341.3,242.5z M342.7,239.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.1-0.2,0.2-0.2
		l0.1-0.1c0.2,0,0.4,0.1,0.7,0.2C342.9,239,342.8,239.1,342.7,239.1z M343.5,237.4c-0.1-0.1-0.2-0.2-0.3-0.3
		c0.4-0.2,0.7-0.3,1.1-0.5c0.1,0.1,0.1,0.2,0.2,0.2C344.2,237,343.8,237.2,343.5,237.4z M350.7,235.4c-0.2,0.5-0.6,0.6-1.7,0.3
		c0.3-0.6,0.5-1.2,1.4-0.9C350.6,234.8,350.8,235.2,350.7,235.4z M353.2,232c0,0,0,0.1-0.1,0.1C353.1,232.1,353.1,232,353.2,232
		c0-0.1,0-0.1,0.1-0.1C353.2,231.9,353.2,232,353.2,232L353.2,232z M355.7,227.6c-0.7,0.6-1.1,0.4-1.5,0.1
		C354.7,226.9,355.1,227.4,355.7,227.6z M354.3,232.1c0.2,0.2,0.3,0.5,0.5,0.7c-0.1,0-0.1,0.1-0.2,0.1c-0.2-0.2-0.4-0.4-0.6-0.6
		C354.1,232.2,354.2,232.2,354.3,232.1z M351.8,227.2c0.3-0.6,0.9-0.6,1.5-0.7c0.1,0.1,0.2,0.2,0.3,0.3c-0.3,0.2-0.6,0.4-0.9,0.7
		C352.5,227.4,352.2,227.3,351.8,227.2z M353,228.2c0.3,0.6,0.6,1,0.9,1.6C352.5,229.4,352.5,229.4,353,228.2z M353,230.5L353,230.5
		v-0.1V230.5z"
      />
      <path
        class="st4"
        d="M326.8,230.7L326.8,230.7c0.1-0.2,0-0.2,0-0.3c-0.2,0-0.4,0.1-0.6,0.1C326.4,230.6,326.6,230.7,326.8,230.7z"
      />
      <path
        class="st4"
        d="M538.3,77.1c0.1,0.5,0.3,0.9,0.4,1.3c0.1,0,0.2,0,0.2,0c0.5-0.3,0.9-0.6,1.2-0.7c0.5-0.1,0.7-0.2,1-0.4
		c-0.4-0.3-0.5-0.7-0.6-1C539.6,76.5,539,76.8,538.3,77.1z M538.9,77.7c0,0-0.1-0.2-0.2-0.3c0.3-0.1,0.6-0.2,0.9-0.4
		c0,0.1,0.1,0.2,0.1,0.3C539.5,77.5,539.2,77.6,538.9,77.7z"
      />
      <path
        class="st4"
        d="M390.1,223.6C390.2,223.7,390.2,223.7,390.1,223.6C390.2,223.6,390.2,223.6,390.1,223.6
		C390.2,223.6,390.2,223.6,390.1,223.6z"
      />
      <path
        class="st4"
        d="M404,89.8c0,0.1,0.1,0.3,0.1,0.4c0.2-0.1,0.3-0.1,0.5-0.2C404.4,89.9,404.2,89.8,404,89.8z"
      />
      <path
        class="st4"
        d="M400,228c-1.2,0.7-2.6,0.7-3.7,0.2c-0.5-0.3-1-0.6-1.5-1c0-1,0.2-1.9,0.7-2.8c-0.3-0.2-0.6-0.4-0.9-0.7
		c-0.1-0.1-0.3-0.1-0.4-0.2c0.1,0,0.2,0,0.2,0c-0.4-0.4-0.7-0.8-1.2-1.2c-0.1,0-0.2,0-0.3,0c0,0.4,0,0.8-0.1,1.2
		c-0.9,0.3-0.9,0.3-1.9,0.2c-0.2,0-0.5,0.1-0.7,0.1l0,0c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.2-0.2,0.3-0.2,0.5c-0.1,0.2-0.5,0.4-0.8,0.6
		c-0.2,0.1-0.6,0.1-0.6,0.2c-0.3,1-1.4,1.3-2.3,1.6c0,0.1,0,0.1,0,0.2c0.2-0.1,0.5-0.2,0.6-0.1c0.8,0.2,1.1,0.7,1.5,1.3
		c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.3,0.4,0.6,0.6,0.8c0.6-0.5,0.7-0.4,1,0.2c0,0,0,0,0.1,0v0.1
		c0.2-0.1,0.4-0.1,0.7-0.2c-0.2-0.2-0.3-0.4-0.4-0.6c0-0.1-0.1-0.3-0.1-0.4c-0.2,0.1-0.4,0.3-0.7,0.4c0.3-0.4,0.4-0.6,0.7-0.7
		c0.1-0.6,0.4-1.2,0.8-1.5c1.1-0.8,3.1-0.4,3.5,0.7c0.2,0.4,0.2,0.9,0.3,1.3c0.5,0.1,1,0.3,1.6,0.4c-0.1,0.3-0.2,0.5-0.3,0.7l0,0
		l0,0c0.5-0.2,0.9-0.5,1.4-0.7c1.2-0.4,2.5-0.2,3.1,0.6c0.4-0.5,1-0.9,1.7-1.1c0.1,0,0.1,0,0.2-0.1c0-0.2,0-0.4,0-0.6
		c-0.9,0.2-1.6,0.4-2.4,0.7C400.1,228.4,400,228.2,400,228z M388.5,225.8c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2
		c0.1,0.1,0.2,0.1,0.3,0.2C388.6,225.7,388.5,225.8,388.5,225.8z"
      />
      <path
        class="st4"
        d="M359.3,236c0.2,0.1,0.3,0.1,0.5,0.1c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.1-0.3-0.2-0.4-0.2
		C359.5,235.9,359.4,235.9,359.3,236z"
      />
      <path
        class="st4"
        d="M349,228.9c0.2-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.2,0.4-0.3c-0.1-0.6-0.3-1.2-0.9-1.6
		c-0.2-0.2-0.4-0.3-0.5-0.5c-0.2,0.1-0.4,0.1-0.6,0.2c0.1-0.4,0.1-0.8,0.2-1.2c-0.4,0.1-0.6,0.2-0.8,0.4c-0.3,0.2-0.5,0.5-0.8,0.8
		c0.1,0.3,0,0.6,0,0.9c1.1,0.3,1.7,1,2.5,1.5c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.1,0.1,0.2C349.1,228.8,349.1,228.9,349,228.9
		C348.9,228.8,348.9,228.9,349,228.9z"
      />
      <path
        class="st4"
        d="M513.3,38.1L513.3,38.1c-0.1,0-0.1,0.1,0,0.1C513.2,38.2,513.3,38.1,513.3,38.1z"
      />
      <path
        class="st4"
        d="M533.6,48.5c-0.2-0.5-0.3-0.9-0.4-1.3c-0.5,0.3-0.7,0.5-0.9,0.5c0.3,0.3,0.5,0.6,0.7,0.8
		C533.2,48.5,533.4,48.5,533.6,48.5z"
      />
      <path
        class="st4"
        d="M374.8,66.5c0.3-0.3,0.8-0.6,1.1-0.9c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.5-0.4-0.6-0.7
		c-0.1-0.1-0.2-0.2-0.4-0.4c-0.7,0.5-1.5,0.6-2.1,1.2c0.7,0.1,1.4,0.3,1.9,0.7C374.4,66,374.6,66.2,374.8,66.5z"
      />
      <path
        class="st4"
        d="M368.9,65.6c0.1-0.1,0.2-0.1,0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.2-0.3-0.6-0.5-0.9
		c-1.2,0.3-0.6,1.2-1.1,1.7c0.1,0.1,0.3,0.1,0.4,0.2C368.3,66,368.6,65.8,368.9,65.6z"
      />
      <path
        class="st4"
        d="M403.5,73.7c0.2,0.1,0.3,0.2,0.4,0.4c0-0.3,0-0.7,0.2-1.1c-0.5-0.1-1-0.1-1.5-0.2c-0.8-0.2-1.4-0.7-1.7-1.3
		c-0.3,0.3-0.3,0.6-0.4,1.3c0,0.3,0,0.5,0,0.8C401.5,73.1,402.7,73.1,403.5,73.7z"
      />
      <path
        class="st4"
        d="M541.2,57.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0,0.1,0.1,0.2,0.1C541.2,57.7,541.2,57.7,541.2,57.6z"
      />
      <path
        class="st4"
        d="M531.6,47.1L531.6,47.1c0,0.1,0.2,0.1,0.3,0.2c0,0-0.1-0.1-0.1-0.2C531.8,47.1,531.7,47.1,531.6,47.1
		C531.7,47.1,531.7,47.1,531.6,47.1z"
      />
      <path
        class="st4"
        d="M530.6,59.4c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0.1-0.3,0.1-0.4C530.9,59.2,530.7,59.3,530.6,59.4z"
      />
      <path
        class="st4"
        d="M510.1,53.7c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.1-0.4-0.2-0.6-0.2C509.9,53.5,510,53.6,510.1,53.7z"
      />
      <path
        class="st4"
        d="M559.3,180.1c0.1,0,0.3,0.1,0.4,0.1c-0.1-0.1-0.3-0.2-0.4-0.3C559.3,180,559.3,180,559.3,180.1z"
      />
      <path
        class="st4"
        d="M307.8,243.3c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.2-0.2,0.3-0.3,0.5c0.3,0.1,0.6,0.2,0.9,0.4c0-0.1,0-0.2,0-0.3
		c0,0,0,0-0.1,0l-0.1-0.1l0.1-0.1c0,0,0,0,0,0.1c0-0.1,0-0.1,0-0.2l0,0C308.1,243.5,308,243.4,307.8,243.3z"
      />
      <path
        class="st4"
        d="M539.6,50.7c-0.1,0-0.2,0.1-0.3,0.1c0.2,0.1,0.4,0.2,0.6,0.4C539.8,51.1,539.7,50.9,539.6,50.7z"
      />
      <path
        class="st4"
        d="M539.5,71.7c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2-0.4-0.2-0.8-0.3-1.3c-0.5-0.1-1-0.3-1.6-0.4l0,0
		c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c0,0,0,0,0,0.1c0.4,0.2,0.8,0.3,1.5,0.6c-1.1,0.2-1.4,0-1.5-0.6
		c0,0,0,0-0.1,0l0,0c-0.9,1-2.1,1.2-3.3,1c0,0.7,0,1.4,0,2c-0.1,0.4-0.3,1-0.7,1.2c-1,0.6-1,1.2-0.6,1.9c0.3,0.1,0.6,0.1,0.8,0.2
		c0.7-0.1,1.4-0.3,1.9-0.9c0.4-0.5,0.8-0.9,1.2-1.2c-0.2-0.3-0.4-0.6-0.6-0.9C536.9,72.3,538.1,71.8,539.5,71.7z M537.7,71L537.7,71
		c-0.1,0-0.2,0-0.3,0C537.5,70.9,537.6,70.9,537.7,71z M535.7,73.3c0,0.2-0.2,0.3-0.3,0.4c-0.1-0.1-0.4-0.1-0.4-0.2s0.1-0.3,0.3-0.4
		C535.4,73.2,535.7,73.3,535.7,73.3z"
      />
      <path
        class="st4"
        d="M531.6,66.4c-0.5,0.2-1,0.4-1.3,0.6c-0.2,0.9-0.4,1.7-0.6,2.4c0.5-0.1,0.9-0.2,1.5-0.3c0-0.1-0.1-0.1-0.1-0.1
		C530.8,68.1,531,67.2,531.6,66.4z"
      />
      <path
        class="st4"
        d="M430.8,60.9c-0.1,0.4-0.2,0.8-0.4,1.2c-0.1,0.4-0.4,0.7-0.6,1c0.6,0.1,1.3,0.2,1.9,0.3
		C431.6,61.3,431.6,61.3,430.8,60.9z"
      />
      <path
        class="st4"
        d="M529.2,70.8c0.2-0.5,0.3-0.9,0.5-1.4c-0.7,0.2-1.1,0.6-1.5,1C528.5,70.5,528.9,70.6,529.2,70.8z"
      />
      <path
        class="st4"
        d="M526.3,64.5C526.3,64.5,526.2,64.5,526.3,64.5c-0.8,0.8-1.1,1.8-1.3,2.8c0.7-0.1,1.5-0.3,2.1-0.8
		c-0.1-0.2-0.2-0.3-0.4-0.5C526.3,65.6,526.2,65,526.3,64.5z"
      />
      <path
        class="st4"
        d="M420.1,50.2c0.3-0.7,0-1-0.7-1.3c0,0.5,0,0.9-0.1,1.2s-0.2,0.5-0.4,0.7c0.3,0,0.6,0.1,0.8,0.2
		C419.8,50.8,419.9,50.5,420.1,50.2z"
      />
      <path
        class="st4"
        d="M398.9,96.4c-0.1,0.4-0.5,0.9-1,0.9c-0.3,0-0.6-0.1-0.9-0.2c0,0.1-0.1,0.3-0.2,0.5l0,0l0,0l0,0
		c-0.6,0.2-0.9,0.6-0.7,1c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.2,0.1,0.4,0.1,0.5,0.2c0-0.3,0-0.6,0.1-0.8
		c0.1-0.2,0.5-0.3,0.8-0.3c0.7,0,0.6,0.4,0.6,0.8c0.2-0.1,0.4-0.1,0.7-0.2l0,0c0.1-0.1,0.1-0.2,0.2-0.2c0,0.1-0.1,0.2-0.1,0.3l0,0
		c0.1,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.5-0.3,0.5-0.3c-0.2-0.4-0.4-0.9-0.6-1.3C399.3,96.8,399.1,96.6,398.9,96.4z"
      />
      <path
        class="st4"
        d="M576.8,25.4c0,0.1,0,0.1,0,0.2C576.8,25.5,576.8,25.4,576.8,25.4C576.9,25.3,576.8,25.4,576.8,25.4z"
      />
      <path
        class="st4"
        d="M606.8,32.7c-1,0-1.4,0.6-1.9,1.2c0,0,0,0.1,0.1,0.1c0.4-0.2,0.8-0.3,1.3-0.4C606.4,33.3,606.6,33,606.8,32.7z
		"
      />
      <path
        class="st4"
        d="M608,31.6c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.5-0.2,0.9-0.2,1.4c0.1,0,0.2,0.1,0.3,0.1l0,0
		C607.9,32.6,608,32.1,608,31.6z"
      />
      <path
        class="st4"
        d="M401.3,233.4c-0.4-0.3-0.7-0.6-0.9-0.9c-0.4,0.3-0.8,0.6-1.3,0.7c0.6,0.4,1,1,1.4,1.7c0.3-0.2,0.6-0.4,0.9-0.6
		v-0.1C401.3,234,401.3,233.7,401.3,233.4z"
      />
      <path
        class="st4"
        d="M396,99.4c-0.3,0.4-0.1,0.5,0.1,0.6c0-0.1,0-0.2,0-0.3l0,0C396.1,99.5,396.1,99.4,396,99.4
		C396.1,99.4,396.1,99.4,396,99.4z"
      />
      <path
        class="st4"
        d="M487.5,41c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.1-0.3,0.2-0.5C487.8,40.9,487.6,41,487.5,41z"
      />
      <path
        class="st4"
        d="M407.6,226.3C407.6,226.3,407.7,226.3,407.6,226.3c0.2-0.4,0.3-0.9,0.5-1.3c-0.6-0.1-1.1-0.1-1.6-0.2
		c0.2-0.2,0.3-0.4,0.3-0.5c-0.5,0-1.2,0-2.1,0c0.6,0.8,0.6,1.6,0.2,2.5c-0.2,0.5-0.4,1-0.5,1.5c0.3,0.1,0.6,0.1,0.9,0.2
		C406.1,227.9,406.6,226.9,407.6,226.3z"
      />
      <path
        class="st4"
        d="M322.1,127.8c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.1-0.3-0.2-0.4-0.3C322,127.5,322,127.7,322.1,127.8z"
      />
      <path
        class="st4"
        d="M540.5,76.1c-0.1-0.6-0.2-1.1-0.7-1.6c-0.3,0-0.5,0.1-0.7,0.2C539.5,75.3,539.9,75.7,540.5,76.1z"
      />
      <path
        class="st4"
        d="M531.3,69.3c0,0.5,0,0.9,0,1.4c0.4-0.1,0.8-0.2,1.1-0.3C531.9,70.1,531.5,69.8,531.3,69.3z"
      />
      <path
        class="st4"
        d="M319.6,121.6c-0.2,0.3-0.4,0.7-0.6,1c0.2,0.2,0.4,0.3,0.5,0.5c0.4,0.5,0.7,1.1,1.1,1.7
		c0.1,0.2,0.2,0.6,0.4,0.6c0.1,0,0.1,0.1,0.1,0.1c0.4,0.2,0.5,0.6,0.5,1c0,0.2,0.1,0.4,0.1,0.5c0.1-0.2,0.3-0.4,0.4-0.4
		c0.2,0,0.6,0.2,0.6,0.3c0,0.1-0.1,0.2-0.2,0.4c0.2-0.1,0.5-0.3,0.7-0.4c0.1-0.2,0-0.5-0.1-0.8c-0.4-0.6-0.4-1.3-0.1-2.1
		c-0.7-0.5-1.1-1.1-1.3-1.9c0-0.1,0-0.2-0.1-0.3C321.2,121.7,320.4,121.6,319.6,121.6C319.7,121.5,319.7,121.6,319.6,121.6
		C319.7,121.6,319.7,121.6,319.6,121.6z M321,124.5c0.2-0.2,0.6-0.1,0.9-0.2c-0.1,0.3-0.1,0.6-0.2,1C321,125.1,320.4,125,321,124.5z
		"
      />
      <path
        class="st4"
        d="M404.7,69.7C404.7,69.7,404.7,69.6,404.7,69.7c-0.1-0.1-0.3-0.1-0.4-0.1c0.1,0,0.1,0.1,0.2,0.1
		C404.6,69.8,404.6,69.8,404.7,69.7z"
      />
      <path
        class="st4"
        d="M360.9,95.8c0.3,0,0.6-0.1,0.9-0.1c-0.4-0.1-0.8-0.3-1.1-0.5C360.7,95.4,360.8,95.6,360.9,95.8z"
      />
      <path
        class="st4"
        d="M367.1,67.4l-0.1,0.1C367,67.4,367,67.4,367.1,67.4C367,67.4,367.1,67.4,367.1,67.4z"
      />
      <path
        class="st4"
        d="M340.8,117c-0.3-0.2-0.5-0.5-0.7-0.7c0,0.8,0.6,1.3,0.9,2c0,0,0,0,0,0.1c0-0.2-0.1-0.3-0.1-0.5
		C340.8,117.6,340.3,117.4,340.8,117z"
      />
      <path
        class="st4"
        d="M347.5,91.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.2,0,0.3,0,0.5,0.1C347.7,91.8,347.6,91.6,347.5,91.5z"
      />
      <path
        class="st4"
        d="M612.1,8.8V4.2c-1.3-0.7-2.6-1.4-4.3-1.7c-0.1,0-0.3,0.1-0.3,0.2c-0.1,0.5-0.1,1.1-0.1,1.6s0.1,1,0,1.5
		c-0.3,1.5,0.8,2.3,1.7,3.3c0.6,0.7,1.2,1.6,1.5,2.4c0.3-0.2,0.6-0.3,0.9-0.3c0.1,0,0.3,0,0.4,0v-0.9c-0.4,0.1-0.8-0.1-1.2-0.2
		C611.2,9,611.5,8.7,612.1,8.8z M610.2,9.7c-0.1,0-0.1,0-0.2,0c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0
		C610.3,9.7,610.3,9.7,610.2,9.7z"
      />
      <path
        class="st4"
        d="M515.3,23.2c0.5,0.4,1,0.8,1.7,1.3c-0.2-1-0.4-1.7-0.5-2.5c-1.1,0.7-2.4,0.9-3,1.9c-0.6,0.7-1.2,1.4-2.1,2.4
		c1.3-0.3,2.1-0.6,3-0.8C514.6,24.8,514,23.8,515.3,23.2z"
      />
      <path
        class="st4"
        d="M527.7,28c0,0.1,0,0.1,0,0.2c0.1,0,0.2-0.1,0.2-0.1S527.8,28.1,527.7,28z"
      />
      <path
        class="st4"
        d="M533.1,23.8c0.1-0.3,0.2-0.4,0.2-0.5c-0.1-1.4,0.4-2.6,2.2-3.2c0.5-0.2,0.5-0.7,0.2-1.2
		c-0.5,0.1-1.3,0.2-1.4,0.4c-0.2,0.8-1.2,1-1.5,1.7c-0.4,1-1.4,1.8-2.4,2.2c-1.3,0.5-1.7,1.3-2,2.3c0.4,0.2,0.8,0.4,1.3,0.6
		C530.3,24.9,531.3,23.9,533.1,23.8z"
      />
      <path
        class="st4"
        d="M438.5,50.2c-0.3-0.1-0.7-0.2-1.3-0.3C437.7,50.5,438.1,50.4,438.5,50.2z"
      />
      <path
        class="st4"
        d="M443,45.7c-0.2-0.2-0.1-0.6-0.1-0.9c-0.1,0.7-0.4,1.3-0.7,1.8c0.1,0,0.2,0.1,0.3,0.1
		C442.6,46.3,443.1,45.8,443,45.7z"
      />
      <path
        class="st4"
        d="M315.6,85.3c0.4-0.3,0.7-0.6,1-0.9c0.4-0.4,0.2-0.7-0.5-0.7c0,0,0,0-0.1,0.1c0,0.2,0,0.3,0,0.5
		c-0.1,0-0.3,0-0.4,0l0,0c-0.2,0.2-0.3,0.4-0.5,0.6C315.2,84.8,315.5,85.1,315.6,85.3L315.6,85.3z"
      />
      <path
        class="st4"
        d="M439.4,50.1c1.2-0.8,2.4-1.2,3.8-0.6c0-0.3-0.1-0.5-0.1-0.9c-0.6-0.2-1.2-0.5-1.8-0.8
		c-0.2,0.2-0.3,0.5-0.5,0.7l0,0c0.1,0,0,0.3-0.1,0.4c-0.1,0-0.2,0.1-0.4,0.1c-0.3,0.3-0.8,0.6-1.2,0.9c-0.2,0.1-0.4,0.1-0.6,0.2
		c0.1,0.1,0.2,0.3,0.3,0.4C439,50.4,439.2,50.3,439.4,50.1z"
      />
      <path
        class="st4"
        d="M600.2,25.7C600.2,25.8,600.1,25.8,600.2,25.7c0,0.1,0,0.2,0.1,0.2v-0.1C600.3,25.8,600.3,25.8,600.2,25.7z"
      />
      <path
        class="st4"
        d="M580.5,22.9c0,0.1,0,0.1-0.1,0.2h0.1C580.5,22.9,580.5,22.9,580.5,22.9z"
      />
      <path
        class="st4"
        d="M531.3,28.4c0.1,0,0.4-0.1,0.4-0.1c0-0.2,0-0.3,0-0.5c-0.1,0.1-0.3,0.2-0.3,0.3
		C531.3,28.2,531.3,28.3,531.3,28.4z"
      />
      <path
        class="st4"
        d="M533.2,26.5c0.1-0.1,0.2-0.2,0.3-0.2c-0.5-0.5-0.9-1-1.7-0.3c0,0.6-0.1,1.2-0.1,1.7
		C532.2,27.3,532.7,26.9,533.2,26.5L533.2,26.5L533.2,26.5L533.2,26.5z M532.6,25.8L532.6,25.8L532.6,25.8L532.6,25.8z"
      />
      <path
        class="st4"
        d="M443.8,43.8c0.8,0,1,0.5,1,0.9s-0.3,0.8-0.5,1.2c0.4,0.1,0.8,0.3,1.2,0.4c-0.1-0.1-0.3-0.2-0.5-0.3
		c-0.1,0-0.1-0.5,0-0.7c0.3-0.3,0.6-0.2,0.9,0.1c0.1,0.1,0.2,0.2,0.4,0.4c0.4-0.4,0.7-0.8,1.1-1.1c-0.4-1-1.2-1.1-2.4-0.8
		c0-0.6,0-1.1-0.1-1.6c-0.5,0.1-1,0.2-1.7,0.4c0,0.2-0.1,0.3-0.1,0.5C443.3,43.6,443.5,43.8,443.8,43.8z M446,44.8L446,44.8
		L446,44.8L446,44.8z"
      />
      <path
        class="st4"
        d="M507.4,50.2c-0.4-0.4-0.6-1-1.5-0.7c0.1,0.4,0.3,0.8,0.2,1.2c-0.1,0.4-0.5,0.7-0.8,1.1
		c1.3,0.7,2.2-0.3,3.2-0.7C507.8,51,507.7,50.5,507.4,50.2z"
      />
      <path
        class="st4"
        d="M380.7,100.1c0.3-0.1,0.6-0.2,0.9-0.3c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.3,0.3-0.4c-0.2-0.2-0.5-0.5-0.8-0.8
		C381,99.5,380.9,99.8,380.7,100.1z"
      />
      <path
        class="st4"
        d="M366.3,115.1c-0.1,0.1-0.3,0.1-0.4,0.2c0.2,0.1,0.3,0.2,0.5,0.4c0.2,0,0.3,0,0.5,0c0.1-0.1,0.1-0.2,0.2-0.3
		c0.2-0.3,0.4-0.7,0.7-1.1c-0.5,0.3-0.9,0.5-1.2,0.7C366.5,115,366.4,115.1,366.3,115.1z"
      />
      <path
        class="st4"
        d="M307,237.1c-0.1,0.2-0.2,0.4-0.3,0.7c0,0,0,0,0,0.1h0.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0.1,0c-0.1-0.3,0-0.7,0.1-1
		C307.1,237,307.1,237.1,307,237.1z"
      />
      <path
        class="st4"
        d="M311.5,236.9c0.3,1-0.5,2-1.7,2.3c-0.1,0-0.1,0-0.2,0v0.1c0.2,0.7-0.1,1.4-0.9,1.9c-0.4,0.3-0.8,0.4-1.2,0.5
		c0.1,0.1,0.1,0.3,0.1,0.4c0.1,0.4,0,0.8-0.1,1.1c0.1,0,0.2,0.1,0.2,0.1c0.2,0.1,0.3,0.1,0.5,0.2c0,0,0,0,0,0.1
		c0.3,0.1,0.6,0.2,1,0.4c0.1-0.4,0.2-0.8,0.5-1.1c0.6-0.5,1.5-0.9,2.3-1.4c-0.5-1.2,0-2.6,0.7-3.8
		C312.3,237.4,311.9,237.1,311.5,236.9z"
      />
      <path
        class="st4"
        d="M366.9,109c0.1,0,0.2-0.1,0.3-0.1c0.5-0.1,1.1,0,1.5,0.2c0.7-0.2,1.4,0.1,2.2,0.7c0.5-0.2,0.9-0.4,1.4-0.6
		c-0.4-0.5-0.4-1.1-0.6-1.8c-0.3,0.3-0.8,0.5-1.2,0.6c-0.6,0.1-1.2,0.1-1.7-0.1c-0.2,0.3-0.6,0.5-0.9,0.5s-0.7,0-0.9-0.1
		C367,108.5,366.9,108.7,366.9,109z M370.2,108.3c0.3,0.3,0.6,0.6,0.9,1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3-0.3-0.7-0.6-1-1
		C370,108.4,370.1,108.3,370.2,108.3z"
      />
      <path
        class="st4"
        d="M382.2,100.4c0.2,0,0.4,0,0.5,0c-0.2-0.1-0.3-0.2-0.4-0.3C382.2,100.2,382.2,100.3,382.2,100.4z"
      />
      <path
        class="st4"
        d="M393,105.6c0.1,0,0.1-0.1,0.1-0.1c0.2-0.1,0.2-0.5,0.3-0.8c0.2-0.1,0.4-0.2,0.7-0.2c-0.3-0.5-0.5-0.8-0.8-1.2
		c0.3-0.1,0.6-0.2,0.8-0.3c-0.1-0.4-1.2-0.2-0.3-1.2c-0.8,0.3-1.2,0.5-1.6,0.7c-0.6,0.3-1.1,0.3-1.5,0.2l0,0
		c-0.1,0.1-0.4-0.1-0.6-0.2c0.1-0.1,0.1-0.2,0.2-0.3c-0.4-0.6-1-0.9-1.9-1c-0.7-0.1-0.9-0.5-1-1c-0.1,0-0.2,0.1-0.3,0.1
		c-0.1-0.2-0.2-0.4-0.2-0.6c-0.2,0.2-0.4,0.3-0.6,0.5c-0.9,0.6-1.9,0.7-2.8,0.5c0.1,0.5,0.1,0.9,0,1.2c0.4,0.6,0.5,1.4,0.3,2.3
		c0.7-0.2,1.2-0.5,1.8-0.6c2-0.5,3.8,0.4,4.3,2c1.6,0.5,2,0.6,2.6,0.4c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3
		C392.7,105.5,392.8,105.6,393,105.6z M385.8,101.9l-0.1-0.1c0.1,0,0.2-0.1,0.2-0.1s0.1,0,0.1,0.1
		C386,101.8,385.9,101.8,385.8,101.9z M388.6,103.1c-0.2-0.2-0.3-0.3-0.5-0.5c-0.3,0.1-0.4,0.1-0.6,0.1s-0.3-0.1-0.4-0.2
		c0.5-0.5-0.7-0.8-0.1-1.3l0,0c-0.1,0-0.2,0-0.3,0c0-0.1,0.1-0.1,0.1-0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0.1,0l0,0
		c1,0,1,0.7,1.4,1.2c0.2,0.1,0.3,0.3,0.5,0.4C388.8,102.9,388.7,103,388.6,103.1z"
      />
      <path
        class="st4"
        d="M449.4,50c-0.1-0.3-0.3-0.5-0.5-0.8c0.1,0.3,0.3,0.6,0.4,0.9C449.3,50.1,449.4,50.1,449.4,50z"
      />
      <path
        class="st4"
        d="M314.8,243.2c-0.1,1-0.4,1.8-1.1,2.3c0,0.6-0.2,1.1-0.6,1.5c0.1,0.1,0.3,0.3,0.6,0.4c0.7-0.7,1.5-1.3,2.2-2
		C315.2,244.9,316.1,243.8,314.8,243.2z"
      />
      <path
        class="st4"
        d="M423.9,57.4c-0.8,0.6-1.6,0.8-2.4,0.6c0.1,0.4,0.2,0.8,0.3,1.1c1.5-0.2,2.6,0,3.2,0.5c0.5-0.5,1.1-0.8,1.9-1
		c0.3-0.1,0.7-0.1,1.2-0.1c-0.9-2,0-3.7,1.2-5.4c-0.7-0.3-1.4-0.5-1.9-0.9c-0.4-0.4-0.6-1-1-1.6c-2.1-0.9-3.9-0.1-4.7,2.4
		c1.6,0,2.9,0.4,3.3,1.8C425.2,55.9,424.8,56.8,423.9,57.4z M424.1,51.6c0,0-0.1,0-0.1-0.1l0.1-0.1
		C424.1,51.4,424.2,51.5,424.1,51.6C424.2,51.5,424.2,51.6,424.1,51.6z"
      />
      <path
        class="st4"
        d="M611,47.1c-0.7-0.3-1.4-0.5-1.9-1L609,46c-0.4,1.4-2.5,2.5-4,2.2c-1.8-0.3-2.9-1.7-2.4-3.3
		c0.2-0.7,0.7-1.2,1.3-1.6c0-0.2,0-0.4,0-0.6c-0.2,0-0.4-0.1-0.6-0.1c-1.1,1-2.7,1.4-4,0.8c-1.1-0.5-1.6-1.7-1.2-2.7
		c-0.1,0.1-0.2,0.1-0.3,0.2c0.1-0.7,0.1-1.2,0.2-1.8c-0.6-0.1-1.3-0.3-2.1-0.4c-0.2-0.4-0.4-0.9-0.6-1.4c0.4-0.6,0.8-1.1,1.2-1.7
		c-1.2-0.7-1.6,0.3-2.3,0.7c-0.9-0.5-1.8-0.9-2.8-1.5c0.2-0.3,0.4-0.5,0.7-0.9c-0.3,0-0.6,0-0.9,0c0.1-0.3,0.2-0.6,0.3-0.7
		c-0.5-0.5-0.9-1-1.4-1.4c-0.3-0.2-0.7-0.4-1.1-0.5c-0.5-0.1-1-0.2-1.6-0.3c-0.1,0.2-0.3,0.4-0.5,0.6c0.5,0.1,0.9,0.5,1.1,1
		c0.2,0.9-0.4,1.7-1.5,2s-2.1-0.2-2.3-1c-0.1-0.6,0.2-1.2,0.8-1.6c-0.2-0.1-0.3-0.3-0.2-0.7c0.2-0.7,0.3-1.3,0.5-2
		c0.2-0.8,0.3-1.5-0.1-2.4c-1.3,0.5-2.6,1-3.7,1.5c0.1,0.1,0.1,0.2,0.2,0.4c-0.5,0.4-1,0.7-1.4,0.2c-0.1-0.1,0-0.6,0.2-0.7
		c0.3-0.2,0.6-0.2,0.8-0.1c0.2-1.1,1.1-1.9,2.7-2.4c-0.4-0.1-0.6-0.2-0.8-0.2c0.1-0.2,0.3-0.4,0.5-0.5c-0.2,0-0.3-0.1-0.5-0.1
		c0,0,0,0,0-0.1c-0.5,0.1-1.2,0.6-1.7,1.3c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.5,0.9-0.8c-0.5-0.1-0.8-0.2-1.1-0.3
		c0-0.6,0-1.2,0-1.7c-0.8-0.2,0.3-0.9-0.4-1.2c-1.4,0.8-2.4,1.8-3,3.1c0.2-0.3,0.5-0.5,0.9-0.7c0.8-0.4,1.3-0.2,2.4,0.8
		c-0.4,0.4-0.6,0.9-1,1.2c-0.5,0.4-1.2,0.6-1.8,0.3c-0.2-0.1-0.5-0.3-0.6-0.6c0,0.1,0,0.1,0.1,0.2c0.1,0.5,0.2,1,0.4,1.8
		c-0.6-0.2-0.9-0.4-1.2-0.5c-0.5,0.4-0.9,1.6-1.8,0.5c-0.6-0.7-0.4-1.3,0.7-1.9c-1.6-0.1-1.9,0.1-2.5,1.1c-0.2,0.4-0.4,0.7-0.9,0.5
		s-0.4-0.6-0.1-0.9c0.1-0.1,0.2-0.2,0.2-0.2c-0.3-0.5-0.6-1-0.9-1.5c-0.7-1.2-1.4-1.2-2.6-0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.2,1.1,1,2.2-0.1,3.4c0-0.2-0.1-0.5-0.2-0.9c-0.5,0.6-0.8,1.1-1.2,1.5c0-0.3,0.1-0.7,0.1-1c0.1-0.7,0.1-1.3,0.1-2
		c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0.3-0.5,0.6-0.7,1s-0.2,0.8-0.4,1.2c-0.4,1-1,1.3-2.1,1c-0.3-0.1-0.6-0.3-1-0.3c-0.5-0.1-1,0-1.2,0
		c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.3,0.9,0.8,1.3,1.2c0.4,0.4,0.3,0.5-0.6,1.4c1.1,1.2,1.1,1.3,0.5,2.5c-1.1-0.5-1.4-1.2-1.2-2.2
		c-1-0.1-1.7-0.4-2.2-0.7c-0.1,0.5-0.2,1-0.3,1.5c1.1,0.4,0.7-0.8,1.3-1c0.8,0.2,0.7,0.9,0.8,1.6c-1,0.2-2,1.2-2.8-0.2h-0.1
		c0.1,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0,0.5-0.1,0.5c-0.2,0.1-0.7,0.3-0.8,0.2c-0.4-0.3-0.9-0.5-1.4-0.6c-0.1,0-0.2,0-0.3,0
		c-0.8,0.3-0.7,1.4-1.8,1.5c-0.1,0-0.2,0.2-0.3,0.4c-0.6,1.7-1.3,2.3-2.8,2.4c-0.1,0-0.2,0-0.3,0c0.1,0,0.2,0.1,0.3,0.1
		c-0.2,0.1-0.3,0.3-0.4,0.3c0,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.1-0.3c-1.1-0.1-1.8-0.8-2.2-2.2c0-0.1-0.1-0.2-0.3-0.4
		c-0.6,0.3-1.3,0.6-2,0.9c-0.7-0.7,0.2-1,0.7-1.6c-0.7-0.5-1.5-1-2.4-1.6c-0.2,0.4-0.4,0.7-0.4,0.9c0.6,3-0.6,4.2-4.2,4.4
		c-0.2,0-0.3,0.1-0.6,0.2c0,0.2,0,0.4,0,0.6c0,0.2,0.1,0.4,0.2,0.6c0.3-0.1,0.6-0.3,0.9-0.4c-0.6,0.8-1.2,1.5-1.9,2.3
		c-0.9,1.1-2.2,1.6-3.6,1.6c-0.8,0.3-1.7,0.4-2.5,0.1c-1.1-0.4-1.7-1.6-1.4-2.6c0.1-0.3,0.2-0.5,0.4-0.8c0-0.1,0-0.2-0.1-0.3
		c-1.1,0.5-2.1,1.2-3.2,0.9c-0.2,0.3-0.5,0.5-0.7,0.8c0-0.1,0-0.1,0-0.2c-0.2,0.4-0.5,0.7-0.7,1s-0.3,0.6-0.5,0.8
		c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c1.7-0.4,3.4,0.5,3.7,1.9s-0.8,2.9-2.5,3.3c-1.8,0.4-3.5-0.5-3.8-1.9c-0.2-1,0.3-2,1.3-2.7
		c-0.1-0.1-0.3-0.1-0.5-0.3c0.1-0.2,0.3-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c0.3-0.3,0.7-0.7,1-1.1c-0.4,0-0.7,0-1.2,0l-0.1,0.1
		c-0.5,0.4-1.1,0.6-1.7,0.2c-0.5-0.4-1-0.9-0.6-1.6c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.6,0.5-0.9,1.1-0.9c0.4,0,0.9,0.4,1,0.7
		s0.3,0.7,0.4,1c0.1-0.2,0.2-0.3,0.3-0.3c0.3,0,0.6,0.2,1,0.4c0.7-0.1,0.6-0.2,0.6-1c0-0.4,0.3-0.8,0.4-1c-0.2-0.2-0.5-0.4-0.6-0.7
		c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.3-0.1-0.5c-0.7,0.1-1.2,1-2,0.4c-0.4-0.4-0.7-0.9-1-1.3c-1.5,1.3-2.8,1.5-3.8,0.9
		c-0.5,0.1-1.1,0.1-1.7,0.2c0,0.7-0.4,1.3-1.3,1.6l0,0c0.8,0.7,0.6,1.5,0.2,2.4c-0.3,0.5-0.8,0.8-1.4,1l0,0c0.6,0.4,0.5,0.8-0.3,1.9
		c-0.2,0-0.5,0-0.7-0.1v0.1c-0.3,0.1-0.6,0.1-0.8,0.2c0-0.1,0-0.1,0-0.2c0.2,0,0.4-0.1,0.6-0.1c-0.7-0.2-1-0.4-1-1
		c0-0.5,0.3-0.8,0.8-1h0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.3-0.7-0.8-1.2-1.2c-0.1,0-0.2,0-0.4,0c-0.2,0.1-0.4,0.2-0.7,0.3
		c-0.5,0.1-1-0.1-1.3-0.4c-0.2,0-0.3,0-0.5-0.1c-1.1-0.8-1.2-2-1.6-3c0,0,0,0-0.1,0V37c-0.1,0-0.2-0.1-0.2-0.1
		c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0,0,0.1
		l0,0c0,0.1,0,0.2,0,0.2s0,0,0.1,0l0,0c1.6-0.9,3.3-1.2,5.3-1.2c-0.1,0.3-0.3,0.6-0.3,0.9c0,0.2,0.3,0.5,0.5,0.9
		c0.4-0.6,0.6-1,0.9-1.4c0.3,0.1,0.6,0.1,0.9,0.2l0.1-0.1c0.2-0.2,0.6-0.2,0.9-0.4c0.1-0.5,0.2-1,0.4-1.4c0-0.1,0.1-0.2,0.2-0.3
		c-0.2-0.1-0.4-0.2-0.5-0.4c0-0.2,0.3-0.5,0.5-0.5s0.4,0.1,0.7,0.3c0.5-0.3,1-0.4,1.5-0.4c0.5-0.9,0.8-1.2,2.1-1.6l0,0
		c0,0,0,0,0.1,0l0,0l0,0c0.3,0.5-0.1,0.9-0.6,1.2c-0.3,0.2-0.6,0.3-0.9,0.5c0.2,0.1,0.5,0.2,0.7,0.4c1.2-0.1,2.1,0.6,2.6,1.8
		c0.3-0.1,0.6-0.3,0.9-0.4c0.8-0.4,1.6-0.6,2.4-0.3c0.4,0.2,0.9,0.1,1.4,0.1c0.6,0,1,0.2,1.1,0.4c0.2-0.7,1-1.2,1.9-1
		s1.3,0.9,0.9,1.7c-0.1,0.3-0.4,0.5-0.7,0.9c0.2,0.1,0.4,0.3,0.6,0.5c0.1,0.1,0.3,0.3,0.4,0.5c1-0.5,2.1-0.9,3.2-1.4
		c0.2-0.6,0.5-1.4,0.8-2.3c-0.7-0.2-1.5-0.4-2.1-0.7s-1-0.9-1.5-1.3c-0.4-0.3-0.4-0.7-0.2-1.1c0.7-1.3,1.6-2.5,3.5-2.7
		c1.7-0.2,2.8,0.5,3.5,1.9c0.5-0.3,0.9-0.6,1.4-0.9c-1.8-0.9-2.6-2.1-1.5-3.8c0.9-1.3,2.1-1.4,4.8-0.7c0.2-0.5,0.3-1,0.5-1.6
		c-0.9,0.2-1.7,0.6-2.5,0.6s-1.6-0.3-2.5-0.5c-0.5,0.3-1,0.9-1.6,1.1c-0.6,0.3-1.4,0.3-2.3,0.4c0,0.4-0.5,1,0.3,1.6
		c0.4,0.2-0.5,1.4-1.4,1.7c-0.7,0.2-1.4,0.3-2.2,0.5c-0.6,1.2-1.5,2.3-3,2.9c-0.3-0.3-0.7-0.7-1.1-1.1c0.1-0.4,0.3-1.1,0.5-1.7
		c-0.7,0.2-0.4-0.3-0.4-0.6c-0.2,0-0.3,0-0.5-0.1c0.1-0.4,0.4-0.8,0.3-1.2c0-0.4-0.3-1-0.5-1c-1.2,0.1-1.7-0.9-2.6-1.3
		c-0.6,1.5-1.7,2.2-3.5,2.2c-0.7,0-1.4,0.6-2.2,0.3c0.1-0.2,0.2-0.4,0.3-0.6c0.3,0.1,0.6,0.2,1,0.3c-0.7-1.1-1.5-1.9-2.9-2.2
		c0.4,0.6,0.7,1.2,1,1.7c-1.3,0.9-1.3,0.9-2.5,0.2c-0.5,0.5-1.1,0.9-2,0.6c-0.7-0.2-1,0.1-0.8,1.1c-0.7,0.5-1.5,1-2.3,1.5
		c-0.2,0.1-0.4,0.3-0.4,0.5c-0.2,0.8-1,0.8-1.9,1.1c0.2-1,0.6-2-0.4-2.6c-1.9,1.2-2,1.3-3.1,3.1c-0.4,0-0.8-0.1-1.3-0.1
		c0.1,1,0.1,1.9,0.2,3c-0.7-0.1-1.1-0.2-1.6-0.3c-0.5,1.2-3,1.8-1.8,3.6c-0.4,0.3-0.7,0.5-1.1,0.8c-0.3-0.5-0.6-0.9-1-1.4
		c-0.1,0-0.3,0.1-0.4,0.1c0,0.4,0,0.8,0,1.1c0,0.6,0,1.2-0.7,1.5c-0.4-0.7-0.8-1.3-1.1-1.9c-0.5,0.1-1,0.2-1.4,0.2
		c-1.1,0.1-1.2,0.2-1.6,1.1c-0.1,0.3-0.5,0.5-0.8,0.7c0,0-0.2-0.1-0.3-0.1c0.2-0.1,0.3-0.3,0.6-0.5c-1.2-0.2-1.8,0.5-2.5,0.9
		c0.4,0.1,0.7,0.3,1.2,0.5c-0.3,0.1-0.5,0.2-0.6,0.2c0.4,0.2,0.9,0.4,1.5,0.7c0.2-0.6,0.3-1,0.5-1.5c0.6,0.2,1.2,0.4,1.7,0.7
		c0.4-0.3,0.8-0.5,0.9-0.6c0.8,0,1.2,0,1.7,0c0.5,0.6,0.9-0.2,1.3-0.3c0.3,0.3,0.7,0.5,1,0.8c0.1-0.9,0.8-1.9,1.7-2.3
		c1.1-0.4,2.2-0.5,3.2-0.1c0.8,0.3,1.5,0.8,2.2,1.3c0.5,0.4,0.6,1.3,0.3,2.1c0.5-0.2,1-0.4,1.7-0.7c-0.3,0.5-0.6,0.7-0.9,0.9
		c0.6,0.2,1,0.6,1.5,0.9c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1,0,0.2,0.1c0.3-0.2,0.6-0.4,0.9-0.6c0.4-0.3,0.9-0.5,1.4-0.8
		c0.5,0.1,0.7,0.4,0.4,1c-0.1,0.2-0.3,0.5-0.5,0.7c-0.9,0.9-1.6,1.8-1.6,3c0,0.2-0.4,0.4-0.5,0.5c0.4,0.5,0.9,0.9,1,1.4
		c0.1,0.6-0.4,1.2-0.7,1.9c-0.1,0-0.1,0-0.1-0.1l0,0c-0.6,0-1,0-1.2-0.1c-0.2,0.3-0.1,0.6,0.1,0.9c0.1,0,0.2,0,0.4,0
		c1.4,0.5,1.4,0.5,2.7,0.4c0.7,0.9,1,1.2,0.8,1.6c0.2,0.1,0.3,0.1,0.5,0.2c0.5-0.5,1-1,1.4-1.5c-0.1-0.1-0.2-0.2-0.2-0.4
		c-0.2-0.7,0.4-1.4,1.3-1.6c0.2,0,0.4-0.1,0.6,0c1.1-0.9,2.3-1.5,4-1.1c1.6,0.5,2.1,1.5,2.1,2.9c0.1,0,0.2,0.1,0.2,0.1
		c0.4,0,0.6,0,0.9,0c0.6-0.2,1.1-0.7,1.6-1c0.2,0.2,0.4,0.5,0.3,0.6c-0.3,0.5-0.6,0.9-1,1.4c0,0.1,0,0.1,0,0.2
		c0.1,0.1,0.3,0.2,0.4,0.3c0.3-0.2,0.6-0.3,1.1-0.6c-0.4,0.5-0.6,0.7-0.8,0.8c0.5,0.3,0.9,0.7,1.4,1c0.3,0.2,0.9-0.1,0.9-0.5
		c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.9-0.1-1.7,0.3-2.4c0,0,0,0-0.1,0l0.1-0.1c0.4-0.7,1-1.2,1.8-1.6c0.1-0.3,0.2-0.6,0.5-0.9
		c0.4-0.4,0.8-0.7,1.3-1.1h0.1c-0.1-0.1-0.1-0.1-0.2-0.3c0,0,0,0-0.1,0c0,0-0.1,0-0.1-0.1c-0.2,0-0.5-0.1-0.7-0.1
		c0-0.1,0.1-0.2,0.1-0.3c0.2,0.1,0.4,0.3,0.6,0.4h0.1v0.1c0.2,0.1,0.5,0.2,0.7,0.4h0.1l0,0c1-0.2,1.6-0.7,2.1-1.4
		c0.2-0.3,0.4-0.7,0.7-0.9c1.3-1.4,3.6-2,5.5-1.5c0.2,0.1,0.3,0.1,0.5,0.2c0-0.2,0.2-0.4,0.5-0.5c0.1-0.1,0-0.4,0-0.6
		c0-0.2,0-0.4,0.1-0.8c0.7,0,1.3,0.1,1.9,0.1c0.3-0.7,1-1.3,1.8-1.5c1.3-0.3,2.6,0.4,2.8,1.5c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0.1,0.1
		c0.1,0.2,0.2,0.4,0.3,0.6c0.6,0.2,1.1,0.7,1.2,1.4c0-0.1,0-0.2,0.1-0.3c0.2-0.6,0.7-0.8,1.5-0.7c1.1,0,2,0.2,2.5,1
		c-0.6,0.4-1.1,0.4-1.6,0c-0.5,0.3-1,0.6-1.5,0.9c-0.4-0.1-0.8-0.3-0.9-0.5c0.1,0.8-0.3,1.5-1,2c-0.1,0.4-0.5,0.9-1.2,1.2
		c-0.6,0.3-1.5,0.3-2-0.2c-0.3-0.3-0.5-0.6-0.7-0.9c-0.6,0-1.1,0-1.7,0c0,0.1,0,0.2,0,0.4s-0.1,0.3-0.1,0.5l0,0
		c0.2,0.1,0.5,0.3,0.6,0.5c0.6,0.7,0.3,1.8-0.4,2.6c0.3,0.1,0.5,0.4,0.8,0.6c0.7,0.1,1.3,0.6,1.4,1.1c0.1,0.8-0.6,1.7-1.6,1.9
		c-0.5,0.1-1,0-1.4-0.2c-1.5,0.3-2.1-0.1-2.8-1.5c-0.6,0.1-1.3,0.3-1.9,0.3l0,0c0.1,0.2,0.2,0.4,0.2,0.6c0,0.3,0,0.7-0.2,0.9
		c0.5,0.2,1,0.4,1.4,0.7c0.9,0.7,1.4,1.7,2.1,2.6c0.2-0.3,0.4-0.7,0.5-1l0,0c0,0,0,0,0-0.1c-0.1,0-0.2,0-0.2-0.1
		c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0-0.1s0.1-0.1,0.1-0.2c0,0.1-0.1,0.2-0.1,0.2l0,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0.1,0l0,0
		c1.2-0.2,2.3-0.8,3.5-0.3c0.6,0.3,1,0.6,0.8,1.2c-0.1,0.5-0.3,0.9-0.4,1.4c-0.4-0.2-1-0.2-1.7-0.2c-1,0-1.9-0.1-2.9-0.1l0,0
		c-0.2-0.1-0.4-0.2-0.6-0.3c-1,1.4-2.3,2.5-4.3,2.6c-0.2,0-0.4,0-0.6,0c-0.4,0.4-1,0.7-1.7,0.9c-0.4,0.1-0.9,0.1-1.3,0
		c0.2,0.6,0,1.2-0.4,1.8c0.2,0.3,0.2,0.7,0.2,1.1c0,0.4,0,0.8,0.1,1.1c1.2-0.7,2.6-0.8,3.8-0.2c0,0,0,0,0.1,0h0.1
		c0.5,0.2,0.9,0.5,1.2,0.9c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0,0.1,0,0.2c0.1,0.3,0.1,0.6,0.1,0.9c0.6-0.1,0.8,0.1,1.3,0.8
		c0.3,0,0.7,0,1.1,0.2c0.4,0.1,0.9,0,1.4,0.1c0.9,0.1,1.5,0.5,1.8,1.2v0.1c0.2,0.1,0.4,0.2,0.7,0.3c0.3-0.3,0.5-0.6,0.8-0.8
		c-0.4-0.4-1-0.6-1.4-0.9c-0.6-0.5-1.3-0.6-2-0.5c-1-1,0.4-2.7-1.2-3.4c-0.7,0-1.3,0-1.8-0.1c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.2-0.1-0.3-0.2-0.5-0.4c-0.5-0.2-0.8-0.6-1-1.1c-0.2-0.8,0.3-1.9,1.2-2.4c1.2-0.7,2.5-0.6,4.1,0.4c2.5-1.4,5-2,7.5-1.2
		c0.4,0.3,0.8,0.6,1.1,1c0.1,0.1,0.2,0.1,0.2,0.2c0.3-0.3,0.5-0.6,0.8-0.9c0.6,0.2,1.2,0.3,1.6,0.4c0.4-0.3,0.7-0.4,0.9-0.7
		c0.3-0.3,0.6-0.8,0.5-1.1c-0.3-0.7-0.1-1.5-0.6-2c0.4-0.6,0.7-1.1,1-1.6c-0.2-0.1-0.4-0.1-0.5-0.1s-0.2,0.1-0.3,0.1
		c-0.9,0.2-1.8-0.4-1.9-1.2c-0.1-0.4,0.1-0.8,0.4-1.2c0-0.2,0-0.4,0-0.6c-0.3,0.3-0.6,0.4-0.9,0.7c-0.3-1.1-1.4-0.3-2.1-0.5
		c-0.5,0.4-0.6,1.1-1.5,1.3c-0.2-1.1,0.9-1.7,1.3-2.5c-0.2-0.1-0.4-0.2-0.7-0.4c-0.3,0.3-0.5,0.5-0.8,0.7s-0.8,0.3-1,0.2
		s-0.3-0.5-0.3-0.8c0.2-0.5,0.5-1,0.8-1.6c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.2-0.4c0.6,0.2,1,0.3,0.8,0.8
		c0.2,0.1,0.4,0.1,0.6,0.1c1.1-0.3,1.4,0.2,1.7,0.8c-0.2,0.4-0.3,0.7-0.6,1.3c0.7-0.4,1.1-0.6,1.5-0.7c0.4-0.1,0.9-0.2,1.4-0.3
		c-0.1-0.3-0.2-0.5-0.2-0.7c-0.1-0.1-0.2-0.1-0.4-0.2c0.1-0.1,0.1-0.2,0.2-0.3l0,0l0,0c0.1-0.2,0.3-0.4,0.4-0.5
		c0.2-0.1,0.5,0.1,0.9,0.2c0-0.2,0-0.3,0-0.5l0,0v-0.1c-0.5-0.2-1.2,0-1.2-0.8c0.7,0,1.1,0.3,1.2,0.8h0.1l0,0c1-0.2,1.3-0.3,1.6,0.1
		c0.2-0.9,0.4-1.8,0.6-2.8c1.4-0.1,2.6,0.5,2.9,1.3c0.1,0.2,0.1,0.5,0.1,0.8c0.5,0.6,1.6,0.2,1.9,1c-1.8,0.2-2.3,0-1.9-1
		c0,0,0,0.1-0.1,0.1c-0.2,0.3-0.5,0.6-0.8,0.8c0.4,0.4,0.6,0.8,0.7,1.3c0,0,0,0,0.1,0l-0.1,0.1c0.5-0.3,0.9-0.5,1.4-0.8
		c0.6,0.5,1.1,0.9,1.5,1.3c0.3-0.4,0.7-0.7,1-1.1c0.2,0.1,0.5,0.2,0.5,0.3c0.4,0.8,1.5,1.2,1.7,2.1c0,0.1,0.2,0.3,0.3,0.3
		c1.3-0.4,1.2,0.6,1.7,0.9c-0.2,0.1-0.4,0.2-0.5,0.3l0,0l0,0c-0.4,0.3-0.3,0.4-0.2,1c0.4-0.2,0.9-0.1,1.3-0.6c0.6-0.7,1-0.7,1.6-0.2
		c0.2-0.1,0.3-0.1,0.5-0.2c-0.2-0.4-0.2-0.6-0.4-0.9c0,0-0.3,0-0.5,0.1l0,0l-0.1,0.1c0,0.1,0,0.3-0.1,0.4c-0.1,0-0.2,0-0.2-0.1
		c0.1-0.1,0.2-0.2,0.3-0.3v-0.1c0,0,0,0,0.1,0c0.1-0.5,0.2-1.1,0.3-1.6c-0.1-0.1-0.1-0.2-0.2-0.4c-0.3-1,0.4-1.9,1.6-2.2
		c0.4-0.1,0.9-0.1,1.2,0c0.2-0.1,0.4-0.1,0.6-0.1c1.5-0.2,3.1,0.4,3.7,1.5c0,0,0,0.1,0.1,0.1c0.1-0.2,0.3-0.3,0.5-0.4
		c-0.3-0.2-0.5-0.3-0.8-0.6c-1.5-1.4-1.8-3.7-0.6-5.5c0.2-0.4,0.5-0.7,0.9-1.3c-2.5,0.3-4.3-0.4-5.6-2.1c0,0.3-0.1,0.6,0,0.8
		c0.3,0.8,0.4,1.6,0.2,2.3c0,0,0,0.1,0.1,0.1h-0.1c-0.2,0.6-0.5,1.2-1.1,1.8c-0.4,0.4-0.5,0.8-0.4,1.3c0,0.5-0.1,1-0.3,1.3
		c0.1,0.1,0.2,0.2,0.3,0.3c-0.2,0-0.3-0.1-0.4-0.1c-0.3,0.5-0.8,0.8-1.4,1c0.3,0.2,0.5,0.6,0.2,0.9c-0.5,0.6-0.3,1,0,1.5
		c-0.1,0.1-0.3,0.1-0.4,0.2c-0.4-0.9-0.8-1.7-1.2-2.5c-0.3,0-0.6-0.1-0.8-0.2c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.2,0.1-0.3,0.1
		c-0.1-0.1-0.1-0.2-0.2-0.4c-0.9-0.4-1.5-1-1.2-2.2c0-0.2-0.1-0.4-0.2-0.7l0,0c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1,0.4-0.1,0.8-0.3,1.5
		c-0.5-0.5-0.9-0.8-0.9-1c0.1-0.6-0.1-1-0.4-1.4c-0.3-0.5,0.1-0.9,0.8-0.9c0.2,0,0.3,0,0.4,0c-0.2-1,0.1-1.9,0.8-2.8
		c1.1-1.4,2.8-2,4.8-1.8l0,0l0.1-0.1l0.1,0.1l0,0c0.1,0,0.2,0,0.3,0c0.8,0.1,1.6,0,2.5,0c0.1-0.6,0.2-1,0.2-1.5
		c0-0.3-0.2-0.7-0.4-0.9c-0.7-0.6-1-1-1.2-1.8c0,0,0,0-0.1,0c0-0.1,0-0.2,0-0.2c0-0.2-0.1-0.4-0.1-0.6c0.1,0,0.2,0.1,0.3,0.1h0.1
		l0,0c0.2,0.1,0.3,0.1,0.5,0.2c-0.2-0.5-0.4-1,0.2-1.5c1.6,0.4,2.1,1,1.8,2.1c-0.1,0.4-0.4,0.8,0.1,0.9c0.4,0.1,0.9-0.1,1.3-0.4
		c0.3-0.2,0.3-0.6,0.5-0.8c0.6-0.2,0.9,0.5,1.5,0c0.9-0.7,1.9-0.4,2.8,0.1c2,1.2,2.5,3.2,1.4,5.2c-0.2,0.4-0.5,0.7-0.8,1.2
		c1.6-0.3,3-0.2,4.3,0.4c0.2,0.1,0.4,0,0.7-0.1l0,0h0.1c0.2-0.4,0.5-0.8,0.8-1.3c0.1,0.4,0.2,0.7,0.2,1.1c0,0,0,0,0.1,0
		c0,0,0,0,0,0.1c0.5-0.1,0.8-0.2,1-0.7c0.9-1.9,2-2.4,4.2-2.2c0.5,0,0.9-0.1,1.5-0.2c0.2,0.7,0.5,1.6,0.7,2.5c0.2,1.3-0.6,2.5-2,3
		c-1.5,0.6-3.1,0.3-3.9-0.7c-0.3-0.4-0.6-0.9-0.8-1.4c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1-0.2-0.2-0.4-0.3-0.7c0,0,0,0-0.1,0
		c0,0,0,0,0-0.1c-0.3,0.1-0.7,0.1-1,0.2c0,0,0,0,0,0.1l0,0c1,1,1.6,2.2,1.8,3.5c0.1,0.7,0,1.3-0.2,1.8h0.1c0.2,0.2,0.4,0.4,0.6,0.6
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.2-0.3-0.4-0.4-0.6c-0.6,1.3-1.8,2.3-2.8,2.8c-0.6,0.3-1.3,0.4-1.9,0.5c-0.2,0.1-0.3,0.3-0.5,0.4
		c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.3c-0.4,0-0.8,0-1.2-0.1c0.3,0.5,0.7,0.9,1,1.5c-1,0.6-2,1.3-3.1,2
		c-0.3-0.3-0.6-0.6-0.9-0.9c-0.1,0.2-0.3,0.3-0.4,0.4c-0.4,0.3-0.8,0.5-1.1,0.8c0,0.2,0,0.4,0,0.6c1.2-0.1,2.3,0.2,3.2,0.9
		c0.5,0.4,1.1,0.7,1.6,1.1c0.7,0.5,0.7,1.3-0.2,1.6c0,0-0.1,0-0.1,0.1c-0.2,0.9-0.7,1.7-1.9,2.2c-0.5,0.2-1.1,0.4-1.6,0.4
		c-0.2,0.5-0.4,1-0.6,1.4c0.1,0.2,0.2,0.4,0.2,0.6c0.2,0.2,0.3,0.3,0.4,0.4c-0.2,0.3-0.4,0.5-0.6,0.8c-0.1,0.3-0.3,0.5-0.6,0.7
		c-0.4,0.5-0.7,0.9-1.1,1.3c-0.8,0.7-1.3,1.5-0.8,2.4c0.5-0.1,0.7-1,1.4-0.4c0.2-0.2,0.3-0.3,0.5-0.5c0,0,0,0,0-0.1
		c-0.1,0-0.1,0-0.1,0h0.1l0,0h0.1v0.1c0.7,0.1,1.3,0,1.7-0.6c-0.2-0.2-0.4-0.3-0.6-0.5c0.9,0.1,1.7,0.2,2.6,0.2c0,0.5-0.1,1-0.1,1.4
		c-0.4-0.1-0.7-0.2-1-0.3c-0.2,0.3-0.5,0.6-0.5,1c0,0.1,0.1,0.2,0.2,0.3c0.6,0.4,1,1,1.5,1.5c-0.3,0.2-0.5,0.4-0.7,0.5
		c0.1,0.3-0.2,0.7-0.1,1c0.3-0.1,0.5-0.2,0.8-0.4c0.4-0.2,0.8-0.5,1.3-0.6c2.7-0.5,2.7-0.5,4.4,1.2c0.1-0.1,0.2-0.1,0.3-0.2
		c-0.1-0.6-0.2-1.2-0.3-1.8c-0.4,0.2-0.6,0.4-0.9,0.5c-0.7-0.6-0.6-0.6,0.1-1c0.2-0.1,0.5-0.2,0.5-0.3c0.1-0.2,0.1-0.5,0.1-0.7
		c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.5,0.1-0.9,0.1-1.4c-0.2-0.2-0.4-0.5-0.6-0.7c-1.3-1.6-1.2-3,0.5-4.6c0.2-0.2,0.4-0.3,0.5-0.4
		c-0.4-0.9-1.1-0.3-1.7-0.3c-0.3-0.4-0.6-0.8-1.1-1.4c0,0.6,0,1,0.1,1.3c-0.1,0-0.2,0.1-0.4,0.1c-0.3-0.6-0.7-1.2-0.9-1.9
		c-0.2-0.5,0.2-0.8,0.6-1c1,0.5,1.8,1.2,2.7,1.3c1.2,0.2,1.3,0.8,1.4,1.5c0.8,0.4,1.6,0.7,2.4,1c-0.6,1.1-0.7,1.2-1.5,1.1
		c-0.9,0-1.5,0.3-2.1,0.9c0,0.6,0.1,1.2,0.4,1.6c0.1-0.1,0.2-0.2,0.2-0.3c0.3,0.3,0.5,0.5,0.7,0.7c0.9-0.5,1-1.1,0.8-1.6
		c0.4-0.2,0.8-0.3,1.1-0.5c0.2-0.2,0.3-0.7,0.5-0.7c0.7-0.2,1.1-0.5,1.6-1c0.4-0.3,1.2-0.1,1.5-0.6c0.4,0.3,0.9,0.3,1.4,0.1
		c0-0.4,0.2-0.8,0.6-1.2c0.2-0.3,0.5-0.5,0.8-0.8l0,0c-0.8,0.3-1.6,0.4-2.4,0.1c-0.4-0.1-0.9,0-1.4,0.1l0,0c0,0,0,0-0.1,0
		c0,0.1,0,0.2,0.1,0.2c0.2,0.4,0.6,0.9,0,1.2c-0.9,0.4-0.8-0.5-1.2-0.7c0.1-0.6,0.7-0.7,1.2-0.8c0,0,0,0,0-0.1l0,0
		c-0.7-0.6-1.5-1.3-2.3-2c0.2-0.3,0.5-0.7,0.8-1.1c1,0.3,2.4-0.3,2.7,1c0.9-0.3,1.7-0.7,2.5-0.1c0.8,0.6,0.3,1.4,0.1,2.1l0,0
		l-0.1,0.1c0.4,0,0.7-0.1,1.1-0.1c1.3,0,2.1,0.5,2.4,1.6c0,0.1,0,0.2,0.1,0.3h0.1c0.2,0,0.4,0.1,0.6,0.2c0.1-0.1,0.3-0.2,0.4-0.3
		c-0.1-0.3,0.1-0.7,0.8-0.9c0.2,0.1,0.5,0.3,0.7,0.5c0.5,0,1,0,1.5,0.2c0.1-0.2,0.1-0.2,0.1-0.3c0-0.5,0-1-0.1-1.5
		c-0.2,0-0.4,0-0.6,0c-1.8,0.1-2.7-0.3-3-1.3s0.2-1.8,1.7-2.7c1.3-0.8,1.6-2,0.6-3c-0.7-0.8-1.4-1.6-1.9-2.5c-0.8-1.3,0-2.8,1.7-3.5
		c1.5-0.6,3.2-0.1,3.9,1c0.7,1.3,0,2.9-1.6,3.6c-0.5,0.2-1,0.3-1.6,0.5c1.1,0.7,1.4,1.5,1.4,2.6c0,1.2,0.4,2.4,1.2,3.4
		c0.4,0.5,0.7,1.2,1.1,1.7c0.2,0.3,0.6,0.7,1,0.7c1.5,0.1,1.4,1.7,2.7,2c0.1,0,0.2,0.2,0.2,0.4c0,0.1-0.1,0.2-0.1,0.4
		c-0.4-0.1-0.8-0.2-1.2-0.3c-0.2,0.3-0.4,0.6-0.7,1c0.8,0.2,1.4,0.3,2.2,0.5c0.1,0.3,0.1,0.7,0.2,1.1c0.5-0.2,0.9-0.4,1.3-0.5
		c0-1.5,0.3-3,1.4-4.3c0.4-0.5,0.8-0.9,1.1-1.4c-0.5,0.2-0.9,0.5-1.4,0.6c-0.1,0.6-0.7,1.2-1.5,1.4c-1,0.2-2-0.3-2.2-1.1
		c0-0.1,0-0.2,0-0.3c-0.4-0.1-0.7-0.3-0.8-0.7s-0.1-0.9,0.1-1.3c0.6-1.1,2.3-0.8,3.2-1.5c0.3-0.2,0.9-0.2,1.4-0.2
		c0.2,0,0.4,0,0.5,0.1c0.4,0.3,0.9,0.4,1.4,0.4V56c-0.1,0-0.2,0-0.4-0.1c-0.5-0.2-0.7-0.6-0.5-1.1c0.2-0.4,0.5-0.7,0.9-0.8v-0.3l0,0
		c-1-0.6-2.1-1.2-3.2-1.8c-0.9-0.5-1.4-1.2-1.3-2.1c0.1-0.9,0.7-1.7,1.8-2.1c0.9-0.3,1.8-0.6,2.8-0.9v-0.5c-0.3-0.1-0.6-0.2-0.9-0.3
		C611.1,46.3,611.1,46.7,611,47.1z M524.9,38.1C524.9,38.1,525,38.1,524.9,38.1v0.2C524.8,38.3,524.8,38.2,524.9,38.1
		C524.8,38.1,524.9,38.1,524.9,38.1z M522.6,37.9c0,0.1,0,0.1,0.1,0.2c-0.3,0.1-0.6,0.2-0.9,0.3c0-0.1,0-0.2-0.1-0.2
		C521.9,38.1,522.3,38,522.6,37.9z M525,32.5c0.4,0.2,0.7,0.3,1.2,0.6c-0.7,0.2-1.2,0.4-1.7,0.6c-0.1-0.1-0.2-0.1-0.2-0.2
		C524.4,33.1,524.7,32.8,525,32.5z M515.4,28.4C515.4,28.4,515.5,28.3,515.4,28.4L515.4,28.4c0.1,0,0.1,0,0.2,0.1
		C515.5,28.4,515.5,28.4,515.4,28.4L515.4,28.4z M508.4,34.7c0.5,0.1,0.8,0.4,1.5,0.7c-0.6,0.5-0.9,0.9-1.3,1
		c-0.5,0.2-1.1-0.2-1.1-0.6C507.4,35.3,507.9,34.7,508.4,34.7z M502.8,37.6c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1,0.1-0.1
		c0,0.1,0.1,0.1,0.1,0.2C502.8,37.5,502.8,37.6,502.8,37.6z M510.4,45c0-0.1,0-0.1,0-0.2c0.3-0.1,0.6-0.1,0.9-0.2c0,0.1,0,0.1,0,0.2
		C511,44.8,510.7,44.9,510.4,45z M513.5,44.5c0.2-0.1,0.4-0.2,0.6-0.2c0,0.1,0.1,0.1,0.1,0.2c-0.2,0-0.4,0.1-0.5,0.1
		C513.5,44.6,513.5,44.6,513.5,44.5z M514.1,45.8C514.1,45.8,514,45.8,514.1,45.8c-0.1-0.1-0.1-0.2,0-0.2
		C514.1,45.6,514.2,45.6,514.1,45.8C514.2,45.7,514.1,45.8,514.1,45.8z M514.6,46.4c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0.1,0.1,0.1
		C514.6,46.3,514.6,46.3,514.6,46.4z M517.8,38C517.8,38,517.9,38,517.8,38v0.2C517.8,38.2,517.7,38.2,517.8,38
		C517.7,38.1,517.7,38,517.8,38z M517.8,45.2C517.8,45.2,517.9,45.2,517.8,45.2c0.1-0.1,0.1,0,0.2,0
		C517.9,45.2,517.9,45.2,517.8,45.2z M517.3,44.8c-0.1-0.1-0.1-0.1-0.2-0.2c0.2-0.3,0.4-0.7,0.7-1.1c0.2,0.2,0.5,0.5,0.4,0.5
		C518,44.3,517.7,44.5,517.3,44.8z M516.1,41.6c0.2-0.9,0.7-1.4,1.5-1.5c0.8-0.2,1.4,0.1,1.8,0.8C518.4,41.4,517.4,41.4,516.1,41.6z
M521.1,47.9c-0.1,0-0.2,0-0.3,0c0.1-0.1,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.1C521.3,47.6,521.2,47.8,521.1,47.9z M522,46.4
		C522,46.5,522,46.5,522,46.4C522,46.5,522,46.4,522,46.4S522.1,46.4,522,46.4C522.1,46.4,522,46.4,522,46.4z M523.2,49.6
		c0-0.1,0.1-0.3,0.1-0.4c0.1,0.1,0.3,0.1,0.3,0.1c0,0.1-0.1,0.2-0.1,0.3C523.4,49.6,523.3,49.6,523.2,49.6z M524.3,50.2l-0.2-0.1
		c0.1-0.1,0.2-0.3,0.3-0.4c-0.2,0.3-0.5,0.5-0.7,0.8c-0.1-0.1-0.2-0.1-0.4-0.2c0.3-0.3,0.7-0.6,1-1c0.1,0,0.2,0.1,0.2,0.1l-0.1,0.1
		c0.1,0,0.2,0.1,0.3,0.2C524.6,50,524.5,50.1,524.3,50.2z M545.4,39.1c-0.1,0.1-0.4-0.2-0.8-0.4c0.3-0.3,0.5-0.5,0.7-0.6
		c0.2,0,0.4,0.2,0.7,0.3C545.8,38.6,545.6,38.9,545.4,39.1z M549.4,42.1c-0.3-0.3-0.5-0.5-0.7-0.7c-0.2,0.2-0.4,0.4-0.6,0.7
		c-0.1,0-0.1-0.1-0.2-0.1c0.2-0.2,0.4-0.5,0.6-0.7l0.1,0.1l0,0c0-0.2,0.4-0.4,0.7-0.6c0.3,0.2,0.7,0.4,0.8,0.6
		C550.1,41.4,549.7,41.7,549.4,42.1z M544.1,49.6c-0.1-0.2-0.1-0.4-0.2-0.6c0.1,0,0.2,0,0.3-0.1c0.1,0.2,0.1,0.4,0.2,0.6
		C544.3,49.6,544.2,49.6,544.1,49.6z M545.2,50.4C545.2,50.4,545.1,50.4,545.2,50.4l-0.1-0.2h0.1C545.2,50.3,545.2,50.3,545.2,50.4z
M539.7,53.8c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0.1-0.3,0.2-0.5c0.2,0.3,0.4,0.4,0.3,0.4C539.9,53.6,539.8,53.7,539.7,53.8z
M533.7,64c-0.2-0.1-0.3-0.1-0.6-0.2c0.2-0.2,0.3-0.4,0.5-0.5c0.1,0,0.4,0.1,0.4,0.2C533.9,63.7,533.8,63.9,533.7,64z M534.8,65
		c-0.2-0.2-0.3-0.2-0.3-0.3c0,0,0.1-0.2,0.2-0.2c0.1,0,0.3,0.1,0.4,0.1C535.1,64.7,534.9,64.8,534.8,65z M540.6,67.2
		c0.1,0,0.2,0,0.3,0c0,0,0,0.2-0.1,0.2S540.6,67.4,540.6,67.2C540.6,67.4,540.6,67.2,540.6,67.2z M539.4,65.9L539.4,65.9
		c-0.3,0.2-0.7,0.2-1,0.3v-0.1C538.7,66,539.1,66,539.4,65.9z M542.4,60.3L542.4,60.3L542.4,60.3L542.4,60.3z M549.4,59.1
		c0-0.1,0-0.1-0.1-0.2h0.1V59C549.4,59,549.4,59.1,549.4,59.1z M548.9,56.6c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0,0
		c0.1,0,0.2,0,0.4,0l0,0l0,0l0,0c0,0,0,0,0.1,0c-0.1-0.2-0.1-0.4-0.2-0.5c-0.2-0.3-0.5-0.7,0-0.9c0.3-0.2,0.8-0.3,1.2-0.2
		c1.3,0.4,2.6,0.8,3.3,1.9c-0.9,1.1-1.4,1.2-2.1,0.3c-0.6-0.7-1.3-0.7-2.1-0.6l0,0c0,0,0,0-0.1,0c0.2,0.3,0.4,0.7,0.6,1
		c-0.8-0.1-1.5-0.2-1-1l0,0l0,0c-0.1,0-0.1,0-0.2,0C548.9,56.8,548.9,56.7,548.9,56.6z M548.8,54.5L548.8,54.5L548.8,54.5
		L548.8,54.5z M549.3,47.6c-0.1,0-0.5-0.1-0.5-0.2c0-0.2,0.2-0.4,0.4-0.5c0.1-0.1,0.4,0.1,0.7,0.2C549.6,47.3,549.4,47.6,549.3,47.6
		z M550.2,46.7c-0.1,0-0.2,0-0.2-0.1s0-0.2,0.1-0.3c0.1,0,0.2,0.1,0.2,0.1C550.3,46.5,550.2,46.6,550.2,46.7z M550.6,47.4
		c0-0.1-0.1-0.2-0.1-0.3l0.1-0.1c0.1,0.1,0.1,0.1,0.2,0.2C550.7,47.3,550.6,47.4,550.6,47.4z M551.8,47.8c-0.1,0-0.2-0.1-0.3-0.1
		l0.1-0.1c0.1,0,0.2,0,0.3,0C551.9,47.6,551.9,47.7,551.8,47.8z M552.2,48.1L552.2,48.1L552.2,48.1L552.2,48.1z M552.9,37.2
		c0.3,0.2,0.7,0.3,0.7,0.4c0,0.1-0.2,0.5-0.4,0.5s-0.6-0.1-0.7-0.3C552.4,37.7,552.7,37.5,552.9,37.2z M553.2,38.5
		c0.2,0.2,0.2,0.7,0.1,0.9c0,0.1-0.7,0.2-1,0.2c-0.4-0.1-0.6-0.4-1-0.7C552.3,38.2,552.8,38.1,553.2,38.5z M552.3,41.6
		c0,0.2,0.1,0.4,0,0.7c-0.4-0.2-0.6-0.4-0.8-0.5c-0.3,0-0.7-0.1-1.1-0.3c0.3-0.2,0.7-0.4,1-0.6c0-0.1,0.1-0.1,0.1-0.2
		c0,0,0.1,0,0.1,0.1c0.5-0.3,0.9-0.5,1.5-0.8C552.9,40.8,552.6,41.3,552.3,41.6z M553.4,42.1c-0.1-0.1-0.2-0.3-0.2-0.3
		c0.2-0.2,0.5-0.3,0.7-0.4c0.1,0.1,0.1,0.1,0.2,0.2C553.8,41.7,553.6,41.9,553.4,42.1z M553.9,45c-0.1-0.2,0.1-0.5,0.2-1.1
		c0.6,0.7,0.9,1,1.2,1.4C554.4,45.8,554.2,45.3,553.9,45z M555.9,46.2c0,0-0.1,0-0.2,0c0.1-0.1,0.2-0.3,0.3-0.4
		c0,0.1,0.1,0.2,0.1,0.2C556.1,46.1,556,46.1,555.9,46.2z M556.2,40.2c-0.9,0.2-1.8-0.2-2.1-1c-0.2-0.8,0.5-1.7,1.5-1.9
		s2,0.3,2.2,1.1C558,39.1,557.3,39.8,556.2,40.2z M573.4,46c0.1,0,0.2,0,0.4,0c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0-0.2,0-0.4,0
		C573.3,46.6,573.4,46.3,573.4,46z M560.4,39.2L560.4,39.2L560.4,39.2L560.4,39.2z M559.4,35.6c-0.1,0.1-0.3,0.2-0.4,0.2
		c-0.2-0.3-0.4-0.6-0.7-1.1C559.3,34.8,559.3,35.2,559.4,35.6z M558.9,43.8c-0.2-0.2-0.5-0.4-0.5-0.4c0.1-0.2,0.3-0.4,0.6-0.5
		c0.1,0,0.3,0.2,0.5,0.3C559.3,43.3,559.1,43.5,558.9,43.8z M560.2,45.8c-0.1-0.1-0.1-0.1-0.1-0.2l0.1-0.1c0.1,0.1,0.1,0.2,0.2,0.2
		C560.3,45.7,560.3,45.8,560.2,45.8z M560.9,44c-0.2-0.2-0.4-0.4-0.7-0.7C561.2,43.2,561.2,43.2,560.9,44z M566.5,31.6
		c-0.3,0-0.8-0.3-0.8-0.6c0-0.2,0.4-0.7,0.7-0.7c0.3-0.1,0.7,0.3,1.2,0.5C567.1,31.2,566.8,31.6,566.5,31.6z M568.3,36.3
		c-0.1-0.1-0.3-0.2-0.3-0.2c0-0.1,0.2-0.2,0.3-0.4c0.1,0.2,0.3,0.3,0.3,0.4C568.6,36.1,568.4,36.2,568.3,36.3z M568.2,35.3
		c-0.3-0.6,0-1.1,0.3-1.6c0,0,0,0,0-0.1c0,0,0,0,0.1-0.1v0.1l0,0C568.6,34.3,568.9,34.8,568.2,35.3z M569.8,33.2
		C569.8,33.2,569.8,33.3,569.8,33.2L569.8,33.2L569.8,33.2L569.8,33.2L569.8,33.2L569.8,33.2C569.9,33.1,569.8,33.2,569.8,33.2z
M572.1,31.9L572.1,31.9L572.1,31.9L572.1,31.9z M573.5,34C573.5,34,573.5,34.1,573.5,34C573.5,34.1,573.5,34,573.5,34
		C573.5,33.9,573.6,33.9,573.5,34C573.6,33.9,573.6,33.9,573.5,34z M581.7,29.7c0.1,0.1,0.3,0.1,0.4,0.2c0,0.1-0.1,0.2-0.1,0.4
		c-0.2-0.1-0.4-0.1-0.4-0.2C581.5,30,581.6,29.9,581.7,29.7z M579.1,33.4c-0.1-0.1-0.2-0.2-0.2-0.3l0.2-0.2c0.1,0,0.2,0.1,0.4,0.2
		C579.3,33.2,579.2,33.3,579.1,33.4z M580,30.9c0.3-0.6,0.5-1.1,0.7-1.6C581.1,30.1,581.1,30.1,580,30.9z M580.6,30.6
		c0.1,0.1,0.2,0.2,0.2,0.2c0,0.1-0.1,0.2-0.3,0.5c-0.1-0.2-0.3-0.3-0.3-0.4C580.3,30.8,580.5,30.7,580.6,30.6z M580.8,36L580.8,36
		l0.1-0.2c0-0.2,0.1-0.5,0.1-0.7c0.1,0,0.2,0.1,0.4,0.1c-0.2,0.2-0.3,0.4-0.5,0.6C580.8,35.8,580.8,35.9,580.8,36L580.8,36
		c0,0.2,0,0.3,0,0.5c-0.1,0-0.2,0-0.3,0C580.6,36.3,580.7,36.2,580.8,36z M581.6,39.5C581.6,39.5,581.6,39.4,581.6,39.5
		c-0.4-0.1-0.7-0.2-1.1-0.3c0.3-0.3,0.5-0.6,0.6-0.6c0.2,0,0.4,0.1,0.6,0.2c0.3-0.2,0.6,0.1,0.8,0.3
		C582.5,39.4,582.2,39.8,581.6,39.5z M583.6,32.4L583.6,32.4l-0.1-0.2c0.1,0,0.1,0,0.2,0.1C583.7,32.3,583.7,32.3,583.6,32.4z
M587.2,38.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.2,0.3-0.5,0.4-0.7c0.1,0,0.2,0.1,0.2,0.1C587.5,37.6,587.3,37.8,587.2,38.1z
M588.9,38.6L588.9,38.6L588.9,38.6L588.9,38.6z M576,62.8c-0.1,0-0.1,0-0.2,0v-0.1C575.9,62.7,576,62.7,576,62.8
		C576,62.7,576,62.8,576,62.8z M576.2,64.1L576.2,64.1c0,0.1-0.1,0.2-0.1,0.3C576.2,64.2,576.2,64.2,576.2,64.1L576.2,64.1
		c0-0.2,0-0.5-0.1-0.9C576.4,63.5,576.8,63.8,576.2,64.1z M576.7,62L576.7,62L576.7,62L576.7,62z M582.5,69.5
		C582.6,69.5,582.6,69.5,582.5,69.5c0.1,0.1,0,0.1,0,0.2C582.5,69.7,582.4,69.7,582.5,69.5C582.4,69.5,582.5,69.5,582.5,69.5z
M579.5,61.8C579.5,61.8,579.5,61.7,579.5,61.8C579.6,61.7,579.6,61.8,579.5,61.8L579.5,61.8C579.5,61.9,579.5,61.9,579.5,61.8
		C579.5,61.9,579.5,61.9,579.5,61.8z M578.1,60.9c0.2,0.2,0.4,0.4,0.6,0.6c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2-0.2-0.3-0.5-0.5-0.7
		C577.9,61,578,60.9,578.1,60.9z M577,66.4c0.7-0.7,1.1-0.4,1.6-0.1C578.1,67.1,577.7,66.6,577,66.4z M578.6,72.4
		c-0.5-0.4-0.5-0.8,0-1.3C579,71.5,579.2,71.9,578.6,72.4z M581,66.8c-0.3,0.6-0.9,0.6-1.5,0.8c-0.1-0.1-0.2-0.2-0.3-0.3
		c0.3-0.2,0.6-0.4,0.9-0.7C580.3,66.6,580.6,66.7,581,66.8z M579.7,63.4L579.7,63.4L579.7,63.4L579.7,63.4z M579.8,65.8
		c-0.3-0.6-0.6-1.1-0.9-1.7C580.2,64.5,580.2,64.5,579.8,65.8z M583.9,65.5c0-0.1-0.1-0.1-0.1-0.2s0.1-0.1,0.2-0.2
		c0.1,0.1,0.1,0.1,0.2,0.2C584,65.4,584,65.4,583.9,65.5z M582.3,59.1c-0.2-0.1-0.4-0.5-0.3-0.7c0.2-0.5,0.6-0.6,1.7-0.3
		C583.4,58.8,583.2,59.4,582.3,59.1z M585.4,56.3c-1.2,0.3-2.4-0.2-3-1c0,0.3,0.1,0.5,0.2,0.8c0.4,0.7-0.5,1.3-1,1.9v0.1
		c0,0-0.1,0-0.1-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c-1.1-0.8-1.7-1.6-0.8-2.9c0.1-0.2,0-0.6,0-0.8c-0.1-0.4-0.1-0.4,0.5-1.2
		c0.6,0.1,1,0.4,1.2,0.7c0-1.1,0.9-2.1,2.2-2.4c0.3-0.1,0.7-0.1,1-0.1c0.2-0.2,0.5-0.5,0.6-0.8c0.3,0.4,0.5,0.7,0.7,1
		c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.3,0.9,0.7,1.1,1.3C587.9,54.5,586.9,56,585.4,56.3z M587.9,54.9c-0.1,0-0.2,0-0.2-0.1v-0.1
		c0.1,0,0.2,0,0.2,0C587.9,54.7,587.9,54.8,587.9,54.9z M588.3,57.1c-0.1-0.1-0.1-0.2-0.2-0.2c0.3-0.2,0.7-0.4,1-0.6
		c0.1,0.1,0.2,0.2,0.3,0.3C589.1,56.8,588.7,56.9,588.3,57.1z M589.2,49.4c-0.1,0-0.2-0.1-0.3-0.2c0.1-0.1,0.3-0.3,0.4-0.4
		c0.1-0.1,0.3,0,0.8,0.1C589.5,49.2,589.3,49.3,589.2,49.4z M596.4,42C596.4,42,596.5,42,596.4,42l0.1,0.2c-0.1,0-0.1,0-0.2-0.1
		C596.4,42.1,596.4,42,596.4,42z M595.6,40.5c0.1,0,0.3,0,0.4,0.1c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0-0.2,0-0.3,0
		C595.4,41,595.5,40.8,595.6,40.5z M595.4,44.6c0.6-0.1,1.1,0.3,1.1,0.7s-0.4,1-0.9,1.1s-1.1-0.2-1.2-0.6
		C594.3,45.2,594.7,44.7,595.4,44.6z M594.7,38.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.1-0.2,0.2c-0.1-0.1-0.2-0.2-0.2-0.2
		C594.5,38.4,594.6,38.3,594.7,38.2z M593.2,45c0.1,0.2,0.2,0.4,0.4,0.6c-0.1,0.1-0.2,0.1-0.2,0.2c-0.2-0.2-0.3-0.3-0.5-0.5
		C593,45.2,593.1,45.1,593.2,45z M593.3,47.1c1.5-0.3,3,0.5,3.2,1.8s-0.8,2.6-2.4,2.9c-1.4,0.3-3.1-0.5-3.2-1.6
		C590.7,48.7,591.7,47.5,593.3,47.1z M591.3,51c0.3,0.5,0.5,0.8,0.8,1.1C591.2,52.1,590.8,51.9,591.3,51z M592.2,57.7L592.2,57.7
		c-0.1-0.2-0.1-0.3,0-0.4l0.1,0.1C592.2,57.5,592.2,57.6,592.2,57.7z M594.9,58.4c0.7-0.1,0.7-0.1,1,0.4
		C595.5,58.6,595.2,58.5,594.9,58.4z M596.1,55.4c-0.9,0.8-2.8,0.7-3.5-0.3c-0.1-0.2-0.1-0.5-0.3-0.7c-0.1-0.2-0.3-0.2-0.5-0.4
		c0.4-0.4,0.8-0.7,1.2-1.1c1-0.8,2.3-0.9,3.1-0.2C597,53.4,597,54.6,596.1,55.4z M597.7,55.2L597.7,55.2L597.7,55.2L597.7,55.2
		C597.7,55.3,597.7,55.3,597.7,55.2z M597.3,55.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.2,0.1-0.2
		C597.1,55.2,597.2,55.2,597.3,55.2z M597.7,46.6c-0.1,0-0.3-0.1-0.4-0.1c0-0.1,0.1-0.3,0.2-0.5c0.2,0.1,0.3,0.2,0.3,0.3
		C597.9,46.3,597.8,46.5,597.7,46.6z M597.8,45.2c-0.3-0.6-0.1-1,0.6-1.2C598.6,44.6,598.3,44.8,597.8,45.2z M602.4,57.1
		c0-0.1-0.1-0.1-0.1-0.2l0.1-0.1l0.1,0.1C602.4,57,602.4,57,602.4,57.1z M605.4,56.2c-1.5,0.3-2.9-0.4-3.1-1.6c0-0.1,0-0.1,0-0.2
		c-0.1,0-0.2,0-0.3,0c0.1-0.3,0.1-0.7,0.2-1c0.1,0,0.2,0,0.3,0c0.3-0.7,1.1-1.3,2.1-1.5c1.5-0.3,2.8,0.4,3,1.7
		C607.7,54.8,606.8,56,605.4,56.2z"
      />
      <path
        class="st4"
        d="M486.1,58.1c-0.1,0-0.1,0.1-0.2,0.1s-0.3-0.2-0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.4c0,0,0,0,0-0.1
		c-0.1-0.4-0.2-0.9-0.3-1.3c-1.2,0.5-1.3,0.6-1.1,1.8c-1.3,0.3-2.4,0.1-3.3-0.4c-0.4,0.5-0.7,0.8-0.8,1.2c-0.2,0.8-0.8,1.2-1.4,1.5
		c0.1,0.5,0,1.1-0.4,1.7l0,0c1-0.2,1.6-0.6,1.8-1.6c0.5,0.3,0.9,0.5,1.3,0.7h0.1c0,0,0,0,0,0.1c0.4,0,1-0.2,1.1,0.3
		c0,0.1-0.2,0.3-0.3,0.4c-0.6,0.1-0.8-0.3-0.8-0.7c0,0,0,0-0.1,0l0,0c-0.3,0.2-0.7,0.3-1,0.5c-0.1,0.1-0.1,0.3-0.2,0.5
		c0.4,0,0.7,0,1.2,0c-0.1,0.9-0.2,1.6-0.3,2.4c0.1,0,0.2,0.1,0.3,0.1c0.4-0.2,0.7-0.5,1.2-0.8c-0.1-0.2-0.3-0.4-0.4-0.9
		c1.2-0.5,1.7-0.5,1.8,0c0.1,0.4,0,0.8-0.6,1c-0.3,0.1-0.5,0.1-0.6,0.1c0.3,0.3,0.5,0.5,0.6,0.8c0.7-0.5,1.4-1,1.4-1.9
		c1.3-0.5,1-1.2,0.6-1.9c-0.3-0.6-0.1-1.2,0.2-2c0.5,0.4,0.9,0.6,1.1,0.8c0.3-0.3,0.5-0.6,0.8-0.9c-0.2,0-0.3,0-0.5,0
		C486.8,58.7,486.4,58.5,486.1,58.1z M481.5,59.2L481.5,59.2L481.5,59.2L481.5,59.2z M484.5,58.6c0,0,0.1,0,0.1,0.1l-0.1,0.1
		c0,0-0.1,0-0.1-0.1C484.4,58.7,484.4,58.7,484.5,58.6z M484.1,60.8c-0.1,0-0.3-0.1-0.4-0.1c0.1-0.2,0.3-0.5,0.4-0.7
		c0.1,0.1,0.3,0.1,0.5,0.2C484.4,60.4,484.3,60.6,484.1,60.8z"
      />
      <path
        class="st4"
        d="M429.9,82.6c0.2-0.2,0.5-0.4,0.7-0.6c-1.1-0.3-2.1-0.5-3-0.7c0,0.9,0,1.9,0,3c1,0,2.1,0,3.2,0
		c0.1-0.2,0.1-0.4,0.2-0.6c-0.2-0.1-0.3-0.2-0.5-0.4C430.3,83.1,430.1,82.9,429.9,82.6z"
      />
      <path
        class="st4"
        d="M431.7,72.7c0-0.1,0-0.2,0-0.2c-0.1,0.5-0.2,1-0.3,1.6c0.8,0.3,1.7,0.5,2.6,0.8c-0.1-0.3-0.2-0.7-0.2-1
		C432.8,73.9,431.8,73.4,431.7,72.7z"
      />
      <path
        class="st4"
        d="M411.7,51.6c-0.1-0.1-0.1-0.2-0.1-0.3c-0.2-0.8,0.4-1.6,1.4-1.7c0.5-0.1,1,0,1.4,0.3l0,0v-0.1
		c-0.1-0.5,0.2-1.1,0.7-1.4c0.2-0.3,0.2-0.6-0.2-0.9c-0.1-0.1,0.2-0.5,0.4-0.7c0.4-0.3,0.9-0.4,1.4-0.6c0.1-1.5-1.7-1.5-2.6-2.4
		c-0.1,0.4-0.2,0.6-0.3,0.8l0,0c0.6,0.3,0.6,0.6-0.1,0.8c-0.9,0.3-1.4,0.4-1.9,0.4c0,0.1,0.1,0.2,0.1,0.3c0.1,0.7-0.4,1.4-1.3,1.6
		c0.1,0.1,0.3,0.1,0.4,0.2c-0.7,0.6-1.4,1.2-2.1,1.8C409.3,51,410.9,51.1,411.7,51.6z"
      />
      <path
        class="st4"
        d="M508.2,54.1c-0.1,0.1-0.1,0.2-0.2,0.4c0,0.1,0,0.1,0,0.2c0.3,0.5-0.1,0.4-0.4,0.5c-0.1,0.1-0.1,0.2-0.2,0.3
		l0,0c0,0,0,0,0,0.1c0,0,0.2,0.2,0.3,0.4c0.1,0.2,0.3,0.4,0.5,0.8c-0.2,0.1-0.4,0.3-0.7,0.5c0,0,0,0,0,0.1c0.2-0.1,0.4-0.1,0.6-0.2
		c0.3-0.9,0.6-1.8,0.8-2.7c-0.2,0-0.4-0.1-0.6-0.2C508.3,54.1,508.3,54.1,508.2,54.1z"
      />
      <path
        class="st4"
        d="M432,70.6c-0.1,0.4-0.2,0.8-0.3,1.2c0.3-0.5,1.1-1,2.2-1.2c0-0.1-0.1-0.3-0.1-0.4
		C433.4,70.4,432.8,70.5,432,70.6z"
      />
      <path
        class="st4"
        d="M492.6,60.5C492.5,60.5,492.5,60.5,492.6,60.5c0.5-0.1,0.9-0.1,1.4-0.2c-0.3-0.4-0.6-0.8-0.9-1.2
		c-0.4,0-0.8,0.1-1.3,0.1c-0.1,0.1-0.3,0.4-0.5,0.6c-0.7,0.6-1.3,0.7-1.8,0c0-0.1-0.1-0.1-0.1-0.2c0,0.3,0.1,0.5,0,0.8
		c-0.1,0.7-1,0.3-1.5,0.7c1.7,0.4,2.7,0,3.4-1.1c0.3-0.6,0.8-0.8,1.3-0.5C493.1,59.8,493,60.2,492.6,60.5z"
      />
      <path
        class="st4"
        d="M493.3,62.3c-0.2-0.2-0.4-0.5-0.7-0.8c0.2,0.4,0.4,0.8,0.6,1.1c0.5,1,1,1.3,1.8,1.1c0-0.1,0-0.2,0.1-0.4
		c-0.8-1-0.8-1,0.2-1.7v-0.1C494.7,61.8,494.1,62,493.3,62.3z"
      />
      <path
        class="st4"
        d="M476.2,53.1c0-0.1,0-0.2-0.1-0.2s-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0,0.2,0.1,0.3,0.1
		C476,53.4,476.1,53.3,476.2,53.1z"
      />
      <path
        class="st4"
        d="M415.7,51.8c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2,0.5-0.7,1-1.4,1.1c-0.6,0.1-1.1-0.1-1.4-0.4
		c0.1,0.6,0.2,1.1,0.4,1.6l0,0c0,0.1,0,0.2,0,0.3s0,0.2,0.1,0.2c0.6-0.1,1.1-0.1,1.5-0.1c-0.1,0.1-0.1,0.3-0.2,0.3
		c-0.6,0.6-1.6,0.9-1.7,1.9c0.7,0.2,1.7,0.1,1.9,0.5c0.6,0.9,1.5,0.9,2.4,1.2c1.1,0.3,1.7,1.2,1.8,2.2c0.4-0.9,0.8-1,2.6-1.2
		c0-0.4-0.1-0.8-0.1-1.2c-0.3-0.1-0.7-0.3-1-0.5c-0.4,0.3-0.7,0.6-1.1,0.7c-0.7,0.3-1.4,0-1.2-0.6c0.1-0.5,0-0.8-0.2-1.1
		c-0.2-0.1-0.4-0.3-0.5-0.6c0-0.2,0-0.4,0-0.5c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.2-0.1-0.5-0.2-0.8c0.7,0.4,1,0.5,1.3,1
		c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.5,0,0.7,0.1c0.1-0.2,0.1-0.4,0.2-0.6c0.2-0.5,0.4-1,0.6-1.5c-1.4,0.1-2.8,0.2-4.3,0
		C415.2,52.1,415.4,51.9,415.7,51.8z M417.9,53.3c0.1,0,0.2,0.1,0.2,0.1s0,0.1-0.1,0.1s-0.2,0-0.3,0
		C417.8,53.4,417.9,53.3,417.9,53.3z"
      />
      <path
        class="st4"
        d="M427.9,64.2L427.9,64.2c-0.4,0.1-0.8,0.1-1.2,0c-1.1-0.1-2-0.7-2.4-1.6c-0.7,0.4-1.5,0.4-2.4,0.3
		c0,0.2,0,0.4,0.1,0.6c0.5,0.2,1,0.5,1.3,1c0.2,0.2,0.3,0.6,0.6,0.7c0.7,0.4,1.4,0.8,2.2,0.8c0.2-0.4,0.5-0.7,1-1.1
		C427.5,64.8,427.9,64.7,427.9,64.2z"
      />
      <path
        class="st4"
        d="M425.8,78.5c-0.1,0-0.1,0-0.2-0.1c-0.4-0.2-0.8-0.5-0.9-0.9c-0.3,0-0.5,0-0.8,0.1c0,0.4,0,0.7-0.1,1.1
		c0,0.1,0,0.2,0,0.2c0,0.2,0,0.3,0.1,0.5c0.9,0,1.8,0.3,2.8,0.8c-0.1-0.6-0.3-1.2-0.4-1.7C426.1,78.6,425.9,78.6,425.8,78.5z"
      />
      <path
        class="st4"
        d="M481.1,57.6c-0.5-0.3-0.9-0.6-1.2-1l-0.1-0.1c0.1,0.6-0.4,0.8-1.2,0.9c-0.2-0.4-0.5-0.9-0.7-1.4l0,0
		c0,0,0,0,0-0.1l0,0l0,0c0.3-0.2,0.5-0.4,0.6-0.6c-0.4-0.4-0.8-0.8-0.9-1.5c0.8-0.5,1.7-1,2.6-1.4c0.2-0.1,0.7,0.3,1,0.2
		c0.9-0.3,1.8-0.7,2.6-1c0-0.3,0-0.5-0.1-0.7c-0.2,0.2-0.4,0.4-0.6,0.7c-0.4-0.3-0.6-0.4-1-0.7c0.4-0.5,0.8-0.9,1.2-0.9
		c0.5-0.7,0.9-1.3,0.7-2.1c-0.2-0.2-0.5-0.5-1-0.9c0.1-0.1,0.3-0.3,0.4-0.3c0.2,0,0.4-0.1,0.5-0.2c-0.3-0.1-0.6-0.3-1-0.6
		c0.6-0.4,1-0.7,1.4-0.9c0.2-0.1,0.6-0.1,0.8,0c0.4-0.6,0.9-1,1.5-1.5c0.1-0.1,0.3-0.2,0.4-0.3c0-0.2-0.1-0.4-0.2-0.6
		c-0.3-0.5-0.1-1,0.4-1.6c-0.4,0.1-0.7,0.3-1.1,0.4l-0.1-0.1c0.1,0.3-0.2,0.6-0.4,1c-0.6-0.1-1.2,0-1.3-0.5c-0.5,0.1-1,0.2-1.5,0.3
		c0.3,0.3,0.5,0.5,0.8,0.8c-0.5-0.1-1-0.1-1.5-0.2c0,0-0.1,0-0.1,0.1c0,0,0,0,0-0.1c-0.4-0.1-0.8-0.1-1.3-0.2c0-0.3-0.1-0.7-0.2-1.2
		c0.3-0.1,0.6-0.2,0.8-0.1c0.3,0.1,0.5,0.1,0.8,0.1c0.1-0.1,0.2-0.2,0.4-0.3c0,0,0,0,0-0.1c0.1-0.1,0.1-0.1,0.1-0.2
		c0,0-0.1,0.1-0.1,0.2l0,0l0,0l0.1-0.1c0.4-0.5,0.3-1,0-1.5c-0.4-0.5-0.9-1-1.5-1.6c1.4-0.3,0.9-1.3,1-1.9c0.1-0.6-0.6-1.5-1.5-1.5
		c-0.8,0-1.4-0.1-2.2-0.2c-0.3-0.8,0.2-1.8-1-2.2l0,0h-0.1c-0.1,0.4-0.2,0.8-0.9,0.6c-0.2-0.4-0.1-0.8,0.4-1.1l0,0
		c-0.4,0-0.8-0.1-1.2-0.1c-0.8,0.1-1.5,0-2.1-0.4c0,1-0.1,2-0.1,3c0,0.2-0.1,0.5,0,0.6c1,1,0.2,2.4,0.7,3.5c0.3,0.6,0.2,1.3-0.3,2
		c-0.5,0.6-0.3,1.3,0.2,1.9c0.7,0.9,1.2,1.9,1.3,3.1c0,0.9-0.2,1.5-0.6,2.1c0.1,0,0.3,0.1,0.4,0.1c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.1,0-0.2,0-0.3-0.1c-0.1,0.1-0.2,0.2-0.4,0.3c-0.3,0.3-0.7,0.5-1,0.7c0.4,0.9,1.2,0.8,2,0.5l0.1,0.1c0-0.1,0.1-0.1,0.1-0.2
		c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.3-0.1,0.4c0.4,0.6,0.5,1.2,0.4,1.8c-0.4,0-0.8,0.1-1.2,0c-0.3-0.1-0.5-0.4-0.8-0.5
		c-1.4-0.5-1.4-0.5-1.3-1.9c-0.1,0-0.1-0.1-0.2-0.1l0,0c0.3,0.4,0,0.8,0.1,1.3c-0.3-0.1-0.5-0.2-0.6-0.3c-0.1,0.2-0.2,0.3-0.4,0.5
		c-0.1,0-0.2-0.1-0.2-0.1c0.1-0.2,0.3-0.4,0.4-0.5c-0.2-0.2-0.1-0.4,0.2-0.8c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.7-0.3-1-0.4
		c-1.8-0.2-2.3-0.7-2-2.2c0-0.1,0-0.3,0-0.4l0,0l-0.1-0.1c0,0,0.1,0,0.1,0.1l0,0c0.3-0.2,0.6-0.4,0.9-0.5c1.3-0.5,2.4-0.1,2.7,0.8
		c0.9,0,1.6-0.5,2.2-1c0-1.2-0.3-2.2-1.3-3c-0.6-0.5-0.7-1-0.7-1.7c0.1-2.2-0.5-4.4-1.7-6.3c-0.4,0-1,0-1.4-0.1
		c-1.3-0.4-2.3,0.3-3.2,1c-0.5,0.4-0.3,0.8,0.2,1.2c0.6-0.2,1.3-0.9,1.9-0.2c0.2,0.2,0.3,0.7,0.2,1c-0.3,0.7-1,0.7-1.9,0.3
		c0.2,1.6-1.2,2.4-1.9,3.7c-0.9-0.6-1.9-1.2-2.7-1.9c-0.8-0.6-1.5-1.2-2.4-2c-0.1,0-0.2-0.1-0.4-0.1c0.1,0,0.1-0.1,0.1-0.1
		c-0.1,0-0.1-0.1-0.2-0.1c-0.3,1.5-0.6,2.7-0.8,4c-0.1,0.4,0,0.8,0.1,1.1c0.1,0.1,0.1,0.3,0.1,0.4c0.2-0.1,0.4-0.1,0.6-0.2
		c0.5,0.3,1,0.6,1.4,0.9l0,0c0.1,0.1,0.2,0.2,0.3,0.3c0-0.1,0-0.3,0-0.4l0,0c0.5-0.1,0.7-0.9,1.5-0.4c-0.2,0.4-0.4,0.9-0.6,1.5
		c0.5,0.2,1,0.6,1.4,0.6c1.2-0.2,1.4,0.3,1.5,1.1c0,0.3,0.2,0.7,0.3,0.9c-0.6,0.7-1.1,1.3-1.6,2c1.1,0.8,1.6,0.2,2.2-0.4
		c-0.6-0.5-0.7-0.8-0.5-1.3c0.2-0.4,0.5-0.6,1-0.6l-0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1,0.1,0.3,0.1c-0.1,0.1-0.1,0.1-0.2,0.2
		c0.2,0,0.5,0,0.8,0c-0.3,0.6-0.5,1.1-0.8,1.7c0.7,0.2,1.4,0.3,1.5,1.1c0,0.1,0.4,0.1,0.6,0.2c0.3,0.1,0.6,0.2,0.9,0.4
		c0,0,0,0,0-0.1c0.4,0.1,0.7,0.2,1.1,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.3-0.1-0.7-0.2-1-0.2c-0.4,0.3-0.8,0.6-1.3,1
		c0.6-0.1,1.1-0.1,1.6-0.1c-0.3,0.5-0.5,0.8-0.7,1.2c0.6,0.5,1.4,0.6,1.5,1.4c0,0.3,0.7,0.8,1,0.7c1-0.2,1.5,0.5,2.4,0.6
		c-0.1-1.2,1-1.6,1.9-2.2c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0,0.2,0,0.4,0l0,0l0,0c-0.4-0.6-0.1-1.1,0.6-1.6c0.2,0.7-0.2,1.1-0.6,1.6
		c0,0,0,0,0,0.1l0,0c1.1,1-0.2,2.2,0,3.3c-0.5,0.4-0.6,0.8-0.7,1.3c0.2,0,0.3,0,0.6,0c0.2,0.1,0.4,0.1,0.9,0.3
		c-0.2,0.4-0.3,0.8-0.5,1c-0.3,0.3-0.7,0.4-1.1,0.4c0.1,0.1,0.3,0.2,0.4,0.2c0.4-0.1,0.8-0.2,1.2-0.3c0.1-0.1,0.3-0.2,0.5-0.3
		l0.1,0.1c0.3-0.1,0.6-0.1,0.8-0.2C479.5,58.4,480.2,58,481.1,57.6z M483.3,45C483.4,45,483.4,45,483.3,45c0.1,0.1,0,0.1,0,0.2
		C483.3,45.1,483.3,45,483.3,45z M481.5,40c0.1,0.1,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.2,0.4c-0.1-0.1-0.3-0.2-0.3-0.2
		C481.3,40.3,481.4,40.1,481.5,40z M473.7,45.1c0,0-0.1,0-0.1,0.1c0,0,0-0.1-0.1-0.1C473.6,45,473.7,45,473.7,45.1
		C473.7,45,473.7,45.1,473.7,45.1z M473.3,44.2c0.1,0,0.3,0.2,0.4,0.3c-0.2,0.1-0.3,0.3-0.5,0.4c-0.1,0-0.2-0.2-0.4-0.3
		C473,44.4,473.1,44.2,473.3,44.2z M469.7,40.4c-0.1,0-0.2,0-0.3,0c0-0.1,0.1-0.1,0.1-0.2c0.1,0,0.2,0,0.3,0
		C469.8,40.3,469.7,40.4,469.7,40.4z M470.8,42.3c0.3,0.3,0.3,0.3-0.5,0.9c-0.1-0.3-0.2-0.6-0.4-1.1
		C470.4,42.1,470.7,42.2,470.8,42.3z M469.5,36.3c0.1,0,0.3,0,0.5,0.1c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0-0.3-0.1-0.4-0.1
		C469.3,36.5,469.3,36.3,469.5,36.3z M465.3,41.6c-0.1-0.1-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.5c0.2-0.1,0.4,0.1,0.8,0.2
		C465.7,41.3,465.5,41.4,465.3,41.6z M471.8,52.5c0,0-0.1,0-0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2l0.1,0.1
		C472,52.4,471.9,52.4,471.8,52.5z M479.2,48.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.2,0.2-0.4,0.3-0.7c0.1,0,0.2,0.1,0.3,0.1
		C479.5,47.7,479.3,47.9,479.2,48.1z M479.1,41.4c0-0.1,0-0.2,0-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0,0.1,0.1,0.1,0.1,0.2
		C479.4,41.3,479.3,41.3,479.1,41.4z M479.6,45.8c0.1,0,0.2,0,0.3,0c0,0.4,0,0.8-0.1,1.2c-0.1,0-0.2,0-0.4,0
		C479.5,46.6,479.6,46.2,479.6,45.8z M480.3,52.2C480.2,52.2,480.2,52.2,480.3,52.2C480.2,52.2,480.2,52.2,480.3,52.2
		c-0.1,0.1-0.1,0.2-0.1,0.2v-0.1C480.1,52.2,480.2,52.2,480.3,52.2C480.2,52.2,480.3,52.1,480.3,52.2
		C480.3,52.1,480.3,52.2,480.3,52.2z M479.9,50.6c-0.1-0.3,0.1-0.6,0.1-0.9c0.1,0,0.2,0,0.3,0c0.3,0.6,0.6,1.2,0.9,1.8
		C480.2,51.7,480.1,51.1,479.9,50.6z M483.6,48.7c-0.7,1-1.3,0.4-1.9,0C482.6,47.8,483,48.6,483.6,48.7z M480.3,47.1
		c0-0.1,0-0.1,0.1-0.2l0,0c0.2-0.1,0.4-0.2,0.8-0.2l0,0l0,0c-0.2-0.3-0.3-0.5-0.5-0.9c0.4-0.2,0.7-0.5,1.2-0.8
		c0.1,0.2,0.3,0.4,0.2,0.5c-0.3,0.4-0.6,0.8-0.8,1.2c0,0,0,0,0,0.1h-0.1c-0.2,0.5-0.5,0.9-0.7,1.4v-0.1c-0.2,0.2-0.4,0.3-0.4,0.5
		c-0.1-0.1-0.2-0.1-0.4-0.2C479.9,48,480,47.6,480.3,47.1L480.3,47.1z M479.6,38.8c0,0.2,0,0.4,0.1,0.6c0.1,0.1,0.2,0.1,0.3,0.2
		c-0.4,0.4-0.6,1-1.1,1.2c-0.6,0.2-1.3-0.1-1.5-0.8C478.2,39.5,478.9,39.2,479.6,38.8z M477.7,38.6c0.1,0.1,0.1,0.3,0.2,0.4
		c-0.3,0.1-0.7,0.2-1,0.3c0-0.1-0.1-0.1-0.1-0.2C477.1,39,477.4,38.8,477.7,38.6z M474.1,33.3c1.3-0.3,1.9,0.2,2.1,1.1
		C474.9,34.9,474.6,34.8,474.1,33.3z M475.6,38.9c-0.1,0-0.4-0.2-0.4-0.2c0.1-0.3,0.3-0.5,0.5-0.7c0.1-0.1,0.4,0.1,0.8,0.2
		C476.1,38.5,475.8,38.7,475.6,38.9z M476.6,38.2c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.2-0.1,0.3h-0.2C476.5,38.4,476.5,38.3,476.6,38.2z
M476.5,42.3c0.4-0.5,0.7-0.9,1-1.3c0.2,0.5,1,0.9,0.2,1.4C477.5,42.6,477.1,42.4,476.5,42.3z M477.6,55.9h-0.1c0,0,0,0,0-0.1
		c0,0,0.1,0,0.1-0.1C477.6,55.8,477.6,55.9,477.6,55.9z M477.2,44.3h-0.1H477.2L477.2,44.3z M477,45.1c-0.1,0-0.1,0-0.2-0.1
		c0.1-0.2,0.2-0.4,0.3-0.6c0.1,0,0.2,0.1,0.3,0.1C477.2,44.6,477.1,44.9,477,45.1z M477.7,58.1c-0.1,0-0.2,0-0.3,0l0.1-0.1
		c0.1,0,0.2,0,0.3,0C477.8,58,477.7,58.1,477.7,58.1z"
      />
      <path
        class="st4"
        d="M434.9,52.7c-0.1-0.6,0.2-0.8,1.6-0.9c0.3-1.4,0.3-1.4-0.9-2.2c-0.5,0.2-0.9,0.4-1.4,0.7c0,0,0.1,0,0.1,0.1
		c0.1,0.1-0.1,0.5-0.2,0.5c-0.3,0.1-0.7,0.3-1,0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.3,0.2-0.7,0.3-1,0.5c-0.4,0.2-0.6,0.7-0.9,1
		c0.6,0.9,2.2,1.6,3.5,1.6c0.4,0,0.7,0,1,0.1c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.1,0.3-0.2,0.4-0.3c-0.2-0.3-0.3-0.6-0.5-0.8
		C435.4,52.6,435.2,52.7,434.9,52.7z"
      />
      <polygon class="st4" points="457.7,62 457.6,62 457.7,62.1 	" />
      <path
        class="st4"
        d="M479.6,39.4c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C479.6,39.6,479.6,39.5,479.6,39.4z"
      />
      <path
        class="st4"
        d="M457.8,59.5c0,0.1,0,0.2,0,0.3c0.1-0.1,0.1-0.2,0.2-0.2C458,59.6,457.9,59.6,457.8,59.5z"
      />
      <path
        class="st4"
        d="M485.5,55.4c-0.4,0.3-0.3,0.5,0.1,0.7v0.1c0.1,0,0.2-0.1,0.3-0.1c0.5-0.2,0.4-0.5,0.2-0.8
		C486,55.3,485.6,55.3,485.5,55.4z"
      />
      <path
        class="st4"
        d="M456.6,69.5L456.6,69.5L456.6,69.5C456.6,69.5,456.6,69.4,456.6,69.5C456.6,69.4,456.6,69.4,456.6,69.5
		c0.2-0.2,0.3-0.3,0.4-0.5c0.5-0.4,1-0.8,1.6-1c-0.1-0.2-0.1-0.4-0.2-0.5c0.5-0.8,0.9-1.3,1.1-1.8c0.1-0.4,0.4-0.7,0.6-1
		c-0.4-0.1-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.7-0.4-1.1c-0.1,0-0.2,0-0.3,0c-0.1,0.5-0.2,1-0.3,1.4c-0.9,0.8-1.9,0.3-2.8,0.3l-0.1,0.1
		c-0.2,0.4-0.5,0.7-0.8,1.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4,0.2-0.8,0.4-1.3,0.6c-0.5,0.1-1,0.2-1.4,0.1c0.1,0.1,0.3,0.1,0.4,0.2
		c0.5,0.4,0.5,0.9,0.4,1.5l0,0l0,0c0.4-0.2,0.8-0.4,1.1-0.6c0.6,0.3,1.2,0.6,1.7,0.9s0.5,1,0.1,1.2c-0.5,0.3-1,0.2-1.2-0.2
		c-0.2-0.4-0.6-0.5-1.1-0.6c-0.3-0.1-0.5-0.4-0.7-0.6c0,0,0,0-0.1,0c0,0,0,0,0-0.1c-0.6,0-1.2,0.1-1.7,0.1c-0.6,0-0.7-0.4-0.7-0.9
		s0.5-0.9,1-1c-1-0.2-1.8-0.8-2.2-1.7c-1.4,0-2.5-0.8-2.8-2c-0.4-1.5,0.8-3.1,2.6-3.5c0.3-0.1,0.6-0.1,1-0.1c0-0.1,0.1-0.3,0.3-0.4
		c0.5-0.4,1.1-0.8,1.8-1.3l0.1,0.1c0-0.2,0-0.4,0-0.7c0-0.1,0-0.2,0-0.3c-0.2,0.1-0.3,0.1-0.5,0.2c-0.7,0.2-1.3,0.1-1.7-0.4
		c0.5-0.7,1-1.4,1.5-2.2c-1.8-0.5-1.7-1.5-1.3-2.6c0.1-0.2,0.1-0.3,0.2-0.5c0-0.1-0.1-0.2-0.1-0.2c-1.2-0.1-1.1,1.4-2.3,1.4
		c-0.2-0.2-0.5-0.5-0.7-0.8c-0.2,0.9-1.1,1.7-2.2,1.6c-0.7-0.1-1,0.2-1.4,0.5c-0.9,0.6-2,0.7-2.8,0.2c-0.9-0.7-1.8-0.7-3-0.7
		c0,0.1,0,0.3,0,0.5c0.3,0.1,0.6,0.3,0.9,0.7c-0.1,0.6-0.5,1-1,1.3c0.1,0.2,0.1,0.4,0.1,0.6c0.1,0.9,0.7,1.3,1.4,1.8
		c0.6,0.4,1,0.8,1.6,1.2c0.4,0.3,0.7,0.5,1.1,0.7c1.4,0.7,2,1.9,1.6,3.2c-0.2,0.6-0.5,1.1-0.9,1.4l0,0c-0.1,0.1-0.3,0.3-0.5,0.4
		h-0.1c-0.5,0.3-1.2,0.5-1.9,0.6c-0.4,0-0.7,0.1-1.1,0.2c-0.7,0.2-1.4,0.4-2.2,0.7c0.4,0.1,0.8,0.2,1.2,0.3c0.8,0.1,1.5,0.2,2.3-0.3
		c1-0.6,2.4-0.1,2.4,0.8c-0.1,1.2,0.6,1.9,1.1,2.8c0,0.1,0,0.2,0,0.6c-2-0.6-3.8-1.1-5.6-1.7c-0.1,0.3-0.2,0.5-0.2,0.7
		c1.1-0.2,2.3,0.1,3.1,0.7c1.7,1.4,2,1.9,0.8,5c0.7-0.2,1.3-0.3,1.8-0.3c0-0.2,0.1-0.4,0.2-0.7c-0.1-0.2-0.2-0.5-0.3-0.8
		c-0.3-2.1,0.9-3.6,3.2-4.1c1.6-0.4,3.1,0.1,3.9,1.2c-0.1-0.3-0.1-0.7-0.3-1.2c0.6,0.3,0.9,0.4,1.3,0.6s0.7,0.5,1.2,0.7
		c0.2-0.5,0.4-0.8,0.7-1.3c0.5,0.5,0.9,1,1.3,1.4c0.5,0.6,1.1-0.3,1.5-0.2C456.1,70.1,456.3,69.8,456.6,69.5L456.6,69.5z
M441.9,57.3c-0.4,0.3-0.8,0.5-1.2,0.1c-0.1-0.1,0-0.3,0.1-0.4c0.2-0.3,0.3-0.3,1.3,0C441.9,57.2,441.9,57.3,441.9,57.3z
M442.9,65.7c-0.3,0.1-0.5,0.2-0.8,0.3c0-0.1-0.1-0.2-0.1-0.3c0.3-0.1,0.6-0.1,0.9-0.2V65.7z M448,55.2c0.1,0,0.1,0.1,0.2,0.1
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C447.8,55.3,447.9,55.2,448,55.2z M448,58.4c0,0,0.2,0.1,0.5,0.3
		c-0.3,0.2-0.4,0.3-0.6,0.3c-0.1,0-0.3-0.1-0.4-0.1C447.6,58.7,447.8,58.5,448,58.4z M446.9,56.3L446.9,56.3v0.2V56.3
		C446.9,56.3,446.9,56.3,446.9,56.3z M445.7,57c0.8,0.5,1,1.2,1.2,1.9c0.1,0.5-0.3,0.7-1,0.8c-0.5-0.5-1-1-1.5-1.5
		C444.5,57.4,445,57.2,445.7,57z M444.5,65C444.4,65,444.4,65.1,444.5,65L444.5,65C444.4,65.1,444.4,65.1,444.5,65L444.5,65
		c-0.1,0-0.2,0-0.2,0S444.4,65,444.5,65z M447.2,68.5c-0.6,0.1-1.4,0.5-2,0.4c-0.5-0.1-0.8-0.7-1.2-1.2c0.6-0.3,1.2-0.5,1.7-0.7
		s1.1-0.5,1.7-0.8C447.4,67,447.3,67.7,447.2,68.5z M455.8,67.4c-0.5,0.3-0.9,0.2-1.2-0.2c-0.3-0.3-0.1-0.7,0.3-0.9
		c0.4-0.2,0.9-0.2,1.5-0.3C456.5,66.7,456.3,67.1,455.8,67.4z"
      />
      <polygon class="st4" points="367.2,106.1 367.3,106.1 367.3,106 	" />
      <path
        class="st4"
        d="M447,81.2c-0.6,0.7-1.3,1.2-2.2,1.5c0.2,0,0.4,0.1,0.6,0.2c-0.7,1.3-1.2,1.6-1.9,1.4c-0.6-0.2-0.8-0.7-0.5-1.2
		l0,0c-0.2,0-0.4,0-0.5,0c-0.4,0-0.7-0.1-1.1-0.1c-0.1,0.4-0.2,0.9-0.3,1.3c1.1,0.7,2.2,1.3,3.5,1.8c-0.2-0.7,0.2-0.9,0.8-1.1
		c-0.2,0.3-0.4,0.6-0.7,1.2c0.5,0.2,1,0.4,1.5,0.5c0.1-0.2,0.3-0.5,0.4-0.8c0.1-0.4,0-0.9,0.1-1.3c0.2-0.7,0.5-1.3,0.1-2
		c-0.1-0.1-0.1-0.3,0-0.4C447.3,81.8,447.2,81.5,447,81.2z M445.9,83.5c0-0.1-0.1-0.1-0.1-0.2c0.1,0,0.2-0.1,0.3-0.1l0.1,0.1
		C446.1,83.4,446,83.5,445.9,83.5z"
      />
      <path
        class="st4"
        d="M608.4,15.1c-0.3-0.1-0.8,0.2-1.2,0.4c-0.5,0.2-1,0.4-1.6,0.7c0,0.2,0,0.6,0,1.1c-0.7-0.3-1.2-0.6-1.9-0.9
		c-0.2,0.4-0.3,0.7-0.5,1c-0.6-0.1-0.8-0.8-1.3-1c-0.3,0.4-0.8,0.7-1.3,0.7c-0.9,0.1-1.9-0.3-2-1c-0.2-0.7,0.6-1.7,1.5-1.9
		c-0.1-0.6-0.2-1.2-0.4-1.7c0-0.1-0.1-0.3,0-0.3c1-0.8,0.1-1.5,0-2.2c0-0.2-0.1-0.4-0.1-0.5c-1-0.2-1.3,0.5-1.8,0.9
		c-0.1-0.3-0.2-0.7-0.3-1c-1.4,0.4-1.4,0.4-2.4-0.5c-0.1,0.3-0.2,0.5-0.3,0.7c-0.1,0.5-0.5,0.8-1,0.8c-0.3,0-0.7-0.3-0.8-0.5
		c-0.2-0.4,0.1-0.8,0.6-1c0.3-0.2,0.6-0.4,0.8-0.8c-0.3,0-0.5,0-0.8,0c-0.2,0-0.5,0.1-0.7,0.2c-0.3,0.5-0.7,1-1,1.5
		c0.3,0.2,0.5,0.4,0.7,0.5c-0.4,0.6-1.5-0.3-1.7,0.8c0.3,0.1,0.7,0.3,1.2,0.5c-0.8,0.5-1.4,0.9-2.1,1.3c1,0.1,1.8,1.6,3.2,0.4l0,0
		c0,0,0,0,0.1,0v0.1c0.9-0.1,1.8-0.2,2.9-0.3c0.2,0.7,0.4,1.5,0.6,2.4c-0.1,0.1-0.3,0.2-0.6,0.3c-0.2-0.5-0.4-1-0.6-1.5
		c-0.4-0.2-0.9-0.3-1.4-0.5c-0.2,0.7-0.5,1.5-0.7,2.2c0.3,0.2,0.9-0.5,1.2,0.2c0.2,0.5,0.9,0.7,1.7,0.6c0.7-0.1,1.1,0.2,1.3,0.8
		c0.4,0.7,0.9,1.4,1.3,2c-0.3,0.5-0.6,0.8-0.8,1.2c-0.3,0.9-0.4,1.1-0.9,1.3c-0.1,0.2-0.3,0.4-0.5,0.6c0.1,0.2,0.2,0.4,0.4,0.7
		c0.6,0,1.4,0,2.1,0c0.1-0.4,0.2-0.8,0.3-1.4c0.6-0.1,1.3-0.2,2.2-0.3c0.1-0.2,0.3-0.5,0.6-0.9c0.2,0.3,0.4,0.5,0.7,0.8
		c-0.2,0.1-0.4,0.2-0.5,0.3l0,0c-0.1,0-0.1,0.1-0.2,0.1l0,0c-0.5,0.3-0.7,0.7-0.7,1.3c0.4-0.1,1-0.1,1.6,0.1
		c-0.5,0.4-0.9,0.9-1.4,1.3c0,0.5-0.3,1-1.3,1.2c0,0,0,0-0.1,0.1c1.4,0.1,2.5,0.2,2.6,1.5v-0.1c0,0,0,0,0,0.1c0,0,0,0-0.1,0
		c-0.2,0.7-0.4,1.5-0.6,2.2c0.3,0,0.5-0.1,0.8-0.2c-0.6-2.1,1.7-4.2,3.9-4.2c0.3,0,0.6-0.1,1-0.1c-0.1-0.4-0.2-0.7-0.2-1.1l0,0
		c-0.1,0.2-0.3,0.4-0.6,0.5c-0.2,0.1-0.8,0-0.9-0.2c-0.2-0.3-0.3-0.7-0.4-1.1c0,0,0,0-0.1,0l0,0c-0.4,0.2-0.7,0.5-1,0.4
		c-0.6-0.1-1.1-0.4-1.5-0.7c-0.1-0.1-0.1-0.5,0-0.7c0.1-0.1,0.6-0.2,0.8-0.1c0.6,0.3,1.2,0.7,1.7,1.1h0.1c0,0,0,0,0,0.1
		c0.2,0,0.4-0.1,0.5-0.1c0.1-0.2,0.4-0.4,0.7-0.6c0.3,0.3,0.6,0.6,0.9,0.9c1-1.6,2.2-2.6,3.6-3l0.1-0.1v-5c-0.8,0.1-1.4-0.2-1.9-0.6
		C609.9,15.1,609.3,15.3,608.4,15.1z M601.4,18.9c-0.9,0.3-0.8,1.1-1.4,1.4c-0.6,0-0.9-0.2-1-0.7l0,0l0,0l0,0l0,0
		c1.2-0.3,0.6-1.4,1.3-2.1c0.3,0,0.7,0,0.9,0.1C601.9,18,602,18.7,601.4,18.9z M604.1,23.6c0.2,0.1,0.4,0.3,0.4,0.4l0,0
		c0.4,1.5,0.2,1.7-1.4,2.4c-0.4-0.6-0.4-1.1-0.1-1.5h-0.1c0.1-0.4,0.1-0.6,0.2-0.8C603.3,23.8,603.6,23.5,604.1,23.6z M609.8,21.1
		c0-0.1-0.1-0.1-0.1-0.2l0.1-0.1C609.8,20.9,609.9,20.9,609.8,21.1C609.9,21,609.9,21.1,609.8,21.1z M608.5,21
		c-0.7,0.2-1.5-0.2-1.9-0.7c-0.4,0.1-0.7,0.4-1,0c-0.2-0.4-0.5-0.8-0.6-1.2c-0.1-0.8,0.6-1.6,1.6-1.9c1.3-0.4,2.6,0.2,2.9,1.2
		c0.3,0.2,0.4,0.5,0.5,0.8C610.1,20,609.4,20.8,608.5,21z M610.7,15.7c0,0-0.1,0-0.1,0.1c-0.1-0.2-0.3-0.4-0.4-0.6
		c0.1,0,0.1-0.1,0.2-0.1C610.5,15.3,610.6,15.5,610.7,15.7z"
      />
      <path
        class="st4"
        d="M406.7,69.4c0.2-0.3,0.5-0.5,0.8-0.6c-0.3-0.1-0.5-0.3-0.8-0.6c-0.5,0.3-1,0.6-1.5,0.9c0,0.1,0,0.2,0.1,0.3
		C405.7,69.4,406.2,69.4,406.7,69.4z"
      />
      <path
        class="st4"
        d="M316.7,236.1c0.5-0.3,1-0.7,1-1.4c0-0.1,0.1-0.3,0.2-0.4l0,0c-0.4,0.4-1,0.7-1.6,1
		C316.5,235.6,316.6,235.9,316.7,236.1z"
      />
      <path
        class="st4"
        d="M558.5,50.7c-0.4-0.1-0.9-0.2-0.9-0.7c-0.5,0.4-1.1,0.8-2,0.2c0,0,0-0.1,0-0.2c-0.4,0.2-0.8,0.5-1.3,0.8
		c0.5,0.3,0.9,0.8,1.1,0.7c1.2-0.3,1.3,0.4,1.4,0.7c-0.3,1.2-0.6,2.1-0.8,3.1c0.7-0.1,1.1-0.4,1.5-0.3c0.3,0,0.5,0.4,0.8,0.8
		c0.4-0.9,0.8-1.7,1.2-2.5c-0.5-0.5-1-1-1.5-1.5c0.4-0.4,0.7-0.7,1-1c0,0,0,0,0-0.1C559,50.8,558.7,50.8,558.5,50.7L558.5,50.7z
M557.2,51.5c-0.2-0.3-0.4-0.6-0.6-0.8c0.1,0,0.2-0.1,0.3-0.1c0.2,0.3,0.3,0.6,0.5,0.9C557.4,51.4,557.3,51.4,557.2,51.5z
M557.7,51.8L557.7,51.8L557.7,51.8L557.7,51.8z"
      />
      <path
        class="st4"
        d="M315.6,236c0-0.1-0.1-0.1-0.1-0.2c-0.5,0.3-0.9,0.6-1.2,1.1c1,0.5,1.4,0.7,1.9,0.8
		C316.1,237.1,315.8,236.6,315.6,236z"
      />
      <path
        class="st4"
        d="M324.2,250c0.6,1,0.9,2,0.2,3.3c0.8-0.3,1.6-0.3,2.3-0.2c0.1-0.7,0.3-1.3,0.4-2c0-0.1,0.2-0.3,0.4-0.4
		c0.1-0.1,0.2-0.2,0.3-0.3c-0.7,0.2-1.5,0.3-2.2,0.1C325.1,250.4,324.7,250.2,324.2,250C324.3,250,324.3,250,324.2,250L324.2,250z"
      />
      <path
        class="st4"
        d="M316.4,250.7c-0.1,0.8-0.3,1.7-0.4,2.5c0.4-0.2,0.9-0.3,1.4-0.2c0.2,0,0.3,0,0.5,0v-0.1
		c-0.3-1.2,0.2-2.2,1.5-2.9c0.2-0.1,0.4-0.2,0.6-0.3c-0.2-0.3-0.4-0.6-0.5-0.9C319,249.7,318.2,250.1,316.4,250.7z"
      />
      <path
        class="st4"
        d="M334.8,259.4c-1.3,0.9,0,1.6,0.1,2.8c-0.4-0.5-0.6-0.7-0.7-0.9c-0.1-0.4-0.3-0.8-0.3-1.2
		c0-0.9-0.5-1.2-1.4-1.3c-0.3,0-0.6-0.1-0.9-0.2c-0.1,0.3-0.2,0.5-0.3,0.6c0.5,0.1,0.8,0.5,0.8,0.9c0,0.6-0.5,1.2-1.3,1.4
		c-0.8,0.2-1.6-0.2-1.7-0.9c-0.1-0.7,0.5-1.3,1.4-1.4c0.2,0,0.4,0,0.5,0c-0.7-0.4-1.4-0.7-2.1-1.1c-0.8,0.8-1.9,1.3-3.2,1.4
		c0,0.7,0.2,1.4,0.4,2.1c1,0.2,1.9,0.6,2.4,1.3c0.9,1.4,0.3,2.8-0.8,3.8c0.2,0.3,0.5,0.5,1,0.6s0.6,0.9,1.3,0.5
		c0.5,1.2,1.9,0.8,2.9,0.8c0.7,0,1.4-0.5,1.2-1.4c-0.9-0.2-2-0.1-2.2-1.2c0-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.6-0.1-0.9-0.2
		c-0.8-0.3-1.3-1-0.9-1.5c0.4-0.4,1-0.6,1.6-0.6c0.8-0.1,1,0.3,1,1.1c0,0.2,0,0.5-0.1,0.7c0.6,0,1.3,0,1.9,0c0.5,0,1.1,0,1.7,0
		c0-1.2,0.1-2.3,0.1-3.5c0.7-0.4,1.3-0.7,2-1.1C337.4,259,335.9,259.5,334.8,259.4z M331.9,263.3c-0.1-0.3-0.2-0.6-0.4-0.9
		c0.1,0,0.1-0.1,0.2-0.1c0.2,0.3,0.3,0.5,0.5,0.8C332.2,263.2,332,263.3,331.9,263.3z"
      />
      <path
        class="st4"
        d="M313.4,261.3c0.9-0.1,1.7-0.1,2.6-0.2c0.1-0.3,0.1-0.6,0.2-0.8c-0.6-0.3-1.1-0.6-1.6-1c-0.4,0-0.8-0.1-1.2-0.1
		C313.4,259.8,313.4,260.6,313.4,261.3z"
      />
      <path
        class="st4"
        d="M576.1,199.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.3,0.1,0.5,0.1,0.8,0.2l0,0C576.5,199.9,576.3,199.7,576.1,199.5z"
      />
      <path
        class="st4"
        d="M330.6,269.3l0.1,0.1l0.1-0.1c0,0-0.1,0-0.1-0.1C330.7,269.3,330.6,269.3,330.6,269.3z"
      />
      <path
        class="st4"
        d="M579.4,200.4c-0.7,0.1-1.3,0.1-2-0.1c-0.5,0.2-1,0.4-1.7,0.7c1.7,0.4,3.3,0,4.3,1.1c-0.3,0.8-0.3,1.2,0.1,1.3
		c0.2-0.1,0.4-0.2,0.7-0.3c-0.1-0.1-0.2-0.3-0.3-0.4c0.1-0.1,0.1-0.3,0.2-0.3c0.5-0.3,1.1-0.6,1.6-0.8c0.1,0,0.1-0.1,0.2-0.1
		c0-0.1,0.1-0.1,0.1-0.2v0.1c0.3-0.1,0.5-0.2,0.7-0.4c-1.4,0-2.8,0.1-4.2,0.1C579.2,201,579.3,200.7,579.4,200.4z"
      />
      <polygon class="st4" points="565.9,54.6 566.1,54.6 566,54.5 	" />
      <path
        class="st4"
        d="M587,196.5c-0.5-0.1-1.1-0.2-1.3,0.4c-0.5-0.3-1-0.6-1.5-0.9c-0.1,0.2-0.2,0.5-0.3,0.8
		c-0.1,0.7-0.4,1.3-0.9,1.8c0.1,0,0.3,0.1,0.4,0.1c0.2-0.3,0.6-0.6,1-0.8c0.5-0.2,1-0.2,1.5-0.1c0-0.2,0.1-0.5,0.1-0.7
		c0.8,0.8,1.6,0.9,2.5,0.6c-0.1-0.4,0-0.7,0.6-0.8c0.3-0.1,0.6-0.3,0.9-0.5c-0.5-0.1-0.9-0.2-1.5-0.3
		C588.3,196.6,587.7,196.7,587,196.5z"
      />
      <path
        class="st4"
        d="M603.1,203L603.1,203c0.1-0.2,0.2-0.4,0.3-0.6c-0.2,0.1-0.3,0.2-0.5,0.2C603,202.8,603,202.9,603.1,203z"
      />
      <path
        class="st4"
        d="M554.2,50.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.1,0-0.2C554.3,50.1,554.3,50.1,554.2,50.2z"
      />
      <path
        class="st4"
        d="M594.7,184.3c0.3-0.2,0.4-0.3,0.3-0.5c-0.2-0.1-0.3-0.2-0.5-0.3C594.3,183.8,594.2,184.1,594.7,184.3z"
      />
      <path
        class="st4"
        d="M324,269.6c0,0,0.1,0,0.1-0.1l0,0C324,269.5,324,269.5,324,269.6z"
      />
      <path
        class="st4"
        d="M588.6,197.7c0,0.1,0.1,0.1,0.1,0.2c0.2,0,0.3,0.1,0.5,0.2c0.3-0.2,0.5-0.4,0.8-0.6
		C589.3,197.1,589,197.4,588.6,197.7z"
      />
      <path
        class="st4"
        d="M324,267.9c0.1,0.4,0.2,0.7,0.2,1c0.3-0.2,0.5-0.3,0.7-0.4c0,0,0,0,0.1,0c0.1-0.1,0.1-0.1,0.2-0.2
		c0.2-0.2,0.4-0.4,0.6-0.7c-0.3,0.1-0.5,0.1-0.8,0.1C324.7,267.8,324.4,267.8,324,267.9z"
      />
      <path
        class="st4"
        d="M547.9,190.7C547.8,190.7,547.8,190.7,547.9,190.7c-0.1,0-0.2,0.1-0.2,0.2
		C547.8,190.8,547.8,190.8,547.9,190.7z"
      />
      <path
        class="st4"
        d="M335.4,249c0.2,0,0.4,0.1,0.6,0.1c-0.1-0.1-0.3-0.2-0.4-0.3C335.5,248.9,335.4,249,335.4,249z"
      />
      <path
        class="st4"
        d="M408.8,242.2v0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0-0.1c0.1,0.1,0.2,0.1,0.4,0.2c-0.2,0.1-0.3,0.3-0.5,0.4
		c0,0,0,0,0.1,0c0.6-0.1,1.2-0.2,1.7-0.3c-0.1-0.2-0.1-0.5-0.1-0.8C409.9,241.9,409.4,242,408.8,242.2z"
      />
      <path
        class="st4"
        d="M405.3,239.5c0,0.2,0.1,0.4,0.2,0.6c0,0.2,0.1,0.4,0.1,0.5c0.6-0.2,1.3-0.2,2,0.1c0.2,0.1,0.4,0.2,0.6,0.4
		c0.1-0.2,0.2-0.3,0.4-0.5c-0.7-0.5-1.4-1.1-2.2-1.5C406,238.8,405.3,239.1,405.3,239.5z"
      />
      <path
        class="st4"
        d="M451.6,60.1c0.4-0.1,0.8-0.1,1.3-0.2c-0.2-0.3-0.3-0.4-0.4-0.6l0,0c-0.4,0.2-0.8,0.3-1,0.7
		C451.5,60,451.5,60,451.6,60.1z"
      />
      <path
        class="st4"
        d="M387.7,241.9c0.4,0.3,0.7,0.5,1,0.7c0.1-0.2,0.3-0.4,0.4-0.6c-0.4,0-0.8,0-1.1-0.2
		C387.9,241.8,387.8,241.9,387.7,241.9z"
      />
      <path
        class="st4"
        d="M391.6,237.7c0.2,0.3,0.3,0.7,0.4,1.1c-0.5-0.2-0.6-0.3-0.8-0.4c-0.3,0.3-0.6,0.6-0.8,0.9
		c0.2,0.1,0.3,0.3,0.4,0.5c0.2-0.2,0.4-0.3,0.6-0.5c1.1,0.7,2.2,1.4,3.7,1.2c0,0.1,0.1,0.1,0.1,0.2c0.2-0.5,0.5-1,0.7-1.4
		c-0.6-0.2-1.4-0.4-1.9-0.7C393.3,238.6,392.5,238.3,391.6,237.7z M391.4,238.8L391.4,238.8L391.4,238.8L391.4,238.8z M392.9,240.1
		c-0.2-0.2-0.4-0.3-0.3-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.2,0.1,0.2,0.2S393,239.8,392.9,240.1z M394.3,240
		c0.1,0,0.2,0.1,0.2,0.1c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-0.2,0-0.2-0.1C394.2,240.2,394.3,240.1,394.3,240z"
      />
      <path
        class="st4"
        d="M396.1,229.7c-0.9,0.5-1.7,0.7-2.7,0.3c-0.2-0.1-0.5-0.1-0.8-0.1l0,0c0.3,0.2,0.7,0.4,1.2,0.7
		c-0.4,0.4-0.8,0.8-1.2,1c0,0.2,0,0.5,0,0.7c0.2,0.2,0.3,0.4,0.3,0.7c-0.1,0-0.2,0-0.2-0.1c0,0.3,0.2,0.7,0.5,0.9
		c0.8-0.7,1.8-1.2,3.1-1.3c-0.4-0.4-0.6-1.1-0.5-1.7C395.9,230.5,396,230.1,396.1,229.7C396.1,229.8,396.1,229.8,396.1,229.7
		C396.1,229.8,396.1,229.7,396.1,229.7z"
      />
      <path
        class="st4"
        d="M455.5,61.8c0.1-0.8,0.4-1.5,1.7-2c-2.3-0.2-2.7-0.5-2.9-1.9V58c0,0,0,0-0.1-0.1c-0.2,0-0.5,0-0.7,0
		c0.1-0.1,0.2-0.2,0.3-0.4c0.1,0.1,0.3,0.3,0.4,0.4c0,0,0,0,0.1,0c-0.1-0.9,0.9-1.7,0.7-2.5c-0.5,0.2-1,0.4-1.6,0.6
		c-0.7,1.3-0.3,2.3,0.7,3.4C454.7,60.1,455.2,61,455.5,61.8z"
      />
      <path
        class="st4"
        d="M548.6,180c-0.2-0.2-0.4-0.4-0.7-0.6c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.3-0.2
		c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.2-0.4-0.3-0.5-0.5c-0.3-0.5-1.1-0.7-1.3-0.5c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.5,0.4,0.7,0.6l0,0
		c0,0,0,0,0,0.1c0.5,0.4,1,0.8,1.5,1.2C548.1,180.1,548.4,180,548.6,180z"
      />
      <path
        class="st4"
        d="M486.3,207.2c0.1-0.1,0.1-0.1,0.2-0.2l0,0C486.4,207.1,486.4,207.2,486.3,207.2z"
      />
      <path
        class="st4"
        d="M456.8,74.8c0.3,0.8-0.1,1.3-0.8,1.8c0.2,0.5,0.3,1,0.4,1.5c0.4-0.2,0.8-0.3,1.2-0.4c0.9-0.2,1.8-0.1,2.7-0.2
		c0.1-0.8,0.3-1.5,0.4-2.3c-1.9-0.1-3.2-0.5-4.1-1.2C456.7,74.3,456.7,74.6,456.8,74.8z M459.5,77.2L459.5,77.2l-0.1,0.1L459.5,77.2
		z"
      />
      <path
        class="st4"
        d="M359.1,242c-0.1-0.1-0.1-0.1-0.2-0.2c-0.9,0.1-1.7,0-2.5-0.3c-0.1,0-0.1,0-0.2-0.1c0,0.2,0,0.3,0.1,0.5
		s0,0.4-0.3,0.7c0.1,0.1,0.1,0.3,0.2,0.4c0.4-0.2,0.7-0.5,1-0.6c0.8-0.3,1.5-0.4,2.1-0.2l0,0C359.2,242.2,359.1,242.1,359.1,242z"
      />
      <path
        class="st4"
        d="M359.1,236.8c0.2,0.1,0.5,0.1,0.7,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C359.4,236.7,359.2,236.8,359.1,236.8z"
      />
      <path
        class="st4"
        d="M347.8,241.4c-0.3,0.4-0.8,0.7-1.1,1.2C347.2,242.2,347.6,241.8,347.8,241.4z"
      />
      <path
        class="st4"
        d="M572.8,189.1c-1.6-0.3-3.5-0.3-4.6-1.5l0,0c0.1,0.4-0.1,0.8-0.3,1.1c0,0,0.1,0,0.1,0.1
		c0.4,0.3,0.6,0.8,0.8,1.2c0.1,0.6-0.2,1.1-1,1.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3,0.5-0.8,1-1.4,1.1c-0.6,0.1-1.2-0.3-1.3-0.9
		c0-0.1,0-0.2,0-0.4c-0.1-0.2-0.2-0.4-0.2-0.6c0.4-0.3,0.7-0.4,1.1-0.4c0.1-0.1,0.3-0.1,0.4-0.1c0.4,0,0.8,0,1.1,0.2
		c0.2-0.3,0-0.6-0.2-0.8h-0.1c-0.9,0.2-1.8-0.2-2.2-0.9c-0.2,0.2-0.3,0.3-0.5,0.6c0.1,0.2,0.3,0.5,0.5,0.8c-1.6,0.6-2.5,0-3.6-0.6
		c-0.4-0.1-0.6-0.4-0.4-0.9c0.4,0.1,0.6,0.2,0.7,0.5c0.5-0.4,0.9-0.9,1.8-0.8c0.1,0,0.4-0.4,0.6-0.7l0,0c0.3-0.1,0.6-0.2,0.9-0.3
		c0.2-0.4,0.6-0.7,1.2-0.9c0.2-0.5,0.3-1.1,0.4-1.7c-1,0-1.9,0-2.9,0H563c-0.1,0.1-0.3,0.2-0.4,0.3c0.1,0.1,0.3,0.2,0.4,0.4
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0.2-0.4,0.4-0.6,0.5l0,0
		c0.1,0.5,0.1,0.9,0.3,1.3c0.2,0.4-0.5,0.9-1.1,0.8c-0.4-0.1-0.9-0.3-1.2-0.5c-0.2-0.1-0.4-0.3-0.4-0.6c-0.1,0-0.2,0-0.2,0l0,0
		c-0.1,0.1-0.2,0.1-0.2,0.2c0-0.1-0.1-0.1-0.1-0.2c-0.6,0-1.2-0.1-1.7-0.4c-0.2,0.2-0.4,0.3-0.6,0.5c-0.1,0-0.2,0.1-0.2,0.1
		c0.2,0,0.5-0.1,0.9-0.1c-0.5,0.4-1.1,0.7-1.7,0.8v0.1c0,0.7-0.2,1.4-0.6,2c-0.1,0.1-0.2,0.2-0.3,0.3c0.5-0.1,1,0,1.6,0.3
		c0.7,0.3,1.5,0.4,2.5,0.6c-1,0.9-1.8,1.6-2.6,2.3c-2-0.2-2.7-0.7-3.1-1.9c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.1,0-0.2,0
		c-0.7-0.1-1.5-0.3-2.3-0.5c-0.3,0.2-0.7,0.2-1.2,0.2c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.7-0.4,1.4-0.6,2.1l0,0l0,0c0.1,0,0.2,0,0.3,0
		c0,0,0,0.1-0.1,0.1c0.3,0.1,0.6,0.3,0.9,0.4c0.1,0.5,0.2,0.9,0.3,1.5c0.9-0.3,1.7-0.3,2.4,0.1c0.1-0.7,0.7-0.9,1.9-1.2
		c0.2,0,0.4-0.1,0.5-0.1c1.3,0,2.6,0.1,3.9,0.1c0,0.1,0,0.2,0,0.3c-0.3,0-0.5,0-0.8,0.1l-0.1,0.1c0.4,0.1,0.9,0.2,1.3,0.2
		c0,0.1,0,0.1,0,0.2c-0.3,0-0.5,0.1-0.9,0.1c-0.2,0.3-0.4,0.6-0.6,0.9c-0.3,0.5-0.6,0.7-1.3,0.8s-1.4,0.3-2.1,0.5
		c-0.1-0.3-0.1-0.4-0.1-0.7c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.2,0.1,0.2c0.4,1.4-0.6,2.5-2.9,3.3c0.7,0.7,1.6,0.8,2.5,0.5
		c0.9-0.4,1.6-0.2,2.4,0c0.8,0.3,1.7,0.4,2.5,0.6c0.7,0.9,1,1.8,0.4,3.1c1.6-0.5,3-0.8,4.5-1.3c-0.1,1.4-0.1,1.4,1,1.6
		c0.3-0.5,0.7-1,0.9-1.5c0.1-0.3,0.2-0.8,0.1-0.9c-0.9-0.5-0.7-1.4-1-2.1c-0.2-0.3-0.4-0.6-0.6-0.9c-0.6,0.1-0.8,0.4-0.9,0.8
		c0.2,0.2,0.2,0.4,0.1,0.8c-0.3,0-0.5,0-0.6-0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.8-1-1.5-2-2.3-3.1c1.2-1.1,2.6-1.3,4-1.7
		c0-0.4,0.1-0.8,0.1-1.2c0.9-0.8,1.6,0,2.4,0.1c0.2,0-0.3,0.7,0.3,0.3c0.1-0.1,0.2-0.4,0.1-0.5c0-0.2-0.2-0.3,0-0.6
		c0.4,0.2,0.8,0.4,1.3,0.6c0.4-0.4,0.8-0.8,1.3-1.3c0.5,0.1,1.1,0.1,1.7,0.2c0.5-0.2,0.9-0.5,1.4-0.7c-0.1-0.2-0.1-0.5-0.1-0.8
		c0-1.5,1.5-2.2,2.4-3.3c0.2-0.3,0.6-0.5,0.9-0.7c0.1-0.1,0.1-0.2,0.2-0.2C573.6,189.5,573.5,189.2,572.8,189.1z M550.9,193.3
		c0,0.3-0.3,0.5-0.7,0.6c0.1-0.2,0.1-0.4,0.2-0.6l-0.1-0.1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.3,0.2-0.5
		C550.9,192.9,550.9,193.1,550.9,193.3c0-0.1,0.1-0.1,0.1-0.1S551,193.3,550.9,193.3z M551.4,195c-0.1-0.1-0.2-0.2-0.2-0.2
		s0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.1,0.1,0.2S551.4,194.9,551.4,195z M552.1,193.3L552.1,193.3l0.1-0.1L552.1,193.3z M555.4,198.6
		C555.4,198.7,555.4,198.7,555.4,198.6C555.4,198.7,555.4,198.7,555.4,198.6c-0.1,0.2-0.2,0.2-0.3,0.3c-0.1,0-0.1-0.1-0.2-0.1
		C555.1,198.8,555.2,198.8,555.4,198.6C555.4,198.7,555.4,198.7,555.4,198.6C555.4,198.7,555.4,198.7,555.4,198.6c0-0.1,0-0.1,0-0.2
		c0.1,0,0.1,0,0.2,0.1C555.6,198.5,555.5,198.6,555.4,198.6z M560.7,192.3c0,0,0,0.1,0.1,0.1l-0.1,0.1
		C560.7,192.4,560.6,192.4,560.7,192.3C560.6,192.3,560.6,192.2,560.7,192.3z M560.4,190.6l-0.1,0.1L560.4,190.6L560.4,190.6z
M559.4,189.1c0.1,0.1,0.2,0.1,0.2,0.2c-0.3,0.2-0.5,0.3-0.8,0.5c-0.1-0.1-0.1-0.1-0.2-0.2C558.9,189.4,559.2,189.2,559.4,189.1z
M557.3,192.6c0.9,0,1,0.5,1.2,1.2C557.6,193.6,557.2,193.3,557.3,192.6z M561,197.5c-1.9,0.2-2.4-0.1-2.9-1.6
		c0.9-0.5,1.7-0.4,2.5,0C561.2,196.3,561.6,196.8,561,197.5z"
      />
      <path
        class="st4"
        d="M311.9,271.9c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.1-0.3,0.2-0.4,0.2C311.9,271.8,311.9,271.9,311.9,271.9z"
      />
      <path
        class="st4"
        d="M385,227.4c0.1,0.5,0.1,0.9,0.2,1.4l0,0l0.1,0.1c0.3-0.3,0.6-0.5,0.8-0.6c-0.1-0.1-0.2-0.3-0.4-0.6
		C385.6,227.6,385.4,227.5,385,227.4z"
      />
      <path
        class="st4"
        d="M553.1,185.9c0.4-0.7,0.6-0.8,1.3-0.9c-0.1-0.2-0.3-0.4-0.4-0.7c-0.5,0.4-1,0.7-1.7,1.1
		C552.5,185.6,552.8,185.7,553.1,185.9z"
      />
      <path
        class="st4"
        d="M399.3,223c0.9,0.1,1.6,0.5,2,1.1c0.6-0.6,0.4-1.3-0.1-1.9c-0.8,0.2-1.7,0.2-2.3,0.8
		C399,223,399.1,223,399.3,223z"
      />
      <path
        class="st4"
        d="M314.8,268.3c-4-0.5-5-1.9-4-5.1c-1.8,0.2-3.2-0.1-3.9-1.4c-0.1-0.2-0.2-0.4-0.2-0.6c-0.1-0.3-0.1-0.6,0-0.9
		c0.1-0.5,0.5-1,1-1.4c1.3-1.1,2.8-1.2,4.4-0.7c-0.2-0.7-0.3-1.4-0.4-2c-0.7,0.2-1.3,0.4-1.9,0.5c-0.7,0.1-1.3,0.1-2,0.1
		c-0.3,0.3-0.6,0.6-0.8,0.8c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.3,0.3,0.3,0.5c0.1,0.5-0.3,1.1-0.8,1.3c-0.1,0.1-0.2,0.1-0.3,0.1
		c-0.1,0-0.2,0-0.3,0v-1.6v-0.6v-0.1v-1.5v-0.1c-0.1-0.3,0-0.6,0-0.8v-2.6v-0.1c-1.4,0.6-3.1,0.6-4.6,0c-2-0.8-3-2.6-2.7-4.4
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.1-0.2-0.2-0.2-0.3c0.2-0.1,0.4-0.2,0.5-0.3l0,0c0.1-0.5,0.3-0.9,0.6-1.4c-0.2,0-0.3-0.1-0.4-0.1
		c-0.1-0.4-0.2-0.5-0.3-0.9c-0.6,0.4-1.1,0.6-1.5,0.9c0.1,0.1,0.1,0.2,0.2,0.4c0.3,0.1,0.7,0.3,1.1,0.4c-0.4,0.4-0.7,0.6-1.1,0.7
		c-0.1,0.4-0.3,0.7-0.4,1.1c-0.2-0.3-0.2-0.6-0.3-0.9l0,0l0,0l0,0l0,0c-0.2-0.6-1-0.9-1.8-0.9c-0.1,0-0.1,0-0.1,0
		c-0.2,0.3-0.5,0.7-0.8,1c-0.4,0.4-0.5,0.8-0.5,1.3c0,0.4-0.1,0.7-0.2,1.1c0.4,0.3,0.8,0.6,1.2,0.9c0.2-0.1,0.3-0.1,0.5-0.1
		c1.1-0.2,2.2,0.4,2.4,1.3c0.1,0.5-0.1,1-0.5,1.5c0.4,0.3,0.9,0.4,1.4,0.6c1.1,0.3,1.8,0.8,1.7,1.7c0.9,0.4,1.6,0.7,2.3,1
		c0,0.2-0.1,0.4-0.2,0.5c0.4,0.2,0.7,0.4,0.7,0.7c0.1,0.6-0.5,1.2-1.2,1.4c-0.8,0.2-1.5-0.2-1.6-0.8c0-0.2,0-0.4,0.1-0.5
		c-0.1,0-0.1,0-0.2,0c-1,0.3-1.3,0.7-1,1.6c0.2,0.6,0.6,1.1,1.1,1.6s0.7,0.9,0.7,1.5c0,0.2,0,0.4,0,0.6c0,0,0,0,0.1-0.1
		c1.2-0.7,2.3-0.6,2.9,0.4c0.6,0.9,0.4,1.8-0.5,2.6c-0.4,0.4-0.9,0.7-0.6,1.3c0,0,0,0,0,0.1c1.4,0.1,2.7,0.1,3.7-1v0.7
		c0.1,0,0.3,0.1,0.4,0.1s0.1,0,0.2,0c0.4,0,1-0.2,1.3,0.4c0.1,0.2,1,0,1.6,0c0,0.3,0,0.6,0,0.9c0.3,0.4,1.4,0,0.9,0.9
		c0.6,0.5,1.2,1.1,1.8,1.6c0.6,0.3,0.9,0.4,1.1,0.6h2.9c-0.3-0.2-0.5-0.5-0.6-0.9C314.8,270.5,314.8,269.4,314.8,268.3z
M310.8,256.7c0.1,0.1,0.3,0.2,0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1-0.1-0.3-0.2-0.4-0.3C310.6,256.8,310.7,256.7,310.8,256.7z
M295.3,247.2c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.3c0.1,0,0.2,0.1,0.2,0.1C295.4,247,295.3,247.1,295.3,247.2z M297,249.8
		c0-0.2-0.1-0.3-0.1-0.5c0.1,0,0.1,0,0.2,0c0.1,0.2,0.1,0.3,0.2,0.5C297.1,249.7,297,249.8,297,249.8z M303.2,254
		c-0.1-0.5,0.4-1.2,1-1.3c0.7-0.1,1.4,0.2,1.5,0.8s-0.4,1.1-1.1,1.2C303.9,254.8,303.3,254.5,303.2,254z M306.2,266.6
		c-0.1-0.1-0.2-0.3-0.4-0.5c-0.4,0.3-1,0.6-1.5,0.2c-0.2-0.2-0.2-0.6-0.1-0.7c0.4-0.3,0.9-0.4,1.3-0.6c0.2-0.4,0.4-0.9,0.7-1.3
		V266.6z"
      />
      <path
        class="st4"
        d="M353.3,90c1.3-1,2.2-0.9,2.9,0.3c0.1,0.2,0.2,0.5,0.4,0.6c0.1-0.1,0.3-0.2,0.5-0.3c0.5-0.1,1.2,0.2,1.3,0.6
		c0.1,0.2,0,0.4-0.2,0.6c0.4,0.3,0.9,0.5,1.6,0.2c0.1,0.3,0.4,0.6,0.5,0.9c0.1-0.2,0.3-0.5,0.4-0.7c2.7-0.7,3.4-0.3,3.8,2.2
		c0.5,0.2,1.1,0.4,1.9,0.6c-0.3,0.2-0.5,0.4-0.7,0.6c0.2,0,0.4,0,0.6,0c0.4-0.4,0.9-0.7,1.5-0.8c0.4-0.1,0.8-0.1,1.2,0
		c0-0.2,0-0.3,0-0.5c0.7-0.3,1.5-0.7,2.5-1.1c-0.1-0.8,0-1.5,0.4-2.1c-0.1-0.2-0.1-0.4,0-0.6c0.2,0,0.4,0,0.5,0.1
		c0.2-0.2,0.5-0.4,0.8-0.6c0.8-0.5,1.3-1.4,2-2.2c0.5,0,1,0,1.5,0c0,0,0,0,0-0.1h-0.1c-0.8-0.2-1.2-1.1-0.9-1.8
		c-0.4-0.1-0.8-0.2-1.1-0.3c-0.6-0.1-1.3,0-2.2-0.1c1.1,1.5,0.2,3-0.2,4.4c-0.2,0.6-0.8,1.1-1.8,1.3c0-0.6-0.1-1.1-0.1-1.9
		c-0.8,0.2-1.4,0.4-2.1,0.7c-0.2-0.3-0.3-0.7-0.3-1c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.2l0,0l0,0v-0.1
		c-0.1,0-0.2-0.1-0.3-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0.1,0c0.1,0.1,0.3,0.1,0.4,0.2c0,0,0.1,0,0.1,0.1
		c0.1,0,0.3,0,0.4,0c-0.2-1.2,0.2-2.4,1.1-3.2c0.9-0.8,0.3-1.5,0.1-2.2c-1.4,0.2-2.5,0.6-3.1,1.8c-0.2,0.3-0.7,0.6-1.1,0.8
		c-1-0.1-1.8-0.4-2.4-1c-0.2,0-0.3,0-0.5,0c0-0.1,0-0.2,0-0.3c0.1,0,0.2,0,0.3,0c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.7-0.6-1-0.9
		c0.3-0.9,1.3-0.6,2-1c-0.1-0.6-0.3-1.2-0.4-1.9c-0.6,0.7-0.9,1.4-1.9,1.2c-0.1,0-0.4,0.2-0.4,0.3c-0.6,1.3-2.4,2-2.7,3.5
		c0,0.1,0,0.1-0.1,0.1c-1.5,0.4-1.9,2.2-3.7,2.2c0,0.4,0,0.7,0,1c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0.2-0.2,0.4-0.4,0.6
		c0,0.3,0.1,0.6,0.1,1C353.1,90.1,353.2,90.1,353.3,90z M365.8,93.3L365.8,93.3L365.8,93.3C365.8,93.3,365.9,93.3,365.8,93.3
		L365.8,93.3z M367.8,90.4c0.2,0.1,0.4,0.1,0.4,0.2s0,0.3-0.1,0.3c-0.2,0-0.3,0-0.4,0C367.7,90.8,367.8,90.7,367.8,90.4z
M365.4,90.8c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1-0.1-0.2-0.1-0.2-0.2C365.3,90.9,365.4,90.8,365.4,90.8z
M365.4,91.5c2.1-0.1,2.6,0.1,3.1,1.7c0,0,0,0,0,0.1c-0.1,0.1-0.1,0.1-0.2,0.1c-0.7,0.5-1.4,0.4-2.1,0
		C365.4,93,365,92.3,365.4,91.5z M360.5,87c0.9,0,1.4,0.4,1.9,1C360.8,88.6,360.4,88.5,360.5,87z"
      />
      <path
        class="st4"
        d="M605.6,199.7c-0.2-0.3,0-0.8,0-1.2c-0.5-0.3-1.3,0.6-1.5-0.2c-0.1-0.3,0.1-0.4,1.1-0.7c0-0.2-0.2-0.5-0.1-0.7
		c0.8-1.2,0.2-2-0.6-3c-1.1-1.4-1.3-3.3,0.5-4.6c0.2-0.1,0.4-0.3,0.5-0.4c-0.3-0.6-0.7-0.6-1.3-0.5c0,0,0,0.1-0.1,0.1
		c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0.1c-0.3-0.5-0.6-0.9-1.1-1.6c0,0.7,0,1.1,0,1.6c-0.6-0.4-0.9-0.9-1-1.5h-0.1
		c-0.9,0.2-1.8-0.3-2.1-1c-0.3,0.1-0.5,0.1-0.8,0.1c-0.7,0-1.4,0.6-2.4,1.1c0.6,0.2,0.9,0.4,1.2,0.5c-0.1,0.2-0.2,0.4-0.3,0.6
		c0.1,0.1,0.2,0.2,0.2,0.3c-0.1,0-0.1,0.1-0.2,0.1c0-0.1-0.1-0.2-0.1-0.3c-0.5,0.8-1,1.6,0.1,2.3c-0.4,0.6-0.9,1.2-1.3,1.7
		c-0.3,0.4-0.6,0.8-1,1.1c-0.9,0.7-1.3,1.5-0.8,2.4c0.3,0,0.5-0.2,0.8-0.4c-0.2-0.7,0.2-1.3,1.2-1.8c0.5,0.4,1,0.7,1.5,1
		c0.1-0.2,0.2-0.4,0.2-0.6c0.4,0,1,0.1,1.9,0.1c0,0.2,0.1,0.7,0.2,1.1c-0.7,0.1-1.3,0.1-1.5,0.3c-0.2,0.3-0.2,0.8,0,1.1
		c0.1,0.2,0.4,0.4,0.6,0.6h0.1v0.1c0.1,0.1,0.3,0.3,0.4,0.4c0.2,0.4-0.4,0.7-0.4,1.2c0.1,1.1,0.4,1.6,1.7,1.6h0.1
		c0.2-0.5,0.7-0.9,1.4-1c1-0.2,1.9,0.2,2.1,0.9c0.1,0.5-0.2,1.1-0.8,1.5c0.1,0,0.2,0,0.2,0c0,0.3-0.1,0.5-0.2,0.8l0,0
		c0.9,0.1,1.7,0.1,2.7,0.2C606,202.2,606.5,200.8,605.6,199.7z M597.6,188.3L597.6,188.3L597.6,188.3L597.6,188.3z M601.2,187.7
		c0.1,0,0.2,0.1,0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1s-0.2-0.1-0.3-0.1C601,187.8,601.1,187.7,601.2,187.7z M598.1,190
		c-0.1-0.1-0.2-0.2-0.2-0.3c0.1,0,0.2-0.1,0.3-0.1s0.2,0.1,0.2,0.2C598.2,189.9,598.2,190,598.1,190z M598.5,189.2
		c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.1,0.1,0.2C598.7,189.1,598.6,189.2,598.5,189.2z M599.4,188.1
		c0,0-0.2-0.1-0.2-0.2c0.2-0.2,0.4-0.5,0.6-0.7c0.2,0.1,0.3,0.2,0.5,0.3C599.9,187.7,599.7,187.9,599.4,188.1z M602.3,197.7
		c-0.4,0.1-0.8,0.2-1.4,0.3c-0.3-0.4-0.6-0.7-0.7-1c-0.3-0.7,0.3-1.5,1.2-1.8s1.9,0.1,2.2,0.8C603.8,196.6,603.3,197.4,602.3,197.7z
M603,191.6c-0.6,0.3-1.3,0.5-1.9,0.1c-0.3-0.2-0.5-0.6-0.8-0.9c0.4-0.9,1.1-1.2,2-1.2c0.7,0,1.2,0.3,1.4,0.9
		C603.8,191,603.5,191.4,603,191.6z"
      />
      <path
        class="st4"
        d="M586,72.9c1-0.3,1.2-1.3,2.5-1.8c-1.8-0.1-2.6-1-3.6-1.6c0,0.9,0.3,1.7,0.6,2.4c0.2-0.1,0.3-0.1,0.5-0.1
		c0,0.3-0.1,0.6-0.1,0.9C585.9,72.7,586,72.8,586,72.9z"
      />
      <path
        class="st4"
        d="M595.9,65.2c-0.1-0.4-0.1-0.8-0.2-1.2c-0.2,0.2-0.5,0.3-0.7,0.4c0.2,0.1,0.5,0.1,0.4,0.2
		C595,65.2,595.2,65.3,595.9,65.2z"
      />
      <path
        class="st4"
        d="M607.7,185c-2-0.8-3-2.6-2.7-4.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.1-0.2-0.2-0.2-0.3c0.2-0.1,0.4-0.2,0.5-0.3
		l0,0c0.1-0.5,0.3-0.9,0.6-1.4c-0.2,0-0.3-0.1-0.4-0.1c-0.1-0.4-0.2-0.5-0.3-0.9c-0.6,0.4-1.1,0.6-1.5,0.9c0.1,0.1,0.1,0.2,0.2,0.4
		c0.3,0.1,0.7,0.3,1.1,0.4c-0.4,0.4-0.7,0.6-1.1,0.7c-0.1,0.4-0.3,0.7-0.4,1.1c-0.2-0.3-0.2-0.6-0.3-0.9l0,0l0,0l0,0l0,0
		c-0.2-0.6-1-0.9-1.8-0.9c-0.1,0-0.1,0-0.1,0c-0.2,0.3-0.5,0.7-0.8,1c-0.4,0.4-0.5,0.8-0.5,1.3c0,0.4-0.1,0.7-0.2,1.1
		c0.4,0.3,0.8,0.6,1.2,0.9c0.2-0.1,0.3-0.1,0.5-0.1c1.1-0.2,2.2,0.4,2.4,1.3c0.1,0.5-0.1,1-0.5,1.5c0.4,0.3,0.9,0.4,1.4,0.6
		c1.1,0.3,1.8,0.8,1.7,1.7c0.9,0.4,1.6,0.7,2.3,1c0,0.2-0.1,0.4-0.2,0.5c0.4,0.2,0.7,0.4,0.7,0.7c0.1,0.6-0.5,1.2-1.2,1.4
		c-0.8,0.2-1.5-0.2-1.6-0.8c0-0.2,0-0.4,0.1-0.5c-0.1,0-0.1,0-0.2,0c-1,0.3-1.3,0.7-1,1.6c0.2,0.6,0.6,1.1,1.1,1.6s0.7,0.9,0.7,1.5
		c0,0.2,0,0.4,0,0.6c0,0,0,0,0.1-0.1c1.2-0.7,2.3-0.6,2.9,0.4c0.6,0.9,0.4,1.8-0.5,2.6c-0.4,0.4-0.9,0.6-0.6,1.3c0,0,0,0,0,0.1
		c1.3,0.1,2.5,0.1,3.5-0.8v-1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4,0.3-1,0.6-1.5,0.2c-0.2-0.2-0.2-0.6-0.1-0.7c0.4-0.3,0.9-0.4,1.3-0.6
		c0.1-0.3,0.3-0.6,0.5-0.9V185C610.7,185.5,609.2,185.5,607.7,185z M601.4,179.9c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.3
		c0.1,0,0.2,0.1,0.2,0.1C601.6,179.7,601.5,179.8,601.4,179.9z M603.1,182.5c0-0.2-0.1-0.3-0.1-0.5c0.1,0,0.1,0,0.2,0
		c0.1,0.2,0.1,0.3,0.2,0.5C603.3,182.4,603.2,182.5,603.1,182.5z M611.8,186.2c0.1,0.6-0.4,1.1-1.1,1.2c-0.6,0.1-1.2-0.2-1.4-0.7
		c-0.1-0.5,0.4-1.2,1-1.3C611,185.3,611.7,185.6,611.8,186.2z"
      />
      <path
        class="st4"
        d="M591.8,176.1c0.1,0.3,0.6,0.5,0.1,0.8c0.2,0.1,0.3,0.3,0.5,0.4c0.2-0.5,0.5-0.9,0.9-1.4l0.1-0.1
		c-0.2-0.4-0.5-0.8-0.8-1.2C591.5,175.1,591.6,175.6,591.8,176.1z"
      />
      <path
        class="st4"
        d="M562.7,182.2c0.1-0.1,0.2-0.3,0.4-0.4c0.1,0.2,0.2,0.3,0.2,0.4c0.2-0.1,0.4-0.3,0.5-0.4
		c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0.1-0.2,0.2-0.3,0.3c-1-0.9-2.1-1.3-3.4-1.2c0.8,0.3,1.4,0.8,1.9,1.3
		C562.1,181.7,562.4,181.9,562.7,182.2z"
      />
      <path
        class="st4"
        d="M590.4,195.5c0,0.3-0.1,0.6-0.1,0.9c0.3,0.1,0.6,0.3,0.8,0.4c-0.2,0.1-0.4,0.1-0.6,0.2c0,0.1,0.1,0.1,0.1,0.2
		c0.2-0.1,0.4-0.3,0.6-0.4c0.5,0,1-0.3,0.8-0.6C591.6,195.8,591.4,195.1,590.4,195.5z"
      />
      <path
        class="st4"
        d="M611.7,168.7c-0.6-0.2-0.6-0.6-0.7-1.1c0-0.1-0.1-0.3-0.1-0.4c0,0,0,0-0.1,0c-0.3-0.1-0.5-0.2-0.7-0.4
		c-0.3,0.1-0.5,0.3-0.8,0.5c-0.1,0.1,0,0.3,0,0.5c0-0.1,0.1-0.1,0.1-0.2c0.1,0.2,0.3,0.3,0.3,0.4c0,0.1-0.1,0.2-0.2,0.2h-0.1
		c0.1,0.3,0.1,0.7-0.3,1c-0.2-0.2-0.3-0.4-0.6-0.6c-0.1,0.3-0.2,0.6-0.4,1c1.1,0.4,1.9,1,2.4,1.9c0.1,0,0.2,0,0.3,0.1
		c0,0.1-0.1,0.2-0.1,0.2h-0.1c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0.1,0.3,0.2,0.5c0.3,0.1,0.5,0.2,0.8,0.3c0,1.4-0.3,2.1-1,2.2
		c-0.1,0.2-0.1,0.3-0.3,0.5c-0.2,0.3-0.4,0.6-0.7,0.8c0.8,0.1,1.6,0.2,2.4,0.4v-2.7c-0.1,0-0.2,0-0.3,0c0.1-0.3,0.1-0.7,0.2-1.1
		c0,0,0,0,0.1,0v-3.6c0,0,0-0.1-0.1-0.1C611.9,169.1,611.9,168.7,611.7,168.7z M610.6,167.1L610.6,167.1l-0.1,0.1L610.6,167.1z
M610.1,168.9c-0.6-0.4-0.5-0.9,0-1.4H610h0.2l0,0c0.6,0.1,1,0.4,1,0.9c0,0.2-0.1,0.4-0.3,0.5C610.6,169,610.3,169,610.1,168.9z
M611.2,170.6L611.2,170.6c0,0.1,0,0.1-0.1,0.1c0,0.2-0.1,0.4-0.1,0.5c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.3-0.3,0.4-0.4
		C611.1,170.7,611.1,170.6,611.2,170.6C611.1,170.6,611.2,170.6,611.2,170.6c0-0.3,0-0.6,0-0.9C611.7,170,611.6,170.3,611.2,170.6z"
      />
      <path
        class="st4"
        d="M612.1,59.2c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.1,0.2-0.1,0.4c0.1,0,0.3-0.1,0.4-0.2C612,59.4,612,59.2,612.1,59.2
		z"
      />
      <path
        class="st4"
        d="M570.2,36.1c0.1,0,0.2-0.1,0.3-0.1c-0.2-0.2-0.3-0.4-0.5-0.6C570.1,35.7,570.2,35.9,570.2,36.1z"
      />
      <path
        class="st4"
        d="M506.1,42.8c-0.3,0.4-0.6,0.7-1,1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.2-0.1,0.3-0.2,0.5
		c-0.2,0.4-0.5,0.8-0.7,1.2C505.6,45.2,506.2,44.5,506.1,42.8z"
      />
      <path
        class="st4"
        d="M419,80.4c0.6-0.1,1.2,0.1,1.6,0.5c0.2-0.2,0.3-0.3,0.5-0.5c0.3-0.2,0.5-0.3,0.8-0.5c0-0.1,0-0.3-0.1-0.4
		c-0.1-0.3-0.2-0.6-0.3-0.8c-0.3-0.3-0.5-0.5-0.6-0.6c-0.7,0.9-1.8,1.6-3.3,1.4c-0.6-0.1-1.2-0.4-1.6-0.8c-0.1,0.2-0.3,0.5-0.5,0.8
		c-0.3-0.2-0.6-0.4-0.6-0.5c0.1-0.3,0.4-0.5,0.6-0.7c0.1,0.1,0.2,0.1,0.4,0.2l0,0l0,0c-0.2-0.3-0.3-0.5-0.3-0.8v-0.1
		c-0.5,0.4-1.3,0.7-2,0.5c-1.1-0.2-2.1-1.1-1.6-1.9c0.6-1.1,0.1-2-0.4-3c1.6,0,1.6,0,2.3,1.2c0.2,0,0.3,0.1,0.5,0.1
		c0.2-0.1,0.4-0.2,0.6-0.2c0.9-0.2,1.7,0.3,2,1c0.2-0.2,0.5-0.3,0.8-0.5c-0.4-0.8-0.6-1.6-0.5-2.6c-0.2,0.2-0.4,0.3-0.8,0.4
		c-0.8,0.2-1.5-0.1-1.6-0.8c-0.1-0.6,0.3-1.1,1-1.3c0.7-0.2,1.3,0,1.6,0.6c0.1-0.5,0.3-1.1,0.5-1.8c-0.2-0.2-0.4-0.4-0.6-0.7
		c-0.1-0.2-0.2-0.3-0.3-0.5c-0.3,0.1-0.6,0.2-0.9,0.2c-0.5,0-1.1-0.1-1.8-0.1c-0.3,0.6-0.8,1.3-1.9,1.2c-0.6-0.1-0.9-0.5-0.9-1
		c-0.1-1.1,1.1-1.1,2-1.5c-0.3-0.3-0.5-0.4-0.8-0.6h-0.1c-0.2,0-0.3,0-0.5,0c0.2,0,0.3,0,0.5,0c0,0,0,0,0.1,0.1
		c0.6,0,0.6-0.5,0.8-0.9c0.5-0.9,1.4-1.5,2.6-1.6c0.8,0,1.4,0.2,1.9,0.6c0.1-0.1,0.2-0.2,0.3-0.3c0.9-0.6,2-0.7,3-0.5
		c0-0.2,0-0.4,0-0.6c-1.4,0-2.7-0.1-3.4-1.2c-0.6,1.2-2.1,2-3.6,1.8c-0.2,0-0.4,0-0.5-0.1c-1.2-0.7-2.1-0.6-3.1,0.6
		c-0.3,0.3-0.9,0.3-1.6,0.4c0.1,0.3,0.2,0.6,0.1,1c-0.1,0.1-0.2,0.1-0.4,0.2v0.1c0,0.4-0.4,0.8-0.7,1.2c0.4,0.4,0.9,0.8,1.3,1.3
		c0.1,0.1,0,0.3-0.1,0.5c1,0.1,1.9,0.7,2.1,1.6c0.1,0.4,0,0.8-0.1,1.2c0.4,0.1,0.6,0.3,0.6,0.7c0,0.5-0.3,0.7-0.9,0.8
		c-0.4,0.1-0.7-0.1-0.9-0.3c-0.3,0.1-0.5,0.3-0.8,0.3c-1.4,0.4-2.9-0.3-3.2-1.5c-0.2-0.5,0-1.1,0.3-1.6c-0.5,0.1-1,0.2-1.5,0.4
		c0.5,0.4,0.9,0.9,1.1,1.6c-0.4,0.3-0.7,0.7-1.1,1c0.6,0.9,1.6,1.7,0.3,2.9c-0.3-0.2-0.5-0.3-0.7-0.5c0,0.3,0,0.6-0.1,1
		c-0.4,1-1.4,1.6-2.7,1.7c0.3,0.9,0.2,1.7-0.6,2.7c-0.1-0.5-0.2-0.8-0.2-1.2c-0.1-0.5-0.1-1-0.2-1.6c-0.2,0-0.4,0-0.6,0
		c-0.1,0-0.2,0.1-0.3,0.1c-0.2-0.7-0.5-1.2-0.6-1.8c0-0.1,0-0.2,0-0.3c-0.2-0.1-0.4-0.2-0.5-0.4c-0.3-0.5-0.9-0.5-1.5-0.6
		c-0.7-0.1-1.3-0.4-1.7-0.7c-0.8,0.4-1.7,0.4-2.9-0.1c-0.7,0.6-1.5,1.3-2.6,0.8s-1-1.3-0.7-2.3c-1.4-0.5-1-1.5-0.6-2.5
		c-0.6,0-1.1,0-1.6-0.1c-0.5-0.2-0.9-0.1-1.4,0c-0.9,0.3-1.7-0.1-2-0.6c-0.3-0.6-0.1-1.2,0.6-1.9c0.4-0.3,1.2-0.5,0.7-1.3
		c-1.7-0.5-1.5,1.4-2.9,1.5c0.3,0.4,0.5,0.7,0.8,1.2c-0.8-0.1-1.4-0.2-2.1-0.3c-0.1,0.3-0.1,0.6-0.2,1c-0.6-0.2-1.1-0.4-1.7-0.6
		c-0.2,0.2-0.4,0.4-0.6,0.7c-0.5-0.2-0.8-0.6-1.5-0.4c-0.6,0.1-0.9,0.1-1.4-0.3c-0.1,0.4-0.2,0.8-0.4,1.1c-0.1,0.2-0.3,0.4-0.4,0.6
		c0.1-0.1,0.2-0.1,0.4-0.2c0.6,0.4,1.2,0.8,1.8,1.1c0.6-0.1,1.3,0.1,1.7,0.6c0.5,0.5,0.4,1.3-0.2,1.8c-0.2,0.2-0.3,0.3-0.5,0.4v0.1
		c0.6-0.2,1.2-0.2,1.5-0.5c0.6-0.5,2-0.3,1.9-1.6c0.6,0.1,1.1,0.3,0.6,0.8c-0.6,0.6-0.6,1.1,0,1.7c0.3,0.3,0.4,0.8,0.5,1.3
		c-0.2,0.4-0.4,0.8-0.7,1.2c0.7-0.4,1.5-0.6,2.4-0.2c0.3,0.7,0.7,1.4,1,2.2c1.3-0.4,1.6-2.3,3.7-1.9c-0.1,0.3-0.3,0.6-0.4,0.9
		c-0.1,0.4-0.1,0.9,0.5,1c1.4,0.1,1.3,1,1.4,1.9c-1.2,0-1.6,0.7-1.8,1.6c0.5,0.3,1,0.7,1.6,1.2c-0.2,0.3-0.5,0.5-1.1,1.1
		c1.4-0.1,2.6,0.7,3.5-0.5c0,0.5,0.5,0.6,1,0.7c0.4,0.8,1-0.1,1.6,0.1c0.4,0.3,0.9,0.7,1.4,1.1c0.3-0.2,0.7-0.4,1-0.6
		c0.1-0.5,0.5-1,1-1.3c0.3-0.2,0.6-0.3,0.9-0.4c1.3-0.3,2.4,0.4,2.6,1.5c0,0.2,0,0.4,0,0.6c0.2,0.2,0.4,0.4,0.7,0.6
		c-0.4,0.6-0.9,0.6-1.3,0.5c-0.2,0.2-0.5,0.4-0.9,0.5c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0,0.5,0.1,0.8,0.1l0,0l0,0c0.2,0,0.5,0.1,0.8,0.1
		c-0.3,0.1-0.5,0.2-0.7,0.3l0,0c0,0,0,0-0.1,0c-0.4,0.2-0.8,0.3-1.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.3c0.2,0.4,0.4,0.8,0.6,1.3
		c-0.8,0-1.4,0-2,0c0,0.3,0,0.6,0.1,0.9c-0.9-0.1-1.8-0.3-2.8-0.4h0.1c0,0,0,0.1-0.1,0.1v-0.1c-0.4-0.1-0.9-0.4-1-0.3
		c-0.4,0.2-0.8,0.3-1.3,0.3c0.2,0.1,0.3,0.2,0.5,0.3c-0.7,0.3-1.1,0.1-1.4-0.2c-0.3,0.1-0.6,0.2-0.8,0.5c-0.6-0.6-1.1-1-0.7-2
		c-2,0.7-2.3-0.4-2.9-1.5c-0.5,0.3-0.8,0.6-1.3,0.9c-0.4,0-1-0.1-1.5-0.2c-0.2,0.3-0.4,0.6-0.7,1c-0.1-0.4-0.2-0.5-0.3-0.7
		c-0.2-0.8-0.5-1-1.3-0.8c-0.5,0.2-0.9,0.3-1.3-0.1s-1-0.8-0.6-1.5c0.1-0.1,0-0.3,0-0.7c-0.7,0.3-1.3,0.7-1.8,0.8
		c-0.5,0.1-1-0.1-1.8-0.2c-0.1,0-0.1,0-0.2,0l0.1,0.1l0.1-0.1c0.1,0,0.1,0.1,0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1
		c0.2,0.2,0.3,0.3,0.4,0.4c1,0.7,1.3,1.6,0.9,2.7s-1.3,1.8-2.7,2c-0.6,0.1-1.3,0.4-2,0.6c0.2,0.4,0.4,0.7,0.6,1c0.5,1,0.3,2-0.5,2.9
		c0,0.1,0,0.1,0.1,0.2c-0.2,0.1-0.3,0.2-0.5,0.2c-0.8,0.6-1.8,0.8-2.9,0.6c-0.3-0.1-0.5-0.2-0.7-0.3c-0.4,0.6-1,1-1.7,1.2
		c-1.5,0.3-2.9-0.5-3.1-1.7l0,0c-0.4-0.1-0.8-0.3-1-0.6c-0.1-0.2-0.2-0.3-0.4-0.6c0.3-0.2,0.5-0.3,0.7-0.4c-0.5,0-1,0-1.5,0
		c0.6,0.2,1.1,0.7,1.3,1.5c0.3,0.9-0.3,1.9-1.3,2.5c-0.4,0.2-0.8,0.4-1.1,0.4c-0.5,0.9-1.5,1.5-2.1,2.4c-0.2,0.3-0.6,0.5-0.9,0.8
		c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0.4,0.2,0.7,0.9,0.8c0.4,0.1,0.9,0.2,1.3,0.2v-0.1h0.1h-0.1c0.4,0.1,0.8,0.2,1.2,0.3
		c0.3,0.1,0.5,0.2,0.7,0.2c0.4,0.2,0.8,0.4,1.1,0.7c0.1,0.1,0.1,0.1,0.2,0.2s0.2,0.2,0.3,0.2c0.3,0.1,0.7-0.1,1.1-0.4
		s0.9-0.7,1.4-0.7l0,0h0.1c0.1-0.6,0.5-1.1,1.1-1.5c-0.1-0.1-0.1-0.2-0.2-0.3c0.3-0.1,0.7-0.2,1-0.2c0.2,0,0.4,0,0.6,0
		c1.3-0.1,2.5,0.6,2.8,1.7c0.1,0.2,0,0.5,0,0.7c0.4,0.1,0.8,0.3,1.1,0.5c0.3,0.2,0.8,0.6,0.1,1v0.2c0,0.1,0.1,0.1,0.1,0.1
		c0.9-1,1.9-1.3,3.1-0.9l0,0c0.2-0.2,0.6-0.2,1-0.4c0.4,0.2,0.8,0.5,1.2,0.7c0.2,0.1,0.3,0.2,0.5,0.3c-0.5,1.1-0.7,1.4-1.3,1.5
		c0,0.4-0.2,0.7-0.4,1c-0.7,0.9-1.7,1.2-3,0.9c0,0.1,0,0.2,0,0.3c-0.1,0.9-0.6,1.5-1.6,1.9c-0.8-0.4-1.3-0.8-1.5-1.2
		c-0.2,0.2-0.4,0.4-0.6,0.7c-0.4-0.6-0.7-0.9-0.9-1.2c-0.2,0.1-0.4,0.2-0.6,0.2c0,0.2-0.2,0.4-0.4,0.6c-0.1-0.2-0.1-0.3-0.2-0.4
		h-0.1c-0.7,0.5-1.1,1.1-1.1,2c0.5-0.4,0.9-0.8,1.3-1.2c0.2,0.2,0.4,0.3,0.6,0.4c0.2,0.2,0.5,0.4,0.7,0.5c0.7-0.6,1.8-0.7,2.7-0.2
		c0.6,0.4,0.8,1,0.6,1.6c0,0.1,0.1,0.1,0.1,0.2c0.3,0.5,0.6,1,1,1.4c0.3-0.4,0.7-0.7,0.8-1.2c0-0.1,0.7-0.2,0.9-0.2
		c0.1,0,0.2,0.1,0.3,0.3c0.1-0.1,0.3-0.3,0.4-0.4c-0.8,0.1-1.3,0.2-1.8,0.2c-0.1-0.2-0.1-0.5-0.2-0.7c0-0.2-0.1-0.4-0.1-0.6
		c1,0.3,1.3-0.3,1.8-0.8c0.4-0.4,0.9-0.7,1.4-0.7c0.2,0,0.4,0,0.5,0s0.3,0,0.4,0.1c0-0.1,0-0.2,0-0.3c-0.3-0.2-0.5-0.4-0.8-1
		c-0.4,0-0.8,0.1-1.4,0.2c1.1-0.9,2.3-0.9,3.4-1.2c0.2,0,0.4,0,0.6,0.2c0,0,0,0,0.1,0h0.1c-0.1-0.1-0.2-0.1-0.3-0.1
		c0.3,0,0.5-0.1,0.8-0.1c0.2,0,0.4,0.1,0.6,0.2l0,0c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0.1,0,0.2c0,0,0,0-0.1,0c0,0,0,0.1-0.1,0.1
		c0.8,0.1,1.5,0.7,1.6,1.5c0.2,1-0.4,1.8-1.4,2.2c0.2,0.1,0.7-0.2,0.9,0.1c0.5,0.6,1.4,1.1,1.8,1.8c0.3,0.5,1,0.7,1.2,0.6
		c-0.1-0.1-0.2-0.3-0.3-0.5c0-0.1,0-0.2,0-0.3c-0.1,0-0.2,0.1-0.2,0.1c-0.2-0.8-0.2-1.5,0.5-1.9c0.4-0.3,0.7-0.4,0.8-0.9
		c0-0.3,0.3-0.5,0.5-0.7c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.4-0.5-0.5-0.6c-0.1-0.6,0-1.1,0.7-1.4c0.6-0.3,1.1-0.1,1.4,0.2
		c0.1,0.1,0.3,0.3,0.4,0.4c0.5,0.6,0.4,1-0.1,1.4c0.2,0,0.4,0.1,0.6,0.2c0.3-0.6,0.5-0.9,0.9-1.1c-0.1-0.6,0.5-1.4,1.3-1.7
		c0,0,0,0,0,0.1c0.3-0.1,0.5-0.1,0.7,0.1c0.2-0.3,0.3-0.6,0.4-0.8c0.1,0.1,0.2,0.2,0.3,0.3c0.4-0.4,0.9-0.7,1.2-1.2
		c-0.2,0.1-0.4,0.1-0.6,0.2c-0.6,0.3-1.5,0.7-1.9,0.5c-0.3-0.2-0.7-0.2-1-0.2c0,0,0,0,0.1,0c0.2,0.2,0.4,0.6,0.2,0.9
		c-0.2,0.4-0.6,0.8-0.9,1.1c-0.8,0-1.5-0.2-1.3-0.8c0.1-0.4,0.5-0.8,0.9-1.2c-0.2,0-0.4,0-0.6,0c0-0.1-0.1-0.1-0.1-0.2
		c-0.5,0.8-1.5,1.5-2.7,1.7c-2.1,0.4-3.9-0.7-4.2-2.5c-0.1-0.5,0-0.9,0-1.5c-0.4,0.2-0.7,0.3-1,0.4c-1.6,0.5-3,0.3-4-0.7
		c-0.5-0.5-0.9-0.7-1.6-0.8c-1-0.2-1.1-0.8-0.3-1.5c0.2-0.2,0.4-0.3,0.5-0.5c-0.3-0.1-0.7-0.1-1.1-0.2c0,0,0,0-0.1,0
		c1-0.9,1.8-1.6,2.6-2.4c0.2,0,0.4,0.1,0.6,0.1c0,0,0,0-0.1,0c0.1,0,0.1-0.1,0.2-0.1l0,0h0.1c0.1-0.1,0.1-0.2,0.2-0.2
		s0.1,0.1,0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1l0,0l0,0c0,0.1,0,0.1,0,0.2c0.2,0,0.4,0.1,0.6,0.2c0.1-0.1,0.3-0.1,0.5-0.1
		c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c-0.3-0.8-0.6-1.6,0-2.5c0.5-0.7,0.6-0.7,1.4,0c0.4-0.6,0.8-1.2,1.2-1.9c0.4-0.1,1-0.3,1.5-0.4
		c1.7-0.3,2.9,0.2,3.6,1.4c0.4,0.8,0.2,1.8-0.4,2.6c0.1,0.1,0.2,0.3,0.3,0.4c-0.1-0.5,0.6-0.9,1.3-0.8c0.3,0,0.6,0.1,0.9,0.3
		l0.1-0.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0.1,0c0,0,0,0,0.1,0.1h0.1h-0.1l0,0h-0.1c0,0,0,0,0-0.1c-0.1,0-0.1,0-0.2,0
		c0.5,0.2,0.9,0.5,1.3,0.6c0.7,0.2,1.2,0.6,1.5,1.1c0.2,0.2,0.4,0.4,0.8,0.7c0.4-0.5,0.7-0.9,1-1.3l0,0l0,0c0.1-0.2,0.2-0.3,0.4-0.5
		c-0.5-0.1-0.8-0.1-1.1-0.1c-1.5-0.2-1.8-0.5-1.7-1.7c0-0.4,0.3-0.9,0.3-1.3c0-0.2-0.2-0.5-0.4-0.8c-0.2,0.4-0.3,0.6-0.4,0.7
		c-1,0.4-0.8-0.5-1.4-0.7c-0.3,0.1-0.6,0.3-1,0.4c-0.2-0.4-0.5-0.7-0.4-1c0.1-0.6-0.3-1-0.9-1.1c-1.2-0.2-1.5-0.9-1.8-1.8
		c0.4,0,0.9,0,1.2,0.1c0.6,0.4,1.2,0.8,2.2,0.5c0.5-0.1,1.3,0.8,1.1,1.3c-0.3,0.2-0.6,0.4-0.9,0.6c0.2,0.2,0.4,0.4,0.7,0.8
		c0.5-0.6,1.1-1,2-0.7c0.2,0.1,0.7-0.3,0.9-0.5c-0.1-0.4-0.2-0.8-0.2-1.1l0.1-0.1c1,0.2,1.4,0.3,1.5,0.9c0.3,1,1,1.4,2.2,1.1
		c0.1,0.2,0.2,0.4,0.3,0.5c0.2-0.2,0.5-0.4,0.9-0.5c0.4,0,0.7,0.1,0.9,0.3c0.4-0.2,0.8-0.3,1-0.5c0.2-0.1,0.2-0.4,0.3-0.6l0,0l0,0
		c-0.3,0.1-0.6,0.2-1.1,0.4c0.2-0.3,0.3-0.5,0.5-0.8c-0.4,0-0.8,0-1.3,0c0.1-0.4,0.2-0.8,0.2-1.1c0-0.3-0.1-0.6,0-0.9
		c0.9,0.6,1.5,1.4,1.7,2.3c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0.5-0.2,1-0.4,1.6-0.7c0.5,0.5,1,1,1.4,1.5l0,0c0-0.1-0.1-0.2-0.1-0.2
		c-0.1-0.7,0.4-1.5,0.6-2.5c-0.7-0.8-0.9-1.3-0.4-2c-0.4-0.3-0.7-0.7-0.4-1.3c0.1-0.3-0.3-0.7-0.4-1c-0.2-0.6,0.3-1,1.1-1
		c1.6,0.2,1.6,0.2,2.3,1.4c-0.2,0.3-0.3,0.6-0.5,1c0.2,0,0.3,0.1,0.5,0.1s0.4,0.1,0.5,0.1c0.9-1.4,2-0.7,3.1-0.6c0.1,0,0.3,0,0.4,0
		c-0.1-0.3-0.3-0.5-0.2-0.7c0.2-0.3,0.3-0.6,0.4-0.9c-0.7-0.4-0.8-1-0.7-1.7c0.4,0.1,0.7,0.2,0.9,0.3c0-0.1,0-0.1,0-0.2
		c0-0.6,0.5-1,1.3-1.2c0.7-0.2,1.4-0.1,1.8,0.4c0.3,0.3,0.6,0.7,0.8,1.1c1.2,0.1,2.4-0.1,3.6,0c0.6,0,1.2,0.1,1.8,0.2
		c0.2,0.1,0.6-0.1,0.9-0.1c0.5-0.1,0.9-0.3,1.2-0.6c-1-0.4-1.8-1-2.1-2.2c-0.1-0.2-0.1-0.5-0.1-0.7h-0.1c-1,0.1-1.8-0.3-1.9-1.2
		C417.4,81.4,418.1,80.6,419,80.4z M410.7,64.3c0.9,0,0.9,0.4,0.7,1.2C411.1,65,410.9,64.7,410.7,64.3z M382,74
		c-0.1-0.1-0.1-0.1-0.2-0.2l0.1-0.1c0,0,0.1,0,0.1,0.1C382.1,73.8,382.1,73.9,382,74z M384.7,75.5c0,0-0.1,0-0.1-0.1
		c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0.1,0.2,0.1C384.9,75.4,384.8,75.4,384.7,75.5z M389.3,74.5c0.1,0.1,0.2,0.2,0.3,0.3l-0.2,0.2
		c-0.1-0.1-0.3-0.1-0.4-0.2C389.1,74.7,389.2,74.6,389.3,74.5z M389,76.5c-0.1-0.1-0.1-0.1-0.2-0.2c0.1,0,0.2-0.1,0.3-0.1l0.1,0.1
		C389.1,76.4,389,76.4,389,76.5z M389.5,77.1c-0.1,0-0.2,0-0.3,0l0.1-0.1c0.1,0,0.2,0,0.3,0C389.6,77.1,389.5,77.1,389.5,77.1z
M392.3,76.4c0.5-0.1,1.1,0.2,1.2,0.6s-0.4,1.1-0.9,1c-0.4,0-0.9-0.3-1.1-0.6C391.2,77.1,391.7,76.5,392.3,76.4z M393.3,78.6
		c-0.4,0.7-0.8,0.9-1.4,0.6C392.1,78.6,392.5,78.4,393.3,78.6z M393,83.5c0,0.5-0.5,1-1.2,1.2c-0.5,0.1-1-0.1-1.3-0.3
		c-0.2-0.1-0.3-0.3-0.3-0.5c-0.1-0.6,0.5-1.2,1.2-1.4c0.8-0.1,1.5,0.2,1.6,0.8C393,83.4,393,83.5,393,83.5z M395,82.6
		C395,82.6,394.9,82.6,395,82.6C394.9,82.6,394.9,82.6,395,82.6c-0.3-0.1-0.5-0.2-0.6-0.3c-0.4-0.2-0.7-0.5-0.9-0.9
		c-0.2,0-0.3,0-0.4-0.1c-0.4-0.2-0.7-0.6-1.1-0.8c0.2-0.7,0.7-0.9,1.3-0.8c0-0.1,0.1-0.1,0.1-0.2c0.3-0.4,0.9-0.7,1.5-1.1
		c1.5,1.1,0.9,2.7,1.6,3.9C396,82.7,395.5,82.7,395,82.6z M366.9,103.2c-0.3-0.1-0.5-0.3-0.8-0.4c-0.6,0.6-0.4,0.9,0,1.3
		c0.2,0.2,0.5,0.5,0.5,0.8v0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.4,0.1-0.8,0.1-1.2,0c-0.2-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.3-0.4-0.5
		c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.2,0-0.4,0-0.6c0.1-0.2,0.2-0.4,0.4-0.6c0.1-0.1,0.3-0.2,0.5-0.2c0.4-0.1,0.8-0.2,1-0.6
		c0-0.1,0.6-0.2,0.8-0.2c0.2,0,0.5,0.1,0.7,0.2c0.3,0.1,0.5,0.3,0.6,0.4c0.2,0.2,0.3,0.5,0.4,0.9
		C367.8,103.5,367.3,103.4,366.9,103.2z M368.8,100.4c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0,0.2,0.1,0.3,0.2
		C369,100.3,368.9,100.3,368.8,100.4z M372.3,103.1l0.1-0.1v0.1H372.3z M375.8,111.2c0.1,0.1,0.2,0.2,0.2,0.3c0,0-0.2,0.1-0.3,0.2
		c-0.1-0.1-0.1-0.2-0.2-0.2C375.6,111.3,375.7,111.3,375.8,111.2z M375.3,113.2c0.4-0.2,0.6-0.2,0.7-0.3c0,0.1,0,0.1,0,0.2
		C375.9,113.2,375.7,113.2,375.3,113.2z M376.5,112C376.5,112,376.4,112,376.5,112c-0.1-0.1,0-0.1,0-0.2
		C376.6,111.9,376.6,111.9,376.5,112C376.6,112,376.6,112,376.5,112z M385.6,111.9l0.1,0.2c-0.2,0.6-0.7,0.2-1.1,0.1
		C384.9,112.1,385.3,112,385.6,111.9z M384.4,113.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1l0.1,0.1C384.4,113,384.4,113,384.4,113.1z
M384,109.6c0,0,0.1,0,0.1,0.1l-0.1,0.1c0,0-0.1,0-0.1-0.1S384,109.6,384,109.6z M384.3,110.4C384.3,110.4,384.3,110.5,384.3,110.4
		c-0.2,0.1-0.3,0.2-0.5,0.2c0-0.1,0-0.1,0-0.2C383.9,110.4,384.1,110.4,384.3,110.4z M382.1,106.6c0.1,0,0.2,0.1,0.2,0.1
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.1-0.2-0.1-0.2-0.2C381.9,106.7,382,106.6,382.1,106.6z M376.5,105.9c-0.9,0-1-0.5-1.2-1.2
		C376.2,104.9,376.5,105.3,376.5,105.9z M381.8,90.5l-0.1-0.1l0.1-0.1l0.1,0.1C381.9,90.4,381.8,90.4,381.8,90.5z M389.1,98.1
		c0.1,0,0.2,0.1,0.2,0.1c-0.1,0.3-0.3,0.5-0.4,0.8c-0.1-0.1-0.3-0.1-0.4-0.2C388.7,98.6,388.9,98.4,389.1,98.1z M387.3,94.9l0.2,0.1
		c0,0.1-0.1,0.2-0.1,0.3c-0.2,0-0.3-0.1-0.4-0.1C387.1,95.1,387.2,95,387.3,94.9z M394.8,94.1c-0.6-0.6-1.1-1,0-1.8
		c0.3,0,0.7,0,1.2,0c0.2,0.3,0.4,0.5,0.6,0.8C396.3,94,395.5,93.9,394.8,94.1z M396.9,94.7c0.1-0.1,0.1-0.2,0.2-0.2s0.3,0.1,0.4,0.1
		c-0.1,0.1-0.2,0.2-0.2,0.2C397.1,94.8,397,94.8,396.9,94.7z M397.6,95.5l-0.2-0.1c0-0.1,0.1-0.2,0.2-0.4c0.2,0.1,0.4,0.2,0.4,0.3
		C397.8,95.3,397.7,95.4,397.6,95.5z M401.9,90.3h-0.1c0,0,0,0-0.1,0C401.8,90.3,401.8,90.3,401.9,90.3z M399.8,92.4
		c-0.1-0.1-0.1-0.1-0.2-0.2l0.1-0.1l0,0l0.1,0.1l0.1,0.1L399.8,92.4z M402.2,93.8c-0.7-0.2-1.4-0.4-2-0.7c-0.5-0.2-0.2-0.6,0.2-0.9
		c0.7,0.2,1.3,0.4,1.8,0.6c0.2,0.1,0.4,0.3,0.5,0.5C402.7,93.5,402.3,93.8,402.2,93.8z M404.6,83.1c0.1,0,0.1-0.1,0.2-0.1
		s0.1,0,0.2,0C404.8,83.1,404.7,83.1,404.6,83.1z M405.2,83.8C405.2,83.8,405.1,83.8,405.2,83.8c-0.1-0.1-0.1-0.1-0.1-0.2h0.1
		C405.2,83.7,405.2,83.8,405.2,83.8z M407.7,88.2c0.1-0.1,0.1-0.2,0.3-0.4c0.1,0.3,0.1,0.5,0.2,0.8v0.1
		C407.7,88.5,407.5,88.5,407.7,88.2z M407.9,87.3c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2c0,0.1-0.1,0.2-0.1,0.3
		C408,87.2,407.9,87.2,407.9,87.3z M407.1,84.7c-0.1-0.2,0-0.5,0.1-0.5c0.2-0.1,0.6-0.1,0.8,0c0.2,0.2,0.3,0.5,0.5,0.7
		C407.8,85.4,407.3,85.3,407.1,84.7z M409.1,81.5c-0.3,0.8-0.9,1.3-1.8,1.5s-1.8,0-2.2-0.7c-0.5-0.7-0.9-1.5-1.3-2.2
		c0.1,0,0.2-0.1,0.3-0.1c0.3,0.1,0.6,0.3,0.9,0.4c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.3-0.5-0.6-0.7-0.9c0.9-1.2,1.4-1.4,2.3-1.3
		c0.8,0.1,0.5,0.7,0.4,1.1c0.4,0.2,0.9,0.3,1.3,0.6C409.1,80.1,409.4,80.7,409.1,81.5z M409.5,74.1L409.5,74.1L409.5,74.1
		L409.5,74.1z M411.5,82.9c-0.1,0-0.1-0.1-0.2-0.1v-0.1c0.1,0,0.1,0,0.2,0C411.6,82.7,411.5,82.8,411.5,82.9z M414.3,83.3
		c-0.9-0.1-0.8-0.7-0.8-1.2c0.7-0.4,1.4-0.5,1.7,0.2C415.3,82.6,414.8,83.3,414.3,83.3z M416.9,80.5c-0.1-0.1-0.1-0.1-0.2-0.2
		c0.1-0.1,0.2-0.3,0.3-0.4c0.2-0.1,0.4-0.1,0.6-0.2c0.1,0.1,0.1,0.2,0.2,0.3C417.5,80.2,417.2,80.3,416.9,80.5z"
      />
      <path
        class="st4"
        d="M527.3,37.2c0.1,0.1,0.2,0.3,0.2,0.4c0.7-0.4,0.8-0.9,0.8-1.4c0,0,0,0.1-0.1,0.1
		C528.1,36.6,527.7,37,527.3,37.2z"
      />
      <path
        class="st4"
        d="M554.8,62.8c0.2,0.1,0.3,0.1,0.5,0.2c0-0.1,0.1-0.3,0.1-0.4c0.2,0,0.3,0.1,0.5,0.1c0.2-0.3,0.4-0.6,0.6-0.9
		c-1.2,0-2,1.4-3.2,0.6c-0.5,0.2-0.9,0.2-1.4,0.1c0.4,0.7,0.6,1.4,0.5,2.2c0.2,0,0.3,0,0.5,0.1c-0.1-0.6,0.4-1.4,0.9-1.3
		C554.8,63.7,554.5,63,554.8,62.8z"
      />
      <path
        class="st4"
        d="M553.5,67.4c-0.2,0-0.3,0-0.5,0c0.3,0.3,0.5,0.6,0.8,0.8c0.1-0.1,0.2-0.3,0.3-0.4
		C553.8,67.8,553.6,67.6,553.5,67.4z"
      />
      <path
        class="st4"
        d="M306.7,245.7c0.1,0,0.2,0,0.3,0c0.6,0.1,1.2,0.3,1.7,0.7c0-0.1-0.1-0.1-0.1-0.2c0-0.2,0-0.5,0-0.7
		c-0.8,0.1-1.2-0.2-1.6-0.6c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1,0.1-0.3,0.1-0.4,0.2v0.7C306.3,245.4,306.5,245.5,306.7,245.7
		L306.7,245.7z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "WrestlingCover_c1",
  props: ["fill"],
};
</script>
